//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class AdvanceMoneyAdjustOrderServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    export(body: AdvanceMoneyAdjustOrderPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceMoneyAdjustOrder/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: AdvanceMoneyAdjustOrderPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<AdvanceMoneyAdjustOrderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceMoneyAdjustOrder/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<AdvanceMoneyAdjustOrderDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AdvanceMoneyAdjustOrderDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<AdvanceMoneyAdjustOrderDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdvanceMoneyAdjustOrderDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    queryModel(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<AdvanceMoneyAdjustOrderDto> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceMoneyAdjustOrder/QueryModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModel(_response);
        });
    }

    protected processQueryModel(response: AxiosResponse): Promise<AdvanceMoneyAdjustOrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AdvanceMoneyAdjustOrderDto.fromJS(resultData200);
            return Promise.resolve<AdvanceMoneyAdjustOrderDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdvanceMoneyAdjustOrderDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: AdvanceMoneyAdjustOrderDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceMoneyAdjustOrder/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AgentServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: AgentPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<AgentDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Agent/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<AgentDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AgentDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<AgentDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgentDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    queryModel(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<AgentDto> {
        let url_ = this.baseUrl + "/api/services/app/Agent/QueryModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModel(_response);
        });
    }

    protected processQueryModel(response: AxiosResponse): Promise<AgentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AgentDto.fromJS(resultData200);
            return Promise.resolve<AgentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgentDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryTotalBalance(body: AgentPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<AgentTotalOutDto> {
        let url_ = this.baseUrl + "/api/services/app/Agent/QueryTotalBalance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryTotalBalance(_response);
        });
    }

    protected processQueryTotalBalance(response: AxiosResponse): Promise<AgentTotalOutDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AgentTotalOutDto.fromJS(resultData200);
            return Promise.resolve<AgentTotalOutDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgentTotalOutDto>(null as any);
    }

    /**
     * @param start (optional) 
     * @param end (optional) 
     * @param agentId (optional) 
     * @return Success
     */
    agentMerchantSummary(start: Date | undefined, end: Date | undefined, agentId: number | undefined , cancelToken?: CancelToken | undefined): Promise<MerchantSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Agent/AgentMerchantSummary?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (agentId === null)
            throw new Error("The parameter 'agentId' cannot be null.");
        else if (agentId !== undefined)
            url_ += "agentId=" + encodeURIComponent("" + agentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAgentMerchantSummary(_response);
        });
    }

    protected processAgentMerchantSummary(response: AxiosResponse): Promise<MerchantSummaryDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MerchantSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MerchantSummaryDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantSummaryDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: AgentDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Agent/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param idList (optional) 
     * @return Success
     */
    deletes(idList: number[] | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Agent/Deletes?";
        if (idList === null)
            throw new Error("The parameter 'idList' cannot be null.");
        else if (idList !== undefined)
            idList && idList.forEach(item => { url_ += "IdList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletes(_response);
        });
    }

    protected processDeletes(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AgentAccountStatementServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: AgentBalanceLogPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<AgentBalanceLogDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AgentAccountStatement/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<AgentBalanceLogDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AgentBalanceLogDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<AgentBalanceLogDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgentBalanceLogDtoPagedResultDto>(null as any);
    }
}

export class AgentBalanceAdjustOrderServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: AgentBalanceAdjustOrderPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<AgentBalanceAdjustOrderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AgentBalanceAdjustOrder/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<AgentBalanceAdjustOrderDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AgentBalanceAdjustOrderDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<AgentBalanceAdjustOrderDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgentBalanceAdjustOrderDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    queryModel(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<AgentBalanceAdjustOrderDto> {
        let url_ = this.baseUrl + "/api/services/app/AgentBalanceAdjustOrder/QueryModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModel(_response);
        });
    }

    protected processQueryModel(response: AxiosResponse): Promise<AgentBalanceAdjustOrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AgentBalanceAdjustOrderDto.fromJS(resultData200);
            return Promise.resolve<AgentBalanceAdjustOrderDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgentBalanceAdjustOrderDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: AgentBalanceAdjustOrderDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AgentBalanceAdjustOrder/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AgentBalanceLogServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: AgentBalanceLogPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<AgentBalanceLogDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AgentBalanceLog/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<AgentBalanceLogDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AgentBalanceLogDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<AgentBalanceLogDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgentBalanceLogDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    queryModel(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<MerchantBalanceLogDto> {
        let url_ = this.baseUrl + "/api/services/app/AgentBalanceLog/QueryModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModel(_response);
        });
    }

    protected processQueryModel(response: AxiosResponse): Promise<MerchantBalanceLogDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MerchantBalanceLogDto.fromJS(resultData200);
            return Promise.resolve<MerchantBalanceLogDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantBalanceLogDto>(null as any);
    }
}

export class AgentChannelServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: ChannelPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<AgentChannelDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AgentChannel/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<AgentChannelDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AgentChannelDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<AgentChannelDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgentChannelDtoPagedResultDto>(null as any);
    }
}

export class AgentClientServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    getMyInfo(  cancelToken?: CancelToken | undefined): Promise<AgentInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/AgentClient/GetMyInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyInfo(_response);
        });
    }

    protected processGetMyInfo(response: AxiosResponse): Promise<AgentInfoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AgentInfoDto.fromJS(resultData200);
            return Promise.resolve<AgentInfoDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgentInfoDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordDto | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/AgentClient/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePayPwd(body: ChangePasswordDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AgentClient/ChangePayPwd";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangePayPwd(_response);
        });
    }

    protected processChangePayPwd(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AgentMerchantServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: MerchantPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<AgentMerchantDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AgentMerchant/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<AgentMerchantDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AgentMerchantDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<AgentMerchantDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgentMerchantDtoPagedResultDto>(null as any);
    }

    /**
     * @param merchantId (optional) 
     * @return Success
     */
    queryChannelType(merchantId: number | undefined , cancelToken?: CancelToken | undefined): Promise<MerchantChannelProductDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AgentMerchant/QueryChannelType?";
        if (merchantId === null)
            throw new Error("The parameter 'merchantId' cannot be null.");
        else if (merchantId !== undefined)
            url_ += "merchantId=" + encodeURIComponent("" + merchantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryChannelType(_response);
        });
    }

    protected processQueryChannelType(response: AxiosResponse): Promise<MerchantChannelProductDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MerchantChannelProductDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MerchantChannelProductDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantChannelProductDto[]>(null as any);
    }
}

export class AgentStatisticsDayServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: AgentStatisticsDayDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AgentStatisticsDay/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param idList (optional) 
     * @return Success
     */
    delete(idList: number[] | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AgentStatisticsDay/Delete?";
        if (idList === null)
            throw new Error("The parameter 'idList' cannot be null.");
        else if (idList !== undefined)
            idList && idList.forEach(item => { url_ += "IdList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    queryModel(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<AgentStatisticsDayDto> {
        let url_ = this.baseUrl + "/api/services/app/AgentStatisticsDay/QueryModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModel(_response);
        });
    }

    protected processQueryModel(response: AxiosResponse): Promise<AgentStatisticsDayDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AgentStatisticsDayDto.fromJS(resultData200);
            return Promise.resolve<AgentStatisticsDayDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgentStatisticsDayDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: AgentStatisticsDayPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<AgentStatisticsDayDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AgentStatisticsDay/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<AgentStatisticsDayDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AgentStatisticsDayDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<AgentStatisticsDayDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgentStatisticsDayDtoPagedResultDto>(null as any);
    }
}

export class AgentSystemServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryStatisticsDay(body: AgentStatisticsDayPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<AgentStatisticsDayDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AgentSystem/QueryStatisticsDay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryStatisticsDay(_response);
        });
    }

    protected processQueryStatisticsDay(response: AxiosResponse): Promise<AgentStatisticsDayDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AgentStatisticsDayDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<AgentStatisticsDayDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgentStatisticsDayDtoPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getAgentInfo(  cancelToken?: CancelToken | undefined): Promise<AgentSystemDto> {
        let url_ = this.baseUrl + "/api/services/app/AgentSystem/GetAgentInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAgentInfo(_response);
        });
    }

    protected processGetAgentInfo(response: AxiosResponse): Promise<AgentSystemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AgentSystemDto.fromJS(resultData200);
            return Promise.resolve<AgentSystemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgentSystemDto>(null as any);
    }

    /**
     * @return Success
     */
    queryAllType(  cancelToken?: CancelToken | undefined): Promise<ChannelTypeSimpleDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AgentSystem/QueryAllType";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryAllType(_response);
        });
    }

    protected processQueryAllType(response: AxiosResponse): Promise<ChannelTypeSimpleDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChannelTypeSimpleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ChannelTypeSimpleDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChannelTypeSimpleDto[]>(null as any);
    }

    /**
     * @param start (optional) 
     * @param end (optional) 
     * @param channelTypeId (optional) 
     * @return Success
     */
    agentMerchantSummary(start: Date | undefined, end: Date | undefined, channelTypeId: number | undefined , cancelToken?: CancelToken | undefined): Promise<MerchantSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AgentSystem/AgentMerchantSummary?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (channelTypeId === null)
            throw new Error("The parameter 'channelTypeId' cannot be null.");
        else if (channelTypeId !== undefined)
            url_ += "channelTypeId=" + encodeURIComponent("" + channelTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAgentMerchantSummary(_response);
        });
    }

    protected processAgentMerchantSummary(response: AxiosResponse): Promise<MerchantSummaryDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MerchantSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MerchantSummaryDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantSummaryDto[]>(null as any);
    }

    /**
     * @param start (optional) 
     * @param end (optional) 
     * @return Success
     */
    agentChannelSummary(start: Date | undefined, end: Date | undefined , cancelToken?: CancelToken | undefined): Promise<ChannelSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AgentSystem/AgentChannelSummary?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAgentChannelSummary(_response);
        });
    }

    protected processAgentChannelSummary(response: AxiosResponse): Promise<ChannelSummaryDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChannelSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ChannelSummaryDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChannelSummaryDto[]>(null as any);
    }
}

export class AreaServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param parentId (optional) 
     * @param selectId (optional) 
     * @return Success
     */
    getAreas(parentId: number | undefined, selectId: number | undefined , cancelToken?: CancelToken | undefined): Promise<AreaListOutDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Area/GetAreas?";
        if (parentId === null)
            throw new Error("The parameter 'parentId' cannot be null.");
        else if (parentId !== undefined)
            url_ += "ParentId=" + encodeURIComponent("" + parentId) + "&";
        if (selectId === null)
            throw new Error("The parameter 'selectId' cannot be null.");
        else if (selectId !== undefined)
            url_ += "SelectId=" + encodeURIComponent("" + selectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAreas(_response);
        });
    }

    protected processGetAreas(response: AxiosResponse): Promise<AreaListOutDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AreaListOutDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AreaListOutDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AreaListOutDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getAllAreas(  cancelToken?: CancelToken | undefined): Promise<WxAreaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Area/GetAllAreas";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllAreas(_response);
        });
    }

    protected processGetAllAreas(response: AxiosResponse): Promise<WxAreaDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WxAreaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<WxAreaDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WxAreaDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getAreaTree(  cancelToken?: CancelToken | undefined): Promise<AreaTreeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Area/GetAreaTree";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAreaTree(_response);
        });
    }

    protected processGetAreaTree(response: AxiosResponse): Promise<AreaTreeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AreaTreeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AreaTreeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AreaTreeDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getMytree(  cancelToken?: CancelToken | undefined): Promise<Mytree[]> {
        let url_ = this.baseUrl + "/api/services/app/Area/GetMytree";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMytree(_response);
        });
    }

    protected processGetMytree(response: AxiosResponse): Promise<Mytree[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Mytree.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Mytree[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Mytree[]>(null as any);
    }

    /**
     * @return Success
     */
    getMytree1(  cancelToken?: CancelToken | undefined): Promise<Mytree1[]> {
        let url_ = this.baseUrl + "/api/services/app/Area/GetMytree1";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMytree1(_response);
        });
    }

    protected processGetMytree1(response: AxiosResponse): Promise<Mytree1[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Mytree1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Mytree1[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Mytree1[]>(null as any);
    }
}

export class AuditLogServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryAuditLogs(body: GetAuditLogsInput | undefined , cancelToken?: CancelToken | undefined): Promise<AuditLogListDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/QueryAuditLogs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryAuditLogs(_response);
        });
    }

    protected processQueryAuditLogs(response: AxiosResponse): Promise<AuditLogListDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuditLogListDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<AuditLogListDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditLogListDtoPagedResultDto>(null as any);
    }

    /**
     * @param isEnabled (optional) 
     * @return Success
     */
    setAuditIsEnable(isEnabled: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/SetAuditIsEnable?";
        if (isEnabled === null)
            throw new Error("The parameter 'isEnabled' cannot be null.");
        else if (isEnabled !== undefined)
            url_ += "IsEnabled=" + encodeURIComponent("" + isEnabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetAuditIsEnable(_response);
        });
    }

    protected processSetAuditIsEnable(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ChannelServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    bindMerchantChannels(body: BindMerchantChannelsInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Channel/BindMerchantChannels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBindMerchantChannels(_response);
        });
    }

    protected processBindMerchantChannels(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryMerchantChannels(body: QueryMerchantChannelsInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<MerchantChannelDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Channel/QueryMerchantChannels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryMerchantChannels(_response);
        });
    }

    protected processQueryMerchantChannels(response: AxiosResponse): Promise<MerchantChannelDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MerchantChannelDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MerchantChannelDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantChannelDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    batchUpdateQuanZhong(body: BatchUpdateQuanZhongInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Channel/BatchUpdateQuanZhong";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchUpdateQuanZhong(_response);
        });
    }

    protected processBatchUpdateQuanZhong(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateChannelQuanzhong(body: UpdateChannelQuanzhongInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Channel/UpdateChannelQuanzhong";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateChannelQuanzhong(_response);
        });
    }

    protected processUpdateChannelQuanzhong(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: ChannelPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<ChannelDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Channel/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<ChannelDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChannelDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<ChannelDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChannelDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    bindChannelType(body: ChannelBindChannelTypeDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Channel/BindChannelType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBindChannelType(_response);
        });
    }

    protected processBindChannelType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    queryModel(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<ChannelDto> {
        let url_ = this.baseUrl + "/api/services/app/Channel/QueryModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModel(_response);
        });
    }

    protected processQueryModel(response: AxiosResponse): Promise<ChannelDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChannelDto.fromJS(resultData200);
            return Promise.resolve<ChannelDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChannelDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelListTotal(body: ChannelPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<ChannelTotalOutDto> {
        let url_ = this.baseUrl + "/api/services/app/Channel/QueryModelListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelListTotal(_response);
        });
    }

    protected processQueryModelListTotal(response: AxiosResponse): Promise<ChannelTotalOutDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChannelTotalOutDto.fromJS(resultData200);
            return Promise.resolve<ChannelTotalOutDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChannelTotalOutDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: ChannelDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Channel/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    badingChannelType(body: ChannelsBadingChannelTypeInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Channel/BadingChannelType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBadingChannelType(_response);
        });
    }

    protected processBadingChannelType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unbundleChannelType(body: ChannelsBadingChannelTypeInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Channel/UnbundleChannelType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnbundleChannelType(_response);
        });
    }

    protected processUnbundleChannelType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param idList (optional) 
     * @return Success
     */
    deletes(idList: number[] | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Channel/Deletes?";
        if (idList === null)
            throw new Error("The parameter 'idList' cannot be null.");
        else if (idList !== undefined)
            idList && idList.forEach(item => { url_ += "IdList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletes(_response);
        });
    }

    protected processDeletes(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param googlecode (optional) 
     * @param body (optional) 
     * @return Success
     */
    googleCodeVerify(googlecode: string | undefined, body: IdsDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Channel/GoogleCodeVerify?";
        if (googlecode === null)
            throw new Error("The parameter 'googlecode' cannot be null.");
        else if (googlecode !== undefined)
            url_ += "googlecode=" + encodeURIComponent("" + googlecode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGoogleCodeVerify(_response);
        });
    }

    protected processGoogleCodeVerify(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateChannelXiane(body: ChannelUpdatelimitInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Channel/UpdateChannelXiane";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateChannelXiane(_response);
        });
    }

    protected processUpdateChannelXiane(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    channelbalanceqingling(body: IdsDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Channel/channelbalanceqingling";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChannelbalanceqingling(_response);
        });
    }

    protected processChannelbalanceqingling(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateChannelRate(body: UpdateChannelRateDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Channel/UpdateChannelRate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateChannelRate(_response);
        });
    }

    protected processUpdateChannelRate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryAllList(body: ChannelSimpleInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<ChannelSimpleDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Channel/QueryAllList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryAllList(_response);
        });
    }

    protected processQueryAllList(response: AxiosResponse): Promise<ChannelSimpleDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChannelSimpleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ChannelSimpleDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChannelSimpleDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    copyChannel(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Channel/CopyChannel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopyChannel(_response);
        });
    }

    protected processCopyChannel(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param status (optional) 
     * @param body (optional) 
     * @return Success
     */
    batchStatusChange(status: number | undefined, body: IdsDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Channel/BatchStatusChange?";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchStatusChange(_response);
        });
    }

    protected processBatchStatusChange(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    settlementPre(body: ChannelSettlementPreMerInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<ChannelSettlementPreOutDto> {
        let url_ = this.baseUrl + "/api/services/app/Channel/SettlementPre";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSettlementPre(_response);
        });
    }

    protected processSettlementPre(response: AxiosResponse): Promise<ChannelSettlementPreOutDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChannelSettlementPreOutDto.fromJS(resultData200);
            return Promise.resolve<ChannelSettlementPreOutDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChannelSettlementPreOutDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    settlement(body: ChannelSettlementPreMerInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<ChannelSettlementPreOutDto> {
        let url_ = this.baseUrl + "/api/services/app/Channel/Settlement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSettlement(_response);
        });
    }

    protected processSettlement(response: AxiosResponse): Promise<ChannelSettlementPreOutDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChannelSettlementPreOutDto.fromJS(resultData200);
            return Promise.resolve<ChannelSettlementPreOutDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChannelSettlementPreOutDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    synchronousUpdate(body: ChannelDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Channel/SynchronousUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSynchronousUpdate(_response);
        });
    }

    protected processSynchronousUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param rate (optional) 
     * @param body (optional) 
     * @return Success
     */
    adjustmentRate(rate: number | undefined, body: IdsDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Channel/AdjustmentRate?";
        if (rate === null)
            throw new Error("The parameter 'rate' cannot be null.");
        else if (rate !== undefined)
            url_ += "rate=" + encodeURIComponent("" + rate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdjustmentRate(_response);
        });
    }

    protected processAdjustmentRate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    bindingAllMerchant(body: IdsDto | undefined , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/services/app/Channel/BindingAllMerchant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBindingAllMerchant(_response);
        });
    }

    protected processBindingAllMerchant(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unbundleLossMerchant(body: IdsDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Channel/UnbundleLossMerchant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnbundleLossMerchant(_response);
        });
    }

    protected processUnbundleLossMerchant(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    queryAgentList(  cancelToken?: CancelToken | undefined): Promise<AgentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Channel/QueryAgentList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryAgentList(_response);
        });
    }

    protected processQueryAgentList(response: AxiosResponse): Promise<AgentDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AgentDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgentDto[]>(null as any);
    }
}

export class ChannelAdvanceMoneyAdjustOrderServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: ChannelAdvanceMoneyAdjustOrderPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<ChannelAdvanceMoneyAdjustOrderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ChannelAdvanceMoneyAdjustOrder/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<ChannelAdvanceMoneyAdjustOrderDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChannelAdvanceMoneyAdjustOrderDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<ChannelAdvanceMoneyAdjustOrderDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChannelAdvanceMoneyAdjustOrderDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    queryModel(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<ChannelAdvanceMoneyAdjustOrderDto> {
        let url_ = this.baseUrl + "/api/services/app/ChannelAdvanceMoneyAdjustOrder/QueryModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModel(_response);
        });
    }

    protected processQueryModel(response: AxiosResponse): Promise<ChannelAdvanceMoneyAdjustOrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChannelAdvanceMoneyAdjustOrderDto.fromJS(resultData200);
            return Promise.resolve<ChannelAdvanceMoneyAdjustOrderDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChannelAdvanceMoneyAdjustOrderDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    export(body: ChannelAdvanceMoneyAdjustOrderPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ChannelAdvanceMoneyAdjustOrder/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: ChannelAdvanceMoneyAdjustOrderDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/ChannelAdvanceMoneyAdjustOrder/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ChannelBalanceAdjustOrderServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: ChannelBalanceAdjustOrderPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<ChannelBalanceAdjustOrderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ChannelBalanceAdjustOrder/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<ChannelBalanceAdjustOrderDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChannelBalanceAdjustOrderDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<ChannelBalanceAdjustOrderDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChannelBalanceAdjustOrderDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    export(body: ChannelBalanceAdjustOrderPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ChannelBalanceAdjustOrder/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    queryModel(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<ChannelBalanceAdjustOrderDto> {
        let url_ = this.baseUrl + "/api/services/app/ChannelBalanceAdjustOrder/QueryModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModel(_response);
        });
    }

    protected processQueryModel(response: AxiosResponse): Promise<ChannelBalanceAdjustOrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChannelBalanceAdjustOrderDto.fromJS(resultData200);
            return Promise.resolve<ChannelBalanceAdjustOrderDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChannelBalanceAdjustOrderDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: ChannelBalanceAdjustOrderDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/ChannelBalanceAdjustOrder/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ChannelBalanceLogServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: ChannelBalanceLogPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<ChannelBalanceLogDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ChannelBalanceLog/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<ChannelBalanceLogDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChannelBalanceLogDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<ChannelBalanceLogDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChannelBalanceLogDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    queryModel(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<ChannelBalanceLogDto> {
        let url_ = this.baseUrl + "/api/services/app/ChannelBalanceLog/QueryModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModel(_response);
        });
    }

    protected processQueryModel(response: AxiosResponse): Promise<ChannelBalanceLogDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChannelBalanceLogDto.fromJS(resultData200);
            return Promise.resolve<ChannelBalanceLogDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChannelBalanceLogDto>(null as any);
    }
}

export class ChannelDayClearServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: ChannelDayClearPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<ChannelDayClearDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ChannelDayClear/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<ChannelDayClearDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChannelDayClearDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<ChannelDayClearDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChannelDayClearDtoPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    generateSettlement(  cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/services/app/ChannelDayClear/GenerateSettlement";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateSettlement(_response);
        });
    }

    protected processGenerateSettlement(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @return Success
     */
    settlement(  cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/ChannelDayClear/Settlement";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSettlement(_response);
        });
    }

    protected processSettlement(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ChannelOrderServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: PayOrderPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<ChannelOrderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ChannelOrder/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<ChannelOrderDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChannelOrderDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<ChannelOrderDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChannelOrderDtoPagedResultDto>(null as any);
    }
}

export class ChannelSuccessRateServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: QueryChannelTotalPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<ZhuYeChannelStatisticsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ChannelSuccessRate/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<ZhuYeChannelStatisticsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ZhuYeChannelStatisticsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ZhuYeChannelStatisticsDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ZhuYeChannelStatisticsDto[]>(null as any);
    }
}

export class ChannelSupplierServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: ChannelSupplierPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<ChannelSupplierOutDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ChannelSupplier/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<ChannelSupplierOutDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChannelSupplierOutDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<ChannelSupplierOutDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChannelSupplierOutDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelListTotal(body: ChannelSupplierPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<ChannelTotalOutDto> {
        let url_ = this.baseUrl + "/api/services/app/ChannelSupplier/QueryModelListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelListTotal(_response);
        });
    }

    protected processQueryModelListTotal(response: AxiosResponse): Promise<ChannelTotalOutDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChannelTotalOutDto.fromJS(resultData200);
            return Promise.resolve<ChannelTotalOutDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChannelTotalOutDto>(null as any);
    }

    /**
     * @return Success
     */
    queryAllList(  cancelToken?: CancelToken | undefined): Promise<SelectItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ChannelSupplier/QueryAllList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryAllList(_response);
        });
    }

    protected processQueryAllList(response: AxiosResponse): Promise<SelectItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SelectItemDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SelectItemDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    queryModel(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<ChannelSupplierOutDto> {
        let url_ = this.baseUrl + "/api/services/app/ChannelSupplier/QueryModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModel(_response);
        });
    }

    protected processQueryModel(response: AxiosResponse): Promise<ChannelSupplierOutDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChannelSupplierOutDto.fromJS(resultData200);
            return Promise.resolve<ChannelSupplierOutDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChannelSupplierOutDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: ChannelSupplierOutDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/ChannelSupplier/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param idList (optional) 
     * @return Success
     */
    deletes(idList: number[] | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/ChannelSupplier/Deletes?";
        if (idList === null)
            throw new Error("The parameter 'idList' cannot be null.");
        else if (idList !== undefined)
            idList && idList.forEach(item => { url_ += "IdList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletes(_response);
        });
    }

    protected processDeletes(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param status (optional) 
     * @param body (optional) 
     * @return Success
     */
    batchStatusChange(status: boolean | undefined, body: IdsDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/ChannelSupplier/BatchStatusChange?";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchStatusChange(_response);
        });
    }

    protected processBatchStatusChange(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param googlecode (optional) 
     * @param body (optional) 
     * @return Success
     */
    googleCodeVerify(googlecode: string | undefined, body: IdsDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/ChannelSupplier/GoogleCodeVerify?";
        if (googlecode === null)
            throw new Error("The parameter 'googlecode' cannot be null.");
        else if (googlecode !== undefined)
            url_ += "googlecode=" + encodeURIComponent("" + googlecode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGoogleCodeVerify(_response);
        });
    }

    protected processGoogleCodeVerify(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    channelSupplierSettlement(body: ChannelSupplierSettlementDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/ChannelSupplier/ChannelSupplierSettlement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChannelSupplierSettlement(_response);
        });
    }

    protected processChannelSupplierSettlement(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ChannelSupplierCreditQuotaOrderServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: ChannelSupplierCreditQuotaOrderPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<ChannelSupplierCreditQuotaOrderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ChannelSupplierCreditQuotaOrder/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<ChannelSupplierCreditQuotaOrderDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChannelSupplierCreditQuotaOrderDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<ChannelSupplierCreditQuotaOrderDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChannelSupplierCreditQuotaOrderDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    queryModel(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<ChannelSupplierCreditQuotaOrderDto> {
        let url_ = this.baseUrl + "/api/services/app/ChannelSupplierCreditQuotaOrder/QueryModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModel(_response);
        });
    }

    protected processQueryModel(response: AxiosResponse): Promise<ChannelSupplierCreditQuotaOrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChannelSupplierCreditQuotaOrderDto.fromJS(resultData200);
            return Promise.resolve<ChannelSupplierCreditQuotaOrderDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChannelSupplierCreditQuotaOrderDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: ChannelSupplierCreditQuotaOrderDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/ChannelSupplierCreditQuotaOrder/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ChannelTypeServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param channelid (optional) 
     * @return Success
     */
    queryChannelTypesByChannelId(channelid: number | undefined , cancelToken?: CancelToken | undefined): Promise<ChannelTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ChannelType/QueryChannelTypesByChannelId?";
        if (channelid === null)
            throw new Error("The parameter 'channelid' cannot be null.");
        else if (channelid !== undefined)
            url_ += "channelid=" + encodeURIComponent("" + channelid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryChannelTypesByChannelId(_response);
        });
    }

    protected processQueryChannelTypesByChannelId(response: AxiosResponse): Promise<ChannelTypeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChannelTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ChannelTypeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChannelTypeDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: ChannelTypePageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<ChannelTypeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ChannelType/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<ChannelTypeDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChannelTypeDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<ChannelTypeDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChannelTypeDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    queryModel(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<ChannelTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/ChannelType/QueryModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModel(_response);
        });
    }

    protected processQueryModel(response: AxiosResponse): Promise<ChannelTypeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChannelTypeDto.fromJS(resultData200);
            return Promise.resolve<ChannelTypeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChannelTypeDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    queryChannelTypeChannel(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<ChannelTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/ChannelType/QueryChannelTypeChannel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryChannelTypeChannel(_response);
        });
    }

    protected processQueryChannelTypeChannel(response: AxiosResponse): Promise<ChannelTypeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChannelTypeDto.fromJS(resultData200);
            return Promise.resolve<ChannelTypeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChannelTypeDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    queryMerchantChannelType(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<ChannelTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/ChannelType/QueryMerchantChannelType?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryMerchantChannelType(_response);
        });
    }

    protected processQueryMerchantChannelType(response: AxiosResponse): Promise<ChannelTypeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChannelTypeDto.fromJS(resultData200);
            return Promise.resolve<ChannelTypeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChannelTypeDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveChannelTypeChannel(body: ChannelTypeDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/ChannelType/SaveChannelTypeChannel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveChannelTypeChannel(_response);
        });
    }

    protected processSaveChannelTypeChannel(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveMerchantChannelType(body: ChannelTypeDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/ChannelType/SaveMerchantChannelType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveMerchantChannelType(_response);
        });
    }

    protected processSaveMerchantChannelType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: ChannelTypeDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/ChannelType/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param idList (optional) 
     * @return Success
     */
    deletes(idList: number[] | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/ChannelType/Deletes?";
        if (idList === null)
            throw new Error("The parameter 'idList' cannot be null.");
        else if (idList !== undefined)
            idList && idList.forEach(item => { url_ += "IdList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletes(_response);
        });
    }

    protected processDeletes(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editMerchantRate(body: EditMerchantRateDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/ChannelType/EditMerchantRate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditMerchantRate(_response);
        });
    }

    protected processEditMerchantRate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryAllTypes(body: ChannelTypePageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<ChannelTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ChannelType/QueryAllTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryAllTypes(_response);
        });
    }

    protected processQueryAllTypes(response: AxiosResponse): Promise<ChannelTypeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChannelTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ChannelTypeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChannelTypeDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unbundleNegativeMerchant(body: IdsDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/ChannelType/UnbundleNegativeMerchant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnbundleNegativeMerchant(_response);
        });
    }

    protected processUnbundleNegativeMerchant(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ChannelTypeDayClearServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: ChannelTypeDayClearPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<ChannelTypeDayClearDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ChannelTypeDayClear/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<ChannelTypeDayClearDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChannelTypeDayClearDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<ChannelTypeDayClearDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChannelTypeDayClearDtoPagedResultDto>(null as any);
    }
}

export class ClearSettingServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    save(body: ClearSettingDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/ClearSetting/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    queryModel(  cancelToken?: CancelToken | undefined): Promise<ClearSettingDto> {
        let url_ = this.baseUrl + "/api/services/app/ClearSetting/QueryModel";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModel(_response);
        });
    }

    protected processQueryModel(response: AxiosResponse): Promise<ClearSettingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ClearSettingDto.fromJS(resultData200);
            return Promise.resolve<ClearSettingDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClearSettingDto>(null as any);
    }
}

export class CommonServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param name (optional) 
     * @return Success
     */
    getEnumKeyValue(name: string | undefined , cancelToken?: CancelToken | undefined): Promise<SelectItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Common/GetEnumKeyValue?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEnumKeyValue(_response);
        });
    }

    protected processGetEnumKeyValue(response: AxiosResponse): Promise<SelectItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SelectItemDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SelectItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    querySystemSetting(  cancelToken?: CancelToken | undefined): Promise<SystemSettingDto> {
        let url_ = this.baseUrl + "/api/services/app/Common/QuerySystemSetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuerySystemSetting(_response);
        });
    }

    protected processQuerySystemSetting(response: AxiosResponse): Promise<SystemSettingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SystemSettingDto.fromJS(resultData200);
            return Promise.resolve<SystemSettingDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SystemSettingDto>(null as any);
    }

    /**
     * @return Success
     */
    testXiuFuMerAndCtypeDayBill(  cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Common/TestXiuFuMerAndCtypeDayBill";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestXiuFuMerAndCtypeDayBill(_response);
        });
    }

    protected processTestXiuFuMerAndCtypeDayBill(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    testXiuFuMerDayBill(  cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Common/TestXiuFuMerDayBill";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestXiuFuMerDayBill(_response);
        });
    }

    protected processTestXiuFuMerDayBill(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ConfigurationServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeUiTheme(body: ChangeUiThemeInput | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/ChangeUiTheme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeUiTheme(_response);
        });
    }

    protected processChangeUiTheme(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class FinanceManageServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportChannelStatistics(body: QueryChannelTotalPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/FinanceManage/ExportChannelStatistics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportChannelStatistics(_response);
        });
    }

    protected processExportChannelStatistics(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryChannelTotal(body: QueryChannelTotalPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<ChannelStatisticsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FinanceManage/QueryChannelTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryChannelTotal(_response);
        });
    }

    protected processQueryChannelTotal(response: AxiosResponse): Promise<ChannelStatisticsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChannelStatisticsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ChannelStatisticsDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChannelStatisticsDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    caiWu_QueryChannelTotal(body: QueryChannelTotalPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<ChannelStatisticsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FinanceManage/CaiWu_QueryChannelTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCaiWu_QueryChannelTotal(_response);
        });
    }

    protected processCaiWu_QueryChannelTotal(response: AxiosResponse): Promise<ChannelStatisticsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChannelStatisticsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ChannelStatisticsDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChannelStatisticsDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportMerchant(body: MerchantStatisticsPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/FinanceManage/ExportMerchant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportMerchant(_response);
        });
    }

    protected processExportMerchant(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryMerchantStatistics(body: MerchantStatisticsPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<MerchantStatisticsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FinanceManage/QueryMerchantStatistics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryMerchantStatistics(_response);
        });
    }

    protected processQueryMerchantStatistics(response: AxiosResponse): Promise<MerchantStatisticsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MerchantStatisticsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MerchantStatisticsDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantStatisticsDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    caiWu_QueryMerchantStatistics(body: MerchantStatisticsPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<MerchantStatisticsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FinanceManage/CaiWu_QueryMerchantStatistics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCaiWu_QueryMerchantStatistics(_response);
        });
    }

    protected processCaiWu_QueryMerchantStatistics(response: AxiosResponse): Promise<MerchantStatisticsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MerchantStatisticsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MerchantStatisticsDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantStatisticsDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportChannelType(body: QueryChannelTypeStatisticsPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/FinanceManage/ExportChannelType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportChannelType(_response);
        });
    }

    protected processExportChannelType(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryChannelTypeStatistics(body: QueryChannelTypeStatisticsPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<ChannelTypeStatisticsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FinanceManage/QueryChannelTypeStatistics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryChannelTypeStatistics(_response);
        });
    }

    protected processQueryChannelTypeStatistics(response: AxiosResponse): Promise<ChannelTypeStatisticsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChannelTypeStatisticsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ChannelTypeStatisticsDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChannelTypeStatisticsDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    caiWu_QueryChannelTypeStatistics(body: QueryChannelTypeStatisticsPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<ChannelTypeStatisticsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FinanceManage/CaiWu_QueryChannelTypeStatistics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCaiWu_QueryChannelTypeStatistics(_response);
        });
    }

    protected processCaiWu_QueryChannelTypeStatistics(response: AxiosResponse): Promise<ChannelTypeStatisticsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChannelTypeStatisticsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ChannelTypeStatisticsDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChannelTypeStatisticsDto[]>(null as any);
    }

    /**
     * @return Success
     */
    zhuYeQueryChannelTypeStatistics(  cancelToken?: CancelToken | undefined): Promise<ZhuYeChannelTypeStatisticsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FinanceManage/ZhuYeQueryChannelTypeStatistics";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processZhuYeQueryChannelTypeStatistics(_response);
        });
    }

    protected processZhuYeQueryChannelTypeStatistics(response: AxiosResponse): Promise<ZhuYeChannelTypeStatisticsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ZhuYeChannelTypeStatisticsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ZhuYeChannelTypeStatisticsDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ZhuYeChannelTypeStatisticsDto[]>(null as any);
    }

    /**
     * @return Success
     */
    zhuYeQueryMerchantStatistics(  cancelToken?: CancelToken | undefined): Promise<ZhuYeMerchantStatisticsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FinanceManage/ZhuYeQueryMerchantStatistics";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processZhuYeQueryMerchantStatistics(_response);
        });
    }

    protected processZhuYeQueryMerchantStatistics(response: AxiosResponse): Promise<ZhuYeMerchantStatisticsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ZhuYeMerchantStatisticsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ZhuYeMerchantStatisticsDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ZhuYeMerchantStatisticsDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    singleQueryMerchantChannelTypeStatistics(body: QueryMerchantChannelTypeStatisticsPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<QueryMerchantChannelTypeStatisticsOutDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FinanceManage/SingleQueryMerchantChannelTypeStatistics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSingleQueryMerchantChannelTypeStatistics(_response);
        });
    }

    protected processSingleQueryMerchantChannelTypeStatistics(response: AxiosResponse): Promise<QueryMerchantChannelTypeStatisticsOutDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QueryMerchantChannelTypeStatisticsOutDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<QueryMerchantChannelTypeStatisticsOutDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryMerchantChannelTypeStatisticsOutDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    singleQueryMerchantChannelStatistics(body: QueryMerchantChannelStatisticsPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<QueryMerchantChannelStatisticsOutDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FinanceManage/SingleQueryMerchantChannelStatistics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSingleQueryMerchantChannelStatistics(_response);
        });
    }

    protected processSingleQueryMerchantChannelStatistics(response: AxiosResponse): Promise<QueryMerchantChannelStatisticsOutDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QueryMerchantChannelStatisticsOutDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<QueryMerchantChannelStatisticsOutDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryMerchantChannelStatisticsOutDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportMerchantChannel(body: QueryMerchantChannelStatisticsPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/FinanceManage/ExportMerchantChannel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportMerchantChannel(_response);
        });
    }

    protected processExportMerchantChannel(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryMerchantChannelStatistics(body: QueryMerchantChannelStatisticsPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<QueryMerchantChannelStatisticsOutDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FinanceManage/QueryMerchantChannelStatistics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryMerchantChannelStatistics(_response);
        });
    }

    protected processQueryMerchantChannelStatistics(response: AxiosResponse): Promise<QueryMerchantChannelStatisticsOutDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QueryMerchantChannelStatisticsOutDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<QueryMerchantChannelStatisticsOutDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryMerchantChannelStatisticsOutDto[]>(null as any);
    }

    /**
     * @param merId (optional) 
     * @return Success
     */
    queryMerchantTypeStatistics(merId: number | undefined , cancelToken?: CancelToken | undefined): Promise<MerchantChannelTypeStatisticsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FinanceManage/QueryMerchantTypeStatistics?";
        if (merId === null)
            throw new Error("The parameter 'merId' cannot be null.");
        else if (merId !== undefined)
            url_ += "merId=" + encodeURIComponent("" + merId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryMerchantTypeStatistics(_response);
        });
    }

    protected processQueryMerchantTypeStatistics(response: AxiosResponse): Promise<MerchantChannelTypeStatisticsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MerchantChannelTypeStatisticsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MerchantChannelTypeStatisticsDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantChannelTypeStatisticsDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryMerchantTotalUpfrontStatistics(body: MerchantTotalUpfrontStatisticsPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<MerchantTotalUpfrontStatisticsDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/FinanceManage/QueryMerchantTotalUpfrontStatistics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryMerchantTotalUpfrontStatistics(_response);
        });
    }

    protected processQueryMerchantTotalUpfrontStatistics(response: AxiosResponse): Promise<MerchantTotalUpfrontStatisticsDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MerchantTotalUpfrontStatisticsDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<MerchantTotalUpfrontStatisticsDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantTotalUpfrontStatisticsDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportMerchantChannelType(body: QueryMerchantChannelTypeStatisticsPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/FinanceManage/ExportMerchantChannelType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportMerchantChannelType(_response);
        });
    }

    protected processExportMerchantChannelType(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryMerchantChannelTypeStatistics(body: QueryMerchantChannelTypeStatisticsPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<QueryMerchantChannelTypeStatisticsOutDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FinanceManage/QueryMerchantChannelTypeStatistics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryMerchantChannelTypeStatistics(_response);
        });
    }

    protected processQueryMerchantChannelTypeStatistics(response: AxiosResponse): Promise<QueryMerchantChannelTypeStatisticsOutDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QueryMerchantChannelTypeStatisticsOutDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<QueryMerchantChannelTypeStatisticsOutDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryMerchantChannelTypeStatisticsOutDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportChannelSupplier(body: QueryChannelSupplierStatisticsPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/FinanceManage/ExportChannelSupplier";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportChannelSupplier(_response);
        });
    }

    protected processExportChannelSupplier(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryChannelSupplierStatistics(body: QueryChannelSupplierStatisticsPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<QueryChannelSupplierStatisticsOutDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FinanceManage/QueryChannelSupplierStatistics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryChannelSupplierStatistics(_response);
        });
    }

    protected processQueryChannelSupplierStatistics(response: AxiosResponse): Promise<QueryChannelSupplierStatisticsOutDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QueryChannelSupplierStatisticsOutDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<QueryChannelSupplierStatisticsOutDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryChannelSupplierStatisticsOutDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    caiWu_QueryChannelSupplierStatistics(body: QueryChannelSupplierStatisticsPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<QueryChannelSupplierStatisticsOutDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FinanceManage/CaiWu_QueryChannelSupplierStatistics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCaiWu_QueryChannelSupplierStatistics(_response);
        });
    }

    protected processCaiWu_QueryChannelSupplierStatistics(response: AxiosResponse): Promise<QueryChannelSupplierStatisticsOutDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QueryChannelSupplierStatisticsOutDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<QueryChannelSupplierStatisticsOutDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryChannelSupplierStatisticsOutDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportPlat(body: QueryPlatStatisticsPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/FinanceManage/ExportPlat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportPlat(_response);
        });
    }

    protected processExportPlat(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryPlatStatistics(body: QueryPlatStatisticsPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<QueryPlatStatisticsOutDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FinanceManage/QueryPlatStatistics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryPlatStatistics(_response);
        });
    }

    protected processQueryPlatStatistics(response: AxiosResponse): Promise<QueryPlatStatisticsOutDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QueryPlatStatisticsOutDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<QueryPlatStatisticsOutDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryPlatStatisticsOutDto[]>(null as any);
    }
}

export class FinancialStatisticsServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    querySystemPayOrderList(body: AllSystemPayOrderDayBillPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<FinancialStatisticsSystemPayOrderOutDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FinancialStatistics/QuerySystemPayOrderList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuerySystemPayOrderList(_response);
        });
    }

    protected processQuerySystemPayOrderList(response: AxiosResponse): Promise<FinancialStatisticsSystemPayOrderOutDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FinancialStatisticsSystemPayOrderOutDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<FinancialStatisticsSystemPayOrderOutDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FinancialStatisticsSystemPayOrderOutDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryChannelList(body: ChannelDayBillPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<FinancialStatisticsChannelOutDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FinancialStatistics/QueryChannelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryChannelList(_response);
        });
    }

    protected processQueryChannelList(response: AxiosResponse): Promise<FinancialStatisticsChannelOutDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FinancialStatisticsChannelOutDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<FinancialStatisticsChannelOutDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FinancialStatisticsChannelOutDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryChannelSupplierList(body: ChannelSupplierDayBillPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<FinancialStatisticsChannelSupplierOutDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FinancialStatistics/QueryChannelSupplierList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryChannelSupplierList(_response);
        });
    }

    protected processQueryChannelSupplierList(response: AxiosResponse): Promise<FinancialStatisticsChannelSupplierOutDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FinancialStatisticsChannelSupplierOutDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<FinancialStatisticsChannelSupplierOutDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FinancialStatisticsChannelSupplierOutDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryMerchantList(body: MerchantsDayBillPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<FinancialStatisticsMerchantOutDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FinancialStatistics/QueryMerchantList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryMerchantList(_response);
        });
    }

    protected processQueryMerchantList(response: AxiosResponse): Promise<FinancialStatisticsMerchantOutDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FinancialStatisticsMerchantOutDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<FinancialStatisticsMerchantOutDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FinancialStatisticsMerchantOutDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryChannelTypeList(body: ChannelTypeDayBillPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<FinancialStatisticsChannelTypeOutDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FinancialStatistics/QueryChannelTypeList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryChannelTypeList(_response);
        });
    }

    protected processQueryChannelTypeList(response: AxiosResponse): Promise<FinancialStatisticsChannelTypeOutDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FinancialStatisticsChannelTypeOutDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<FinancialStatisticsChannelTypeOutDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FinancialStatisticsChannelTypeOutDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryMerchantChannelList(body: MerchantAndChannelDayBillPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<FinancialStatisticsMerchantChannelOutDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FinancialStatistics/QueryMerchantChannelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryMerchantChannelList(_response);
        });
    }

    protected processQueryMerchantChannelList(response: AxiosResponse): Promise<FinancialStatisticsMerchantChannelOutDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FinancialStatisticsMerchantChannelOutDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<FinancialStatisticsMerchantChannelOutDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FinancialStatisticsMerchantChannelOutDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryMerchantChannelTypeList(body: MerchantAndChannelTypeDayBillPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<FinancialStatisticsMerchantChannelTypeOutDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FinancialStatistics/QueryMerchantChannelTypeList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryMerchantChannelTypeList(_response);
        });
    }

    protected processQueryMerchantChannelTypeList(response: AxiosResponse): Promise<FinancialStatisticsMerchantChannelTypeOutDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FinancialStatisticsMerchantChannelTypeOutDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<FinancialStatisticsMerchantChannelTypeOutDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FinancialStatisticsMerchantChannelTypeOutDto[]>(null as any);
    }
}

export class GoogleTokenServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    createToken(  cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/services/app/GoogleToken/CreateToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateToken(_response);
        });
    }

    protected processCreateToken(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param googleKey (optional) 
     * @param code (optional) 
     * @return Success
     */
    bindToken(googleKey: string | undefined, code: string | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/GoogleToken/BindToken?";
        if (googleKey === null)
            throw new Error("The parameter 'googleKey' cannot be null.");
        else if (googleKey !== undefined)
            url_ += "GoogleKey=" + encodeURIComponent("" + googleKey) + "&";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBindToken(_response);
        });
    }

    protected processBindToken(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    clearToken(code: string | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/GoogleToken/ClearToken?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClearToken(_response);
        });
    }

    protected processClearToken(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    isBind(  cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/GoogleToken/IsBind";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsBind(_response);
        });
    }

    protected processIsBind(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class HistoricalBillManageServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: AllSystemPayOrderDayBillPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<AllSystemPayOrderDayBillDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/HistoricalBillManage/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<AllSystemPayOrderDayBillDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AllSystemPayOrderDayBillDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<AllSystemPayOrderDayBillDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AllSystemPayOrderDayBillDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryChannelModelList(body: ChannelDayBillPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<ChannelDayBillDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/HistoricalBillManage/QueryChannelModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryChannelModelList(_response);
        });
    }

    protected processQueryChannelModelList(response: AxiosResponse): Promise<ChannelDayBillDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChannelDayBillDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<ChannelDayBillDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChannelDayBillDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryChannelSupplierModelList(body: ChannelSupplierDayBillPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<ChannelSupplierDayBillDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/HistoricalBillManage/QueryChannelSupplierModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryChannelSupplierModelList(_response);
        });
    }

    protected processQueryChannelSupplierModelList(response: AxiosResponse): Promise<ChannelSupplierDayBillDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChannelSupplierDayBillDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<ChannelSupplierDayBillDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChannelSupplierDayBillDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryMerchantModelList(body: MerchantsDayBillPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<MerchantsDayBillDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/HistoricalBillManage/QueryMerchantModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryMerchantModelList(_response);
        });
    }

    protected processQueryMerchantModelList(response: AxiosResponse): Promise<MerchantsDayBillDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MerchantsDayBillDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<MerchantsDayBillDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantsDayBillDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryChannelTypeModelList(body: ChannelTypeDayBillPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<ChannelTypeDayBillDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/HistoricalBillManage/QueryChannelTypeModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryChannelTypeModelList(_response);
        });
    }

    protected processQueryChannelTypeModelList(response: AxiosResponse): Promise<ChannelTypeDayBillDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChannelTypeDayBillDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<ChannelTypeDayBillDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChannelTypeDayBillDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryMerchantAndChannelModelList(body: MerchantAndChannelDayBillPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<MerchantAndChannelDayBillDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/HistoricalBillManage/QueryMerchantAndChannelModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryMerchantAndChannelModelList(_response);
        });
    }

    protected processQueryMerchantAndChannelModelList(response: AxiosResponse): Promise<MerchantAndChannelDayBillDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MerchantAndChannelDayBillDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<MerchantAndChannelDayBillDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantAndChannelDayBillDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryMerchantAndChannelTypeModelList(body: MerchantAndChannelTypeDayBillPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<MerchantAndChannelTypeDayBillDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/HistoricalBillManage/QueryMerchantAndChannelTypeModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryMerchantAndChannelTypeModelList(_response);
        });
    }

    protected processQueryMerchantAndChannelTypeModelList(response: AxiosResponse): Promise<MerchantAndChannelTypeDayBillDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MerchantAndChannelTypeDayBillDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<MerchantAndChannelTypeDayBillDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantAndChannelTypeDayBillDtoPagedResultDto>(null as any);
    }
}

export class HomeServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    queryTotal(  cancelToken?: CancelToken | undefined): Promise<HomeOutDto> {
        let url_ = this.baseUrl + "/api/services/app/Home/QueryTotal";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryTotal(_response);
        });
    }

    protected processQueryTotal(response: AxiosResponse): Promise<HomeOutDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HomeOutDto.fromJS(resultData200);
            return Promise.resolve<HomeOutDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HomeOutDto>(null as any);
    }
}

export class MerchantServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    copyMerchantRate(body: CopyMerchantRateInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Merchant/CopyMerchantRate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopyMerchantRate(_response);
        });
    }

    protected processCopyMerchantRate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    settlementPre(body: SettlementPreMerInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<SettlementPreOutDto> {
        let url_ = this.baseUrl + "/api/services/app/Merchant/SettlementPre";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSettlementPre(_response);
        });
    }

    protected processSettlementPre(response: AxiosResponse): Promise<SettlementPreOutDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SettlementPreOutDto.fromJS(resultData200);
            return Promise.resolve<SettlementPreOutDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SettlementPreOutDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryMerchantChannelTypesByTypeIds(body: QueryMerchantChannelTypesByTypeIdsInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<MerchantChannelTypeOutResult> {
        let url_ = this.baseUrl + "/api/services/app/Merchant/QueryMerchantChannelTypesByTypeIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryMerchantChannelTypesByTypeIds(_response);
        });
    }

    protected processQueryMerchantChannelTypesByTypeIds(response: AxiosResponse): Promise<MerchantChannelTypeOutResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MerchantChannelTypeOutResult.fromJS(resultData200);
            return Promise.resolve<MerchantChannelTypeOutResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantChannelTypeOutResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    settlement(body: SettlementPreMerInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Merchant/Settlement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSettlement(_response);
        });
    }

    protected processSettlement(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createWarehousingProduct(body: WarehousingProductDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Merchant/CreateWarehousingProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateWarehousingProduct(_response);
        });
    }

    protected processCreateWarehousingProduct(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param merId (optional) 
     * @return Success
     */
    queryMerchantChannelType(merId: number | undefined , cancelToken?: CancelToken | undefined): Promise<ChannelTypeSimpleDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Merchant/QueryMerchantChannelType?";
        if (merId === null)
            throw new Error("The parameter 'merId' cannot be null.");
        else if (merId !== undefined)
            url_ += "merId=" + encodeURIComponent("" + merId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryMerchantChannelType(_response);
        });
    }

    protected processQueryMerchantChannelType(response: AxiosResponse): Promise<ChannelTypeSimpleDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChannelTypeSimpleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ChannelTypeSimpleDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChannelTypeSimpleDto[]>(null as any);
    }

    /**
     * @param merchantId (optional) 
     * @return Success
     */
    updateMsecret(merchantId: number | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Merchant/UpdateMsecret?";
        if (merchantId === null)
            throw new Error("The parameter 'merchantId' cannot be null.");
        else if (merchantId !== undefined)
            url_ += "merchantId=" + encodeURIComponent("" + merchantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMsecret(_response);
        });
    }

    protected processUpdateMsecret(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param status (optional) 
     * @param body (optional) 
     * @return Success
     */
    batchApiStatusChange(status: boolean | undefined, body: IdsDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Merchant/BatchApiStatusChange?";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchApiStatusChange(_response);
        });
    }

    protected processBatchApiStatusChange(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param status (optional) 
     * @param body (optional) 
     * @return Success
     */
    loginWhiteLimitChange(status: boolean | undefined, body: IdsDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Merchant/LoginWhiteLimitChange?";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLoginWhiteLimitChange(_response);
        });
    }

    protected processLoginWhiteLimitChange(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    merLoginWhiteLimit(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<MerchantLoginWhiteLimitDto> {
        let url_ = this.baseUrl + "/api/services/app/Merchant/MerLoginWhiteLimit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMerLoginWhiteLimit(_response);
        });
    }

    protected processMerLoginWhiteLimit(response: AxiosResponse): Promise<MerchantLoginWhiteLimitDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MerchantLoginWhiteLimitDto.fromJS(resultData200);
            return Promise.resolve<MerchantLoginWhiteLimitDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantLoginWhiteLimitDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param ip (optional) 
     * @return Success
     */
    loginWhiteLimit(id: number | undefined, ip: string | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Merchant/LoginWhiteLimit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (ip === null)
            throw new Error("The parameter 'ip' cannot be null.");
        else if (ip !== undefined)
            url_ += "ip=" + encodeURIComponent("" + ip) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLoginWhiteLimit(_response);
        });
    }

    protected processLoginWhiteLimit(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param status (optional) 
     * @param body (optional) 
     * @return Success
     */
    batchStatusChange(status: number | undefined, body: IdsDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Merchant/BatchStatusChange?";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchStatusChange(_response);
        });
    }

    protected processBatchStatusChange(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    queryMerchantInfo(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<MerchantApidocDto> {
        let url_ = this.baseUrl + "/api/services/app/Merchant/QueryMerchantInfo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryMerchantInfo(_response);
        });
    }

    protected processQueryMerchantInfo(response: AxiosResponse): Promise<MerchantApidocDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MerchantApidocDto.fromJS(resultData200);
            return Promise.resolve<MerchantApidocDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantApidocDto>(null as any);
    }

    /**
     * @return Success
     */
    queryAgentList(  cancelToken?: CancelToken | undefined): Promise<AgentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Merchant/QueryAgentList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryAgentList(_response);
        });
    }

    protected processQueryAgentList(response: AxiosResponse): Promise<AgentDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AgentDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgentDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryAllList(body: MerchantSimpleInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<MerchantSimpleDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Merchant/QueryAllList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryAllList(_response);
        });
    }

    protected processQueryAllList(response: AxiosResponse): Promise<MerchantSimpleDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MerchantSimpleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MerchantSimpleDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantSimpleDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: MerchantPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<MerchantDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Merchant/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<MerchantDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MerchantDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<MerchantDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateGroupMark(body: MerchantUpdateGroupMarkDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Merchant/UpdateGroupMark";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateGroupMark(_response);
        });
    }

    protected processUpdateGroupMark(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelListTotal(body: MerchantPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<MerchantTotalOutDto> {
        let url_ = this.baseUrl + "/api/services/app/Merchant/QueryModelListTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelListTotal(_response);
        });
    }

    protected processQueryModelListTotal(response: AxiosResponse): Promise<MerchantTotalOutDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MerchantTotalOutDto.fromJS(resultData200);
            return Promise.resolve<MerchantTotalOutDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantTotalOutDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    queryModel(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<MerchantDto> {
        let url_ = this.baseUrl + "/api/services/app/Merchant/QueryModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModel(_response);
        });
    }

    protected processQueryModel(response: AxiosResponse): Promise<MerchantDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MerchantDto.fromJS(resultData200);
            return Promise.resolve<MerchantDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: MerchantDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Merchant/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param idList (optional) 
     * @return Success
     */
    deletes(idList: number[] | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Merchant/Deletes?";
        if (idList === null)
            throw new Error("The parameter 'idList' cannot be null.");
        else if (idList !== undefined)
            idList && idList.forEach(item => { url_ += "IdList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletes(_response);
        });
    }

    protected processDeletes(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param googlecode (optional) 
     * @param body (optional) 
     * @return Success
     */
    googleCodeVerify(googlecode: string | undefined, body: IdsDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Merchant/GoogleCodeVerify?";
        if (googlecode === null)
            throw new Error("The parameter 'googlecode' cannot be null.");
        else if (googlecode !== undefined)
            url_ += "googlecode=" + encodeURIComponent("" + googlecode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGoogleCodeVerify(_response);
        });
    }

    protected processGoogleCodeVerify(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    createMerchantCheckoutCounter(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/services/app/Merchant/CreateMerchantCheckoutCounter?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMerchantCheckoutCounter(_response);
        });
    }

    protected processCreateMerchantCheckoutCounter(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class MerchantAndChannelTypeDayBillServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    export(body: ClientMerAndChannelTypeDayBillPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MerchantAndChannelTypeDayBill/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: ClientMerAndChannelTypeDayBillPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<MerchantAndChannelTypeDayBillDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MerchantAndChannelTypeDayBill/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<MerchantAndChannelTypeDayBillDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MerchantAndChannelTypeDayBillDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<MerchantAndChannelTypeDayBillDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantAndChannelTypeDayBillDtoPagedResultDto>(null as any);
    }
}

export class MerchantAndMerBinDingServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param idList (optional) 
     * @return Success
     */
    deletes(idList: number[] | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MerchantAndMerBinDing/Deletes?";
        if (idList === null)
            throw new Error("The parameter 'idList' cannot be null.");
        else if (idList !== undefined)
            idList && idList.forEach(item => { url_ += "IdList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletes(_response);
        });
    }

    protected processDeletes(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    queryModel(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<MerchantAndMerBinDingDto> {
        let url_ = this.baseUrl + "/api/services/app/MerchantAndMerBinDing/QueryModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModel(_response);
        });
    }

    protected processQueryModel(response: AxiosResponse): Promise<MerchantAndMerBinDingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MerchantAndMerBinDingDto.fromJS(resultData200);
            return Promise.resolve<MerchantAndMerBinDingDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantAndMerBinDingDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: MerchantAndMerBinDingPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<MerchantAndMerBinDingDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MerchantAndMerBinDing/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<MerchantAndMerBinDingDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MerchantAndMerBinDingDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<MerchantAndMerBinDingDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantAndMerBinDingDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: MerchantAndMerBinDingDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MerchantAndMerBinDing/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class MerchantBalanceAdjustOrderServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: MerchantBalanceAdjustOrderPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<MerchantBalanceAdjustOrderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MerchantBalanceAdjustOrder/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<MerchantBalanceAdjustOrderDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MerchantBalanceAdjustOrderDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<MerchantBalanceAdjustOrderDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantBalanceAdjustOrderDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    queryModel(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<MerchantBalanceAdjustOrderDto> {
        let url_ = this.baseUrl + "/api/services/app/MerchantBalanceAdjustOrder/QueryModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModel(_response);
        });
    }

    protected processQueryModel(response: AxiosResponse): Promise<MerchantBalanceAdjustOrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MerchantBalanceAdjustOrderDto.fromJS(resultData200);
            return Promise.resolve<MerchantBalanceAdjustOrderDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantBalanceAdjustOrderDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: MerchantBalanceAdjustOrderDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MerchantBalanceAdjustOrder/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    export(body: MerchantBalanceAdjustOrderPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MerchantBalanceAdjustOrder/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class MerchantBalanceLogServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: MerchantBalanceLogPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<MerchantBalanceLogDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MerchantBalanceLog/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<MerchantBalanceLogDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MerchantBalanceLogDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<MerchantBalanceLogDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantBalanceLogDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    queryModel(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<MerchantBalanceLogDto> {
        let url_ = this.baseUrl + "/api/services/app/MerchantBalanceLog/QueryModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModel(_response);
        });
    }

    protected processQueryModel(response: AxiosResponse): Promise<MerchantBalanceLogDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MerchantBalanceLogDto.fromJS(resultData200);
            return Promise.resolve<MerchantBalanceLogDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantBalanceLogDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    export(body: MerchantBalanceLogPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MerchantBalanceLog/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class MerchantChannelDayClearServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: MerchantChannelDayClearPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<MerchantChannelDayClearDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MerchantChannelDayClear/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<MerchantChannelDayClearDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MerchantChannelDayClearDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<MerchantChannelDayClearDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantChannelDayClearDtoPagedResultDto>(null as any);
    }
}

export class MerchantChannelTypeDayClearServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: MerchantChannelTypeDayClearPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<MerchantChannelTypeDayClearDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MerchantChannelTypeDayClear/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<MerchantChannelTypeDayClearDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MerchantChannelTypeDayClearDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<MerchantChannelTypeDayClearDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantChannelTypeDayClearDtoPagedResultDto>(null as any);
    }
}

export class MerchantClientServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    queryBinDingsList(  cancelToken?: CancelToken | undefined): Promise<MerchantBinDingOutDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MerchantClient/QueryBinDingsList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryBinDingsList(_response);
        });
    }

    protected processQueryBinDingsList(response: AxiosResponse): Promise<MerchantBinDingOutDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MerchantBinDingOutDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MerchantBinDingOutDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantBinDingOutDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    showAppkey(body: ShowAppkeyInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/services/app/MerchantClient/ShowAppkey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processShowAppkey(_response);
        });
    }

    protected processShowAppkey(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryMerchantStatistics(body: MerchantStatisticsPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<MerchantStatisticsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MerchantClient/QueryMerchantStatistics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryMerchantStatistics(_response);
        });
    }

    protected processQueryMerchantStatistics(response: AxiosResponse): Promise<MerchantStatisticsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MerchantStatisticsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MerchantStatisticsDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantStatisticsDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryMerchantChannelTypeStatistics(body: QueryMerchantChannelTypeStatisticsPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<QueryMerchantChannelTypeStatisticsOutDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MerchantClient/QueryMerchantChannelTypeStatistics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryMerchantChannelTypeStatistics(_response);
        });
    }

    protected processQueryMerchantChannelTypeStatistics(response: AxiosResponse): Promise<QueryMerchantChannelTypeStatisticsOutDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QueryMerchantChannelTypeStatisticsOutDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<QueryMerchantChannelTypeStatisticsOutDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryMerchantChannelTypeStatisticsOutDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getMyInfo(  cancelToken?: CancelToken | undefined): Promise<MerchantInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/MerchantClient/GetMyInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyInfo(_response);
        });
    }

    protected processGetMyInfo(response: AxiosResponse): Promise<MerchantInfoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MerchantInfoDto.fromJS(resultData200);
            return Promise.resolve<MerchantInfoDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantInfoDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordDto | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MerchantClient/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLoginWhiteList(body: MerchantLoginWhiteListDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MerchantClient/ChangeLoginWhiteList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeLoginWhiteList(_response);
        });
    }

    protected processChangeLoginWhiteList(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    queryModelLoginWhiteList(  cancelToken?: CancelToken | undefined): Promise<MerchantLoginWhiteListDto> {
        let url_ = this.baseUrl + "/api/services/app/MerchantClient/QueryModelLoginWhiteList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelLoginWhiteList(_response);
        });
    }

    protected processQueryModelLoginWhiteList(response: AxiosResponse): Promise<MerchantLoginWhiteListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MerchantLoginWhiteListDto.fromJS(resultData200);
            return Promise.resolve<MerchantLoginWhiteListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantLoginWhiteListDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePayPwd(body: ChangePasswordDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MerchantClient/ChangePayPwd";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangePayPwd(_response);
        });
    }

    protected processChangePayPwd(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryAllTypes(body: ChannelTypePageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<ChannelTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MerchantClient/QueryAllTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryAllTypes(_response);
        });
    }

    protected processQueryAllTypes(response: AxiosResponse): Promise<ChannelTypeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChannelTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ChannelTypeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChannelTypeDto[]>(null as any);
    }

    /**
     * @return Success
     */
    queryChannelTypes(  cancelToken?: CancelToken | undefined): Promise<MerchantChannelTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MerchantClient/QueryChannelTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryChannelTypes(_response);
        });
    }

    protected processQueryChannelTypes(response: AxiosResponse): Promise<MerchantChannelTypeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MerchantChannelTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MerchantChannelTypeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantChannelTypeDto[]>(null as any);
    }
}

export class MerchantConcurrentStatisticsServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    statisticsMerchantConCurrentList(body: MerchantConCurrentPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<MerchantConCurrentOutDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MerchantConcurrentStatistics/StatisticsMerchantConCurrentList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStatisticsMerchantConCurrentList(_response);
        });
    }

    protected processStatisticsMerchantConCurrentList(response: AxiosResponse): Promise<MerchantConCurrentOutDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MerchantConCurrentOutDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MerchantConCurrentOutDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantConCurrentOutDto[]>(null as any);
    }
}

export class MerchantDayBillServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    export(body: MerchantDayBillPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MerchantDayBill/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: MerchantDayBillPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<MerchantDayBillDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MerchantDayBill/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<MerchantDayBillDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MerchantDayBillDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<MerchantDayBillDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantDayBillDtoPagedResultDto>(null as any);
    }
}

export class MerchantDayClearServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: MerchantDayClearPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<MerchantDayClearDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MerchantDayClear/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<MerchantDayClearDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MerchantDayClearDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<MerchantDayClearDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantDayClearDtoPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    generateSettlement(  cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MerchantDayClear/GenerateSettlement";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateSettlement(_response);
        });
    }

    protected processGenerateSettlement(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    settlement(  cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MerchantDayClear/Settlement";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSettlement(_response);
        });
    }

    protected processSettlement(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class MerchantOrderServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: PayOrderPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<MerchantOrderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MerchantOrder/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<MerchantOrderDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MerchantOrderDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<MerchantOrderDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantOrderDtoPagedResultDto>(null as any);
    }
}

export class MerchantPayOrderServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: PayOrderPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<MerchantPayOrderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MerchantPayOrder/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<MerchantPayOrderDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MerchantPayOrderDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<MerchantPayOrderDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantPayOrderDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryMerchantOrderTotal(body: PayOrderPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<QueryMerchantOrderTotalOutDto> {
        let url_ = this.baseUrl + "/api/services/app/MerchantPayOrder/QueryMerchantOrderTotal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryMerchantOrderTotal(_response);
        });
    }

    protected processQueryMerchantOrderTotal(response: AxiosResponse): Promise<QueryMerchantOrderTotalOutDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryMerchantOrderTotalOutDto.fromJS(resultData200);
            return Promise.resolve<QueryMerchantOrderTotalOutDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryMerchantOrderTotalOutDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    export(body: PayOrderPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MerchantPayOrder/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class MerchantRevAccountServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: MerchantRevAccountPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<MerchantRevAccountDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MerchantRevAccount/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<MerchantRevAccountDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MerchantRevAccountDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<MerchantRevAccountDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantRevAccountDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    queryModel(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<MerchantRevAccountDto> {
        let url_ = this.baseUrl + "/api/services/app/MerchantRevAccount/QueryModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModel(_response);
        });
    }

    protected processQueryModel(response: AxiosResponse): Promise<MerchantRevAccountDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MerchantRevAccountDto.fromJS(resultData200);
            return Promise.resolve<MerchantRevAccountDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantRevAccountDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: MerchantRevAccountDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MerchantRevAccount/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param idList (optional) 
     * @return Success
     */
    deletes(idList: number[] | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MerchantRevAccount/Deletes?";
        if (idList === null)
            throw new Error("The parameter 'idList' cannot be null.");
        else if (idList !== undefined)
            idList && idList.forEach(item => { url_ += "IdList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletes(_response);
        });
    }

    protected processDeletes(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class MerchantWithdrawOrderServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: MerchantWithdrawOrderPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<MerchantWithdrawOrderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MerchantWithdrawOrder/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<MerchantWithdrawOrderDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MerchantWithdrawOrderDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<MerchantWithdrawOrderDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MerchantWithdrawOrderDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approvd(body: IdsDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MerchantWithdrawOrder/Approvd";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApprovd(_response);
        });
    }

    protected processApprovd(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param reason (optional) 
     * @param body (optional) 
     * @return Success
     */
    notApprovd(reason: string | undefined, body: IdsDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MerchantWithdrawOrder/NotApprovd?";
        if (reason === null)
            throw new Error("The parameter 'reason' cannot be null.");
        else if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNotApprovd(_response);
        });
    }

    protected processNotApprovd(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    applyWithdraw(body: ApplyWithdrawInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MerchantWithdrawOrder/ApplyWithdraw";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApplyWithdraw(_response);
        });
    }

    protected processApplyWithdraw(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    ruJinAndChuJinUsdt(body: RuJinAndChuJinUsdtDto | undefined , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/services/app/MerchantWithdrawOrder/RuJinAndChuJinUsdt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRuJinAndChuJinUsdt(_response);
        });
    }

    protected processRuJinAndChuJinUsdt(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class OperatorLogServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: OperatorLogQueryInput | undefined , cancelToken?: CancelToken | undefined): Promise<OperatorLogOutDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OperatorLog/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<OperatorLogOutDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OperatorLogOutDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OperatorLogOutDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperatorLogOutDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryPageList(body: OperatorLogPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<OperatorLogOutDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/OperatorLog/QueryPageList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryPageList(_response);
        });
    }

    protected processQueryPageList(response: AxiosResponse): Promise<OperatorLogOutDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OperatorLogOutDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<OperatorLogOutDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperatorLogOutDtoPagedResultDto>(null as any);
    }
}

export class PayOrderServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    export(body: PayOrderPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/PayOrder/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: PayOrderPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<PayOrderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PayOrder/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<PayOrderDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PayOrderDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<PayOrderDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayOrderDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryPageList(body: PayOrderPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<PayOrderPageOutDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PayOrder/QueryPageList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryPageList(_response);
        });
    }

    protected processQueryPageList(response: AxiosResponse): Promise<PayOrderPageOutDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PayOrderPageOutDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<PayOrderPageOutDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayOrderPageOutDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    queryModel(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<PayOrderDto> {
        let url_ = this.baseUrl + "/api/services/app/PayOrder/QueryModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModel(_response);
        });
    }

    protected processQueryModel(response: AxiosResponse): Promise<PayOrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PayOrderDto.fromJS(resultData200);
            return Promise.resolve<PayOrderDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayOrderDto>(null as any);
    }

    /**
     * @param payorderid (optional) 
     * @param money (optional) 
     * @return Success
     */
    updateOrderMoney(payorderid: number | undefined, money: number | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/PayOrder/UpdateOrderMoney?";
        if (payorderid === null)
            throw new Error("The parameter 'payorderid' cannot be null.");
        else if (payorderid !== undefined)
            url_ += "payorderid=" + encodeURIComponent("" + payorderid) + "&";
        if (money === null)
            throw new Error("The parameter 'money' cannot be null.");
        else if (money !== undefined)
            url_ += "money=" + encodeURIComponent("" + money) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateOrderMoney(_response);
        });
    }

    protected processUpdateOrderMoney(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrder(body: CreatePayOrderInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<OrderSubmitPlatOutDto> {
        let url_ = this.baseUrl + "/api/services/app/PayOrder/CreateOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrder(_response);
        });
    }

    protected processCreateOrder(response: AxiosResponse): Promise<OrderSubmitPlatOutDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderSubmitPlatOutDto.fromJS(resultData200);
            return Promise.resolve<OrderSubmitPlatOutDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderSubmitPlatOutDto>(null as any);
    }

    /**
     * @param googlecode (optional) 
     * @param body (optional) 
     * @return Success
     */
    batchOrderSuccess(googlecode: string | undefined, body: IdsDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/PayOrder/BatchOrderSuccess?";
        if (googlecode === null)
            throw new Error("The parameter 'googlecode' cannot be null.");
        else if (googlecode !== undefined)
            url_ += "googlecode=" + encodeURIComponent("" + googlecode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchOrderSuccess(_response);
        });
    }

    protected processBatchOrderSuccess(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @param comment (optional) 
     * @return Success
     */
    setComment(id: number | undefined, comment: string | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/PayOrder/SetComment?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (comment === null)
            throw new Error("The parameter 'comment' cannot be null.");
        else if (comment !== undefined)
            url_ += "comment=" + encodeURIComponent("" + comment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetComment(_response);
        });
    }

    protected processSetComment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param googlecode (optional) 
     * @param body (optional) 
     * @return Success
     */
    chongZheng(googlecode: string | undefined, body: IdsDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/PayOrder/ChongZheng?";
        if (googlecode === null)
            throw new Error("The parameter 'googlecode' cannot be null.");
        else if (googlecode !== undefined)
            url_ += "googlecode=" + encodeURIComponent("" + googlecode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChongZheng(_response);
        });
    }

    protected processChongZheng(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    querySuccessTotal(  cancelToken?: CancelToken | undefined): Promise<QuerySuccessTotalOutDto> {
        let url_ = this.baseUrl + "/api/services/app/PayOrder/QuerySuccessTotal";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuerySuccessTotal(_response);
        });
    }

    protected processQuerySuccessTotal(response: AxiosResponse): Promise<QuerySuccessTotalOutDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuerySuccessTotalOutDto.fromJS(resultData200);
            return Promise.resolve<QuerySuccessTotalOutDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuerySuccessTotalOutDto>(null as any);
    }

    /**
     * @return Success
     */
    queryHomeTotal(  cancelToken?: CancelToken | undefined): Promise<QueryHomeTotalOutDto> {
        let url_ = this.baseUrl + "/api/services/app/PayOrder/QueryHomeTotal";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryHomeTotal(_response);
        });
    }

    protected processQueryHomeTotal(response: AxiosResponse): Promise<QueryHomeTotalOutDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryHomeTotalOutDto.fromJS(resultData200);
            return Promise.resolve<QueryHomeTotalOutDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryHomeTotalOutDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    orderNotice(body: IdsDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/PayOrder/OrderNotice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrderNotice(_response);
        });
    }

    protected processOrderNotice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PayUnusalOrderServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryPageList(body: PayUnusalOrderPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<PayUnusalOrderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PayUnusalOrder/QueryPageList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryPageList(_response);
        });
    }

    protected processQueryPageList(response: AxiosResponse): Promise<PayUnusalOrderDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PayUnusalOrderDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<PayUnusalOrderDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayUnusalOrderDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    queryModel(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<PayUnusalOrderDto> {
        let url_ = this.baseUrl + "/api/services/app/PayUnusalOrder/QueryModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModel(_response);
        });
    }

    protected processQueryModel(response: AxiosResponse): Promise<PayUnusalOrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PayUnusalOrderDto.fromJS(resultData200);
            return Promise.resolve<PayUnusalOrderDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayUnusalOrderDto>(null as any);
    }
}

export class RealBalanceLogServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    export(body: RealBalanceLogPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/RealBalanceLog/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: RealBalanceLogPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<RealBalanceLogDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/RealBalanceLog/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<RealBalanceLogDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RealBalanceLogDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<RealBalanceLogDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RealBalanceLogDtoPagedResultDto>(null as any);
    }
}

export class RoleServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateRoleDto | undefined , cancelToken?: CancelToken | undefined): Promise<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<RoleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleDto.fromJS(resultData200);
            return Promise.resolve<RoleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDto>(null as any);
    }

    /**
     * @param permission (optional) 
     * @return Success
     */
    getRoles(permission: string | undefined , cancelToken?: CancelToken | undefined): Promise<RoleListDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (permission === null)
            throw new Error("The parameter 'permission' cannot be null.");
        else if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRoles(_response);
        });
    }

    protected processGetRoles(response: AxiosResponse): Promise<RoleListDtoListResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleListDtoListResultDto.fromJS(resultData200);
            return Promise.resolve<RoleListDtoListResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleListDtoListResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: RoleDto | undefined , cancelToken?: CancelToken | undefined): Promise<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<RoleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleDto.fromJS(resultData200);
            return Promise.resolve<RoleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getAllPermissions(  cancelToken?: CancelToken | undefined): Promise<PermissionDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllPermissions(_response);
        });
    }

    protected processGetAllPermissions(response: AxiosResponse): Promise<PermissionDtoListResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PermissionDtoListResultDto.fromJS(resultData200);
            return Promise.resolve<PermissionDtoListResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PermissionDtoListResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRoleForEdit(_response);
        });
    }

    protected processGetRoleForEdit(response: AxiosResponse): Promise<GetRoleForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetRoleForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRoleForEditOutput>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<RoleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleDto.fromJS(resultData200);
            return Promise.resolve<RoleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<RoleDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<RoleDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<RoleDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDtoPagedResultDto>(null as any);
    }
}

export class SessionServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(  cancelToken?: CancelToken | undefined): Promise<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentLoginInformations(_response);
        });
    }

    protected processGetCurrentLoginInformations(response: AxiosResponse): Promise<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return Promise.resolve<GetCurrentLoginInformationsOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCurrentLoginInformationsOutput>(null as any);
    }
}

export class StorageQueryProductChannelServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param idList (optional) 
     * @return Success
     */
    deletes(idList: number[] | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/StorageQueryProductChannel/Deletes?";
        if (idList === null)
            throw new Error("The parameter 'idList' cannot be null.");
        else if (idList !== undefined)
            idList && idList.forEach(item => { url_ += "IdList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletes(_response);
        });
    }

    protected processDeletes(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: StorageQueryProductChannelPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<StorageQueryProductChannelDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/StorageQueryProductChannel/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<StorageQueryProductChannelDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StorageQueryProductChannelDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<StorageQueryProductChannelDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StorageQueryProductChannelDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    queryModel(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<StorageQueryProductChannelDto> {
        let url_ = this.baseUrl + "/api/services/app/StorageQueryProductChannel/QueryModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModel(_response);
        });
    }

    protected processQueryModel(response: AxiosResponse): Promise<StorageQueryProductChannelDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StorageQueryProductChannelDto.fromJS(resultData200);
            return Promise.resolve<StorageQueryProductChannelDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StorageQueryProductChannelDto>(null as any);
    }

    /**
     * @return Success
     */
    queryAllList(  cancelToken?: CancelToken | undefined): Promise<StorageQueryProductChannelDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StorageQueryProductChannel/QueryAllList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryAllList(_response);
        });
    }

    protected processQueryAllList(response: AxiosResponse): Promise<StorageQueryProductChannelDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StorageQueryProductChannelDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StorageQueryProductChannelDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StorageQueryProductChannelDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: StorageQueryProductChannelDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/StorageQueryProductChannel/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SystemBalanceLogServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: SystemBalanceLogPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<SystemBalanceLogDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/SystemBalanceLog/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<SystemBalanceLogDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SystemBalanceLogDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<SystemBalanceLogDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SystemBalanceLogDtoPagedResultDto>(null as any);
    }
}

export class SystemSettingServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    save(body: SystemSettingDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/SystemSetting/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    clearCache(  cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/SystemSetting/ClearCache";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClearCache(_response);
        });
    }

    protected processClearCache(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    queryModel(  cancelToken?: CancelToken | undefined): Promise<SystemSettingDto> {
        let url_ = this.baseUrl + "/api/services/app/SystemSetting/QueryModel";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModel(_response);
        });
    }

    protected processQueryModel(response: AxiosResponse): Promise<SystemSettingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SystemSettingDto.fromJS(resultData200);
            return Promise.resolve<SystemSettingDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SystemSettingDto>(null as any);
    }
}

export class TelegramGroupServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: TelegramGroupPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<TelegramGroupDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TelegramGroup/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<TelegramGroupDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TelegramGroupDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<TelegramGroupDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TelegramGroupDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: TelegramGroupDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TelegramGroup/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TelegramSearchOrderServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: TelegramSearchOrderPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<TelegramSearchOrderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TelegramSearchOrder/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<TelegramSearchOrderDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TelegramSearchOrderDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<TelegramSearchOrderDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TelegramSearchOrderDtoPagedResultDto>(null as any);
    }
}

export class TelegramSettingServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    save(body: TelegramSettingDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TelegramSetting/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    queryModel(  cancelToken?: CancelToken | undefined): Promise<TelegramSettingDto> {
        let url_ = this.baseUrl + "/api/services/app/TelegramSetting/QueryModel";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModel(_response);
        });
    }

    protected processQueryModel(response: AxiosResponse): Promise<TelegramSettingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TelegramSettingDto.fromJS(resultData200);
            return Promise.resolve<TelegramSettingDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TelegramSettingDto>(null as any);
    }
}

export class TenantServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTenantDto | undefined , cancelToken?: CancelToken | undefined): Promise<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<TenantDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TenantDto.fromJS(resultData200);
            return Promise.resolve<TenantDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<TenantDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TenantDto.fromJS(resultData200);
            return Promise.resolve<TenantDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<TenantDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<TenantDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TenantDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<TenantDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: TenantDto | undefined , cancelToken?: CancelToken | undefined): Promise<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<TenantDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TenantDto.fromJS(resultData200);
            return Promise.resolve<TenantDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantDto>(null as any);
    }
}

export class TokenAuthServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticate(body: AuthenticateModel | undefined , cancelToken?: CancelToken | undefined): Promise<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthenticate(_response);
        });
    }

    protected processAuthenticate(response: AxiosResponse): Promise<AuthenticateResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return Promise.resolve<AuthenticateResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticateResultModel>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    qieHuanMerchantLogin(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/QieHuanMerchantLogin?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQieHuanMerchantLogin(_response);
        });
    }

    protected processQieHuanMerchantLogin(response: AxiosResponse): Promise<AuthenticateResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return Promise.resolve<AuthenticateResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticateResultModel>(null as any);
    }

    /**
     * @return Success
     */
    generateCode(  cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/TokenAuth/GenerateCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateCode(_response);
        });
    }

    protected processGenerateCode(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Success
     */
    phoneGetAll(  cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/PhoneGetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPhoneGetAll(_response);
        });
    }

    protected processPhoneGetAll(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UsdtTransactionServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: UsdtTransactionPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<UsdtTransactionDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/UsdtTransaction/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<UsdtTransactionDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UsdtTransactionDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<UsdtTransactionDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UsdtTransactionDtoPagedResultDto>(null as any);
    }
}

export class UserServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDto.fromJS(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserDto | undefined , cancelToken?: CancelToken | undefined): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDto.fromJS(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UserDto | undefined , cancelToken?: CancelToken | undefined): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDto.fromJS(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, from: Date | undefined, to: Date | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<UserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<UserDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<UserDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activate(body: Int64EntityDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivate(_response);
        });
    }

    protected processActivate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deActivate(body: Int64EntityDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/User/DeActivate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeActivate(_response);
        });
    }

    protected processDeActivate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getRoles(  cancelToken?: CancelToken | undefined): Promise<RoleDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRoles(_response);
        });
    }

    protected processGetRoles(response: AxiosResponse): Promise<RoleDtoListResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleDtoListResultDto.fromJS(resultData200);
            return Promise.resolve<RoleDtoListResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDtoListResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeLanguage(_response);
        });
    }

    protected processChangeLanguage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordDto | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordDto | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class UserManageServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param userid (optional) 
     * @return Success
     */
    resetLoginPwd(userid: number | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/UserManage/ResetLoginPwd?";
        if (userid === null)
            throw new Error("The parameter 'userid' cannot be null.");
        else if (userid !== undefined)
            url_ += "userid=" + encodeURIComponent("" + userid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetLoginPwd(_response);
        });
    }

    protected processResetLoginPwd(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    unlockUser(userId: number | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/UserManage/UnlockUser?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnlockUser(_response);
        });
    }

    protected processUnlockUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param userid (optional) 
     * @return Success
     */
    clearGoogleKey(userid: number | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/UserManage/ClearGoogleKey?";
        if (userid === null)
            throw new Error("The parameter 'userid' cannot be null.");
        else if (userid !== undefined)
            url_ += "userid=" + encodeURIComponent("" + userid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClearGoogleKey(_response);
        });
    }

    protected processClearGoogleKey(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    queryMyUser(  cancelToken?: CancelToken | undefined): Promise<UserInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/UserManage/QueryMyUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryMyUser(_response);
        });
    }

    protected processQueryMyUser(response: AxiosResponse): Promise<UserInfoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserInfoDto.fromJS(resultData200);
            return Promise.resolve<UserInfoDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserInfoDto>(null as any);
    }
}

export class WarehousingProductServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param idList (optional) 
     * @return Success
     */
    deletes(idList: number[] | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/WarehousingProduct/Deletes?";
        if (idList === null)
            throw new Error("The parameter 'idList' cannot be null.");
        else if (idList !== undefined)
            idList && idList.forEach(item => { url_ += "IdList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletes(_response);
        });
    }

    protected processDeletes(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryModelList(body: WarehousingProductPageInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<WarehousingProductDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/WarehousingProduct/QueryModelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModelList(_response);
        });
    }

    protected processQueryModelList(response: AxiosResponse): Promise<WarehousingProductDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WarehousingProductDtoPagedResultDto.fromJS(resultData200);
            return Promise.resolve<WarehousingProductDtoPagedResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WarehousingProductDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    queryModel(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<WarehousingProductDto> {
        let url_ = this.baseUrl + "/api/services/app/WarehousingProduct/QueryModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryModel(_response);
        });
    }

    protected processQueryModel(response: AxiosResponse): Promise<WarehousingProductDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WarehousingProductDto.fromJS(resultData200);
            return Promise.resolve<WarehousingProductDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WarehousingProductDto>(null as any);
    }

    /**
     * @return Success
     */
    queryAllList(  cancelToken?: CancelToken | undefined): Promise<WarehousingProductDto[]> {
        let url_ = this.baseUrl + "/api/services/app/WarehousingProduct/QueryAllList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryAllList(_response);
        });
    }

    protected processQueryAllList(response: AxiosResponse): Promise<WarehousingProductDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WarehousingProductDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<WarehousingProductDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WarehousingProductDto[]>(null as any);
    }
}

export class AdvanceMoneyAdjustOrderDto implements IAdvanceMoneyAdjustOrderDto {
    id!: number;
    orderNo!: string | undefined;
    merchantId!: number | undefined;
    mid!: string | undefined;
    merchantName!: string | undefined;
    money!: number;
    balance!: number;
    afterBalance!: number;
    createUserName!: string | undefined;
    creationTime!: Date;
    comment!: string | undefined;

    constructor(data?: IAdvanceMoneyAdjustOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNo = _data["orderNo"];
            this.merchantId = _data["merchantId"];
            this.mid = _data["mid"];
            this.merchantName = _data["merchantName"];
            this.money = _data["money"];
            this.balance = _data["balance"];
            this.afterBalance = _data["afterBalance"];
            this.createUserName = _data["createUserName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): AdvanceMoneyAdjustOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdvanceMoneyAdjustOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNo"] = this.orderNo;
        data["merchantId"] = this.merchantId;
        data["mid"] = this.mid;
        data["merchantName"] = this.merchantName;
        data["money"] = this.money;
        data["balance"] = this.balance;
        data["afterBalance"] = this.afterBalance;
        data["createUserName"] = this.createUserName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        return data;
    }

    clone(): AdvanceMoneyAdjustOrderDto {
        const json = this.toJSON();
        let result = new AdvanceMoneyAdjustOrderDto();
        result.init(json);
        return result;
    }
}

export interface IAdvanceMoneyAdjustOrderDto {
    id: number;
    orderNo: string | undefined;
    merchantId: number | undefined;
    mid: string | undefined;
    merchantName: string | undefined;
    money: number;
    balance: number;
    afterBalance: number;
    createUserName: string | undefined;
    creationTime: Date;
    comment: string | undefined;
}

export class AdvanceMoneyAdjustOrderDtoPagedResultDto implements IAdvanceMoneyAdjustOrderDtoPagedResultDto {
    items!: AdvanceMoneyAdjustOrderDto[] | undefined;
    totalCount!: number;

    constructor(data?: IAdvanceMoneyAdjustOrderDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AdvanceMoneyAdjustOrderDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AdvanceMoneyAdjustOrderDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdvanceMoneyAdjustOrderDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AdvanceMoneyAdjustOrderDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AdvanceMoneyAdjustOrderDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAdvanceMoneyAdjustOrderDtoPagedResultDto {
    items: AdvanceMoneyAdjustOrderDto[] | undefined;
    totalCount: number;
}

export class AdvanceMoneyAdjustOrderPageInputDto implements IAdvanceMoneyAdjustOrderPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    orderNo!: string | undefined;
    merchantId!: number | undefined;
    mid!: string | undefined;
    merchantName!: string | undefined;
    createStartTime!: Date | undefined;
    createEndTime!: Date | undefined;

    constructor(data?: IAdvanceMoneyAdjustOrderPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.orderNo = _data["orderNo"];
            this.merchantId = _data["merchantId"];
            this.mid = _data["mid"];
            this.merchantName = _data["merchantName"];
            this.createStartTime = _data["createStartTime"] ? new Date(_data["createStartTime"].toString()) : <any>undefined;
            this.createEndTime = _data["createEndTime"] ? new Date(_data["createEndTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AdvanceMoneyAdjustOrderPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdvanceMoneyAdjustOrderPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["orderNo"] = this.orderNo;
        data["merchantId"] = this.merchantId;
        data["mid"] = this.mid;
        data["merchantName"] = this.merchantName;
        data["createStartTime"] = this.createStartTime ? this.createStartTime.toISOString() : <any>undefined;
        data["createEndTime"] = this.createEndTime ? this.createEndTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): AdvanceMoneyAdjustOrderPageInputDto {
        const json = this.toJSON();
        let result = new AdvanceMoneyAdjustOrderPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IAdvanceMoneyAdjustOrderPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    orderNo: string | undefined;
    merchantId: number | undefined;
    mid: string | undefined;
    merchantName: string | undefined;
    createStartTime: Date | undefined;
    createEndTime: Date | undefined;
}

export class AgentBalanceAdjustOrderDto implements IAgentBalanceAdjustOrderDto {
    id!: number;
    orderNo!: string | undefined;
    agentId!: number | undefined;
    agentName!: string | undefined;
    money!: number;
    balance!: number;
    afterBalance!: number;
    createUserName!: string | undefined;
    creationTime!: Date;
    comment!: string | undefined;

    constructor(data?: IAgentBalanceAdjustOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNo = _data["orderNo"];
            this.agentId = _data["agentId"];
            this.agentName = _data["agentName"];
            this.money = _data["money"];
            this.balance = _data["balance"];
            this.afterBalance = _data["afterBalance"];
            this.createUserName = _data["createUserName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): AgentBalanceAdjustOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentBalanceAdjustOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNo"] = this.orderNo;
        data["agentId"] = this.agentId;
        data["agentName"] = this.agentName;
        data["money"] = this.money;
        data["balance"] = this.balance;
        data["afterBalance"] = this.afterBalance;
        data["createUserName"] = this.createUserName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        return data;
    }

    clone(): AgentBalanceAdjustOrderDto {
        const json = this.toJSON();
        let result = new AgentBalanceAdjustOrderDto();
        result.init(json);
        return result;
    }
}

export interface IAgentBalanceAdjustOrderDto {
    id: number;
    orderNo: string | undefined;
    agentId: number | undefined;
    agentName: string | undefined;
    money: number;
    balance: number;
    afterBalance: number;
    createUserName: string | undefined;
    creationTime: Date;
    comment: string | undefined;
}

export class AgentBalanceAdjustOrderDtoPagedResultDto implements IAgentBalanceAdjustOrderDtoPagedResultDto {
    items!: AgentBalanceAdjustOrderDto[] | undefined;
    totalCount!: number;

    constructor(data?: IAgentBalanceAdjustOrderDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AgentBalanceAdjustOrderDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AgentBalanceAdjustOrderDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentBalanceAdjustOrderDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AgentBalanceAdjustOrderDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AgentBalanceAdjustOrderDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAgentBalanceAdjustOrderDtoPagedResultDto {
    items: AgentBalanceAdjustOrderDto[] | undefined;
    totalCount: number;
}

export class AgentBalanceAdjustOrderPageInputDto implements IAgentBalanceAdjustOrderPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    orderNo!: string | undefined;
    agentId!: number | undefined;
    agentName!: string | undefined;
    createStartTime!: Date | undefined;
    createEndTime!: Date | undefined;

    constructor(data?: IAgentBalanceAdjustOrderPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.orderNo = _data["orderNo"];
            this.agentId = _data["agentId"];
            this.agentName = _data["agentName"];
            this.createStartTime = _data["createStartTime"] ? new Date(_data["createStartTime"].toString()) : <any>undefined;
            this.createEndTime = _data["createEndTime"] ? new Date(_data["createEndTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AgentBalanceAdjustOrderPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentBalanceAdjustOrderPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["orderNo"] = this.orderNo;
        data["agentId"] = this.agentId;
        data["agentName"] = this.agentName;
        data["createStartTime"] = this.createStartTime ? this.createStartTime.toISOString() : <any>undefined;
        data["createEndTime"] = this.createEndTime ? this.createEndTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): AgentBalanceAdjustOrderPageInputDto {
        const json = this.toJSON();
        let result = new AgentBalanceAdjustOrderPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IAgentBalanceAdjustOrderPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    orderNo: string | undefined;
    agentId: number | undefined;
    agentName: string | undefined;
    createStartTime: Date | undefined;
    createEndTime: Date | undefined;
}

export class AgentBalanceLogDto implements IAgentBalanceLogDto {
    id!: number;
    serialNumber!: string | undefined;
    agentId!: number | undefined;
    agentName!: string | undefined;
    money!: number;
    balance!: number;
    afterBalance!: number;
    tid!: string | undefined;
    tradeId!: number | undefined;
    balanceType!: AgentBalanceLogTypeEnum;
    readonly balanceTypeName!: string | undefined;
    creationTime!: Date;
    comment!: string | undefined;

    constructor(data?: IAgentBalanceLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serialNumber = _data["serialNumber"];
            this.agentId = _data["agentId"];
            this.agentName = _data["agentName"];
            this.money = _data["money"];
            this.balance = _data["balance"];
            this.afterBalance = _data["afterBalance"];
            this.tid = _data["tid"];
            this.tradeId = _data["tradeId"];
            this.balanceType = _data["balanceType"];
            (<any>this).balanceTypeName = _data["balanceTypeName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): AgentBalanceLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentBalanceLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serialNumber"] = this.serialNumber;
        data["agentId"] = this.agentId;
        data["agentName"] = this.agentName;
        data["money"] = this.money;
        data["balance"] = this.balance;
        data["afterBalance"] = this.afterBalance;
        data["tid"] = this.tid;
        data["tradeId"] = this.tradeId;
        data["balanceType"] = this.balanceType;
        data["balanceTypeName"] = this.balanceTypeName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        return data;
    }

    clone(): AgentBalanceLogDto {
        const json = this.toJSON();
        let result = new AgentBalanceLogDto();
        result.init(json);
        return result;
    }
}

export interface IAgentBalanceLogDto {
    id: number;
    serialNumber: string | undefined;
    agentId: number | undefined;
    agentName: string | undefined;
    money: number;
    balance: number;
    afterBalance: number;
    tid: string | undefined;
    tradeId: number | undefined;
    balanceType: AgentBalanceLogTypeEnum;
    balanceTypeName: string | undefined;
    creationTime: Date;
    comment: string | undefined;
}

export class AgentBalanceLogDtoPagedResultDto implements IAgentBalanceLogDtoPagedResultDto {
    items!: AgentBalanceLogDto[] | undefined;
    totalCount!: number;

    constructor(data?: IAgentBalanceLogDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AgentBalanceLogDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AgentBalanceLogDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentBalanceLogDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AgentBalanceLogDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AgentBalanceLogDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAgentBalanceLogDtoPagedResultDto {
    items: AgentBalanceLogDto[] | undefined;
    totalCount: number;
}

export class AgentBalanceLogPageInputDto implements IAgentBalanceLogPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    serialNumber!: string | undefined;
    agentId!: number | undefined;
    agentName!: string | undefined;
    tid!: string | undefined;
    createStartTime!: Date | undefined;
    createEndTime!: Date | undefined;
    balanceType!: AgentBalanceLogTypeEnum;

    constructor(data?: IAgentBalanceLogPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.serialNumber = _data["serialNumber"];
            this.agentId = _data["agentId"];
            this.agentName = _data["agentName"];
            this.tid = _data["tid"];
            this.createStartTime = _data["createStartTime"] ? new Date(_data["createStartTime"].toString()) : <any>undefined;
            this.createEndTime = _data["createEndTime"] ? new Date(_data["createEndTime"].toString()) : <any>undefined;
            this.balanceType = _data["balanceType"];
        }
    }

    static fromJS(data: any): AgentBalanceLogPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentBalanceLogPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["serialNumber"] = this.serialNumber;
        data["agentId"] = this.agentId;
        data["agentName"] = this.agentName;
        data["tid"] = this.tid;
        data["createStartTime"] = this.createStartTime ? this.createStartTime.toISOString() : <any>undefined;
        data["createEndTime"] = this.createEndTime ? this.createEndTime.toISOString() : <any>undefined;
        data["balanceType"] = this.balanceType;
        return data;
    }

    clone(): AgentBalanceLogPageInputDto {
        const json = this.toJSON();
        let result = new AgentBalanceLogPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IAgentBalanceLogPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    serialNumber: string | undefined;
    agentId: number | undefined;
    agentName: string | undefined;
    tid: string | undefined;
    createStartTime: Date | undefined;
    createEndTime: Date | undefined;
    balanceType: AgentBalanceLogTypeEnum;
}

export enum AgentBalanceLogTypeEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class AgentChannelDto implements IAgentChannelDto {
    id!: number;
    name!: string | undefined;
    botId!: string | undefined;
    agentId!: number | undefined;
    agentName!: string | undefined;
    status!: StatusEnum;
    agentRate!: number;
    createOrderUrl!: string | undefined;
    queryOrderUrl!: string | undefined;
    creationTime!: Date;
    channelFlag!: string | undefined;
    channelSupplierName!: string | undefined;
    channelSupplierId!: number | undefined;
    channelTypes!: ChannelTypeSimpleDto[] | undefined;
    csort!: string | undefined;

    constructor(data?: IAgentChannelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.botId = _data["botId"];
            this.agentId = _data["agentId"];
            this.agentName = _data["agentName"];
            this.status = _data["status"];
            this.agentRate = _data["agentRate"];
            this.createOrderUrl = _data["createOrderUrl"];
            this.queryOrderUrl = _data["queryOrderUrl"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.channelFlag = _data["channelFlag"];
            this.channelSupplierName = _data["channelSupplierName"];
            this.channelSupplierId = _data["channelSupplierId"];
            if (Array.isArray(_data["channelTypes"])) {
                this.channelTypes = [] as any;
                for (let item of _data["channelTypes"])
                    this.channelTypes!.push(ChannelTypeSimpleDto.fromJS(item));
            }
            this.csort = _data["csort"];
        }
    }

    static fromJS(data: any): AgentChannelDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentChannelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["botId"] = this.botId;
        data["agentId"] = this.agentId;
        data["agentName"] = this.agentName;
        data["status"] = this.status;
        data["agentRate"] = this.agentRate;
        data["createOrderUrl"] = this.createOrderUrl;
        data["queryOrderUrl"] = this.queryOrderUrl;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["channelFlag"] = this.channelFlag;
        data["channelSupplierName"] = this.channelSupplierName;
        data["channelSupplierId"] = this.channelSupplierId;
        if (Array.isArray(this.channelTypes)) {
            data["channelTypes"] = [];
            for (let item of this.channelTypes)
                data["channelTypes"].push(item.toJSON());
        }
        data["csort"] = this.csort;
        return data;
    }

    clone(): AgentChannelDto {
        const json = this.toJSON();
        let result = new AgentChannelDto();
        result.init(json);
        return result;
    }
}

export interface IAgentChannelDto {
    id: number;
    name: string | undefined;
    botId: string | undefined;
    agentId: number | undefined;
    agentName: string | undefined;
    status: StatusEnum;
    agentRate: number;
    createOrderUrl: string | undefined;
    queryOrderUrl: string | undefined;
    creationTime: Date;
    channelFlag: string | undefined;
    channelSupplierName: string | undefined;
    channelSupplierId: number | undefined;
    channelTypes: ChannelTypeSimpleDto[] | undefined;
    csort: string | undefined;
}

export class AgentChannelDtoPagedResultDto implements IAgentChannelDtoPagedResultDto {
    items!: AgentChannelDto[] | undefined;
    totalCount!: number;

    constructor(data?: IAgentChannelDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AgentChannelDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AgentChannelDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentChannelDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AgentChannelDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AgentChannelDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAgentChannelDtoPagedResultDto {
    items: AgentChannelDto[] | undefined;
    totalCount: number;
}

export class AgentDto implements IAgentDto {
    id!: number;
    aCode!: string | undefined;
    name!: string | undefined;
    balance!: number;
    withdrawMethod!: number;
    withdrawRate!: number;
    status!: StatusEnum;
    userName!: string | undefined;
    userId!: number | undefined;
    creationTime!: Date;

    constructor(data?: IAgentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.aCode = _data["aCode"];
            this.name = _data["name"];
            this.balance = _data["balance"];
            this.withdrawMethod = _data["withdrawMethod"];
            this.withdrawRate = _data["withdrawRate"];
            this.status = _data["status"];
            this.userName = _data["userName"];
            this.userId = _data["userId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AgentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["aCode"] = this.aCode;
        data["name"] = this.name;
        data["balance"] = this.balance;
        data["withdrawMethod"] = this.withdrawMethod;
        data["withdrawRate"] = this.withdrawRate;
        data["status"] = this.status;
        data["userName"] = this.userName;
        data["userId"] = this.userId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): AgentDto {
        const json = this.toJSON();
        let result = new AgentDto();
        result.init(json);
        return result;
    }
}

export interface IAgentDto {
    id: number;
    aCode: string | undefined;
    name: string | undefined;
    balance: number;
    withdrawMethod: number;
    withdrawRate: number;
    status: StatusEnum;
    userName: string | undefined;
    userId: number | undefined;
    creationTime: Date;
}

export class AgentDtoPagedResultDto implements IAgentDtoPagedResultDto {
    items!: AgentDto[] | undefined;
    totalCount!: number;

    constructor(data?: IAgentDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AgentDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AgentDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AgentDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AgentDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAgentDtoPagedResultDto {
    items: AgentDto[] | undefined;
    totalCount: number;
}

export class AgentInfoDto implements IAgentInfoDto {
    id!: number;
    aCode!: string | undefined;
    name!: string | undefined;
    status!: StatusEnum;
    userName!: string | undefined;
    userId!: number | undefined;
    isUpdateLoginPwd!: boolean;
    balance!: number;

    constructor(data?: IAgentInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.aCode = _data["aCode"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.userName = _data["userName"];
            this.userId = _data["userId"];
            this.isUpdateLoginPwd = _data["isUpdateLoginPwd"];
            this.balance = _data["balance"];
        }
    }

    static fromJS(data: any): AgentInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["aCode"] = this.aCode;
        data["name"] = this.name;
        data["status"] = this.status;
        data["userName"] = this.userName;
        data["userId"] = this.userId;
        data["isUpdateLoginPwd"] = this.isUpdateLoginPwd;
        data["balance"] = this.balance;
        return data;
    }

    clone(): AgentInfoDto {
        const json = this.toJSON();
        let result = new AgentInfoDto();
        result.init(json);
        return result;
    }
}

export interface IAgentInfoDto {
    id: number;
    aCode: string | undefined;
    name: string | undefined;
    status: StatusEnum;
    userName: string | undefined;
    userId: number | undefined;
    isUpdateLoginPwd: boolean;
    balance: number;
}

export class AgentMerchantDto implements IAgentMerchantDto {
    id!: number;
    mid!: string | undefined;
    userName!: string | undefined;
    merchantName!: string | undefined;
    status!: StatusEnum;
    agentId!: number | undefined;
    agentName!: string | undefined;
    creationTime!: Date;

    constructor(data?: IAgentMerchantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mid = _data["mid"];
            this.userName = _data["userName"];
            this.merchantName = _data["merchantName"];
            this.status = _data["status"];
            this.agentId = _data["agentId"];
            this.agentName = _data["agentName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AgentMerchantDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentMerchantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mid"] = this.mid;
        data["userName"] = this.userName;
        data["merchantName"] = this.merchantName;
        data["status"] = this.status;
        data["agentId"] = this.agentId;
        data["agentName"] = this.agentName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): AgentMerchantDto {
        const json = this.toJSON();
        let result = new AgentMerchantDto();
        result.init(json);
        return result;
    }
}

export interface IAgentMerchantDto {
    id: number;
    mid: string | undefined;
    userName: string | undefined;
    merchantName: string | undefined;
    status: StatusEnum;
    agentId: number | undefined;
    agentName: string | undefined;
    creationTime: Date;
}

export class AgentMerchantDtoPagedResultDto implements IAgentMerchantDtoPagedResultDto {
    items!: AgentMerchantDto[] | undefined;
    totalCount!: number;

    constructor(data?: IAgentMerchantDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AgentMerchantDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AgentMerchantDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentMerchantDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AgentMerchantDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AgentMerchantDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAgentMerchantDtoPagedResultDto {
    items: AgentMerchantDto[] | undefined;
    totalCount: number;
}

export class AgentPageInputDto implements IAgentPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    aCode!: string | undefined;
    name!: string | undefined;
    status!: StatusEnum;
    userName!: string | undefined;

    constructor(data?: IAgentPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.aCode = _data["aCode"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): AgentPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["aCode"] = this.aCode;
        data["name"] = this.name;
        data["status"] = this.status;
        data["userName"] = this.userName;
        return data;
    }

    clone(): AgentPageInputDto {
        const json = this.toJSON();
        let result = new AgentPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IAgentPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    aCode: string | undefined;
    name: string | undefined;
    status: StatusEnum;
    userName: string | undefined;
}

export class AgentStatisticsDayDto implements IAgentStatisticsDayDto {
    id!: number;
    agentId!: number;
    aCode!: string | undefined;
    agentName!: string | undefined;
    successMoney!: number;
    successCount!: number;
    agentMoney!: number;
    statisticsTime!: string | undefined;
    creationTime!: Date;

    constructor(data?: IAgentStatisticsDayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.agentId = _data["agentId"];
            this.aCode = _data["aCode"];
            this.agentName = _data["agentName"];
            this.successMoney = _data["successMoney"];
            this.successCount = _data["successCount"];
            this.agentMoney = _data["agentMoney"];
            this.statisticsTime = _data["statisticsTime"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AgentStatisticsDayDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentStatisticsDayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["agentId"] = this.agentId;
        data["aCode"] = this.aCode;
        data["agentName"] = this.agentName;
        data["successMoney"] = this.successMoney;
        data["successCount"] = this.successCount;
        data["agentMoney"] = this.agentMoney;
        data["statisticsTime"] = this.statisticsTime;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): AgentStatisticsDayDto {
        const json = this.toJSON();
        let result = new AgentStatisticsDayDto();
        result.init(json);
        return result;
    }
}

export interface IAgentStatisticsDayDto {
    id: number;
    agentId: number;
    aCode: string | undefined;
    agentName: string | undefined;
    successMoney: number;
    successCount: number;
    agentMoney: number;
    statisticsTime: string | undefined;
    creationTime: Date;
}

export class AgentStatisticsDayDtoPagedResultDto implements IAgentStatisticsDayDtoPagedResultDto {
    items!: AgentStatisticsDayDto[] | undefined;
    totalCount!: number;

    constructor(data?: IAgentStatisticsDayDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AgentStatisticsDayDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AgentStatisticsDayDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentStatisticsDayDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AgentStatisticsDayDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AgentStatisticsDayDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAgentStatisticsDayDtoPagedResultDto {
    items: AgentStatisticsDayDto[] | undefined;
    totalCount: number;
}

export class AgentStatisticsDayPageInputDto implements IAgentStatisticsDayPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    statisticsTime!: string | undefined;
    agentId!: number | undefined;
    startTime!: Date | undefined;
    endTime!: Date | undefined;

    constructor(data?: IAgentStatisticsDayPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.statisticsTime = _data["statisticsTime"];
            this.agentId = _data["agentId"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AgentStatisticsDayPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentStatisticsDayPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["statisticsTime"] = this.statisticsTime;
        data["agentId"] = this.agentId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): AgentStatisticsDayPageInputDto {
        const json = this.toJSON();
        let result = new AgentStatisticsDayPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IAgentStatisticsDayPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    statisticsTime: string | undefined;
    agentId: number | undefined;
    startTime: Date | undefined;
    endTime: Date | undefined;
}

export class AgentSystemDto implements IAgentSystemDto {
    status!: StatusEnum;
    accountBalance!: number;
    merchantNum!: number;
    channelNum!: number;

    constructor(data?: IAgentSystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.accountBalance = _data["accountBalance"];
            this.merchantNum = _data["merchantNum"];
            this.channelNum = _data["channelNum"];
        }
    }

    static fromJS(data: any): AgentSystemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentSystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["accountBalance"] = this.accountBalance;
        data["merchantNum"] = this.merchantNum;
        data["channelNum"] = this.channelNum;
        return data;
    }

    clone(): AgentSystemDto {
        const json = this.toJSON();
        let result = new AgentSystemDto();
        result.init(json);
        return result;
    }
}

export interface IAgentSystemDto {
    status: StatusEnum;
    accountBalance: number;
    merchantNum: number;
    channelNum: number;
}

export class AgentTotalOutDto implements IAgentTotalOutDto {
    balance!: number;

    constructor(data?: IAgentTotalOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.balance = _data["balance"];
        }
    }

    static fromJS(data: any): AgentTotalOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentTotalOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["balance"] = this.balance;
        return data;
    }

    clone(): AgentTotalOutDto {
        const json = this.toJSON();
        let result = new AgentTotalOutDto();
        result.init(json);
        return result;
    }
}

export interface IAgentTotalOutDto {
    balance: number;
}

export class AllSystemPayOrderDayBillDto implements IAllSystemPayOrderDayBillDto {
    orderNum!: number;
    money!: number;
    payMoney!: number;
    budanNum!: number;
    budanMoney!: number;
    commission!: number;
    channelCommission!: number;
    settlementTimeStr!: string | undefined;
    settlementTime!: Date;
    creationTime!: Date;

    constructor(data?: IAllSystemPayOrderDayBillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderNum = _data["orderNum"];
            this.money = _data["money"];
            this.payMoney = _data["payMoney"];
            this.budanNum = _data["budanNum"];
            this.budanMoney = _data["budanMoney"];
            this.commission = _data["commission"];
            this.channelCommission = _data["channelCommission"];
            this.settlementTimeStr = _data["settlementTimeStr"];
            this.settlementTime = _data["settlementTime"] ? new Date(_data["settlementTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AllSystemPayOrderDayBillDto {
        data = typeof data === 'object' ? data : {};
        let result = new AllSystemPayOrderDayBillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderNum"] = this.orderNum;
        data["money"] = this.money;
        data["payMoney"] = this.payMoney;
        data["budanNum"] = this.budanNum;
        data["budanMoney"] = this.budanMoney;
        data["commission"] = this.commission;
        data["channelCommission"] = this.channelCommission;
        data["settlementTimeStr"] = this.settlementTimeStr;
        data["settlementTime"] = this.settlementTime ? this.settlementTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): AllSystemPayOrderDayBillDto {
        const json = this.toJSON();
        let result = new AllSystemPayOrderDayBillDto();
        result.init(json);
        return result;
    }
}

export interface IAllSystemPayOrderDayBillDto {
    orderNum: number;
    money: number;
    payMoney: number;
    budanNum: number;
    budanMoney: number;
    commission: number;
    channelCommission: number;
    settlementTimeStr: string | undefined;
    settlementTime: Date;
    creationTime: Date;
}

export class AllSystemPayOrderDayBillDtoPagedResultDto implements IAllSystemPayOrderDayBillDtoPagedResultDto {
    items!: AllSystemPayOrderDayBillDto[] | undefined;
    totalCount!: number;

    constructor(data?: IAllSystemPayOrderDayBillDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AllSystemPayOrderDayBillDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AllSystemPayOrderDayBillDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AllSystemPayOrderDayBillDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AllSystemPayOrderDayBillDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AllSystemPayOrderDayBillDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAllSystemPayOrderDayBillDtoPagedResultDto {
    items: AllSystemPayOrderDayBillDto[] | undefined;
    totalCount: number;
}

export class AllSystemPayOrderDayBillPageInputDto implements IAllSystemPayOrderDayBillPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    createStartTime!: Date | undefined;
    createEndTime!: Date | undefined;

    constructor(data?: IAllSystemPayOrderDayBillPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.createStartTime = _data["createStartTime"] ? new Date(_data["createStartTime"].toString()) : <any>undefined;
            this.createEndTime = _data["createEndTime"] ? new Date(_data["createEndTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AllSystemPayOrderDayBillPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new AllSystemPayOrderDayBillPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["createStartTime"] = this.createStartTime ? this.createStartTime.toISOString() : <any>undefined;
        data["createEndTime"] = this.createEndTime ? this.createEndTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): AllSystemPayOrderDayBillPageInputDto {
        const json = this.toJSON();
        let result = new AllSystemPayOrderDayBillPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IAllSystemPayOrderDayBillPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    createStartTime: Date | undefined;
    createEndTime: Date | undefined;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version!: string | undefined;
    releaseDate!: Date;
    features!: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? new Date(_data["releaseDate"].toString()) : <any>undefined;
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (<any>this.features)![key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (<any>data["features"])[key] = (<any>this.features)[key];
            }
        }
        return data;
    }

    clone(): ApplicationInfoDto {
        const json = this.toJSON();
        let result = new ApplicationInfoDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: Date;
    features: { [key: string]: boolean; } | undefined;
}

export class ApplyWithdrawInputDto implements IApplyWithdrawInputDto {
    money!: number;
    bank!: string | undefined;
    bankNo!: string | undefined;
    bankName!: string | undefined;
    bankZhiHang!: string | undefined;
    bankProvince!: string | undefined;
    payPassword!: string | undefined;

    constructor(data?: IApplyWithdrawInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.money = _data["money"];
            this.bank = _data["bank"];
            this.bankNo = _data["bankNo"];
            this.bankName = _data["bankName"];
            this.bankZhiHang = _data["bankZhiHang"];
            this.bankProvince = _data["bankProvince"];
            this.payPassword = _data["payPassword"];
        }
    }

    static fromJS(data: any): ApplyWithdrawInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplyWithdrawInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["money"] = this.money;
        data["bank"] = this.bank;
        data["bankNo"] = this.bankNo;
        data["bankName"] = this.bankName;
        data["bankZhiHang"] = this.bankZhiHang;
        data["bankProvince"] = this.bankProvince;
        data["payPassword"] = this.payPassword;
        return data;
    }

    clone(): ApplyWithdrawInputDto {
        const json = this.toJSON();
        let result = new ApplyWithdrawInputDto();
        result.init(json);
        return result;
    }
}

export interface IApplyWithdrawInputDto {
    money: number;
    bank: string | undefined;
    bankNo: string | undefined;
    bankName: string | undefined;
    bankZhiHang: string | undefined;
    bankProvince: string | undefined;
    payPassword: string | undefined;
}

export class AreaListOutDto implements IAreaListOutDto {
    id!: number;
    name!: string | undefined;
    pid!: number | undefined;

    constructor(data?: IAreaListOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.pid = _data["pid"];
        }
    }

    static fromJS(data: any): AreaListOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new AreaListOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["pid"] = this.pid;
        return data;
    }

    clone(): AreaListOutDto {
        const json = this.toJSON();
        let result = new AreaListOutDto();
        result.init(json);
        return result;
    }
}

export interface IAreaListOutDto {
    id: number;
    name: string | undefined;
    pid: number | undefined;
}

export class AreaTreeDto implements IAreaTreeDto {
    title!: string | undefined;
    key!: string | undefined;
    value!: string | undefined;
    isLeaf!: boolean;

    constructor(data?: IAreaTreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.key = _data["key"];
            this.value = _data["value"];
            this.isLeaf = _data["isLeaf"];
        }
    }

    static fromJS(data: any): AreaTreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AreaTreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["key"] = this.key;
        data["value"] = this.value;
        data["isLeaf"] = this.isLeaf;
        return data;
    }

    clone(): AreaTreeDto {
        const json = this.toJSON();
        let result = new AreaTreeDto();
        result.init(json);
        return result;
    }
}

export interface IAreaTreeDto {
    title: string | undefined;
    key: string | undefined;
    value: string | undefined;
    isLeaf: boolean;
}

export class AuditLogListDto implements IAuditLogListDto {
    id!: number;
    userId!: number | undefined;
    userName!: string | undefined;
    impersonatorTenantId!: number | undefined;
    impersonatorUserId!: number | undefined;
    serviceName!: string | undefined;
    methodName!: string | undefined;
    parameters!: string | undefined;
    executionTime!: Date;
    executionDuration!: number;
    clientIpAddress!: string | undefined;
    clientName!: string | undefined;
    browserInfo!: string | undefined;
    exception!: string | undefined;
    customData!: string | undefined;

    constructor(data?: IAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.impersonatorTenantId = _data["impersonatorTenantId"];
            this.impersonatorUserId = _data["impersonatorUserId"];
            this.serviceName = _data["serviceName"];
            this.methodName = _data["methodName"];
            this.parameters = _data["parameters"];
            this.executionTime = _data["executionTime"] ? new Date(_data["executionTime"].toString()) : <any>undefined;
            this.executionDuration = _data["executionDuration"];
            this.clientIpAddress = _data["clientIpAddress"];
            this.clientName = _data["clientName"];
            this.browserInfo = _data["browserInfo"];
            this.exception = _data["exception"];
            this.customData = _data["customData"];
        }
    }

    static fromJS(data: any): AuditLogListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["impersonatorTenantId"] = this.impersonatorTenantId;
        data["impersonatorUserId"] = this.impersonatorUserId;
        data["serviceName"] = this.serviceName;
        data["methodName"] = this.methodName;
        data["parameters"] = this.parameters;
        data["executionTime"] = this.executionTime ? this.executionTime.toISOString() : <any>undefined;
        data["executionDuration"] = this.executionDuration;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["exception"] = this.exception;
        data["customData"] = this.customData;
        return data;
    }

    clone(): AuditLogListDto {
        const json = this.toJSON();
        let result = new AuditLogListDto();
        result.init(json);
        return result;
    }
}

export interface IAuditLogListDto {
    id: number;
    userId: number | undefined;
    userName: string | undefined;
    impersonatorTenantId: number | undefined;
    impersonatorUserId: number | undefined;
    serviceName: string | undefined;
    methodName: string | undefined;
    parameters: string | undefined;
    executionTime: Date;
    executionDuration: number;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    exception: string | undefined;
    customData: string | undefined;
}

export class AuditLogListDtoPagedResultDto implements IAuditLogListDtoPagedResultDto {
    items!: AuditLogListDto[] | undefined;
    totalCount!: number;

    constructor(data?: IAuditLogListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AuditLogListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AuditLogListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AuditLogListDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AuditLogListDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAuditLogListDtoPagedResultDto {
    items: AuditLogListDto[] | undefined;
    totalCount: number;
}

export enum AuditStatusEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress!: string;
    password!: string;
    rememberClient!: boolean;
    userType!: UserTypeEnum;
    googleCode!: string | undefined;
    loginId!: string | undefined;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.rememberClient = _data["rememberClient"];
            this.userType = _data["userType"];
            this.googleCode = _data["googleCode"];
            this.loginId = _data["loginId"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["rememberClient"] = this.rememberClient;
        data["userType"] = this.userType;
        data["googleCode"] = this.googleCode;
        data["loginId"] = this.loginId;
        return data;
    }

    clone(): AuthenticateModel {
        const json = this.toJSON();
        let result = new AuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;
    userType: UserTypeEnum;
    googleCode: string | undefined;
    loginId: string | undefined;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    userId!: number;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["userId"] = this.userId;
        return data;
    }

    clone(): AuthenticateResultModel {
        const json = this.toJSON();
        let result = new AuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;
}

export enum BalanceTypeEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export class BatchUpdateQuanZhongInputDto implements IBatchUpdateQuanZhongInputDto {
    channelIds!: number[] | undefined;
    quanZhong!: number;

    constructor(data?: IBatchUpdateQuanZhongInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["channelIds"])) {
                this.channelIds = [] as any;
                for (let item of _data["channelIds"])
                    this.channelIds!.push(item);
            }
            this.quanZhong = _data["quanZhong"];
        }
    }

    static fromJS(data: any): BatchUpdateQuanZhongInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchUpdateQuanZhongInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.channelIds)) {
            data["channelIds"] = [];
            for (let item of this.channelIds)
                data["channelIds"].push(item);
        }
        data["quanZhong"] = this.quanZhong;
        return data;
    }

    clone(): BatchUpdateQuanZhongInputDto {
        const json = this.toJSON();
        let result = new BatchUpdateQuanZhongInputDto();
        result.init(json);
        return result;
    }
}

export interface IBatchUpdateQuanZhongInputDto {
    channelIds: number[] | undefined;
    quanZhong: number;
}

export class BindMerchantChannelsInputDto implements IBindMerchantChannelsInputDto {
    channelId!: number;
    typeIds!: number[] | undefined;
    merchantChannels!: MerchantChannelDto[] | undefined;
    unBind!: boolean;

    constructor(data?: IBindMerchantChannelsInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelId = _data["channelId"];
            if (Array.isArray(_data["typeIds"])) {
                this.typeIds = [] as any;
                for (let item of _data["typeIds"])
                    this.typeIds!.push(item);
            }
            if (Array.isArray(_data["merchantChannels"])) {
                this.merchantChannels = [] as any;
                for (let item of _data["merchantChannels"])
                    this.merchantChannels!.push(MerchantChannelDto.fromJS(item));
            }
            this.unBind = _data["unBind"];
        }
    }

    static fromJS(data: any): BindMerchantChannelsInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new BindMerchantChannelsInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelId"] = this.channelId;
        if (Array.isArray(this.typeIds)) {
            data["typeIds"] = [];
            for (let item of this.typeIds)
                data["typeIds"].push(item);
        }
        if (Array.isArray(this.merchantChannels)) {
            data["merchantChannels"] = [];
            for (let item of this.merchantChannels)
                data["merchantChannels"].push(item.toJSON());
        }
        data["unBind"] = this.unBind;
        return data;
    }

    clone(): BindMerchantChannelsInputDto {
        const json = this.toJSON();
        let result = new BindMerchantChannelsInputDto();
        result.init(json);
        return result;
    }
}

export interface IBindMerchantChannelsInputDto {
    channelId: number;
    typeIds: number[] | undefined;
    merchantChannels: MerchantChannelDto[] | undefined;
    unBind: boolean;
}

export class ChangePasswordDto implements IChangePasswordDto {
    currentPassword!: string | undefined;
    newPassword!: string;
    againPassword!: string | undefined;

    constructor(data?: IChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
            this.againPassword = _data["againPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        data["againPassword"] = this.againPassword;
        return data;
    }

    clone(): ChangePasswordDto {
        const json = this.toJSON();
        let result = new ChangePasswordDto();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordDto {
    currentPassword: string | undefined;
    newPassword: string;
    againPassword: string | undefined;
}

export class ChangeUiThemeInput implements IChangeUiThemeInput {
    theme!: string;

    constructor(data?: IChangeUiThemeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"];
        }
    }

    static fromJS(data: any): ChangeUiThemeInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUiThemeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        return data;
    }

    clone(): ChangeUiThemeInput {
        const json = this.toJSON();
        let result = new ChangeUiThemeInput();
        result.init(json);
        return result;
    }
}

export interface IChangeUiThemeInput {
    theme: string;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName!: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    }

    clone(): ChangeUserLanguageDto {
        const json = this.toJSON();
        let result = new ChangeUserLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class ChannelAdvanceMoneyAdjustOrderDto implements IChannelAdvanceMoneyAdjustOrderDto {
    id!: number;
    orderNo!: string | undefined;
    channelId!: number | undefined;
    channelName!: string | undefined;
    money!: number;
    balance!: number;
    afterBalance!: number;
    createUserName!: string | undefined;
    creationTime!: Date;
    comment!: string | undefined;

    constructor(data?: IChannelAdvanceMoneyAdjustOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNo = _data["orderNo"];
            this.channelId = _data["channelId"];
            this.channelName = _data["channelName"];
            this.money = _data["money"];
            this.balance = _data["balance"];
            this.afterBalance = _data["afterBalance"];
            this.createUserName = _data["createUserName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): ChannelAdvanceMoneyAdjustOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelAdvanceMoneyAdjustOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNo"] = this.orderNo;
        data["channelId"] = this.channelId;
        data["channelName"] = this.channelName;
        data["money"] = this.money;
        data["balance"] = this.balance;
        data["afterBalance"] = this.afterBalance;
        data["createUserName"] = this.createUserName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        return data;
    }

    clone(): ChannelAdvanceMoneyAdjustOrderDto {
        const json = this.toJSON();
        let result = new ChannelAdvanceMoneyAdjustOrderDto();
        result.init(json);
        return result;
    }
}

export interface IChannelAdvanceMoneyAdjustOrderDto {
    id: number;
    orderNo: string | undefined;
    channelId: number | undefined;
    channelName: string | undefined;
    money: number;
    balance: number;
    afterBalance: number;
    createUserName: string | undefined;
    creationTime: Date;
    comment: string | undefined;
}

export class ChannelAdvanceMoneyAdjustOrderDtoPagedResultDto implements IChannelAdvanceMoneyAdjustOrderDtoPagedResultDto {
    items!: ChannelAdvanceMoneyAdjustOrderDto[] | undefined;
    totalCount!: number;

    constructor(data?: IChannelAdvanceMoneyAdjustOrderDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ChannelAdvanceMoneyAdjustOrderDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ChannelAdvanceMoneyAdjustOrderDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelAdvanceMoneyAdjustOrderDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ChannelAdvanceMoneyAdjustOrderDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ChannelAdvanceMoneyAdjustOrderDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IChannelAdvanceMoneyAdjustOrderDtoPagedResultDto {
    items: ChannelAdvanceMoneyAdjustOrderDto[] | undefined;
    totalCount: number;
}

export class ChannelAdvanceMoneyAdjustOrderPageInputDto implements IChannelAdvanceMoneyAdjustOrderPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    orderNo!: string | undefined;
    channelId!: number | undefined;
    channelName!: string | undefined;
    createStartTime!: Date | undefined;
    createEndTime!: Date | undefined;

    constructor(data?: IChannelAdvanceMoneyAdjustOrderPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.orderNo = _data["orderNo"];
            this.channelId = _data["channelId"];
            this.channelName = _data["channelName"];
            this.createStartTime = _data["createStartTime"] ? new Date(_data["createStartTime"].toString()) : <any>undefined;
            this.createEndTime = _data["createEndTime"] ? new Date(_data["createEndTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ChannelAdvanceMoneyAdjustOrderPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelAdvanceMoneyAdjustOrderPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["orderNo"] = this.orderNo;
        data["channelId"] = this.channelId;
        data["channelName"] = this.channelName;
        data["createStartTime"] = this.createStartTime ? this.createStartTime.toISOString() : <any>undefined;
        data["createEndTime"] = this.createEndTime ? this.createEndTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): ChannelAdvanceMoneyAdjustOrderPageInputDto {
        const json = this.toJSON();
        let result = new ChannelAdvanceMoneyAdjustOrderPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IChannelAdvanceMoneyAdjustOrderPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    orderNo: string | undefined;
    channelId: number | undefined;
    channelName: string | undefined;
    createStartTime: Date | undefined;
    createEndTime: Date | undefined;
}

export enum ChannelApiTypeEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12,
    _13 = 13,
    _14 = 14,
    _15 = 15,
    _16 = 16,
    _17 = 17,
    _18 = 18,
    _19 = 19,
    _20 = 20,
    _21 = 21,
    _22 = 22,
    _23 = 23,
    _24 = 24,
    _25 = 25,
    _26 = 26,
    _27 = 27,
    _28 = 28,
    _29 = 29,
    _30 = 30,
    _31 = 31,
    _32 = 32,
    _33 = 33,
    _34 = 34,
    _35 = 35,
    _36 = 36,
    _37 = 37,
    _38 = 38,
    _39 = 39,
    _40 = 40,
    _41 = 41,
    _42 = 42,
    _43 = 43,
    _44 = 44,
    _45 = 45,
    _46 = 46,
    _47 = 47,
    _48 = 48,
    _49 = 49,
    _50 = 50,
    _51 = 51,
    _52 = 52,
    _53 = 53,
    _54 = 54,
    _55 = 55,
    _56 = 56,
    _57 = 57,
    _58 = 58,
    _59 = 59,
    _60 = 60,
    _61 = 61,
    _62 = 62,
    _63 = 63,
    _64 = 64,
    _65 = 65,
    _66 = 66,
    _67 = 67,
    _68 = 68,
    _69 = 69,
    _70 = 70,
    _71 = 71,
    _72 = 72,
    _73 = 73,
    _74 = 74,
    _75 = 75,
    _76 = 76,
    _77 = 77,
    _78 = 78,
    _79 = 79,
    _80 = 80,
    _81 = 81,
    _82 = 82,
    _83 = 83,
    _84 = 84,
    _85 = 85,
    _86 = 86,
    _87 = 87,
    _88 = 88,
    _89 = 89,
    _90 = 90,
    _91 = 91,
    _92 = 92,
    _93 = 93,
    _94 = 94,
    _95 = 95,
    _96 = 96,
    _97 = 97,
    _98 = 98,
    _99 = 99,
    _100 = 100,
    _101 = 101,
    _102 = 102,
    _103 = 103,
    _104 = 104,
    _105 = 105,
    _106 = 106,
    _107 = 107,
    _108 = 108,
    _109 = 109,
    _110 = 110,
    _111 = 111,
    _112 = 112,
    _113 = 113,
    _114 = 114,
    _115 = 115,
    _116 = 116,
    _117 = 117,
    _118 = 118,
    _119 = 119,
    _120 = 120,
    _121 = 121,
    _122 = 122,
    _123 = 123,
    _124 = 124,
    _125 = 125,
    _126 = 126,
    _127 = 127,
    _128 = 128,
    _129 = 129,
    _130 = 130,
    _131 = 131,
    _132 = 132,
    _133 = 133,
    _134 = 134,
    _135 = 135,
    _136 = 136,
    _137 = 137,
    _138 = 138,
    _139 = 139,
    _140 = 140,
    _141 = 141,
    _142 = 142,
    _143 = 143,
    _144 = 144,
    _145 = 145,
    _146 = 146,
    _147 = 147,
    _148 = 148,
    _149 = 149,
    _150 = 150,
    _151 = 151,
    _152 = 152,
    _153 = 153,
    _154 = 154,
    _155 = 155,
    _156 = 156,
    _157 = 157,
    _158 = 158,
    _159 = 159,
    _160 = 160,
    _161 = 161,
    _162 = 162,
    _163 = 163,
    _164 = 164,
    _165 = 165,
    _166 = 166,
    _167 = 167,
    _168 = 168,
    _169 = 169,
    _170 = 170,
    _171 = 171,
    _172 = 172,
    _173 = 173,
    _174 = 174,
    _175 = 175,
    _176 = 176,
    _177 = 177,
    _178 = 178,
    _179 = 179,
    _180 = 180,
    _181 = 181,
    _182 = 182,
    _183 = 183,
    _184 = 184,
    _185 = 185,
    _186 = 186,
    _187 = 187,
    _188 = 188,
    _189 = 189,
    _190 = 190,
    _191 = 191,
    _192 = 192,
    _193 = 193,
    _194 = 194,
    _195 = 195,
    _196 = 196,
    _197 = 197,
    _198 = 198,
    _199 = 199,
    _200 = 200,
    _201 = 201,
    _202 = 202,
    _203 = 203,
    _204 = 204,
    _205 = 205,
    _206 = 206,
    _207 = 207,
    _208 = 208,
    _209 = 209,
    _210 = 210,
    _211 = 211,
    _212 = 212,
    _213 = 213,
    _214 = 214,
    _215 = 215,
    _216 = 216,
    _217 = 217,
    _218 = 218,
    _219 = 219,
    _220 = 220,
    _221 = 221,
    _222 = 222,
    _223 = 223,
    _224 = 224,
    _225 = 225,
    _226 = 226,
    _227 = 227,
    _228 = 228,
    _229 = 229,
    _230 = 230,
    _231 = 231,
    _232 = 232,
    _234 = 234,
    _235 = 235,
    _236 = 236,
    _237 = 237,
    _238 = 238,
    _239 = 239,
    _240 = 240,
    _241 = 241,
    _242 = 242,
    _243 = 243,
    _244 = 244,
    _245 = 245,
    _246 = 246,
    _247 = 247,
    _248 = 248,
    _249 = 249,
    _250 = 250,
    _251 = 251,
    _252 = 252,
    _253 = 253,
    _254 = 254,
    _255 = 255,
    _256 = 256,
    _257 = 257,
    _258 = 258,
    _259 = 259,
    _260 = 260,
    _261 = 261,
    _262 = 262,
    _263 = 263,
    _264 = 264,
    _265 = 265,
    _266 = 266,
    _267 = 267,
    _268 = 268,
    _269 = 269,
    _270 = 270,
    _271 = 271,
    _272 = 272,
    _273 = 273,
    _274 = 274,
    _275 = 275,
    _276 = 276,
    _277 = 277,
    _278 = 278,
    _279 = 279,
    _280 = 280,
    _281 = 281,
    _282 = 282,
    _283 = 283,
    _284 = 284,
    _285 = 285,
    _286 = 286,
    _287 = 287,
    _288 = 288,
    _289 = 289,
    _290 = 290,
    _291 = 291,
    _292 = 292,
    _293 = 293,
    _294 = 294,
    _295 = 295,
    _296 = 296,
    _297 = 297,
    _298 = 298,
    _299 = 299,
    _300 = 300,
    _301 = 301,
    _302 = 302,
    _303 = 303,
    _304 = 304,
    _305 = 305,
    _306 = 306,
    _307 = 307,
    _308 = 308,
    _309 = 309,
    _310 = 310,
    _311 = 311,
    _312 = 312,
    _313 = 313,
    _314 = 314,
    _315 = 315,
    _316 = 316,
    _317 = 317,
    _318 = 318,
    _319 = 319,
    _320 = 320,
    _321 = 321,
    _322 = 322,
    _323 = 323,
    _324 = 324,
    _325 = 325,
    _326 = 326,
    _327 = 327,
    _328 = 328,
    _329 = 329,
    _330 = 330,
    _331 = 331,
    _332 = 332,
    _333 = 333,
    _334 = 334,
    _335 = 335,
    _336 = 336,
    _337 = 337,
    _338 = 338,
    _339 = 339,
    _340 = 340,
    _341 = 341,
    _342 = 342,
    _343 = 343,
    _344 = 344,
    _345 = 345,
    _346 = 346,
    _347 = 347,
    _348 = 348,
    _349 = 349,
    _350 = 350,
    _351 = 351,
    _352 = 352,
    _353 = 353,
    _354 = 354,
    _355 = 355,
    _357 = 357,
    _358 = 358,
    _359 = 359,
    _360 = 360,
    _361 = 361,
    _362 = 362,
    _363 = 363,
    _364 = 364,
    _365 = 365,
    _366 = 366,
    _367 = 367,
    _368 = 368,
    _369 = 369,
    _370 = 370,
    _371 = 371,
    _372 = 372,
    _373 = 373,
    _374 = 374,
    _375 = 375,
    _376 = 376,
    _378 = 378,
    _379 = 379,
    _380 = 380,
    _381 = 381,
    _382 = 382,
    _383 = 383,
    _384 = 384,
    _385 = 385,
    _386 = 386,
    _387 = 387,
    _388 = 388,
    _389 = 389,
    _390 = 390,
    _391 = 391,
    _392 = 392,
    _393 = 393,
    _394 = 394,
    _395 = 395,
    _396 = 396,
    _397 = 397,
    _398 = 398,
    _399 = 399,
    _400 = 400,
    _401 = 401,
    _402 = 402,
    _403 = 403,
    _404 = 404,
    _405 = 405,
    _406 = 406,
    _407 = 407,
    _408 = 408,
    _409 = 409,
    _410 = 410,
    _411 = 411,
    _412 = 412,
    _413 = 413,
    _414 = 414,
    _415 = 415,
    _416 = 416,
    _417 = 417,
    _418 = 418,
    _419 = 419,
    _420 = 420,
    _421 = 421,
    _422 = 422,
    _423 = 423,
    _424 = 424,
    _425 = 425,
    _426 = 426,
    _427 = 427,
    _428 = 428,
    _429 = 429,
    _430 = 430,
    _431 = 431,
    _432 = 432,
    _433 = 433,
    _434 = 434,
    _435 = 435,
    _436 = 436,
    _437 = 437,
    _438 = 438,
    _439 = 439,
    _440 = 440,
    _441 = 441,
    _442 = 442,
    _443 = 443,
    _444 = 444,
    _445 = 445,
    _446 = 446,
    _447 = 447,
    _448 = 448,
    _449 = 449,
    _450 = 450,
    _451 = 451,
    _452 = 452,
    _453 = 453,
    _454 = 454,
    _455 = 455,
    _456 = 456,
    _457 = 457,
    _458 = 458,
    _459 = 459,
    _460 = 460,
    _461 = 461,
    _462 = 462,
    _463 = 463,
    _464 = 464,
    _465 = 465,
    _466 = 466,
    _467 = 467,
    _468 = 468,
    _469 = 469,
    _470 = 470,
    _471 = 471,
    _472 = 472,
    _473 = 473,
    _484 = 484,
    _485 = 485,
    _486 = 486,
    _487 = 487,
    _488 = 488,
    _489 = 489,
    _490 = 490,
    _491 = 491,
    _492 = 492,
    _493 = 493,
    _494 = 494,
    _495 = 495,
    _496 = 496,
    _497 = 497,
    _498 = 498,
    _499 = 499,
    _500 = 500,
    _501 = 501,
    _502 = 502,
    _503 = 503,
    _504 = 504,
    _505 = 505,
    _506 = 506,
    _507 = 507,
    _508 = 508,
    _509 = 509,
    _510 = 510,
    _511 = 511,
    _512 = 512,
    _513 = 513,
    _514 = 514,
    _515 = 515,
    _516 = 516,
    _517 = 517,
    _518 = 518,
    _519 = 519,
    _520 = 520,
    _521 = 521,
    _522 = 522,
    _523 = 523,
    _524 = 524,
    _525 = 525,
    _526 = 526,
    _527 = 527,
    _528 = 528,
    _529 = 529,
    _530 = 530,
    _531 = 531,
    _532 = 532,
    _533 = 533,
    _534 = 534,
    _535 = 535,
    _536 = 536,
    _537 = 537,
    _538 = 538,
    _539 = 539,
    _540 = 540,
    _541 = 541,
    _542 = 542,
    _543 = 543,
    _544 = 544,
    _545 = 545,
    _546 = 546,
    _547 = 547,
    _548 = 548,
    _549 = 549,
    _550 = 550,
    _551 = 551,
    _552 = 552,
    _553 = 553,
    _554 = 554,
    _555 = 555,
    _556 = 556,
    _557 = 557,
    _558 = 558,
    _559 = 559,
    _560 = 560,
    _561 = 561,
    _562 = 562,
    _563 = 563,
    _564 = 564,
    _565 = 565,
    _567 = 567,
    _568 = 568,
    _569 = 569,
    _570 = 570,
    _571 = 571,
    _572 = 572,
    _573 = 573,
    _574 = 574,
    _575 = 575,
    _576 = 576,
    _577 = 577,
    _578 = 578,
    _579 = 579,
    _580 = 580,
    _581 = 581,
    _582 = 582,
    _583 = 583,
    _585 = 585,
    _586 = 586,
    _587 = 587,
    _588 = 588,
    _589 = 589,
    _590 = 590,
    _591 = 591,
    _592 = 592,
    _593 = 593,
    _594 = 594,
    _595 = 595,
    _596 = 596,
    _597 = 597,
    _598 = 598,
    _599 = 599,
    _600 = 600,
    _601 = 601,
    _602 = 602,
    _603 = 603,
    _604 = 604,
    _605 = 605,
    _606 = 606,
    _607 = 607,
    _608 = 608,
    _609 = 609,
    _610 = 610,
    _611 = 611,
    _612 = 612,
    _613 = 613,
    _614 = 614,
    _615 = 615,
    _616 = 616,
    _617 = 617,
    _618 = 618,
    _619 = 619,
    _620 = 620,
    _621 = 621,
    _622 = 622,
    _623 = 623,
    _624 = 624,
    _625 = 625,
    _626 = 626,
    _627 = 627,
    _628 = 628,
    _629 = 629,
    _630 = 630,
    _631 = 631,
    _632 = 632,
    _633 = 633,
    _634 = 634,
    _635 = 635,
    _636 = 636,
    _637 = 637,
    _638 = 638,
    _639 = 639,
    _640 = 640,
    _641 = 641,
    _642 = 642,
    _643 = 643,
    _644 = 644,
    _645 = 645,
    _646 = 646,
    _647 = 647,
    _648 = 648,
    _649 = 649,
    _650 = 650,
    _651 = 651,
    _652 = 652,
    _653 = 653,
    _654 = 654,
    _655 = 655,
    _656 = 656,
    _657 = 657,
    _658 = 658,
    _659 = 659,
    _660 = 660,
    _661 = 661,
    _662 = 662,
    _663 = 663,
    _664 = 664,
    _665 = 665,
    _666 = 666,
    _667 = 667,
    _668 = 668,
    _669 = 669,
    _670 = 670,
    _671 = 671,
    _672 = 672,
    _673 = 673,
    _674 = 674,
    _675 = 675,
    _676 = 676,
    _677 = 677,
    _678 = 678,
    _679 = 679,
    _680 = 680,
    _681 = 681,
    _682 = 682,
    _683 = 683,
    _684 = 684,
    _685 = 685,
    _686 = 686,
    _687 = 687,
    _688 = 688,
    _689 = 689,
    _690 = 690,
    _691 = 691,
    _692 = 692,
    _693 = 693,
    _694 = 694,
    _695 = 695,
    _696 = 696,
    _697 = 697,
    _698 = 698,
    _699 = 699,
    _700 = 700,
    _701 = 701,
    _702 = 702,
    _703 = 703,
    _704 = 704,
    _705 = 705,
    _706 = 706,
    _707 = 707,
    _708 = 708,
    _709 = 709,
    _710 = 710,
    _711 = 711,
    _712 = 712,
    _714 = 714,
    _715 = 715,
    _716 = 716,
    _717 = 717,
    _718 = 718,
    _719 = 719,
    _720 = 720,
    _721 = 721,
    _722 = 722,
    _723 = 723,
    _724 = 724,
    _725 = 725,
    _726 = 726,
    _727 = 727,
    _728 = 728,
    _729 = 729,
    _730 = 730,
    _731 = 731,
    _732 = 732,
    _733 = 733,
    _734 = 734,
    _735 = 735,
    _736 = 736,
    _737 = 737,
    _738 = 738,
    _739 = 739,
    _740 = 740,
    _741 = 741,
    _742 = 742,
    _743 = 743,
    _744 = 744,
    _745 = 745,
    _746 = 746,
    _747 = 747,
    _748 = 748,
    _749 = 749,
    _750 = 750,
    _751 = 751,
    _752 = 752,
    _753 = 753,
    _754 = 754,
    _755 = 755,
    _756 = 756,
    _757 = 757,
    _758 = 758,
    _759 = 759,
    _760 = 760,
    _761 = 761,
    _762 = 762,
    _763 = 763,
    _764 = 764,
    _765 = 765,
    _766 = 766,
    _767 = 767,
    _768 = 768,
    _769 = 769,
    _770 = 770,
    _771 = 771,
    _772 = 772,
    _773 = 773,
    _774 = 774,
    _775 = 775,
    _776 = 776,
    _777 = 777,
    _778 = 778,
    _779 = 779,
    _780 = 780,
    _781 = 781,
    _782 = 782,
    _783 = 783,
    _784 = 784,
    _785 = 785,
    _786 = 786,
    _787 = 787,
    _788 = 788,
    _789 = 789,
    _790 = 790,
    _791 = 791,
    _792 = 792,
    _793 = 793,
    _794 = 794,
    _795 = 795,
    _796 = 796,
    _797 = 797,
    _798 = 798,
    _799 = 799,
    _800 = 800,
    _801 = 801,
    _802 = 802,
    _803 = 803,
    _804 = 804,
    _805 = 805,
    _806 = 806,
    _807 = 807,
    _808 = 808,
    _809 = 809,
    _810 = 810,
    _811 = 811,
    _812 = 812,
    _813 = 813,
    _814 = 814,
    _815 = 815,
    _816 = 816,
    _817 = 817,
    _818 = 818,
    _819 = 819,
    _820 = 820,
    _821 = 821,
    _822 = 822,
    _823 = 823,
    _824 = 824,
    _825 = 825,
    _826 = 826,
    _827 = 827,
    _828 = 828,
    _829 = 829,
    _830 = 830,
    _831 = 831,
    _832 = 832,
    _833 = 833,
    _834 = 834,
    _835 = 835,
    _836 = 836,
    _837 = 837,
    _838 = 838,
    _839 = 839,
    _840 = 840,
    _841 = 841,
    _842 = 842,
    _843 = 843,
    _844 = 844,
    _845 = 845,
    _846 = 846,
    _847 = 847,
    _848 = 848,
    _849 = 849,
    _850 = 850,
    _851 = 851,
    _852 = 852,
    _853 = 853,
    _854 = 854,
    _855 = 855,
    _856 = 856,
    _857 = 857,
    _858 = 858,
    _859 = 859,
    _860 = 860,
    _861 = 861,
    _862 = 862,
    _863 = 863,
    _864 = 864,
    _865 = 865,
    _866 = 866,
    _867 = 867,
    _868 = 868,
    _869 = 869,
    _870 = 870,
    _871 = 871,
    _872 = 872,
    _873 = 873,
    _874 = 874,
    _875 = 875,
    _876 = 876,
    _877 = 877,
    _878 = 878,
    _879 = 879,
    _880 = 880,
    _881 = 881,
    _882 = 882,
    _883 = 883,
    _884 = 884,
    _885 = 885,
    _886 = 886,
    _887 = 887,
    _888 = 888,
    _889 = 889,
    _890 = 890,
    _891 = 891,
    _892 = 892,
    _893 = 893,
    _894 = 894,
    _895 = 895,
    _896 = 896,
    _897 = 897,
    _898 = 898,
    _899 = 899,
    _900 = 900,
    _901 = 901,
    _902 = 902,
    _903 = 903,
    _904 = 904,
    _905 = 905,
    _906 = 906,
    _907 = 907,
    _908 = 908,
    _909 = 909,
    _910 = 910,
    _911 = 911,
    _912 = 912,
    _913 = 913,
    _914 = 914,
    _915 = 915,
    _916 = 916,
    _917 = 917,
    _918 = 918,
    _919 = 919,
    _920 = 920,
    _921 = 921,
    _922 = 922,
    _923 = 923,
    _924 = 924,
    _925 = 925,
    _926 = 926,
    _927 = 927,
    _928 = 928,
    _929 = 929,
    _930 = 930,
    _931 = 931,
    _932 = 932,
    _933 = 933,
    _934 = 934,
    _935 = 935,
    _936 = 936,
    _937 = 937,
    _938 = 938,
    _939 = 939,
    _940 = 940,
    _941 = 941,
    _942 = 942,
    _943 = 943,
    _944 = 944,
    _945 = 945,
    _946 = 946,
    _947 = 947,
    _948 = 948,
    _949 = 949,
    _950 = 950,
    _951 = 951,
    _952 = 952,
    _953 = 953,
}

export class ChannelBalanceAdjustOrderDto implements IChannelBalanceAdjustOrderDto {
    id!: number;
    orderNo!: string | undefined;
    channelId!: number | undefined;
    channelName!: string | undefined;
    money!: number;
    balance!: number;
    afterBalance!: number;
    createUserName!: string | undefined;
    creationTime!: Date;
    comment!: string | undefined;

    constructor(data?: IChannelBalanceAdjustOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNo = _data["orderNo"];
            this.channelId = _data["channelId"];
            this.channelName = _data["channelName"];
            this.money = _data["money"];
            this.balance = _data["balance"];
            this.afterBalance = _data["afterBalance"];
            this.createUserName = _data["createUserName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): ChannelBalanceAdjustOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelBalanceAdjustOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNo"] = this.orderNo;
        data["channelId"] = this.channelId;
        data["channelName"] = this.channelName;
        data["money"] = this.money;
        data["balance"] = this.balance;
        data["afterBalance"] = this.afterBalance;
        data["createUserName"] = this.createUserName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        return data;
    }

    clone(): ChannelBalanceAdjustOrderDto {
        const json = this.toJSON();
        let result = new ChannelBalanceAdjustOrderDto();
        result.init(json);
        return result;
    }
}

export interface IChannelBalanceAdjustOrderDto {
    id: number;
    orderNo: string | undefined;
    channelId: number | undefined;
    channelName: string | undefined;
    money: number;
    balance: number;
    afterBalance: number;
    createUserName: string | undefined;
    creationTime: Date;
    comment: string | undefined;
}

export class ChannelBalanceAdjustOrderDtoPagedResultDto implements IChannelBalanceAdjustOrderDtoPagedResultDto {
    items!: ChannelBalanceAdjustOrderDto[] | undefined;
    totalCount!: number;

    constructor(data?: IChannelBalanceAdjustOrderDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ChannelBalanceAdjustOrderDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ChannelBalanceAdjustOrderDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelBalanceAdjustOrderDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ChannelBalanceAdjustOrderDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ChannelBalanceAdjustOrderDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IChannelBalanceAdjustOrderDtoPagedResultDto {
    items: ChannelBalanceAdjustOrderDto[] | undefined;
    totalCount: number;
}

export class ChannelBalanceAdjustOrderPageInputDto implements IChannelBalanceAdjustOrderPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    orderNo!: string | undefined;
    channelId!: number | undefined;
    channelName!: string | undefined;
    createStartTime!: Date | undefined;
    createEndTime!: Date | undefined;

    constructor(data?: IChannelBalanceAdjustOrderPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.orderNo = _data["orderNo"];
            this.channelId = _data["channelId"];
            this.channelName = _data["channelName"];
            this.createStartTime = _data["createStartTime"] ? new Date(_data["createStartTime"].toString()) : <any>undefined;
            this.createEndTime = _data["createEndTime"] ? new Date(_data["createEndTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ChannelBalanceAdjustOrderPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelBalanceAdjustOrderPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["orderNo"] = this.orderNo;
        data["channelId"] = this.channelId;
        data["channelName"] = this.channelName;
        data["createStartTime"] = this.createStartTime ? this.createStartTime.toISOString() : <any>undefined;
        data["createEndTime"] = this.createEndTime ? this.createEndTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): ChannelBalanceAdjustOrderPageInputDto {
        const json = this.toJSON();
        let result = new ChannelBalanceAdjustOrderPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IChannelBalanceAdjustOrderPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    orderNo: string | undefined;
    channelId: number | undefined;
    channelName: string | undefined;
    createStartTime: Date | undefined;
    createEndTime: Date | undefined;
}

export class ChannelBalanceLogDto implements IChannelBalanceLogDto {
    id!: number;
    serialNumber!: string | undefined;
    channelId!: number | undefined;
    channelName!: string | undefined;
    money!: number;
    balance!: number;
    afterBalance!: number;
    tid!: string | undefined;
    tradeId!: number | undefined;
    balanceType!: ChannelBalanceLogTypeEnum;
    readonly balanceTypeName!: string | undefined;
    creationTime!: Date;
    comment!: string | undefined;

    constructor(data?: IChannelBalanceLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serialNumber = _data["serialNumber"];
            this.channelId = _data["channelId"];
            this.channelName = _data["channelName"];
            this.money = _data["money"];
            this.balance = _data["balance"];
            this.afterBalance = _data["afterBalance"];
            this.tid = _data["tid"];
            this.tradeId = _data["tradeId"];
            this.balanceType = _data["balanceType"];
            (<any>this).balanceTypeName = _data["balanceTypeName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): ChannelBalanceLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelBalanceLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serialNumber"] = this.serialNumber;
        data["channelId"] = this.channelId;
        data["channelName"] = this.channelName;
        data["money"] = this.money;
        data["balance"] = this.balance;
        data["afterBalance"] = this.afterBalance;
        data["tid"] = this.tid;
        data["tradeId"] = this.tradeId;
        data["balanceType"] = this.balanceType;
        data["balanceTypeName"] = this.balanceTypeName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        return data;
    }

    clone(): ChannelBalanceLogDto {
        const json = this.toJSON();
        let result = new ChannelBalanceLogDto();
        result.init(json);
        return result;
    }
}

export interface IChannelBalanceLogDto {
    id: number;
    serialNumber: string | undefined;
    channelId: number | undefined;
    channelName: string | undefined;
    money: number;
    balance: number;
    afterBalance: number;
    tid: string | undefined;
    tradeId: number | undefined;
    balanceType: ChannelBalanceLogTypeEnum;
    balanceTypeName: string | undefined;
    creationTime: Date;
    comment: string | undefined;
}

export class ChannelBalanceLogDtoPagedResultDto implements IChannelBalanceLogDtoPagedResultDto {
    items!: ChannelBalanceLogDto[] | undefined;
    totalCount!: number;

    constructor(data?: IChannelBalanceLogDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ChannelBalanceLogDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ChannelBalanceLogDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelBalanceLogDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ChannelBalanceLogDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ChannelBalanceLogDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IChannelBalanceLogDtoPagedResultDto {
    items: ChannelBalanceLogDto[] | undefined;
    totalCount: number;
}

export class ChannelBalanceLogPageInputDto implements IChannelBalanceLogPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    serialNumber!: string | undefined;
    channelId!: number | undefined;
    channelName!: string | undefined;
    tid!: string | undefined;
    createStartTime!: Date | undefined;
    createEndTime!: Date | undefined;
    balanceType!: ChannelBalanceLogTypeEnum;

    constructor(data?: IChannelBalanceLogPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.serialNumber = _data["serialNumber"];
            this.channelId = _data["channelId"];
            this.channelName = _data["channelName"];
            this.tid = _data["tid"];
            this.createStartTime = _data["createStartTime"] ? new Date(_data["createStartTime"].toString()) : <any>undefined;
            this.createEndTime = _data["createEndTime"] ? new Date(_data["createEndTime"].toString()) : <any>undefined;
            this.balanceType = _data["balanceType"];
        }
    }

    static fromJS(data: any): ChannelBalanceLogPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelBalanceLogPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["serialNumber"] = this.serialNumber;
        data["channelId"] = this.channelId;
        data["channelName"] = this.channelName;
        data["tid"] = this.tid;
        data["createStartTime"] = this.createStartTime ? this.createStartTime.toISOString() : <any>undefined;
        data["createEndTime"] = this.createEndTime ? this.createEndTime.toISOString() : <any>undefined;
        data["balanceType"] = this.balanceType;
        return data;
    }

    clone(): ChannelBalanceLogPageInputDto {
        const json = this.toJSON();
        let result = new ChannelBalanceLogPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IChannelBalanceLogPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    serialNumber: string | undefined;
    channelId: number | undefined;
    channelName: string | undefined;
    tid: string | undefined;
    createStartTime: Date | undefined;
    createEndTime: Date | undefined;
    balanceType: ChannelBalanceLogTypeEnum;
}

export enum ChannelBalanceLogTypeEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class ChannelBindChannelTypeDto implements IChannelBindChannelTypeDto {
    channelId!: number;
    channelTypeIds!: number[] | undefined;

    constructor(data?: IChannelBindChannelTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelId = _data["channelId"];
            if (Array.isArray(_data["channelTypeIds"])) {
                this.channelTypeIds = [] as any;
                for (let item of _data["channelTypeIds"])
                    this.channelTypeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ChannelBindChannelTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelBindChannelTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelId"] = this.channelId;
        if (Array.isArray(this.channelTypeIds)) {
            data["channelTypeIds"] = [];
            for (let item of this.channelTypeIds)
                data["channelTypeIds"].push(item);
        }
        return data;
    }

    clone(): ChannelBindChannelTypeDto {
        const json = this.toJSON();
        let result = new ChannelBindChannelTypeDto();
        result.init(json);
        return result;
    }
}

export interface IChannelBindChannelTypeDto {
    channelId: number;
    channelTypeIds: number[] | undefined;
}

export class ChannelDayBillDto implements IChannelDayBillDto {
    channelId!: number | undefined;
    name!: string | undefined;
    money!: number;
    payMoney!: number;
    budanNum!: number;
    budanMoney!: number;
    commission!: number;
    settlementTimeStr!: string | undefined;
    settlementTime!: Date;
    orderNum!: number;
    creationTime!: Date;

    constructor(data?: IChannelDayBillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelId = _data["channelId"];
            this.name = _data["name"];
            this.money = _data["money"];
            this.payMoney = _data["payMoney"];
            this.budanNum = _data["budanNum"];
            this.budanMoney = _data["budanMoney"];
            this.commission = _data["commission"];
            this.settlementTimeStr = _data["settlementTimeStr"];
            this.settlementTime = _data["settlementTime"] ? new Date(_data["settlementTime"].toString()) : <any>undefined;
            this.orderNum = _data["orderNum"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ChannelDayBillDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelDayBillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelId"] = this.channelId;
        data["name"] = this.name;
        data["money"] = this.money;
        data["payMoney"] = this.payMoney;
        data["budanNum"] = this.budanNum;
        data["budanMoney"] = this.budanMoney;
        data["commission"] = this.commission;
        data["settlementTimeStr"] = this.settlementTimeStr;
        data["settlementTime"] = this.settlementTime ? this.settlementTime.toISOString() : <any>undefined;
        data["orderNum"] = this.orderNum;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): ChannelDayBillDto {
        const json = this.toJSON();
        let result = new ChannelDayBillDto();
        result.init(json);
        return result;
    }
}

export interface IChannelDayBillDto {
    channelId: number | undefined;
    name: string | undefined;
    money: number;
    payMoney: number;
    budanNum: number;
    budanMoney: number;
    commission: number;
    settlementTimeStr: string | undefined;
    settlementTime: Date;
    orderNum: number;
    creationTime: Date;
}

export class ChannelDayBillDtoPagedResultDto implements IChannelDayBillDtoPagedResultDto {
    items!: ChannelDayBillDto[] | undefined;
    totalCount!: number;

    constructor(data?: IChannelDayBillDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ChannelDayBillDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ChannelDayBillDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelDayBillDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ChannelDayBillDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ChannelDayBillDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IChannelDayBillDtoPagedResultDto {
    items: ChannelDayBillDto[] | undefined;
    totalCount: number;
}

export class ChannelDayBillPageInputDto implements IChannelDayBillPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    createStartTime!: Date | undefined;
    createEndTime!: Date | undefined;
    channelId!: number | undefined;

    constructor(data?: IChannelDayBillPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.createStartTime = _data["createStartTime"] ? new Date(_data["createStartTime"].toString()) : <any>undefined;
            this.createEndTime = _data["createEndTime"] ? new Date(_data["createEndTime"].toString()) : <any>undefined;
            this.channelId = _data["channelId"];
        }
    }

    static fromJS(data: any): ChannelDayBillPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelDayBillPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["createStartTime"] = this.createStartTime ? this.createStartTime.toISOString() : <any>undefined;
        data["createEndTime"] = this.createEndTime ? this.createEndTime.toISOString() : <any>undefined;
        data["channelId"] = this.channelId;
        return data;
    }

    clone(): ChannelDayBillPageInputDto {
        const json = this.toJSON();
        let result = new ChannelDayBillPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IChannelDayBillPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    createStartTime: Date | undefined;
    createEndTime: Date | undefined;
    channelId: number | undefined;
}

export class ChannelDayClearDto implements IChannelDayClearDto {
    id!: number;
    channelId!: number | undefined;
    channelName!: string | undefined;
    totalOrderNum!: number;
    successOrderNum!: number;
    totalAmount!: number;
    successAmount!: number;
    liRun!: number;
    successRate!: number;
    settlementStatus!: number;
    settlementTime!: Date | undefined;
    startTime!: Date;
    endTime!: Date;
    settlementAdvanceMoney!: number;
    settlementBalance!: number;
    settlementYingDe!: number;
    afterSettlementAdvanceMoney!: number;
    afterSettlementBalance!: number;
    afterSettlementYingDe!: number;
    channelRateCommission!: number;
    creationTime!: Date;

    constructor(data?: IChannelDayClearDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.channelId = _data["channelId"];
            this.channelName = _data["channelName"];
            this.totalOrderNum = _data["totalOrderNum"];
            this.successOrderNum = _data["successOrderNum"];
            this.totalAmount = _data["totalAmount"];
            this.successAmount = _data["successAmount"];
            this.liRun = _data["liRun"];
            this.successRate = _data["successRate"];
            this.settlementStatus = _data["settlementStatus"];
            this.settlementTime = _data["settlementTime"] ? new Date(_data["settlementTime"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.settlementAdvanceMoney = _data["settlementAdvanceMoney"];
            this.settlementBalance = _data["settlementBalance"];
            this.settlementYingDe = _data["settlementYingDe"];
            this.afterSettlementAdvanceMoney = _data["afterSettlementAdvanceMoney"];
            this.afterSettlementBalance = _data["afterSettlementBalance"];
            this.afterSettlementYingDe = _data["afterSettlementYingDe"];
            this.channelRateCommission = _data["channelRateCommission"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ChannelDayClearDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelDayClearDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["channelId"] = this.channelId;
        data["channelName"] = this.channelName;
        data["totalOrderNum"] = this.totalOrderNum;
        data["successOrderNum"] = this.successOrderNum;
        data["totalAmount"] = this.totalAmount;
        data["successAmount"] = this.successAmount;
        data["liRun"] = this.liRun;
        data["successRate"] = this.successRate;
        data["settlementStatus"] = this.settlementStatus;
        data["settlementTime"] = this.settlementTime ? this.settlementTime.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["settlementAdvanceMoney"] = this.settlementAdvanceMoney;
        data["settlementBalance"] = this.settlementBalance;
        data["settlementYingDe"] = this.settlementYingDe;
        data["afterSettlementAdvanceMoney"] = this.afterSettlementAdvanceMoney;
        data["afterSettlementBalance"] = this.afterSettlementBalance;
        data["afterSettlementYingDe"] = this.afterSettlementYingDe;
        data["channelRateCommission"] = this.channelRateCommission;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): ChannelDayClearDto {
        const json = this.toJSON();
        let result = new ChannelDayClearDto();
        result.init(json);
        return result;
    }
}

export interface IChannelDayClearDto {
    id: number;
    channelId: number | undefined;
    channelName: string | undefined;
    totalOrderNum: number;
    successOrderNum: number;
    totalAmount: number;
    successAmount: number;
    liRun: number;
    successRate: number;
    settlementStatus: number;
    settlementTime: Date | undefined;
    startTime: Date;
    endTime: Date;
    settlementAdvanceMoney: number;
    settlementBalance: number;
    settlementYingDe: number;
    afterSettlementAdvanceMoney: number;
    afterSettlementBalance: number;
    afterSettlementYingDe: number;
    channelRateCommission: number;
    creationTime: Date;
}

export class ChannelDayClearDtoPagedResultDto implements IChannelDayClearDtoPagedResultDto {
    items!: ChannelDayClearDto[] | undefined;
    totalCount!: number;

    constructor(data?: IChannelDayClearDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ChannelDayClearDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ChannelDayClearDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelDayClearDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ChannelDayClearDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ChannelDayClearDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IChannelDayClearDtoPagedResultDto {
    items: ChannelDayClearDto[] | undefined;
    totalCount: number;
}

export class ChannelDayClearPageInputDto implements IChannelDayClearPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    createTime!: Date | undefined;
    endTime!: Date | undefined;
    channelId!: number | undefined;
    channelName!: string | undefined;

    constructor(data?: IChannelDayClearPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.createTime = _data["createTime"] ? new Date(_data["createTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.channelId = _data["channelId"];
            this.channelName = _data["channelName"];
        }
    }

    static fromJS(data: any): ChannelDayClearPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelDayClearPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["channelId"] = this.channelId;
        data["channelName"] = this.channelName;
        return data;
    }

    clone(): ChannelDayClearPageInputDto {
        const json = this.toJSON();
        let result = new ChannelDayClearPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IChannelDayClearPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    createTime: Date | undefined;
    endTime: Date | undefined;
    channelId: number | undefined;
    channelName: string | undefined;
}

export class ChannelDto implements IChannelDto {
    id!: number;
    name!: string | undefined;
    shouKuanFangShi!: number;
    shouKuanGuiZe!: string | undefined;
    botId!: string | undefined;
    agentId!: number | undefined;
    agentName!: string | undefined;
    balance!: number;
    status!: StatusEnum;
    advanceMoney!: number;
    rate!: number;
    agentRate!: number;
    channelApiType!: ChannelApiTypeEnum;
    mid!: string | undefined;
    mSecret!: string | undefined;
    apiUrl!: string | undefined;
    createOrderUrl!: string | undefined;
    queryOrderUrl!: string | undefined;
    payCode!: string | undefined;
    apiIps!: string | undefined;
    creationTime!: Date;
    readonly realBalance!: number;
    autoOpenAndClose!: boolean;
    openTime!: string | undefined;
    closeTime!: string | undefined;
    channelFlag!: string | undefined;
    rsaPublicKey!: string | undefined;
    rsaPrivateKey!: string | undefined;
    channelSupplierName!: string | undefined;
    channelSupplierId!: number | undefined;
    channelTypes!: ChannelTypeSimpleDto[] | undefined;
    csort!: string | undefined;
    appid!: string | undefined;
    daySuccessRate!: number;
    hourSuccessRate!: number;
    channelTypeIds!: number[] | undefined;
    quanZhong!: number;

    constructor(data?: IChannelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.shouKuanFangShi = _data["shouKuanFangShi"];
            this.shouKuanGuiZe = _data["shouKuanGuiZe"];
            this.botId = _data["botId"];
            this.agentId = _data["agentId"];
            this.agentName = _data["agentName"];
            this.balance = _data["balance"];
            this.status = _data["status"];
            this.advanceMoney = _data["advanceMoney"];
            this.rate = _data["rate"];
            this.agentRate = _data["agentRate"];
            this.channelApiType = _data["channelApiType"];
            this.mid = _data["mid"];
            this.mSecret = _data["mSecret"];
            this.apiUrl = _data["apiUrl"];
            this.createOrderUrl = _data["createOrderUrl"];
            this.queryOrderUrl = _data["queryOrderUrl"];
            this.payCode = _data["payCode"];
            this.apiIps = _data["apiIps"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            (<any>this).realBalance = _data["realBalance"];
            this.autoOpenAndClose = _data["autoOpenAndClose"];
            this.openTime = _data["openTime"];
            this.closeTime = _data["closeTime"];
            this.channelFlag = _data["channelFlag"];
            this.rsaPublicKey = _data["rsaPublicKey"];
            this.rsaPrivateKey = _data["rsaPrivateKey"];
            this.channelSupplierName = _data["channelSupplierName"];
            this.channelSupplierId = _data["channelSupplierId"];
            if (Array.isArray(_data["channelTypes"])) {
                this.channelTypes = [] as any;
                for (let item of _data["channelTypes"])
                    this.channelTypes!.push(ChannelTypeSimpleDto.fromJS(item));
            }
            this.csort = _data["csort"];
            this.appid = _data["appid"];
            this.daySuccessRate = _data["daySuccessRate"];
            this.hourSuccessRate = _data["hourSuccessRate"];
            if (Array.isArray(_data["channelTypeIds"])) {
                this.channelTypeIds = [] as any;
                for (let item of _data["channelTypeIds"])
                    this.channelTypeIds!.push(item);
            }
            this.quanZhong = _data["quanZhong"];
        }
    }

    static fromJS(data: any): ChannelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["shouKuanFangShi"] = this.shouKuanFangShi;
        data["shouKuanGuiZe"] = this.shouKuanGuiZe;
        data["botId"] = this.botId;
        data["agentId"] = this.agentId;
        data["agentName"] = this.agentName;
        data["balance"] = this.balance;
        data["status"] = this.status;
        data["advanceMoney"] = this.advanceMoney;
        data["rate"] = this.rate;
        data["agentRate"] = this.agentRate;
        data["channelApiType"] = this.channelApiType;
        data["mid"] = this.mid;
        data["mSecret"] = this.mSecret;
        data["apiUrl"] = this.apiUrl;
        data["createOrderUrl"] = this.createOrderUrl;
        data["queryOrderUrl"] = this.queryOrderUrl;
        data["payCode"] = this.payCode;
        data["apiIps"] = this.apiIps;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["realBalance"] = this.realBalance;
        data["autoOpenAndClose"] = this.autoOpenAndClose;
        data["openTime"] = this.openTime;
        data["closeTime"] = this.closeTime;
        data["channelFlag"] = this.channelFlag;
        data["rsaPublicKey"] = this.rsaPublicKey;
        data["rsaPrivateKey"] = this.rsaPrivateKey;
        data["channelSupplierName"] = this.channelSupplierName;
        data["channelSupplierId"] = this.channelSupplierId;
        if (Array.isArray(this.channelTypes)) {
            data["channelTypes"] = [];
            for (let item of this.channelTypes)
                data["channelTypes"].push(item.toJSON());
        }
        data["csort"] = this.csort;
        data["appid"] = this.appid;
        data["daySuccessRate"] = this.daySuccessRate;
        data["hourSuccessRate"] = this.hourSuccessRate;
        if (Array.isArray(this.channelTypeIds)) {
            data["channelTypeIds"] = [];
            for (let item of this.channelTypeIds)
                data["channelTypeIds"].push(item);
        }
        data["quanZhong"] = this.quanZhong;
        return data;
    }

    clone(): ChannelDto {
        const json = this.toJSON();
        let result = new ChannelDto();
        result.init(json);
        return result;
    }
}

export interface IChannelDto {
    id: number;
    name: string | undefined;
    shouKuanFangShi: number;
    shouKuanGuiZe: string | undefined;
    botId: string | undefined;
    agentId: number | undefined;
    agentName: string | undefined;
    balance: number;
    status: StatusEnum;
    advanceMoney: number;
    rate: number;
    agentRate: number;
    channelApiType: ChannelApiTypeEnum;
    mid: string | undefined;
    mSecret: string | undefined;
    apiUrl: string | undefined;
    createOrderUrl: string | undefined;
    queryOrderUrl: string | undefined;
    payCode: string | undefined;
    apiIps: string | undefined;
    creationTime: Date;
    realBalance: number;
    autoOpenAndClose: boolean;
    openTime: string | undefined;
    closeTime: string | undefined;
    channelFlag: string | undefined;
    rsaPublicKey: string | undefined;
    rsaPrivateKey: string | undefined;
    channelSupplierName: string | undefined;
    channelSupplierId: number | undefined;
    channelTypes: ChannelTypeSimpleDto[] | undefined;
    csort: string | undefined;
    appid: string | undefined;
    daySuccessRate: number;
    hourSuccessRate: number;
    channelTypeIds: number[] | undefined;
    quanZhong: number;
}

export class ChannelDtoPagedResultDto implements IChannelDtoPagedResultDto {
    items!: ChannelDto[] | undefined;
    totalCount!: number;

    constructor(data?: IChannelDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ChannelDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ChannelDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ChannelDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ChannelDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IChannelDtoPagedResultDto {
    items: ChannelDto[] | undefined;
    totalCount: number;
}

export class ChannelOrderDto implements IChannelOrderDto {
    id!: number;
    tid!: string | undefined;
    outTid!: string | undefined;
    merOrderTid!: string | undefined;
    money!: number;
    agentRateCommission!: number;
    agentRate!: number;
    channelName!: string | undefined;
    channelTypeId!: number | undefined;
    channelTypeName!: string | undefined;
    channelTypeCode!: string | undefined;
    successTime!: Date | undefined;
    failTime!: Date | undefined;
    payOrderStatus!: PayOrderStatusEnum;
    readonly payOrderStatusName!: string | undefined;
    isBuDan!: boolean;
    channelId!: number | undefined;
    creationTime!: Date;
    payTimeConsuming!: number;
    errorMsg!: string | undefined;
    isCz!: boolean;
    channelRate!: number;
    endTime!: Date | undefined;
    clientUserPayRemark!: string | undefined;
    clientUserId!: string | undefined;
    clientUserName!: string | undefined;

    constructor(data?: IChannelOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tid = _data["tid"];
            this.outTid = _data["outTid"];
            this.merOrderTid = _data["merOrderTid"];
            this.money = _data["money"];
            this.agentRateCommission = _data["agentRateCommission"];
            this.agentRate = _data["agentRate"];
            this.channelName = _data["channelName"];
            this.channelTypeId = _data["channelTypeId"];
            this.channelTypeName = _data["channelTypeName"];
            this.channelTypeCode = _data["channelTypeCode"];
            this.successTime = _data["successTime"] ? new Date(_data["successTime"].toString()) : <any>undefined;
            this.failTime = _data["failTime"] ? new Date(_data["failTime"].toString()) : <any>undefined;
            this.payOrderStatus = _data["payOrderStatus"];
            (<any>this).payOrderStatusName = _data["payOrderStatusName"];
            this.isBuDan = _data["isBuDan"];
            this.channelId = _data["channelId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.payTimeConsuming = _data["payTimeConsuming"];
            this.errorMsg = _data["errorMsg"];
            this.isCz = _data["isCz"];
            this.channelRate = _data["channelRate"];
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.clientUserPayRemark = _data["clientUserPayRemark"];
            this.clientUserId = _data["clientUserId"];
            this.clientUserName = _data["clientUserName"];
        }
    }

    static fromJS(data: any): ChannelOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tid"] = this.tid;
        data["outTid"] = this.outTid;
        data["merOrderTid"] = this.merOrderTid;
        data["money"] = this.money;
        data["agentRateCommission"] = this.agentRateCommission;
        data["agentRate"] = this.agentRate;
        data["channelName"] = this.channelName;
        data["channelTypeId"] = this.channelTypeId;
        data["channelTypeName"] = this.channelTypeName;
        data["channelTypeCode"] = this.channelTypeCode;
        data["successTime"] = this.successTime ? this.successTime.toISOString() : <any>undefined;
        data["failTime"] = this.failTime ? this.failTime.toISOString() : <any>undefined;
        data["payOrderStatus"] = this.payOrderStatus;
        data["payOrderStatusName"] = this.payOrderStatusName;
        data["isBuDan"] = this.isBuDan;
        data["channelId"] = this.channelId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["payTimeConsuming"] = this.payTimeConsuming;
        data["errorMsg"] = this.errorMsg;
        data["isCz"] = this.isCz;
        data["channelRate"] = this.channelRate;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["clientUserPayRemark"] = this.clientUserPayRemark;
        data["clientUserId"] = this.clientUserId;
        data["clientUserName"] = this.clientUserName;
        return data;
    }

    clone(): ChannelOrderDto {
        const json = this.toJSON();
        let result = new ChannelOrderDto();
        result.init(json);
        return result;
    }
}

export interface IChannelOrderDto {
    id: number;
    tid: string | undefined;
    outTid: string | undefined;
    merOrderTid: string | undefined;
    money: number;
    agentRateCommission: number;
    agentRate: number;
    channelName: string | undefined;
    channelTypeId: number | undefined;
    channelTypeName: string | undefined;
    channelTypeCode: string | undefined;
    successTime: Date | undefined;
    failTime: Date | undefined;
    payOrderStatus: PayOrderStatusEnum;
    payOrderStatusName: string | undefined;
    isBuDan: boolean;
    channelId: number | undefined;
    creationTime: Date;
    payTimeConsuming: number;
    errorMsg: string | undefined;
    isCz: boolean;
    channelRate: number;
    endTime: Date | undefined;
    clientUserPayRemark: string | undefined;
    clientUserId: string | undefined;
    clientUserName: string | undefined;
}

export class ChannelOrderDtoPagedResultDto implements IChannelOrderDtoPagedResultDto {
    items!: ChannelOrderDto[] | undefined;
    totalCount!: number;

    constructor(data?: IChannelOrderDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ChannelOrderDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ChannelOrderDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelOrderDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ChannelOrderDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ChannelOrderDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IChannelOrderDtoPagedResultDto {
    items: ChannelOrderDto[] | undefined;
    totalCount: number;
}

export class ChannelPageInputDto implements IChannelPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    name!: string | undefined;
    channelTypeId!: number | undefined;
    agentId!: number | undefined;
    agentName!: string | undefined;
    payCode!: string | undefined;
    channelApiType!: ChannelApiTypeEnum;
    mid!: string | undefined;
    status!: StatusEnum;
    isZhiDing!: boolean | undefined;
    channelSupplierId!: number | undefined;
    createStartTime!: Date | undefined;
    createEndTime!: Date | undefined;

    constructor(data?: IChannelPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.name = _data["name"];
            this.channelTypeId = _data["channelTypeId"];
            this.agentId = _data["agentId"];
            this.agentName = _data["agentName"];
            this.payCode = _data["payCode"];
            this.channelApiType = _data["channelApiType"];
            this.mid = _data["mid"];
            this.status = _data["status"];
            this.isZhiDing = _data["isZhiDing"];
            this.channelSupplierId = _data["channelSupplierId"];
            this.createStartTime = _data["createStartTime"] ? new Date(_data["createStartTime"].toString()) : <any>undefined;
            this.createEndTime = _data["createEndTime"] ? new Date(_data["createEndTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ChannelPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["name"] = this.name;
        data["channelTypeId"] = this.channelTypeId;
        data["agentId"] = this.agentId;
        data["agentName"] = this.agentName;
        data["payCode"] = this.payCode;
        data["channelApiType"] = this.channelApiType;
        data["mid"] = this.mid;
        data["status"] = this.status;
        data["isZhiDing"] = this.isZhiDing;
        data["channelSupplierId"] = this.channelSupplierId;
        data["createStartTime"] = this.createStartTime ? this.createStartTime.toISOString() : <any>undefined;
        data["createEndTime"] = this.createEndTime ? this.createEndTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): ChannelPageInputDto {
        const json = this.toJSON();
        let result = new ChannelPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IChannelPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    name: string | undefined;
    channelTypeId: number | undefined;
    agentId: number | undefined;
    agentName: string | undefined;
    payCode: string | undefined;
    channelApiType: ChannelApiTypeEnum;
    mid: string | undefined;
    status: StatusEnum;
    isZhiDing: boolean | undefined;
    channelSupplierId: number | undefined;
    createStartTime: Date | undefined;
    createEndTime: Date | undefined;
}

export class ChannelsBadingChannelTypeInputDto implements IChannelsBadingChannelTypeInputDto {
    channelIds!: number[] | undefined;
    channelTypeId!: number;

    constructor(data?: IChannelsBadingChannelTypeInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["channelIds"])) {
                this.channelIds = [] as any;
                for (let item of _data["channelIds"])
                    this.channelIds!.push(item);
            }
            this.channelTypeId = _data["channelTypeId"];
        }
    }

    static fromJS(data: any): ChannelsBadingChannelTypeInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelsBadingChannelTypeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.channelIds)) {
            data["channelIds"] = [];
            for (let item of this.channelIds)
                data["channelIds"].push(item);
        }
        data["channelTypeId"] = this.channelTypeId;
        return data;
    }

    clone(): ChannelsBadingChannelTypeInputDto {
        const json = this.toJSON();
        let result = new ChannelsBadingChannelTypeInputDto();
        result.init(json);
        return result;
    }
}

export interface IChannelsBadingChannelTypeInputDto {
    channelIds: number[] | undefined;
    channelTypeId: number;
}

export class ChannelSettlementPreDataOutDto implements IChannelSettlementPreDataOutDto {
    channelId!: number | undefined;
    name!: string | undefined;
    money!: number;
    payMoney!: number;
    commission!: number;
    jiZhang!: number;
    jiZhangNum!: number;
    xiafa!: number;
    xiafaNum!: number;
    settlementAdvanceMoney!: number;
    settlementBalance!: number;
    settlementYingDe!: number;
    afterSettlementAdvanceMoney!: number;
    afterSettlementBalance!: number;
    afterSettlementYingDe!: number;

    constructor(data?: IChannelSettlementPreDataOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelId = _data["channelId"];
            this.name = _data["name"];
            this.money = _data["money"];
            this.payMoney = _data["payMoney"];
            this.commission = _data["commission"];
            this.jiZhang = _data["jiZhang"];
            this.jiZhangNum = _data["jiZhangNum"];
            this.xiafa = _data["xiafa"];
            this.xiafaNum = _data["xiafaNum"];
            this.settlementAdvanceMoney = _data["settlementAdvanceMoney"];
            this.settlementBalance = _data["settlementBalance"];
            this.settlementYingDe = _data["settlementYingDe"];
            this.afterSettlementAdvanceMoney = _data["afterSettlementAdvanceMoney"];
            this.afterSettlementBalance = _data["afterSettlementBalance"];
            this.afterSettlementYingDe = _data["afterSettlementYingDe"];
        }
    }

    static fromJS(data: any): ChannelSettlementPreDataOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelSettlementPreDataOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelId"] = this.channelId;
        data["name"] = this.name;
        data["money"] = this.money;
        data["payMoney"] = this.payMoney;
        data["commission"] = this.commission;
        data["jiZhang"] = this.jiZhang;
        data["jiZhangNum"] = this.jiZhangNum;
        data["xiafa"] = this.xiafa;
        data["xiafaNum"] = this.xiafaNum;
        data["settlementAdvanceMoney"] = this.settlementAdvanceMoney;
        data["settlementBalance"] = this.settlementBalance;
        data["settlementYingDe"] = this.settlementYingDe;
        data["afterSettlementAdvanceMoney"] = this.afterSettlementAdvanceMoney;
        data["afterSettlementBalance"] = this.afterSettlementBalance;
        data["afterSettlementYingDe"] = this.afterSettlementYingDe;
        return data;
    }

    clone(): ChannelSettlementPreDataOutDto {
        const json = this.toJSON();
        let result = new ChannelSettlementPreDataOutDto();
        result.init(json);
        return result;
    }
}

export interface IChannelSettlementPreDataOutDto {
    channelId: number | undefined;
    name: string | undefined;
    money: number;
    payMoney: number;
    commission: number;
    jiZhang: number;
    jiZhangNum: number;
    xiafa: number;
    xiafaNum: number;
    settlementAdvanceMoney: number;
    settlementBalance: number;
    settlementYingDe: number;
    afterSettlementAdvanceMoney: number;
    afterSettlementBalance: number;
    afterSettlementYingDe: number;
}

export class ChannelSettlementPreMerInputDto implements IChannelSettlementPreMerInputDto {
    channelIds!: number[] | undefined;
    time!: Date;

    constructor(data?: IChannelSettlementPreMerInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["channelIds"])) {
                this.channelIds = [] as any;
                for (let item of _data["channelIds"])
                    this.channelIds!.push(item);
            }
            this.time = _data["time"] ? new Date(_data["time"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ChannelSettlementPreMerInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelSettlementPreMerInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.channelIds)) {
            data["channelIds"] = [];
            for (let item of this.channelIds)
                data["channelIds"].push(item);
        }
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        return data;
    }

    clone(): ChannelSettlementPreMerInputDto {
        const json = this.toJSON();
        let result = new ChannelSettlementPreMerInputDto();
        result.init(json);
        return result;
    }
}

export interface IChannelSettlementPreMerInputDto {
    channelIds: number[] | undefined;
    time: Date;
}

export class ChannelSettlementPreOutDto implements IChannelSettlementPreOutDto {
    datas!: ChannelSettlementPreDataOutDto[] | undefined;

    constructor(data?: IChannelSettlementPreOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["datas"])) {
                this.datas = [] as any;
                for (let item of _data["datas"])
                    this.datas!.push(ChannelSettlementPreDataOutDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChannelSettlementPreOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelSettlementPreOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datas)) {
            data["datas"] = [];
            for (let item of this.datas)
                data["datas"].push(item.toJSON());
        }
        return data;
    }

    clone(): ChannelSettlementPreOutDto {
        const json = this.toJSON();
        let result = new ChannelSettlementPreOutDto();
        result.init(json);
        return result;
    }
}

export interface IChannelSettlementPreOutDto {
    datas: ChannelSettlementPreDataOutDto[] | undefined;
}

export class ChannelSimpleDto implements IChannelSimpleDto {
    id!: number;
    name!: string | undefined;
    channelTypeId!: number | undefined;
    channelTypeName!: string | undefined;
    balance!: number;
    status!: StatusEnum;
    rate!: number;
    agentRate!: number;
    weight!: number;

    constructor(data?: IChannelSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.channelTypeId = _data["channelTypeId"];
            this.channelTypeName = _data["channelTypeName"];
            this.balance = _data["balance"];
            this.status = _data["status"];
            this.rate = _data["rate"];
            this.agentRate = _data["agentRate"];
            this.weight = _data["weight"];
        }
    }

    static fromJS(data: any): ChannelSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["channelTypeId"] = this.channelTypeId;
        data["channelTypeName"] = this.channelTypeName;
        data["balance"] = this.balance;
        data["status"] = this.status;
        data["rate"] = this.rate;
        data["agentRate"] = this.agentRate;
        data["weight"] = this.weight;
        return data;
    }

    clone(): ChannelSimpleDto {
        const json = this.toJSON();
        let result = new ChannelSimpleDto();
        result.init(json);
        return result;
    }
}

export interface IChannelSimpleDto {
    id: number;
    name: string | undefined;
    channelTypeId: number | undefined;
    channelTypeName: string | undefined;
    balance: number;
    status: StatusEnum;
    rate: number;
    agentRate: number;
    weight: number;
}

export class ChannelSimpleInputDto implements IChannelSimpleInputDto {
    status!: StatusEnum;
    channelTypeId!: number | undefined;

    constructor(data?: IChannelSimpleInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.channelTypeId = _data["channelTypeId"];
        }
    }

    static fromJS(data: any): ChannelSimpleInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelSimpleInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["channelTypeId"] = this.channelTypeId;
        return data;
    }

    clone(): ChannelSimpleInputDto {
        const json = this.toJSON();
        let result = new ChannelSimpleInputDto();
        result.init(json);
        return result;
    }
}

export interface IChannelSimpleInputDto {
    status: StatusEnum;
    channelTypeId: number | undefined;
}

export class ChannelStatisticsDto implements IChannelStatisticsDto {
    channelName!: string | undefined;
    channelId!: number | undefined;
    totalOrderNum!: number;
    successOrderNum!: number;
    totalAmount!: number;
    successAmount!: number;
    liRun!: number;
    successRate!: number;
    channelRateCommission!: number;
    channelActualAmount!: number;
    buDanAmount!: number;
    buDanNum!: number;
    isBuDan!: boolean;

    constructor(data?: IChannelStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelName = _data["channelName"];
            this.channelId = _data["channelId"];
            this.totalOrderNum = _data["totalOrderNum"];
            this.successOrderNum = _data["successOrderNum"];
            this.totalAmount = _data["totalAmount"];
            this.successAmount = _data["successAmount"];
            this.liRun = _data["liRun"];
            this.successRate = _data["successRate"];
            this.channelRateCommission = _data["channelRateCommission"];
            this.channelActualAmount = _data["channelActualAmount"];
            this.buDanAmount = _data["buDanAmount"];
            this.buDanNum = _data["buDanNum"];
            this.isBuDan = _data["isBuDan"];
        }
    }

    static fromJS(data: any): ChannelStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelName"] = this.channelName;
        data["channelId"] = this.channelId;
        data["totalOrderNum"] = this.totalOrderNum;
        data["successOrderNum"] = this.successOrderNum;
        data["totalAmount"] = this.totalAmount;
        data["successAmount"] = this.successAmount;
        data["liRun"] = this.liRun;
        data["successRate"] = this.successRate;
        data["channelRateCommission"] = this.channelRateCommission;
        data["channelActualAmount"] = this.channelActualAmount;
        data["buDanAmount"] = this.buDanAmount;
        data["buDanNum"] = this.buDanNum;
        data["isBuDan"] = this.isBuDan;
        return data;
    }

    clone(): ChannelStatisticsDto {
        const json = this.toJSON();
        let result = new ChannelStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface IChannelStatisticsDto {
    channelName: string | undefined;
    channelId: number | undefined;
    totalOrderNum: number;
    successOrderNum: number;
    totalAmount: number;
    successAmount: number;
    liRun: number;
    successRate: number;
    channelRateCommission: number;
    channelActualAmount: number;
    buDanAmount: number;
    buDanNum: number;
    isBuDan: boolean;
}

export class ChannelSummaryDto implements IChannelSummaryDto {
    channelName!: string | undefined;
    balance!: number;
    totalMoney!: number;
    bargainMoney!: number;
    bargainRate!: number;
    agentMoney!: number;

    constructor(data?: IChannelSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelName = _data["channelName"];
            this.balance = _data["balance"];
            this.totalMoney = _data["totalMoney"];
            this.bargainMoney = _data["bargainMoney"];
            this.bargainRate = _data["bargainRate"];
            this.agentMoney = _data["agentMoney"];
        }
    }

    static fromJS(data: any): ChannelSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelName"] = this.channelName;
        data["balance"] = this.balance;
        data["totalMoney"] = this.totalMoney;
        data["bargainMoney"] = this.bargainMoney;
        data["bargainRate"] = this.bargainRate;
        data["agentMoney"] = this.agentMoney;
        return data;
    }

    clone(): ChannelSummaryDto {
        const json = this.toJSON();
        let result = new ChannelSummaryDto();
        result.init(json);
        return result;
    }
}

export interface IChannelSummaryDto {
    channelName: string | undefined;
    balance: number;
    totalMoney: number;
    bargainMoney: number;
    bargainRate: number;
    agentMoney: number;
}

export class ChannelSupplierCreditQuotaOrderDto implements IChannelSupplierCreditQuotaOrderDto {
    id!: number;
    orderNo!: string | undefined;
    channelSupplierId!: number | undefined;
    channelSupplierName!: string | undefined;
    money!: number;
    balance!: number;
    afterBalance!: number;
    createUserName!: string | undefined;
    creationTime!: Date;
    comment!: string | undefined;

    constructor(data?: IChannelSupplierCreditQuotaOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNo = _data["orderNo"];
            this.channelSupplierId = _data["channelSupplierId"];
            this.channelSupplierName = _data["channelSupplierName"];
            this.money = _data["money"];
            this.balance = _data["balance"];
            this.afterBalance = _data["afterBalance"];
            this.createUserName = _data["createUserName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): ChannelSupplierCreditQuotaOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelSupplierCreditQuotaOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNo"] = this.orderNo;
        data["channelSupplierId"] = this.channelSupplierId;
        data["channelSupplierName"] = this.channelSupplierName;
        data["money"] = this.money;
        data["balance"] = this.balance;
        data["afterBalance"] = this.afterBalance;
        data["createUserName"] = this.createUserName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        return data;
    }

    clone(): ChannelSupplierCreditQuotaOrderDto {
        const json = this.toJSON();
        let result = new ChannelSupplierCreditQuotaOrderDto();
        result.init(json);
        return result;
    }
}

export interface IChannelSupplierCreditQuotaOrderDto {
    id: number;
    orderNo: string | undefined;
    channelSupplierId: number | undefined;
    channelSupplierName: string | undefined;
    money: number;
    balance: number;
    afterBalance: number;
    createUserName: string | undefined;
    creationTime: Date;
    comment: string | undefined;
}

export class ChannelSupplierCreditQuotaOrderDtoPagedResultDto implements IChannelSupplierCreditQuotaOrderDtoPagedResultDto {
    items!: ChannelSupplierCreditQuotaOrderDto[] | undefined;
    totalCount!: number;

    constructor(data?: IChannelSupplierCreditQuotaOrderDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ChannelSupplierCreditQuotaOrderDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ChannelSupplierCreditQuotaOrderDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelSupplierCreditQuotaOrderDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ChannelSupplierCreditQuotaOrderDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ChannelSupplierCreditQuotaOrderDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IChannelSupplierCreditQuotaOrderDtoPagedResultDto {
    items: ChannelSupplierCreditQuotaOrderDto[] | undefined;
    totalCount: number;
}

export class ChannelSupplierCreditQuotaOrderPageInputDto implements IChannelSupplierCreditQuotaOrderPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    orderNo!: string | undefined;
    channelSupplierId!: number | undefined;
    channelSupplierName!: string | undefined;

    constructor(data?: IChannelSupplierCreditQuotaOrderPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.orderNo = _data["orderNo"];
            this.channelSupplierId = _data["channelSupplierId"];
            this.channelSupplierName = _data["channelSupplierName"];
        }
    }

    static fromJS(data: any): ChannelSupplierCreditQuotaOrderPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelSupplierCreditQuotaOrderPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["orderNo"] = this.orderNo;
        data["channelSupplierId"] = this.channelSupplierId;
        data["channelSupplierName"] = this.channelSupplierName;
        return data;
    }

    clone(): ChannelSupplierCreditQuotaOrderPageInputDto {
        const json = this.toJSON();
        let result = new ChannelSupplierCreditQuotaOrderPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IChannelSupplierCreditQuotaOrderPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    orderNo: string | undefined;
    channelSupplierId: number | undefined;
    channelSupplierName: string | undefined;
}

export class ChannelSupplierDayBillDto implements IChannelSupplierDayBillDto {
    channelSupplierId!: number | undefined;
    name!: string | undefined;
    money!: number;
    payMoney!: number;
    commission!: number;
    settlementTimeStr!: string | undefined;
    settlementTime!: Date;
    orderNum!: number;
    creationTime!: Date;

    constructor(data?: IChannelSupplierDayBillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelSupplierId = _data["channelSupplierId"];
            this.name = _data["name"];
            this.money = _data["money"];
            this.payMoney = _data["payMoney"];
            this.commission = _data["commission"];
            this.settlementTimeStr = _data["settlementTimeStr"];
            this.settlementTime = _data["settlementTime"] ? new Date(_data["settlementTime"].toString()) : <any>undefined;
            this.orderNum = _data["orderNum"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ChannelSupplierDayBillDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelSupplierDayBillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelSupplierId"] = this.channelSupplierId;
        data["name"] = this.name;
        data["money"] = this.money;
        data["payMoney"] = this.payMoney;
        data["commission"] = this.commission;
        data["settlementTimeStr"] = this.settlementTimeStr;
        data["settlementTime"] = this.settlementTime ? this.settlementTime.toISOString() : <any>undefined;
        data["orderNum"] = this.orderNum;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): ChannelSupplierDayBillDto {
        const json = this.toJSON();
        let result = new ChannelSupplierDayBillDto();
        result.init(json);
        return result;
    }
}

export interface IChannelSupplierDayBillDto {
    channelSupplierId: number | undefined;
    name: string | undefined;
    money: number;
    payMoney: number;
    commission: number;
    settlementTimeStr: string | undefined;
    settlementTime: Date;
    orderNum: number;
    creationTime: Date;
}

export class ChannelSupplierDayBillDtoPagedResultDto implements IChannelSupplierDayBillDtoPagedResultDto {
    items!: ChannelSupplierDayBillDto[] | undefined;
    totalCount!: number;

    constructor(data?: IChannelSupplierDayBillDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ChannelSupplierDayBillDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ChannelSupplierDayBillDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelSupplierDayBillDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ChannelSupplierDayBillDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ChannelSupplierDayBillDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IChannelSupplierDayBillDtoPagedResultDto {
    items: ChannelSupplierDayBillDto[] | undefined;
    totalCount: number;
}

export class ChannelSupplierDayBillPageInputDto implements IChannelSupplierDayBillPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    createStartTime!: Date | undefined;
    createEndTime!: Date | undefined;
    channelSupplierId!: number | undefined;

    constructor(data?: IChannelSupplierDayBillPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.createStartTime = _data["createStartTime"] ? new Date(_data["createStartTime"].toString()) : <any>undefined;
            this.createEndTime = _data["createEndTime"] ? new Date(_data["createEndTime"].toString()) : <any>undefined;
            this.channelSupplierId = _data["channelSupplierId"];
        }
    }

    static fromJS(data: any): ChannelSupplierDayBillPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelSupplierDayBillPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["createStartTime"] = this.createStartTime ? this.createStartTime.toISOString() : <any>undefined;
        data["createEndTime"] = this.createEndTime ? this.createEndTime.toISOString() : <any>undefined;
        data["channelSupplierId"] = this.channelSupplierId;
        return data;
    }

    clone(): ChannelSupplierDayBillPageInputDto {
        const json = this.toJSON();
        let result = new ChannelSupplierDayBillPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IChannelSupplierDayBillPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    createStartTime: Date | undefined;
    createEndTime: Date | undefined;
    channelSupplierId: number | undefined;
}

export class ChannelSupplierOutDto implements IChannelSupplierOutDto {
    id!: number;
    name!: string | undefined;
    balance!: number;
    advanceMoney!: number;
    readonly realBalance!: number;
    groupId!: string | undefined;
    isEnable!: boolean;
    agentId!: number | undefined;
    agentName!: string | undefined;
    creationTime!: Date;
    arrears!: number;
    creditQuota!: number;
    disableCreateOrder!: number;
    isDisableCreateOrder!: boolean;
    settlementTime!: string | undefined;
    sendBill!: boolean;
    balanceSettlement!: boolean;
    nextSettlementTime!: Date | undefined;
    advanceRemindTime!: number;
    isHuiFu!: boolean;

    constructor(data?: IChannelSupplierOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.balance = _data["balance"];
            this.advanceMoney = _data["advanceMoney"];
            (<any>this).realBalance = _data["realBalance"];
            this.groupId = _data["groupId"];
            this.isEnable = _data["isEnable"];
            this.agentId = _data["agentId"];
            this.agentName = _data["agentName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.arrears = _data["arrears"];
            this.creditQuota = _data["creditQuota"];
            this.disableCreateOrder = _data["disableCreateOrder"];
            this.isDisableCreateOrder = _data["isDisableCreateOrder"];
            this.settlementTime = _data["settlementTime"];
            this.sendBill = _data["sendBill"];
            this.balanceSettlement = _data["balanceSettlement"];
            this.nextSettlementTime = _data["nextSettlementTime"] ? new Date(_data["nextSettlementTime"].toString()) : <any>undefined;
            this.advanceRemindTime = _data["advanceRemindTime"];
            this.isHuiFu = _data["isHuiFu"];
        }
    }

    static fromJS(data: any): ChannelSupplierOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelSupplierOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["balance"] = this.balance;
        data["advanceMoney"] = this.advanceMoney;
        data["realBalance"] = this.realBalance;
        data["groupId"] = this.groupId;
        data["isEnable"] = this.isEnable;
        data["agentId"] = this.agentId;
        data["agentName"] = this.agentName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["arrears"] = this.arrears;
        data["creditQuota"] = this.creditQuota;
        data["disableCreateOrder"] = this.disableCreateOrder;
        data["isDisableCreateOrder"] = this.isDisableCreateOrder;
        data["settlementTime"] = this.settlementTime;
        data["sendBill"] = this.sendBill;
        data["balanceSettlement"] = this.balanceSettlement;
        data["nextSettlementTime"] = this.nextSettlementTime ? this.nextSettlementTime.toISOString() : <any>undefined;
        data["advanceRemindTime"] = this.advanceRemindTime;
        data["isHuiFu"] = this.isHuiFu;
        return data;
    }

    clone(): ChannelSupplierOutDto {
        const json = this.toJSON();
        let result = new ChannelSupplierOutDto();
        result.init(json);
        return result;
    }
}

export interface IChannelSupplierOutDto {
    id: number;
    name: string | undefined;
    balance: number;
    advanceMoney: number;
    realBalance: number;
    groupId: string | undefined;
    isEnable: boolean;
    agentId: number | undefined;
    agentName: string | undefined;
    creationTime: Date;
    arrears: number;
    creditQuota: number;
    disableCreateOrder: number;
    isDisableCreateOrder: boolean;
    settlementTime: string | undefined;
    sendBill: boolean;
    balanceSettlement: boolean;
    nextSettlementTime: Date | undefined;
    advanceRemindTime: number;
    isHuiFu: boolean;
}

export class ChannelSupplierOutDtoPagedResultDto implements IChannelSupplierOutDtoPagedResultDto {
    items!: ChannelSupplierOutDto[] | undefined;
    totalCount!: number;

    constructor(data?: IChannelSupplierOutDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ChannelSupplierOutDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ChannelSupplierOutDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelSupplierOutDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ChannelSupplierOutDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ChannelSupplierOutDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IChannelSupplierOutDtoPagedResultDto {
    items: ChannelSupplierOutDto[] | undefined;
    totalCount: number;
}

export class ChannelSupplierPageInputDto implements IChannelSupplierPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    name!: string | undefined;

    constructor(data?: IChannelSupplierPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ChannelSupplierPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelSupplierPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["name"] = this.name;
        return data;
    }

    clone(): ChannelSupplierPageInputDto {
        const json = this.toJSON();
        let result = new ChannelSupplierPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IChannelSupplierPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    name: string | undefined;
}

export class ChannelSupplierSettlementDto implements IChannelSupplierSettlementDto {
    supplierIds!: number[] | undefined;
    time!: Date;
    sendbills!: boolean;

    constructor(data?: IChannelSupplierSettlementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["supplierIds"])) {
                this.supplierIds = [] as any;
                for (let item of _data["supplierIds"])
                    this.supplierIds!.push(item);
            }
            this.time = _data["time"] ? new Date(_data["time"].toString()) : <any>undefined;
            this.sendbills = _data["sendbills"];
        }
    }

    static fromJS(data: any): ChannelSupplierSettlementDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelSupplierSettlementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.supplierIds)) {
            data["supplierIds"] = [];
            for (let item of this.supplierIds)
                data["supplierIds"].push(item);
        }
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        data["sendbills"] = this.sendbills;
        return data;
    }

    clone(): ChannelSupplierSettlementDto {
        const json = this.toJSON();
        let result = new ChannelSupplierSettlementDto();
        result.init(json);
        return result;
    }
}

export interface IChannelSupplierSettlementDto {
    supplierIds: number[] | undefined;
    time: Date;
    sendbills: boolean;
}

export class ChannelTotalOutDto implements IChannelTotalOutDto {
    balance!: number;
    advanceMoney!: number;
    creditQuota!: number;

    constructor(data?: IChannelTotalOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.balance = _data["balance"];
            this.advanceMoney = _data["advanceMoney"];
            this.creditQuota = _data["creditQuota"];
        }
    }

    static fromJS(data: any): ChannelTotalOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelTotalOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["balance"] = this.balance;
        data["advanceMoney"] = this.advanceMoney;
        data["creditQuota"] = this.creditQuota;
        return data;
    }

    clone(): ChannelTotalOutDto {
        const json = this.toJSON();
        let result = new ChannelTotalOutDto();
        result.init(json);
        return result;
    }
}

export interface IChannelTotalOutDto {
    balance: number;
    advanceMoney: number;
    creditQuota: number;
}

export class ChannelTypeChannelDto implements IChannelTypeChannelDto {
    id!: number;
    channelId!: number | undefined;
    channelTypeId!: number | undefined;
    weight!: number;
    channelName!: string | undefined;
    channelStatus!: StatusEnum;

    constructor(data?: IChannelTypeChannelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.channelId = _data["channelId"];
            this.channelTypeId = _data["channelTypeId"];
            this.weight = _data["weight"];
            this.channelName = _data["channelName"];
            this.channelStatus = _data["channelStatus"];
        }
    }

    static fromJS(data: any): ChannelTypeChannelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelTypeChannelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["channelId"] = this.channelId;
        data["channelTypeId"] = this.channelTypeId;
        data["weight"] = this.weight;
        data["channelName"] = this.channelName;
        data["channelStatus"] = this.channelStatus;
        return data;
    }

    clone(): ChannelTypeChannelDto {
        const json = this.toJSON();
        let result = new ChannelTypeChannelDto();
        result.init(json);
        return result;
    }
}

export interface IChannelTypeChannelDto {
    id: number;
    channelId: number | undefined;
    channelTypeId: number | undefined;
    weight: number;
    channelName: string | undefined;
    channelStatus: StatusEnum;
}

export class ChannelTypeDayBillDto implements IChannelTypeDayBillDto {
    channelTypeId!: number | undefined;
    name!: string | undefined;
    channelTypeCode!: string | undefined;
    money!: number;
    payMoney!: number;
    commission!: number;
    channelCommission!: number;
    settlementTimeStr!: string | undefined;
    orderNum!: number;
    settlementTime!: Date;
    creationTime!: Date;

    constructor(data?: IChannelTypeDayBillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelTypeId = _data["channelTypeId"];
            this.name = _data["name"];
            this.channelTypeCode = _data["channelTypeCode"];
            this.money = _data["money"];
            this.payMoney = _data["payMoney"];
            this.commission = _data["commission"];
            this.channelCommission = _data["channelCommission"];
            this.settlementTimeStr = _data["settlementTimeStr"];
            this.orderNum = _data["orderNum"];
            this.settlementTime = _data["settlementTime"] ? new Date(_data["settlementTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ChannelTypeDayBillDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelTypeDayBillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelTypeId"] = this.channelTypeId;
        data["name"] = this.name;
        data["channelTypeCode"] = this.channelTypeCode;
        data["money"] = this.money;
        data["payMoney"] = this.payMoney;
        data["commission"] = this.commission;
        data["channelCommission"] = this.channelCommission;
        data["settlementTimeStr"] = this.settlementTimeStr;
        data["orderNum"] = this.orderNum;
        data["settlementTime"] = this.settlementTime ? this.settlementTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): ChannelTypeDayBillDto {
        const json = this.toJSON();
        let result = new ChannelTypeDayBillDto();
        result.init(json);
        return result;
    }
}

export interface IChannelTypeDayBillDto {
    channelTypeId: number | undefined;
    name: string | undefined;
    channelTypeCode: string | undefined;
    money: number;
    payMoney: number;
    commission: number;
    channelCommission: number;
    settlementTimeStr: string | undefined;
    orderNum: number;
    settlementTime: Date;
    creationTime: Date;
}

export class ChannelTypeDayBillDtoPagedResultDto implements IChannelTypeDayBillDtoPagedResultDto {
    items!: ChannelTypeDayBillDto[] | undefined;
    totalCount!: number;

    constructor(data?: IChannelTypeDayBillDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ChannelTypeDayBillDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ChannelTypeDayBillDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelTypeDayBillDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ChannelTypeDayBillDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ChannelTypeDayBillDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IChannelTypeDayBillDtoPagedResultDto {
    items: ChannelTypeDayBillDto[] | undefined;
    totalCount: number;
}

export class ChannelTypeDayBillPageInputDto implements IChannelTypeDayBillPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    createStartTime!: Date | undefined;
    createEndTime!: Date | undefined;
    channelTypeId!: number | undefined;

    constructor(data?: IChannelTypeDayBillPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.createStartTime = _data["createStartTime"] ? new Date(_data["createStartTime"].toString()) : <any>undefined;
            this.createEndTime = _data["createEndTime"] ? new Date(_data["createEndTime"].toString()) : <any>undefined;
            this.channelTypeId = _data["channelTypeId"];
        }
    }

    static fromJS(data: any): ChannelTypeDayBillPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelTypeDayBillPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["createStartTime"] = this.createStartTime ? this.createStartTime.toISOString() : <any>undefined;
        data["createEndTime"] = this.createEndTime ? this.createEndTime.toISOString() : <any>undefined;
        data["channelTypeId"] = this.channelTypeId;
        return data;
    }

    clone(): ChannelTypeDayBillPageInputDto {
        const json = this.toJSON();
        let result = new ChannelTypeDayBillPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IChannelTypeDayBillPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    createStartTime: Date | undefined;
    createEndTime: Date | undefined;
    channelTypeId: number | undefined;
}

export class ChannelTypeDayClearDto implements IChannelTypeDayClearDto {
    id!: number;
    channelTypeId!: number | undefined;
    channelTypeName!: string | undefined;
    channelTypeCode!: string | undefined;
    totalOrderNum!: number;
    successOrderNum!: number;
    totalAmount!: number;
    successAmount!: number;
    liRun!: number;
    successRate!: number;
    settlementStatus!: number;
    settlementTime!: Date | undefined;
    startTime!: Date;
    endTime!: Date;
    creationTime!: Date;

    constructor(data?: IChannelTypeDayClearDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.channelTypeId = _data["channelTypeId"];
            this.channelTypeName = _data["channelTypeName"];
            this.channelTypeCode = _data["channelTypeCode"];
            this.totalOrderNum = _data["totalOrderNum"];
            this.successOrderNum = _data["successOrderNum"];
            this.totalAmount = _data["totalAmount"];
            this.successAmount = _data["successAmount"];
            this.liRun = _data["liRun"];
            this.successRate = _data["successRate"];
            this.settlementStatus = _data["settlementStatus"];
            this.settlementTime = _data["settlementTime"] ? new Date(_data["settlementTime"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ChannelTypeDayClearDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelTypeDayClearDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["channelTypeId"] = this.channelTypeId;
        data["channelTypeName"] = this.channelTypeName;
        data["channelTypeCode"] = this.channelTypeCode;
        data["totalOrderNum"] = this.totalOrderNum;
        data["successOrderNum"] = this.successOrderNum;
        data["totalAmount"] = this.totalAmount;
        data["successAmount"] = this.successAmount;
        data["liRun"] = this.liRun;
        data["successRate"] = this.successRate;
        data["settlementStatus"] = this.settlementStatus;
        data["settlementTime"] = this.settlementTime ? this.settlementTime.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): ChannelTypeDayClearDto {
        const json = this.toJSON();
        let result = new ChannelTypeDayClearDto();
        result.init(json);
        return result;
    }
}

export interface IChannelTypeDayClearDto {
    id: number;
    channelTypeId: number | undefined;
    channelTypeName: string | undefined;
    channelTypeCode: string | undefined;
    totalOrderNum: number;
    successOrderNum: number;
    totalAmount: number;
    successAmount: number;
    liRun: number;
    successRate: number;
    settlementStatus: number;
    settlementTime: Date | undefined;
    startTime: Date;
    endTime: Date;
    creationTime: Date;
}

export class ChannelTypeDayClearDtoPagedResultDto implements IChannelTypeDayClearDtoPagedResultDto {
    items!: ChannelTypeDayClearDto[] | undefined;
    totalCount!: number;

    constructor(data?: IChannelTypeDayClearDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ChannelTypeDayClearDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ChannelTypeDayClearDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelTypeDayClearDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ChannelTypeDayClearDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ChannelTypeDayClearDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IChannelTypeDayClearDtoPagedResultDto {
    items: ChannelTypeDayClearDto[] | undefined;
    totalCount: number;
}

export class ChannelTypeDayClearPageInputDto implements IChannelTypeDayClearPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    createTime!: Date | undefined;
    endTime!: Date | undefined;
    channelTypeId!: number | undefined;
    channelTypeName!: string | undefined;
    channelTypeCode!: string | undefined;

    constructor(data?: IChannelTypeDayClearPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.createTime = _data["createTime"] ? new Date(_data["createTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.channelTypeId = _data["channelTypeId"];
            this.channelTypeName = _data["channelTypeName"];
            this.channelTypeCode = _data["channelTypeCode"];
        }
    }

    static fromJS(data: any): ChannelTypeDayClearPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelTypeDayClearPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["channelTypeId"] = this.channelTypeId;
        data["channelTypeName"] = this.channelTypeName;
        data["channelTypeCode"] = this.channelTypeCode;
        return data;
    }

    clone(): ChannelTypeDayClearPageInputDto {
        const json = this.toJSON();
        let result = new ChannelTypeDayClearPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IChannelTypeDayClearPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    createTime: Date | undefined;
    endTime: Date | undefined;
    channelTypeId: number | undefined;
    channelTypeName: string | undefined;
    channelTypeCode: string | undefined;
}

export class ChannelTypeDto implements IChannelTypeDto {
    id!: number;
    name!: string | undefined;
    isEnable!: boolean;
    code!: string | undefined;
    comment!: string | undefined;
    rate!: number;
    qiangZhiLunXun!: boolean;
    channelIds!: number[] | undefined;
    channelTypeChannels!: ChannelTypeChannelDto[] | undefined;
    merchantChannelTypes!: MerchantChannelTypeDto[] | undefined;
    merchantAgentRates!: MerchantAgentRateDto[] | undefined;

    constructor(data?: IChannelTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isEnable = _data["isEnable"];
            this.code = _data["code"];
            this.comment = _data["comment"];
            this.rate = _data["rate"];
            this.qiangZhiLunXun = _data["qiangZhiLunXun"];
            if (Array.isArray(_data["channelIds"])) {
                this.channelIds = [] as any;
                for (let item of _data["channelIds"])
                    this.channelIds!.push(item);
            }
            if (Array.isArray(_data["channelTypeChannels"])) {
                this.channelTypeChannels = [] as any;
                for (let item of _data["channelTypeChannels"])
                    this.channelTypeChannels!.push(ChannelTypeChannelDto.fromJS(item));
            }
            if (Array.isArray(_data["merchantChannelTypes"])) {
                this.merchantChannelTypes = [] as any;
                for (let item of _data["merchantChannelTypes"])
                    this.merchantChannelTypes!.push(MerchantChannelTypeDto.fromJS(item));
            }
            if (Array.isArray(_data["merchantAgentRates"])) {
                this.merchantAgentRates = [] as any;
                for (let item of _data["merchantAgentRates"])
                    this.merchantAgentRates!.push(MerchantAgentRateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChannelTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isEnable"] = this.isEnable;
        data["code"] = this.code;
        data["comment"] = this.comment;
        data["rate"] = this.rate;
        data["qiangZhiLunXun"] = this.qiangZhiLunXun;
        if (Array.isArray(this.channelIds)) {
            data["channelIds"] = [];
            for (let item of this.channelIds)
                data["channelIds"].push(item);
        }
        if (Array.isArray(this.channelTypeChannels)) {
            data["channelTypeChannels"] = [];
            for (let item of this.channelTypeChannels)
                data["channelTypeChannels"].push(item.toJSON());
        }
        if (Array.isArray(this.merchantChannelTypes)) {
            data["merchantChannelTypes"] = [];
            for (let item of this.merchantChannelTypes)
                data["merchantChannelTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.merchantAgentRates)) {
            data["merchantAgentRates"] = [];
            for (let item of this.merchantAgentRates)
                data["merchantAgentRates"].push(item.toJSON());
        }
        return data;
    }

    clone(): ChannelTypeDto {
        const json = this.toJSON();
        let result = new ChannelTypeDto();
        result.init(json);
        return result;
    }
}

export interface IChannelTypeDto {
    id: number;
    name: string | undefined;
    isEnable: boolean;
    code: string | undefined;
    comment: string | undefined;
    rate: number;
    qiangZhiLunXun: boolean;
    channelIds: number[] | undefined;
    channelTypeChannels: ChannelTypeChannelDto[] | undefined;
    merchantChannelTypes: MerchantChannelTypeDto[] | undefined;
    merchantAgentRates: MerchantAgentRateDto[] | undefined;
}

export class ChannelTypeDtoPagedResultDto implements IChannelTypeDtoPagedResultDto {
    items!: ChannelTypeDto[] | undefined;
    totalCount!: number;

    constructor(data?: IChannelTypeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ChannelTypeDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ChannelTypeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelTypeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ChannelTypeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ChannelTypeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IChannelTypeDtoPagedResultDto {
    items: ChannelTypeDto[] | undefined;
    totalCount: number;
}

export class ChannelTypePageInputDto implements IChannelTypePageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    isEnable!: boolean | undefined;
    name!: string | undefined;
    code!: string | undefined;

    constructor(data?: IChannelTypePageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.isEnable = _data["isEnable"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ChannelTypePageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelTypePageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["isEnable"] = this.isEnable;
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }

    clone(): ChannelTypePageInputDto {
        const json = this.toJSON();
        let result = new ChannelTypePageInputDto();
        result.init(json);
        return result;
    }
}

export interface IChannelTypePageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    isEnable: boolean | undefined;
    name: string | undefined;
    code: string | undefined;
}

export class ChannelTypeSimpleDto implements IChannelTypeSimpleDto {
    id!: number;
    name!: string | undefined;
    isEnable!: boolean;
    code!: string | undefined;
    rate!: number;

    constructor(data?: IChannelTypeSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isEnable = _data["isEnable"];
            this.code = _data["code"];
            this.rate = _data["rate"];
        }
    }

    static fromJS(data: any): ChannelTypeSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelTypeSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isEnable"] = this.isEnable;
        data["code"] = this.code;
        data["rate"] = this.rate;
        return data;
    }

    clone(): ChannelTypeSimpleDto {
        const json = this.toJSON();
        let result = new ChannelTypeSimpleDto();
        result.init(json);
        return result;
    }
}

export interface IChannelTypeSimpleDto {
    id: number;
    name: string | undefined;
    isEnable: boolean;
    code: string | undefined;
    rate: number;
}

export class ChannelTypeStatisticsDto implements IChannelTypeStatisticsDto {
    channelTypeName!: string | undefined;
    channelTypeId!: number | undefined;
    channelTypeCode!: string | undefined;
    totalOrderNum!: number;
    successOrderNum!: number;
    totalAmount!: number;
    successAmount!: number;
    liRun!: number;
    successRate!: number;
    channelRateCommission!: number;
    commission!: number;
    channelActualAmount!: number;
    merchantActualAmount!: number;
    buDanAmount!: number;
    buDanNum!: number;

    constructor(data?: IChannelTypeStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelTypeName = _data["channelTypeName"];
            this.channelTypeId = _data["channelTypeId"];
            this.channelTypeCode = _data["channelTypeCode"];
            this.totalOrderNum = _data["totalOrderNum"];
            this.successOrderNum = _data["successOrderNum"];
            this.totalAmount = _data["totalAmount"];
            this.successAmount = _data["successAmount"];
            this.liRun = _data["liRun"];
            this.successRate = _data["successRate"];
            this.channelRateCommission = _data["channelRateCommission"];
            this.commission = _data["commission"];
            this.channelActualAmount = _data["channelActualAmount"];
            this.merchantActualAmount = _data["merchantActualAmount"];
            this.buDanAmount = _data["buDanAmount"];
            this.buDanNum = _data["buDanNum"];
        }
    }

    static fromJS(data: any): ChannelTypeStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelTypeStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelTypeName"] = this.channelTypeName;
        data["channelTypeId"] = this.channelTypeId;
        data["channelTypeCode"] = this.channelTypeCode;
        data["totalOrderNum"] = this.totalOrderNum;
        data["successOrderNum"] = this.successOrderNum;
        data["totalAmount"] = this.totalAmount;
        data["successAmount"] = this.successAmount;
        data["liRun"] = this.liRun;
        data["successRate"] = this.successRate;
        data["channelRateCommission"] = this.channelRateCommission;
        data["commission"] = this.commission;
        data["channelActualAmount"] = this.channelActualAmount;
        data["merchantActualAmount"] = this.merchantActualAmount;
        data["buDanAmount"] = this.buDanAmount;
        data["buDanNum"] = this.buDanNum;
        return data;
    }

    clone(): ChannelTypeStatisticsDto {
        const json = this.toJSON();
        let result = new ChannelTypeStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface IChannelTypeStatisticsDto {
    channelTypeName: string | undefined;
    channelTypeId: number | undefined;
    channelTypeCode: string | undefined;
    totalOrderNum: number;
    successOrderNum: number;
    totalAmount: number;
    successAmount: number;
    liRun: number;
    successRate: number;
    channelRateCommission: number;
    commission: number;
    channelActualAmount: number;
    merchantActualAmount: number;
    buDanAmount: number;
    buDanNum: number;
}

export class ChannelUpdatelimitInputDto implements IChannelUpdatelimitInputDto {
    channelIds!: number[] | undefined;
    shouKuanFangShi!: number;
    shouKuanGuiZe!: string | undefined;

    constructor(data?: IChannelUpdatelimitInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["channelIds"])) {
                this.channelIds = [] as any;
                for (let item of _data["channelIds"])
                    this.channelIds!.push(item);
            }
            this.shouKuanFangShi = _data["shouKuanFangShi"];
            this.shouKuanGuiZe = _data["shouKuanGuiZe"];
        }
    }

    static fromJS(data: any): ChannelUpdatelimitInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelUpdatelimitInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.channelIds)) {
            data["channelIds"] = [];
            for (let item of this.channelIds)
                data["channelIds"].push(item);
        }
        data["shouKuanFangShi"] = this.shouKuanFangShi;
        data["shouKuanGuiZe"] = this.shouKuanGuiZe;
        return data;
    }

    clone(): ChannelUpdatelimitInputDto {
        const json = this.toJSON();
        let result = new ChannelUpdatelimitInputDto();
        result.init(json);
        return result;
    }
}

export interface IChannelUpdatelimitInputDto {
    channelIds: number[] | undefined;
    shouKuanFangShi: number;
    shouKuanGuiZe: string | undefined;
}

export class ClearSettingDto implements IClearSettingDto {
    id!: number;
    autoMerchantGroup!: boolean;
    autoChannelGroup!: boolean;

    constructor(data?: IClearSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.autoMerchantGroup = _data["autoMerchantGroup"];
            this.autoChannelGroup = _data["autoChannelGroup"];
        }
    }

    static fromJS(data: any): ClearSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClearSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["autoMerchantGroup"] = this.autoMerchantGroup;
        data["autoChannelGroup"] = this.autoChannelGroup;
        return data;
    }

    clone(): ClearSettingDto {
        const json = this.toJSON();
        let result = new ClearSettingDto();
        result.init(json);
        return result;
    }
}

export interface IClearSettingDto {
    id: number;
    autoMerchantGroup: boolean;
    autoChannelGroup: boolean;
}

export class ClientMerAndChannelTypeDayBillPageInputDto implements IClientMerAndChannelTypeDayBillPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    createStartTime!: Date | undefined;
    createEndTime!: Date | undefined;
    merchantId!: number | undefined;
    channelTypeCode!: string | undefined;

    constructor(data?: IClientMerAndChannelTypeDayBillPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.createStartTime = _data["createStartTime"] ? new Date(_data["createStartTime"].toString()) : <any>undefined;
            this.createEndTime = _data["createEndTime"] ? new Date(_data["createEndTime"].toString()) : <any>undefined;
            this.merchantId = _data["merchantId"];
            this.channelTypeCode = _data["channelTypeCode"];
        }
    }

    static fromJS(data: any): ClientMerAndChannelTypeDayBillPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientMerAndChannelTypeDayBillPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["createStartTime"] = this.createStartTime ? this.createStartTime.toISOString() : <any>undefined;
        data["createEndTime"] = this.createEndTime ? this.createEndTime.toISOString() : <any>undefined;
        data["merchantId"] = this.merchantId;
        data["channelTypeCode"] = this.channelTypeCode;
        return data;
    }

    clone(): ClientMerAndChannelTypeDayBillPageInputDto {
        const json = this.toJSON();
        let result = new ClientMerAndChannelTypeDayBillPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IClientMerAndChannelTypeDayBillPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    createStartTime: Date | undefined;
    createEndTime: Date | undefined;
    merchantId: number | undefined;
    channelTypeCode: string | undefined;
}

export class CopyMerchantRateInputDto implements ICopyMerchantRateInputDto {
    merchantId!: number;
    merchantIds!: number[] | undefined;

    constructor(data?: ICopyMerchantRateInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.merchantId = _data["merchantId"];
            if (Array.isArray(_data["merchantIds"])) {
                this.merchantIds = [] as any;
                for (let item of _data["merchantIds"])
                    this.merchantIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CopyMerchantRateInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CopyMerchantRateInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["merchantId"] = this.merchantId;
        if (Array.isArray(this.merchantIds)) {
            data["merchantIds"] = [];
            for (let item of this.merchantIds)
                data["merchantIds"].push(item);
        }
        return data;
    }

    clone(): CopyMerchantRateInputDto {
        const json = this.toJSON();
        let result = new CopyMerchantRateInputDto();
        result.init(json);
        return result;
    }
}

export interface ICopyMerchantRateInputDto {
    merchantId: number;
    merchantIds: number[] | undefined;
}

export class CreatePayOrderInputDto implements ICreatePayOrderInputDto {
    merOrderTid!: string | undefined;
    merId!: number;
    channelTypeCode!: string | undefined;
    money!: number;
    channelId!: number | undefined;
    clientUserPayRemark!: string | undefined;
    orderApiIps!: string | undefined;
    clientUserId!: string | undefined;
    clientUserName!: string | undefined;

    constructor(data?: ICreatePayOrderInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.merOrderTid = _data["merOrderTid"];
            this.merId = _data["merId"];
            this.channelTypeCode = _data["channelTypeCode"];
            this.money = _data["money"];
            this.channelId = _data["channelId"];
            this.clientUserPayRemark = _data["clientUserPayRemark"];
            this.orderApiIps = _data["orderApiIps"];
            this.clientUserId = _data["clientUserId"];
            this.clientUserName = _data["clientUserName"];
        }
    }

    static fromJS(data: any): CreatePayOrderInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePayOrderInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["merOrderTid"] = this.merOrderTid;
        data["merId"] = this.merId;
        data["channelTypeCode"] = this.channelTypeCode;
        data["money"] = this.money;
        data["channelId"] = this.channelId;
        data["clientUserPayRemark"] = this.clientUserPayRemark;
        data["orderApiIps"] = this.orderApiIps;
        data["clientUserId"] = this.clientUserId;
        data["clientUserName"] = this.clientUserName;
        return data;
    }

    clone(): CreatePayOrderInputDto {
        const json = this.toJSON();
        let result = new CreatePayOrderInputDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePayOrderInputDto {
    merOrderTid: string | undefined;
    merId: number;
    channelTypeCode: string | undefined;
    money: number;
    channelId: number | undefined;
    clientUserPayRemark: string | undefined;
    orderApiIps: string | undefined;
    clientUserId: string | undefined;
    clientUserName: string | undefined;
}

export class CreateRoleDto implements ICreateRoleDto {
    name!: string;
    displayName!: string;
    normalizedName!: string | undefined;
    description!: string | undefined;
    grantedPermissions!: string[] | undefined;

    constructor(data?: ICreateRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data;
    }

    clone(): CreateRoleDto {
        const json = this.toJSON();
        let result = new CreateRoleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class CreateTenantDto implements ICreateTenantDto {
    tenancyName!: string;
    name!: string;
    adminEmailAddress!: string;
    connectionString!: string | undefined;
    isActive!: boolean;

    constructor(data?: ICreateTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): CreateTenantDto {
        const json = this.toJSON();
        let result = new CreateTenantDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean;
}

export class CreateUserDto implements ICreateUserDto {
    userName!: string;
    name!: string;
    surname!: string;
    emailAddress!: string;
    isActive!: boolean;
    roleNames!: string[] | undefined;
    password!: string;
    isShow!: boolean;

    constructor(data?: ICreateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
            this.password = _data["password"];
            this.isShow = _data["isShow"];
        }
    }

    static fromJS(data: any): CreateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["password"] = this.password;
        data["isShow"] = this.isShow;
        return data;
    }

    clone(): CreateUserDto {
        const json = this.toJSON();
        let result = new CreateUserDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    roleNames: string[] | undefined;
    password: string;
    isShow: boolean;
}

export class EditMerchantRateDto implements IEditMerchantRateDto {
    channelTypeId!: number[] | undefined;
    merchantId!: number;
    merchantRate!: string | undefined;
    isAuto!: boolean;
    isAdd!: boolean;

    constructor(data?: IEditMerchantRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["channelTypeId"])) {
                this.channelTypeId = [] as any;
                for (let item of _data["channelTypeId"])
                    this.channelTypeId!.push(item);
            }
            this.merchantId = _data["merchantId"];
            this.merchantRate = _data["merchantRate"];
            this.isAuto = _data["isAuto"];
            this.isAdd = _data["isAdd"];
        }
    }

    static fromJS(data: any): EditMerchantRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditMerchantRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.channelTypeId)) {
            data["channelTypeId"] = [];
            for (let item of this.channelTypeId)
                data["channelTypeId"].push(item);
        }
        data["merchantId"] = this.merchantId;
        data["merchantRate"] = this.merchantRate;
        data["isAuto"] = this.isAuto;
        data["isAdd"] = this.isAdd;
        return data;
    }

    clone(): EditMerchantRateDto {
        const json = this.toJSON();
        let result = new EditMerchantRateDto();
        result.init(json);
        return result;
    }
}

export interface IEditMerchantRateDto {
    channelTypeId: number[] | undefined;
    merchantId: number;
    merchantRate: string | undefined;
    isAuto: boolean;
    isAdd: boolean;
}

export class FileDto implements IFileDto {
    fileName!: string;
    fileType!: string;
    fileToken!: string;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileToken = _data["fileToken"];
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }

    clone(): FileDto {
        const json = this.toJSON();
        let result = new FileDto();
        result.init(json);
        return result;
    }
}

export interface IFileDto {
    fileName: string;
    fileType: string;
    fileToken: string;
}

export class FinancialStatisticsChannelOutDto implements IFinancialStatisticsChannelOutDto {
    channelId!: number | undefined;
    name!: string | undefined;
    money!: number;
    payMoney!: number;
    budanNum!: number;
    budanMoney!: number;
    commission!: number;
    orderNum!: number;

    constructor(data?: IFinancialStatisticsChannelOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelId = _data["channelId"];
            this.name = _data["name"];
            this.money = _data["money"];
            this.payMoney = _data["payMoney"];
            this.budanNum = _data["budanNum"];
            this.budanMoney = _data["budanMoney"];
            this.commission = _data["commission"];
            this.orderNum = _data["orderNum"];
        }
    }

    static fromJS(data: any): FinancialStatisticsChannelOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialStatisticsChannelOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelId"] = this.channelId;
        data["name"] = this.name;
        data["money"] = this.money;
        data["payMoney"] = this.payMoney;
        data["budanNum"] = this.budanNum;
        data["budanMoney"] = this.budanMoney;
        data["commission"] = this.commission;
        data["orderNum"] = this.orderNum;
        return data;
    }

    clone(): FinancialStatisticsChannelOutDto {
        const json = this.toJSON();
        let result = new FinancialStatisticsChannelOutDto();
        result.init(json);
        return result;
    }
}

export interface IFinancialStatisticsChannelOutDto {
    channelId: number | undefined;
    name: string | undefined;
    money: number;
    payMoney: number;
    budanNum: number;
    budanMoney: number;
    commission: number;
    orderNum: number;
}

export class FinancialStatisticsChannelSupplierOutDto implements IFinancialStatisticsChannelSupplierOutDto {
    channelSupplierId!: number | undefined;
    name!: string | undefined;
    money!: number;
    payMoney!: number;
    commission!: number;
    orderNum!: number;

    constructor(data?: IFinancialStatisticsChannelSupplierOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelSupplierId = _data["channelSupplierId"];
            this.name = _data["name"];
            this.money = _data["money"];
            this.payMoney = _data["payMoney"];
            this.commission = _data["commission"];
            this.orderNum = _data["orderNum"];
        }
    }

    static fromJS(data: any): FinancialStatisticsChannelSupplierOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialStatisticsChannelSupplierOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelSupplierId"] = this.channelSupplierId;
        data["name"] = this.name;
        data["money"] = this.money;
        data["payMoney"] = this.payMoney;
        data["commission"] = this.commission;
        data["orderNum"] = this.orderNum;
        return data;
    }

    clone(): FinancialStatisticsChannelSupplierOutDto {
        const json = this.toJSON();
        let result = new FinancialStatisticsChannelSupplierOutDto();
        result.init(json);
        return result;
    }
}

export interface IFinancialStatisticsChannelSupplierOutDto {
    channelSupplierId: number | undefined;
    name: string | undefined;
    money: number;
    payMoney: number;
    commission: number;
    orderNum: number;
}

export class FinancialStatisticsChannelTypeOutDto implements IFinancialStatisticsChannelTypeOutDto {
    channelTypeId!: number | undefined;
    name!: string | undefined;
    channelTypeCode!: string | undefined;
    money!: number;
    payMoney!: number;
    commission!: number;
    channelCommission!: number;
    orderNum!: number;

    constructor(data?: IFinancialStatisticsChannelTypeOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelTypeId = _data["channelTypeId"];
            this.name = _data["name"];
            this.channelTypeCode = _data["channelTypeCode"];
            this.money = _data["money"];
            this.payMoney = _data["payMoney"];
            this.commission = _data["commission"];
            this.channelCommission = _data["channelCommission"];
            this.orderNum = _data["orderNum"];
        }
    }

    static fromJS(data: any): FinancialStatisticsChannelTypeOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialStatisticsChannelTypeOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelTypeId"] = this.channelTypeId;
        data["name"] = this.name;
        data["channelTypeCode"] = this.channelTypeCode;
        data["money"] = this.money;
        data["payMoney"] = this.payMoney;
        data["commission"] = this.commission;
        data["channelCommission"] = this.channelCommission;
        data["orderNum"] = this.orderNum;
        return data;
    }

    clone(): FinancialStatisticsChannelTypeOutDto {
        const json = this.toJSON();
        let result = new FinancialStatisticsChannelTypeOutDto();
        result.init(json);
        return result;
    }
}

export interface IFinancialStatisticsChannelTypeOutDto {
    channelTypeId: number | undefined;
    name: string | undefined;
    channelTypeCode: string | undefined;
    money: number;
    payMoney: number;
    commission: number;
    channelCommission: number;
    orderNum: number;
}

export class FinancialStatisticsMerchantChannelOutDto implements IFinancialStatisticsMerchantChannelOutDto {
    merId!: number | undefined;
    merName!: string | undefined;
    mid!: string | undefined;
    channelId!: number | undefined;
    channelName!: string | undefined;
    money!: number;
    payMoney!: number;
    commission!: number;
    channelCommission!: number;
    orderNum!: number;

    constructor(data?: IFinancialStatisticsMerchantChannelOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.merId = _data["merId"];
            this.merName = _data["merName"];
            this.mid = _data["mid"];
            this.channelId = _data["channelId"];
            this.channelName = _data["channelName"];
            this.money = _data["money"];
            this.payMoney = _data["payMoney"];
            this.commission = _data["commission"];
            this.channelCommission = _data["channelCommission"];
            this.orderNum = _data["orderNum"];
        }
    }

    static fromJS(data: any): FinancialStatisticsMerchantChannelOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialStatisticsMerchantChannelOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["merId"] = this.merId;
        data["merName"] = this.merName;
        data["mid"] = this.mid;
        data["channelId"] = this.channelId;
        data["channelName"] = this.channelName;
        data["money"] = this.money;
        data["payMoney"] = this.payMoney;
        data["commission"] = this.commission;
        data["channelCommission"] = this.channelCommission;
        data["orderNum"] = this.orderNum;
        return data;
    }

    clone(): FinancialStatisticsMerchantChannelOutDto {
        const json = this.toJSON();
        let result = new FinancialStatisticsMerchantChannelOutDto();
        result.init(json);
        return result;
    }
}

export interface IFinancialStatisticsMerchantChannelOutDto {
    merId: number | undefined;
    merName: string | undefined;
    mid: string | undefined;
    channelId: number | undefined;
    channelName: string | undefined;
    money: number;
    payMoney: number;
    commission: number;
    channelCommission: number;
    orderNum: number;
}

export class FinancialStatisticsMerchantChannelTypeOutDto implements IFinancialStatisticsMerchantChannelTypeOutDto {
    merId!: number | undefined;
    merName!: string | undefined;
    mid!: string | undefined;
    channelTypeId!: number | undefined;
    channelTypeName!: string | undefined;
    channelTypeCode!: string | undefined;
    payMoney!: number;
    money!: number;
    commission!: number;
    orderNum!: number;

    constructor(data?: IFinancialStatisticsMerchantChannelTypeOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.merId = _data["merId"];
            this.merName = _data["merName"];
            this.mid = _data["mid"];
            this.channelTypeId = _data["channelTypeId"];
            this.channelTypeName = _data["channelTypeName"];
            this.channelTypeCode = _data["channelTypeCode"];
            this.payMoney = _data["payMoney"];
            this.money = _data["money"];
            this.commission = _data["commission"];
            this.orderNum = _data["orderNum"];
        }
    }

    static fromJS(data: any): FinancialStatisticsMerchantChannelTypeOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialStatisticsMerchantChannelTypeOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["merId"] = this.merId;
        data["merName"] = this.merName;
        data["mid"] = this.mid;
        data["channelTypeId"] = this.channelTypeId;
        data["channelTypeName"] = this.channelTypeName;
        data["channelTypeCode"] = this.channelTypeCode;
        data["payMoney"] = this.payMoney;
        data["money"] = this.money;
        data["commission"] = this.commission;
        data["orderNum"] = this.orderNum;
        return data;
    }

    clone(): FinancialStatisticsMerchantChannelTypeOutDto {
        const json = this.toJSON();
        let result = new FinancialStatisticsMerchantChannelTypeOutDto();
        result.init(json);
        return result;
    }
}

export interface IFinancialStatisticsMerchantChannelTypeOutDto {
    merId: number | undefined;
    merName: string | undefined;
    mid: string | undefined;
    channelTypeId: number | undefined;
    channelTypeName: string | undefined;
    channelTypeCode: string | undefined;
    payMoney: number;
    money: number;
    commission: number;
    orderNum: number;
}

export class FinancialStatisticsMerchantOutDto implements IFinancialStatisticsMerchantOutDto {
    merId!: number | undefined;
    name!: string | undefined;
    mid!: string | undefined;
    money!: number;
    payMoney!: number;
    budanNum!: number;
    budanMoney!: number;
    commission!: number;
    orderNum!: number;

    constructor(data?: IFinancialStatisticsMerchantOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.merId = _data["merId"];
            this.name = _data["name"];
            this.mid = _data["mid"];
            this.money = _data["money"];
            this.payMoney = _data["payMoney"];
            this.budanNum = _data["budanNum"];
            this.budanMoney = _data["budanMoney"];
            this.commission = _data["commission"];
            this.orderNum = _data["orderNum"];
        }
    }

    static fromJS(data: any): FinancialStatisticsMerchantOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialStatisticsMerchantOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["merId"] = this.merId;
        data["name"] = this.name;
        data["mid"] = this.mid;
        data["money"] = this.money;
        data["payMoney"] = this.payMoney;
        data["budanNum"] = this.budanNum;
        data["budanMoney"] = this.budanMoney;
        data["commission"] = this.commission;
        data["orderNum"] = this.orderNum;
        return data;
    }

    clone(): FinancialStatisticsMerchantOutDto {
        const json = this.toJSON();
        let result = new FinancialStatisticsMerchantOutDto();
        result.init(json);
        return result;
    }
}

export interface IFinancialStatisticsMerchantOutDto {
    merId: number | undefined;
    name: string | undefined;
    mid: string | undefined;
    money: number;
    payMoney: number;
    budanNum: number;
    budanMoney: number;
    commission: number;
    orderNum: number;
}

export class FinancialStatisticsSystemPayOrderOutDto implements IFinancialStatisticsSystemPayOrderOutDto {
    orderNum!: number;
    money!: number;
    payMoney!: number;
    budanNum!: number;
    budanMoney!: number;
    commission!: number;
    channelCommission!: number;

    constructor(data?: IFinancialStatisticsSystemPayOrderOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderNum = _data["orderNum"];
            this.money = _data["money"];
            this.payMoney = _data["payMoney"];
            this.budanNum = _data["budanNum"];
            this.budanMoney = _data["budanMoney"];
            this.commission = _data["commission"];
            this.channelCommission = _data["channelCommission"];
        }
    }

    static fromJS(data: any): FinancialStatisticsSystemPayOrderOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialStatisticsSystemPayOrderOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderNum"] = this.orderNum;
        data["money"] = this.money;
        data["payMoney"] = this.payMoney;
        data["budanNum"] = this.budanNum;
        data["budanMoney"] = this.budanMoney;
        data["commission"] = this.commission;
        data["channelCommission"] = this.channelCommission;
        return data;
    }

    clone(): FinancialStatisticsSystemPayOrderOutDto {
        const json = this.toJSON();
        let result = new FinancialStatisticsSystemPayOrderOutDto();
        result.init(json);
        return result;
    }
}

export interface IFinancialStatisticsSystemPayOrderOutDto {
    orderNum: number;
    money: number;
    payMoney: number;
    budanNum: number;
    budanMoney: number;
    commission: number;
    channelCommission: number;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }

    clone(): FlatPermissionDto {
        const json = this.toJSON();
        let result = new FlatPermissionDto();
        result.init(json);
        return result;
    }
}

export interface IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class GetAuditLogsInput implements IGetAuditLogsInput {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    startDate!: Date | undefined;
    endDate!: Date | undefined;
    userName!: string | undefined;
    serviceName!: string | undefined;
    methodName!: string | undefined;
    browserInfo!: string | undefined;
    clientName!: string | undefined;
    hasException!: boolean | undefined;
    minExecutionDuration!: number | undefined;
    maxExecutionDuration!: number | undefined;

    constructor(data?: IGetAuditLogsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.userName = _data["userName"];
            this.serviceName = _data["serviceName"];
            this.methodName = _data["methodName"];
            this.browserInfo = _data["browserInfo"];
            this.clientName = _data["clientName"];
            this.hasException = _data["hasException"];
            this.minExecutionDuration = _data["minExecutionDuration"];
            this.maxExecutionDuration = _data["maxExecutionDuration"];
        }
    }

    static fromJS(data: any): GetAuditLogsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAuditLogsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["userName"] = this.userName;
        data["serviceName"] = this.serviceName;
        data["methodName"] = this.methodName;
        data["browserInfo"] = this.browserInfo;
        data["clientName"] = this.clientName;
        data["hasException"] = this.hasException;
        data["minExecutionDuration"] = this.minExecutionDuration;
        data["maxExecutionDuration"] = this.maxExecutionDuration;
        return data;
    }

    clone(): GetAuditLogsInput {
        const json = this.toJSON();
        let result = new GetAuditLogsInput();
        result.init(json);
        return result;
    }
}

export interface IGetAuditLogsInput {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    startDate: Date | undefined;
    endDate: Date | undefined;
    userName: string | undefined;
    serviceName: string | undefined;
    methodName: string | undefined;
    browserInfo: string | undefined;
    clientName: string | undefined;
    hasException: boolean | undefined;
    minExecutionDuration: number | undefined;
    maxExecutionDuration: number | undefined;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    application!: ApplicationInfoDto;
    user!: UserLoginInfoDto;
    tenant!: TenantLoginInfoDto;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : <any>undefined;
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetCurrentLoginInformationsOutput {
        const json = this.toJSON();
        let result = new GetCurrentLoginInformationsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role!: RoleEditDto;
    permissions!: FlatPermissionDto[] | undefined;
    grantedPermissionNames!: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }

    clone(): GetRoleForEditOutput {
        const json = this.toJSON();
        let result = new GetRoleForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class HomeOutDto implements IHomeOutDto {
    merchantNum!: number;
    agentNum!: number;
    channelNum!: number;
    productNum!: number;

    constructor(data?: IHomeOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.merchantNum = _data["merchantNum"];
            this.agentNum = _data["agentNum"];
            this.channelNum = _data["channelNum"];
            this.productNum = _data["productNum"];
        }
    }

    static fromJS(data: any): HomeOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new HomeOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["merchantNum"] = this.merchantNum;
        data["agentNum"] = this.agentNum;
        data["channelNum"] = this.channelNum;
        data["productNum"] = this.productNum;
        return data;
    }

    clone(): HomeOutDto {
        const json = this.toJSON();
        let result = new HomeOutDto();
        result.init(json);
        return result;
    }
}

export interface IHomeOutDto {
    merchantNum: number;
    agentNum: number;
    channelNum: number;
    productNum: number;
}

export class IdsDto implements IIdsDto {
    idList!: number[] | undefined;

    constructor(data?: IIdsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["idList"])) {
                this.idList = [] as any;
                for (let item of _data["idList"])
                    this.idList!.push(item);
            }
        }
    }

    static fromJS(data: any): IdsDto {
        data = typeof data === 'object' ? data : {};
        let result = new IdsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.idList)) {
            data["idList"] = [];
            for (let item of this.idList)
                data["idList"].push(item);
        }
        return data;
    }

    clone(): IdsDto {
        const json = this.toJSON();
        let result = new IdsDto();
        result.init(json);
        return result;
    }
}

export interface IIdsDto {
    idList: number[] | undefined;
}

export class Int64EntityDto implements IInt64EntityDto {
    id!: number;

    constructor(data?: IInt64EntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Int64EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new Int64EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): Int64EntityDto {
        const json = this.toJSON();
        let result = new Int64EntityDto();
        result.init(json);
        return result;
    }
}

export interface IInt64EntityDto {
    id: number;
}

export class MerchantAgentRateDto implements IMerchantAgentRateDto {
    id!: number;
    merchantId!: number | undefined;
    channelTypeId!: number | undefined;
    agentRate!: number;
    merchantName!: string | undefined;
    channelTypeName!: string | undefined;

    constructor(data?: IMerchantAgentRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.merchantId = _data["merchantId"];
            this.channelTypeId = _data["channelTypeId"];
            this.agentRate = _data["agentRate"];
            this.merchantName = _data["merchantName"];
            this.channelTypeName = _data["channelTypeName"];
        }
    }

    static fromJS(data: any): MerchantAgentRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantAgentRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["merchantId"] = this.merchantId;
        data["channelTypeId"] = this.channelTypeId;
        data["agentRate"] = this.agentRate;
        data["merchantName"] = this.merchantName;
        data["channelTypeName"] = this.channelTypeName;
        return data;
    }

    clone(): MerchantAgentRateDto {
        const json = this.toJSON();
        let result = new MerchantAgentRateDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantAgentRateDto {
    id: number;
    merchantId: number | undefined;
    channelTypeId: number | undefined;
    agentRate: number;
    merchantName: string | undefined;
    channelTypeName: string | undefined;
}

export class MerchantAndChannelDayBillDto implements IMerchantAndChannelDayBillDto {
    merId!: number | undefined;
    merName!: string | undefined;
    mid!: string | undefined;
    channelId!: number | undefined;
    channelName!: string | undefined;
    money!: number;
    payMoney!: number;
    commission!: number;
    channelCommission!: number;
    settlementTimeStr!: string | undefined;
    settlementTime!: Date;
    orderNum!: number;
    creationTime!: Date;

    constructor(data?: IMerchantAndChannelDayBillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.merId = _data["merId"];
            this.merName = _data["merName"];
            this.mid = _data["mid"];
            this.channelId = _data["channelId"];
            this.channelName = _data["channelName"];
            this.money = _data["money"];
            this.payMoney = _data["payMoney"];
            this.commission = _data["commission"];
            this.channelCommission = _data["channelCommission"];
            this.settlementTimeStr = _data["settlementTimeStr"];
            this.settlementTime = _data["settlementTime"] ? new Date(_data["settlementTime"].toString()) : <any>undefined;
            this.orderNum = _data["orderNum"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MerchantAndChannelDayBillDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantAndChannelDayBillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["merId"] = this.merId;
        data["merName"] = this.merName;
        data["mid"] = this.mid;
        data["channelId"] = this.channelId;
        data["channelName"] = this.channelName;
        data["money"] = this.money;
        data["payMoney"] = this.payMoney;
        data["commission"] = this.commission;
        data["channelCommission"] = this.channelCommission;
        data["settlementTimeStr"] = this.settlementTimeStr;
        data["settlementTime"] = this.settlementTime ? this.settlementTime.toISOString() : <any>undefined;
        data["orderNum"] = this.orderNum;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): MerchantAndChannelDayBillDto {
        const json = this.toJSON();
        let result = new MerchantAndChannelDayBillDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantAndChannelDayBillDto {
    merId: number | undefined;
    merName: string | undefined;
    mid: string | undefined;
    channelId: number | undefined;
    channelName: string | undefined;
    money: number;
    payMoney: number;
    commission: number;
    channelCommission: number;
    settlementTimeStr: string | undefined;
    settlementTime: Date;
    orderNum: number;
    creationTime: Date;
}

export class MerchantAndChannelDayBillDtoPagedResultDto implements IMerchantAndChannelDayBillDtoPagedResultDto {
    items!: MerchantAndChannelDayBillDto[] | undefined;
    totalCount!: number;

    constructor(data?: IMerchantAndChannelDayBillDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MerchantAndChannelDayBillDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MerchantAndChannelDayBillDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantAndChannelDayBillDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MerchantAndChannelDayBillDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MerchantAndChannelDayBillDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantAndChannelDayBillDtoPagedResultDto {
    items: MerchantAndChannelDayBillDto[] | undefined;
    totalCount: number;
}

export class MerchantAndChannelDayBillPageInputDto implements IMerchantAndChannelDayBillPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    createStartTime!: Date | undefined;
    createEndTime!: Date | undefined;
    channelId!: number | undefined;
    merchantId!: number | undefined;

    constructor(data?: IMerchantAndChannelDayBillPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.createStartTime = _data["createStartTime"] ? new Date(_data["createStartTime"].toString()) : <any>undefined;
            this.createEndTime = _data["createEndTime"] ? new Date(_data["createEndTime"].toString()) : <any>undefined;
            this.channelId = _data["channelId"];
            this.merchantId = _data["merchantId"];
        }
    }

    static fromJS(data: any): MerchantAndChannelDayBillPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantAndChannelDayBillPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["createStartTime"] = this.createStartTime ? this.createStartTime.toISOString() : <any>undefined;
        data["createEndTime"] = this.createEndTime ? this.createEndTime.toISOString() : <any>undefined;
        data["channelId"] = this.channelId;
        data["merchantId"] = this.merchantId;
        return data;
    }

    clone(): MerchantAndChannelDayBillPageInputDto {
        const json = this.toJSON();
        let result = new MerchantAndChannelDayBillPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantAndChannelDayBillPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    createStartTime: Date | undefined;
    createEndTime: Date | undefined;
    channelId: number | undefined;
    merchantId: number | undefined;
}

export class MerchantAndChannelTypeDayBillDto implements IMerchantAndChannelTypeDayBillDto {
    merId!: number | undefined;
    merName!: string | undefined;
    mid!: string | undefined;
    channelTypeId!: number | undefined;
    channelTypeName!: string | undefined;
    channelTypeCode!: string | undefined;
    money!: number;
    payMoney!: number;
    commission!: number;
    settlementTimeStr!: string | undefined;
    settlementTime!: Date;
    orderNum!: number;
    creationTime!: Date;

    constructor(data?: IMerchantAndChannelTypeDayBillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.merId = _data["merId"];
            this.merName = _data["merName"];
            this.mid = _data["mid"];
            this.channelTypeId = _data["channelTypeId"];
            this.channelTypeName = _data["channelTypeName"];
            this.channelTypeCode = _data["channelTypeCode"];
            this.money = _data["money"];
            this.payMoney = _data["payMoney"];
            this.commission = _data["commission"];
            this.settlementTimeStr = _data["settlementTimeStr"];
            this.settlementTime = _data["settlementTime"] ? new Date(_data["settlementTime"].toString()) : <any>undefined;
            this.orderNum = _data["orderNum"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MerchantAndChannelTypeDayBillDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantAndChannelTypeDayBillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["merId"] = this.merId;
        data["merName"] = this.merName;
        data["mid"] = this.mid;
        data["channelTypeId"] = this.channelTypeId;
        data["channelTypeName"] = this.channelTypeName;
        data["channelTypeCode"] = this.channelTypeCode;
        data["money"] = this.money;
        data["payMoney"] = this.payMoney;
        data["commission"] = this.commission;
        data["settlementTimeStr"] = this.settlementTimeStr;
        data["settlementTime"] = this.settlementTime ? this.settlementTime.toISOString() : <any>undefined;
        data["orderNum"] = this.orderNum;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): MerchantAndChannelTypeDayBillDto {
        const json = this.toJSON();
        let result = new MerchantAndChannelTypeDayBillDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantAndChannelTypeDayBillDto {
    merId: number | undefined;
    merName: string | undefined;
    mid: string | undefined;
    channelTypeId: number | undefined;
    channelTypeName: string | undefined;
    channelTypeCode: string | undefined;
    money: number;
    payMoney: number;
    commission: number;
    settlementTimeStr: string | undefined;
    settlementTime: Date;
    orderNum: number;
    creationTime: Date;
}

export class MerchantAndChannelTypeDayBillDtoPagedResultDto implements IMerchantAndChannelTypeDayBillDtoPagedResultDto {
    items!: MerchantAndChannelTypeDayBillDto[] | undefined;
    totalCount!: number;

    constructor(data?: IMerchantAndChannelTypeDayBillDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MerchantAndChannelTypeDayBillDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MerchantAndChannelTypeDayBillDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantAndChannelTypeDayBillDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MerchantAndChannelTypeDayBillDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MerchantAndChannelTypeDayBillDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantAndChannelTypeDayBillDtoPagedResultDto {
    items: MerchantAndChannelTypeDayBillDto[] | undefined;
    totalCount: number;
}

export class MerchantAndChannelTypeDayBillPageInputDto implements IMerchantAndChannelTypeDayBillPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    createStartTime!: Date | undefined;
    createEndTime!: Date | undefined;
    merchantId!: number | undefined;
    channelTypeId!: number | undefined;

    constructor(data?: IMerchantAndChannelTypeDayBillPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.createStartTime = _data["createStartTime"] ? new Date(_data["createStartTime"].toString()) : <any>undefined;
            this.createEndTime = _data["createEndTime"] ? new Date(_data["createEndTime"].toString()) : <any>undefined;
            this.merchantId = _data["merchantId"];
            this.channelTypeId = _data["channelTypeId"];
        }
    }

    static fromJS(data: any): MerchantAndChannelTypeDayBillPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantAndChannelTypeDayBillPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["createStartTime"] = this.createStartTime ? this.createStartTime.toISOString() : <any>undefined;
        data["createEndTime"] = this.createEndTime ? this.createEndTime.toISOString() : <any>undefined;
        data["merchantId"] = this.merchantId;
        data["channelTypeId"] = this.channelTypeId;
        return data;
    }

    clone(): MerchantAndChannelTypeDayBillPageInputDto {
        const json = this.toJSON();
        let result = new MerchantAndChannelTypeDayBillPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantAndChannelTypeDayBillPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    createStartTime: Date | undefined;
    createEndTime: Date | undefined;
    merchantId: number | undefined;
    channelTypeId: number | undefined;
}

export class MerchantAndMerBinDingDto implements IMerchantAndMerBinDingDto {
    id!: number;
    name!: string | undefined;
    creationTime!: Date;

    constructor(data?: IMerchantAndMerBinDingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MerchantAndMerBinDingDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantAndMerBinDingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): MerchantAndMerBinDingDto {
        const json = this.toJSON();
        let result = new MerchantAndMerBinDingDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantAndMerBinDingDto {
    id: number;
    name: string | undefined;
    creationTime: Date;
}

export class MerchantAndMerBinDingDtoPagedResultDto implements IMerchantAndMerBinDingDtoPagedResultDto {
    items!: MerchantAndMerBinDingDto[] | undefined;
    totalCount!: number;

    constructor(data?: IMerchantAndMerBinDingDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MerchantAndMerBinDingDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MerchantAndMerBinDingDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantAndMerBinDingDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MerchantAndMerBinDingDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MerchantAndMerBinDingDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantAndMerBinDingDtoPagedResultDto {
    items: MerchantAndMerBinDingDto[] | undefined;
    totalCount: number;
}

export class MerchantAndMerBinDingPageInputDto implements IMerchantAndMerBinDingPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    name!: string | undefined;

    constructor(data?: IMerchantAndMerBinDingPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MerchantAndMerBinDingPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantAndMerBinDingPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["name"] = this.name;
        return data;
    }

    clone(): MerchantAndMerBinDingPageInputDto {
        const json = this.toJSON();
        let result = new MerchantAndMerBinDingPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantAndMerBinDingPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    name: string | undefined;
}

export class MerchantApidocDto implements IMerchantApidocDto {
    apiUrl!: string | undefined;
    merchantUrl!: string | undefined;
    userName!: string | undefined;
    loginPwd!: string | undefined;
    mid!: string | undefined;
    mSecret!: string | undefined;
    apiIps!: string | undefined;
    createOrderUrl!: string | undefined;
    queryOrderUrl!: string | undefined;
    docUrl!: string | undefined;
    merchantName!: string | undefined;

    constructor(data?: IMerchantApidocDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiUrl = _data["apiUrl"];
            this.merchantUrl = _data["merchantUrl"];
            this.userName = _data["userName"];
            this.loginPwd = _data["loginPwd"];
            this.mid = _data["mid"];
            this.mSecret = _data["mSecret"];
            this.apiIps = _data["apiIps"];
            this.createOrderUrl = _data["createOrderUrl"];
            this.queryOrderUrl = _data["queryOrderUrl"];
            this.docUrl = _data["docUrl"];
            this.merchantName = _data["merchantName"];
        }
    }

    static fromJS(data: any): MerchantApidocDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantApidocDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiUrl"] = this.apiUrl;
        data["merchantUrl"] = this.merchantUrl;
        data["userName"] = this.userName;
        data["loginPwd"] = this.loginPwd;
        data["mid"] = this.mid;
        data["mSecret"] = this.mSecret;
        data["apiIps"] = this.apiIps;
        data["createOrderUrl"] = this.createOrderUrl;
        data["queryOrderUrl"] = this.queryOrderUrl;
        data["docUrl"] = this.docUrl;
        data["merchantName"] = this.merchantName;
        return data;
    }

    clone(): MerchantApidocDto {
        const json = this.toJSON();
        let result = new MerchantApidocDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantApidocDto {
    apiUrl: string | undefined;
    merchantUrl: string | undefined;
    userName: string | undefined;
    loginPwd: string | undefined;
    mid: string | undefined;
    mSecret: string | undefined;
    apiIps: string | undefined;
    createOrderUrl: string | undefined;
    queryOrderUrl: string | undefined;
    docUrl: string | undefined;
    merchantName: string | undefined;
}

export class MerchantBalanceAdjustOrderDto implements IMerchantBalanceAdjustOrderDto {
    id!: number;
    orderNo!: string | undefined;
    merchantId!: number | undefined;
    mid!: string | undefined;
    merchantName!: string | undefined;
    money!: number;
    balance!: number;
    afterBalance!: number;
    createUserName!: string | undefined;
    creationTime!: Date;
    comment!: string | undefined;

    constructor(data?: IMerchantBalanceAdjustOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNo = _data["orderNo"];
            this.merchantId = _data["merchantId"];
            this.mid = _data["mid"];
            this.merchantName = _data["merchantName"];
            this.money = _data["money"];
            this.balance = _data["balance"];
            this.afterBalance = _data["afterBalance"];
            this.createUserName = _data["createUserName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): MerchantBalanceAdjustOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantBalanceAdjustOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNo"] = this.orderNo;
        data["merchantId"] = this.merchantId;
        data["mid"] = this.mid;
        data["merchantName"] = this.merchantName;
        data["money"] = this.money;
        data["balance"] = this.balance;
        data["afterBalance"] = this.afterBalance;
        data["createUserName"] = this.createUserName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        return data;
    }

    clone(): MerchantBalanceAdjustOrderDto {
        const json = this.toJSON();
        let result = new MerchantBalanceAdjustOrderDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantBalanceAdjustOrderDto {
    id: number;
    orderNo: string | undefined;
    merchantId: number | undefined;
    mid: string | undefined;
    merchantName: string | undefined;
    money: number;
    balance: number;
    afterBalance: number;
    createUserName: string | undefined;
    creationTime: Date;
    comment: string | undefined;
}

export class MerchantBalanceAdjustOrderDtoPagedResultDto implements IMerchantBalanceAdjustOrderDtoPagedResultDto {
    items!: MerchantBalanceAdjustOrderDto[] | undefined;
    totalCount!: number;

    constructor(data?: IMerchantBalanceAdjustOrderDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MerchantBalanceAdjustOrderDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MerchantBalanceAdjustOrderDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantBalanceAdjustOrderDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MerchantBalanceAdjustOrderDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MerchantBalanceAdjustOrderDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantBalanceAdjustOrderDtoPagedResultDto {
    items: MerchantBalanceAdjustOrderDto[] | undefined;
    totalCount: number;
}

export class MerchantBalanceAdjustOrderPageInputDto implements IMerchantBalanceAdjustOrderPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    merchantId!: number | undefined;
    orderNo!: string | undefined;
    mid!: string | undefined;
    merchantName!: string | undefined;
    createStartTime!: Date | undefined;
    createEndTime!: Date | undefined;

    constructor(data?: IMerchantBalanceAdjustOrderPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.merchantId = _data["merchantId"];
            this.orderNo = _data["orderNo"];
            this.mid = _data["mid"];
            this.merchantName = _data["merchantName"];
            this.createStartTime = _data["createStartTime"] ? new Date(_data["createStartTime"].toString()) : <any>undefined;
            this.createEndTime = _data["createEndTime"] ? new Date(_data["createEndTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MerchantBalanceAdjustOrderPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantBalanceAdjustOrderPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["merchantId"] = this.merchantId;
        data["orderNo"] = this.orderNo;
        data["mid"] = this.mid;
        data["merchantName"] = this.merchantName;
        data["createStartTime"] = this.createStartTime ? this.createStartTime.toISOString() : <any>undefined;
        data["createEndTime"] = this.createEndTime ? this.createEndTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): MerchantBalanceAdjustOrderPageInputDto {
        const json = this.toJSON();
        let result = new MerchantBalanceAdjustOrderPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantBalanceAdjustOrderPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    merchantId: number | undefined;
    orderNo: string | undefined;
    mid: string | undefined;
    merchantName: string | undefined;
    createStartTime: Date | undefined;
    createEndTime: Date | undefined;
}

export class MerchantBalanceLogDto implements IMerchantBalanceLogDto {
    id!: number;
    serialNumber!: string | undefined;
    merchantId!: number | undefined;
    mid!: string | undefined;
    merchantName!: string | undefined;
    money!: number;
    balance!: number;
    afterBalance!: number;
    tid!: string | undefined;
    merchantTid!: string | undefined;
    tradeId!: number | undefined;
    balanceType!: BalanceTypeEnum;
    readonly balanceTypeName!: string | undefined;
    orderMoney!: number;
    orderCommission!: number;
    creationTime!: Date;
    comment!: string | undefined;

    constructor(data?: IMerchantBalanceLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serialNumber = _data["serialNumber"];
            this.merchantId = _data["merchantId"];
            this.mid = _data["mid"];
            this.merchantName = _data["merchantName"];
            this.money = _data["money"];
            this.balance = _data["balance"];
            this.afterBalance = _data["afterBalance"];
            this.tid = _data["tid"];
            this.merchantTid = _data["merchantTid"];
            this.tradeId = _data["tradeId"];
            this.balanceType = _data["balanceType"];
            (<any>this).balanceTypeName = _data["balanceTypeName"];
            this.orderMoney = _data["orderMoney"];
            this.orderCommission = _data["orderCommission"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): MerchantBalanceLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantBalanceLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serialNumber"] = this.serialNumber;
        data["merchantId"] = this.merchantId;
        data["mid"] = this.mid;
        data["merchantName"] = this.merchantName;
        data["money"] = this.money;
        data["balance"] = this.balance;
        data["afterBalance"] = this.afterBalance;
        data["tid"] = this.tid;
        data["merchantTid"] = this.merchantTid;
        data["tradeId"] = this.tradeId;
        data["balanceType"] = this.balanceType;
        data["balanceTypeName"] = this.balanceTypeName;
        data["orderMoney"] = this.orderMoney;
        data["orderCommission"] = this.orderCommission;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        return data;
    }

    clone(): MerchantBalanceLogDto {
        const json = this.toJSON();
        let result = new MerchantBalanceLogDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantBalanceLogDto {
    id: number;
    serialNumber: string | undefined;
    merchantId: number | undefined;
    mid: string | undefined;
    merchantName: string | undefined;
    money: number;
    balance: number;
    afterBalance: number;
    tid: string | undefined;
    merchantTid: string | undefined;
    tradeId: number | undefined;
    balanceType: BalanceTypeEnum;
    balanceTypeName: string | undefined;
    orderMoney: number;
    orderCommission: number;
    creationTime: Date;
    comment: string | undefined;
}

export class MerchantBalanceLogDtoPagedResultDto implements IMerchantBalanceLogDtoPagedResultDto {
    items!: MerchantBalanceLogDto[] | undefined;
    totalCount!: number;

    constructor(data?: IMerchantBalanceLogDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MerchantBalanceLogDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MerchantBalanceLogDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantBalanceLogDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MerchantBalanceLogDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MerchantBalanceLogDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantBalanceLogDtoPagedResultDto {
    items: MerchantBalanceLogDto[] | undefined;
    totalCount: number;
}

export class MerchantBalanceLogPageInputDto implements IMerchantBalanceLogPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    balanceType!: BalanceTypeEnum;
    serialNumber!: string | undefined;
    merchantId!: number | undefined;
    mid!: string | undefined;
    merchantName!: string | undefined;
    tid!: string | undefined;
    createStartTime!: Date | undefined;
    createEndTime!: Date | undefined;
    merchantTid!: string | undefined;

    constructor(data?: IMerchantBalanceLogPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.balanceType = _data["balanceType"];
            this.serialNumber = _data["serialNumber"];
            this.merchantId = _data["merchantId"];
            this.mid = _data["mid"];
            this.merchantName = _data["merchantName"];
            this.tid = _data["tid"];
            this.createStartTime = _data["createStartTime"] ? new Date(_data["createStartTime"].toString()) : <any>undefined;
            this.createEndTime = _data["createEndTime"] ? new Date(_data["createEndTime"].toString()) : <any>undefined;
            this.merchantTid = _data["merchantTid"];
        }
    }

    static fromJS(data: any): MerchantBalanceLogPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantBalanceLogPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["balanceType"] = this.balanceType;
        data["serialNumber"] = this.serialNumber;
        data["merchantId"] = this.merchantId;
        data["mid"] = this.mid;
        data["merchantName"] = this.merchantName;
        data["tid"] = this.tid;
        data["createStartTime"] = this.createStartTime ? this.createStartTime.toISOString() : <any>undefined;
        data["createEndTime"] = this.createEndTime ? this.createEndTime.toISOString() : <any>undefined;
        data["merchantTid"] = this.merchantTid;
        return data;
    }

    clone(): MerchantBalanceLogPageInputDto {
        const json = this.toJSON();
        let result = new MerchantBalanceLogPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantBalanceLogPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    balanceType: BalanceTypeEnum;
    serialNumber: string | undefined;
    merchantId: number | undefined;
    mid: string | undefined;
    merchantName: string | undefined;
    tid: string | undefined;
    createStartTime: Date | undefined;
    createEndTime: Date | undefined;
    merchantTid: string | undefined;
}

export class MerchantBinDingOutDto implements IMerchantBinDingOutDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: IMerchantBinDingOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MerchantBinDingOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantBinDingOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): MerchantBinDingOutDto {
        const json = this.toJSON();
        let result = new MerchantBinDingOutDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantBinDingOutDto {
    id: number;
    name: string | undefined;
}

export class MerchantChannelDayClearDto implements IMerchantChannelDayClearDto {
    id!: number;
    merchantId!: number | undefined;
    mid!: string | undefined;
    merchantName!: string | undefined;
    channelId!: number | undefined;
    channelName!: string | undefined;
    totalOrderNum!: number;
    successOrderNum!: number;
    totalAmount!: number;
    successAmount!: number;
    liRun!: number;
    successRate!: number;
    startTime!: Date;
    endTime!: Date;
    commission!: number;
    channelRateCommission!: number;
    creationTime!: Date;

    constructor(data?: IMerchantChannelDayClearDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.merchantId = _data["merchantId"];
            this.mid = _data["mid"];
            this.merchantName = _data["merchantName"];
            this.channelId = _data["channelId"];
            this.channelName = _data["channelName"];
            this.totalOrderNum = _data["totalOrderNum"];
            this.successOrderNum = _data["successOrderNum"];
            this.totalAmount = _data["totalAmount"];
            this.successAmount = _data["successAmount"];
            this.liRun = _data["liRun"];
            this.successRate = _data["successRate"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.commission = _data["commission"];
            this.channelRateCommission = _data["channelRateCommission"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MerchantChannelDayClearDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantChannelDayClearDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["merchantId"] = this.merchantId;
        data["mid"] = this.mid;
        data["merchantName"] = this.merchantName;
        data["channelId"] = this.channelId;
        data["channelName"] = this.channelName;
        data["totalOrderNum"] = this.totalOrderNum;
        data["successOrderNum"] = this.successOrderNum;
        data["totalAmount"] = this.totalAmount;
        data["successAmount"] = this.successAmount;
        data["liRun"] = this.liRun;
        data["successRate"] = this.successRate;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["commission"] = this.commission;
        data["channelRateCommission"] = this.channelRateCommission;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): MerchantChannelDayClearDto {
        const json = this.toJSON();
        let result = new MerchantChannelDayClearDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantChannelDayClearDto {
    id: number;
    merchantId: number | undefined;
    mid: string | undefined;
    merchantName: string | undefined;
    channelId: number | undefined;
    channelName: string | undefined;
    totalOrderNum: number;
    successOrderNum: number;
    totalAmount: number;
    successAmount: number;
    liRun: number;
    successRate: number;
    startTime: Date;
    endTime: Date;
    commission: number;
    channelRateCommission: number;
    creationTime: Date;
}

export class MerchantChannelDayClearDtoPagedResultDto implements IMerchantChannelDayClearDtoPagedResultDto {
    items!: MerchantChannelDayClearDto[] | undefined;
    totalCount!: number;

    constructor(data?: IMerchantChannelDayClearDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MerchantChannelDayClearDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MerchantChannelDayClearDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantChannelDayClearDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MerchantChannelDayClearDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MerchantChannelDayClearDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantChannelDayClearDtoPagedResultDto {
    items: MerchantChannelDayClearDto[] | undefined;
    totalCount: number;
}

export class MerchantChannelDayClearPageInputDto implements IMerchantChannelDayClearPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    createTime!: Date | undefined;
    endTime!: Date | undefined;
    merchantId!: number | undefined;
    mid!: string | undefined;
    merchantName!: string | undefined;
    channelId!: number | undefined;
    channelName!: string | undefined;

    constructor(data?: IMerchantChannelDayClearPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.createTime = _data["createTime"] ? new Date(_data["createTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.merchantId = _data["merchantId"];
            this.mid = _data["mid"];
            this.merchantName = _data["merchantName"];
            this.channelId = _data["channelId"];
            this.channelName = _data["channelName"];
        }
    }

    static fromJS(data: any): MerchantChannelDayClearPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantChannelDayClearPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["merchantId"] = this.merchantId;
        data["mid"] = this.mid;
        data["merchantName"] = this.merchantName;
        data["channelId"] = this.channelId;
        data["channelName"] = this.channelName;
        return data;
    }

    clone(): MerchantChannelDayClearPageInputDto {
        const json = this.toJSON();
        let result = new MerchantChannelDayClearPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantChannelDayClearPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    createTime: Date | undefined;
    endTime: Date | undefined;
    merchantId: number | undefined;
    mid: string | undefined;
    merchantName: string | undefined;
    channelId: number | undefined;
    channelName: string | undefined;
}

export class MerchantChannelDto implements IMerchantChannelDto {
    id!: number;
    merchantId!: number | undefined;
    channelId!: number | undefined;
    weight!: number;
    channelName!: string | undefined;
    channelTypeId!: number | undefined;

    constructor(data?: IMerchantChannelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.merchantId = _data["merchantId"];
            this.channelId = _data["channelId"];
            this.weight = _data["weight"];
            this.channelName = _data["channelName"];
            this.channelTypeId = _data["channelTypeId"];
        }
    }

    static fromJS(data: any): MerchantChannelDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantChannelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["merchantId"] = this.merchantId;
        data["channelId"] = this.channelId;
        data["weight"] = this.weight;
        data["channelName"] = this.channelName;
        data["channelTypeId"] = this.channelTypeId;
        return data;
    }

    clone(): MerchantChannelDto {
        const json = this.toJSON();
        let result = new MerchantChannelDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantChannelDto {
    id: number;
    merchantId: number | undefined;
    channelId: number | undefined;
    weight: number;
    channelName: string | undefined;
    channelTypeId: number | undefined;
}

export class MerchantChannelProductDto implements IMerchantChannelProductDto {
    id!: number;
    merchantId!: number | undefined;
    channelTypeId!: number | undefined;
    rate!: number;
    agentRate!: number;
    code!: string | undefined;
    channelTypeName!: string | undefined;

    constructor(data?: IMerchantChannelProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.merchantId = _data["merchantId"];
            this.channelTypeId = _data["channelTypeId"];
            this.rate = _data["rate"];
            this.agentRate = _data["agentRate"];
            this.code = _data["code"];
            this.channelTypeName = _data["channelTypeName"];
        }
    }

    static fromJS(data: any): MerchantChannelProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantChannelProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["merchantId"] = this.merchantId;
        data["channelTypeId"] = this.channelTypeId;
        data["rate"] = this.rate;
        data["agentRate"] = this.agentRate;
        data["code"] = this.code;
        data["channelTypeName"] = this.channelTypeName;
        return data;
    }

    clone(): MerchantChannelProductDto {
        const json = this.toJSON();
        let result = new MerchantChannelProductDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantChannelProductDto {
    id: number;
    merchantId: number | undefined;
    channelTypeId: number | undefined;
    rate: number;
    agentRate: number;
    code: string | undefined;
    channelTypeName: string | undefined;
}

export class MerchantChannelTypeDayClearDto implements IMerchantChannelTypeDayClearDto {
    id!: number;
    merchantId!: number | undefined;
    mid!: string | undefined;
    merchantName!: string | undefined;
    channelTypeId!: number | undefined;
    channelTypeName!: string | undefined;
    channelTypeCode!: string | undefined;
    totalOrderNum!: number;
    successOrderNum!: number;
    totalAmount!: number;
    successAmount!: number;
    liRun!: number;
    successRate!: number;
    startTime!: Date;
    endTime!: Date;
    commission!: number;
    channelRateCommission!: number;
    creationTime!: Date;

    constructor(data?: IMerchantChannelTypeDayClearDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.merchantId = _data["merchantId"];
            this.mid = _data["mid"];
            this.merchantName = _data["merchantName"];
            this.channelTypeId = _data["channelTypeId"];
            this.channelTypeName = _data["channelTypeName"];
            this.channelTypeCode = _data["channelTypeCode"];
            this.totalOrderNum = _data["totalOrderNum"];
            this.successOrderNum = _data["successOrderNum"];
            this.totalAmount = _data["totalAmount"];
            this.successAmount = _data["successAmount"];
            this.liRun = _data["liRun"];
            this.successRate = _data["successRate"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.commission = _data["commission"];
            this.channelRateCommission = _data["channelRateCommission"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MerchantChannelTypeDayClearDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantChannelTypeDayClearDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["merchantId"] = this.merchantId;
        data["mid"] = this.mid;
        data["merchantName"] = this.merchantName;
        data["channelTypeId"] = this.channelTypeId;
        data["channelTypeName"] = this.channelTypeName;
        data["channelTypeCode"] = this.channelTypeCode;
        data["totalOrderNum"] = this.totalOrderNum;
        data["successOrderNum"] = this.successOrderNum;
        data["totalAmount"] = this.totalAmount;
        data["successAmount"] = this.successAmount;
        data["liRun"] = this.liRun;
        data["successRate"] = this.successRate;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["commission"] = this.commission;
        data["channelRateCommission"] = this.channelRateCommission;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): MerchantChannelTypeDayClearDto {
        const json = this.toJSON();
        let result = new MerchantChannelTypeDayClearDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantChannelTypeDayClearDto {
    id: number;
    merchantId: number | undefined;
    mid: string | undefined;
    merchantName: string | undefined;
    channelTypeId: number | undefined;
    channelTypeName: string | undefined;
    channelTypeCode: string | undefined;
    totalOrderNum: number;
    successOrderNum: number;
    totalAmount: number;
    successAmount: number;
    liRun: number;
    successRate: number;
    startTime: Date;
    endTime: Date;
    commission: number;
    channelRateCommission: number;
    creationTime: Date;
}

export class MerchantChannelTypeDayClearDtoPagedResultDto implements IMerchantChannelTypeDayClearDtoPagedResultDto {
    items!: MerchantChannelTypeDayClearDto[] | undefined;
    totalCount!: number;

    constructor(data?: IMerchantChannelTypeDayClearDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MerchantChannelTypeDayClearDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MerchantChannelTypeDayClearDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantChannelTypeDayClearDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MerchantChannelTypeDayClearDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MerchantChannelTypeDayClearDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantChannelTypeDayClearDtoPagedResultDto {
    items: MerchantChannelTypeDayClearDto[] | undefined;
    totalCount: number;
}

export class MerchantChannelTypeDayClearPageInputDto implements IMerchantChannelTypeDayClearPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    createTime!: Date | undefined;
    endTime!: Date | undefined;
    merchantId!: number | undefined;
    mid!: string | undefined;
    merchantName!: string | undefined;
    channelTypeId!: number | undefined;
    channelTypeName!: string | undefined;
    channelTypeCode!: string | undefined;

    constructor(data?: IMerchantChannelTypeDayClearPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.createTime = _data["createTime"] ? new Date(_data["createTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.merchantId = _data["merchantId"];
            this.mid = _data["mid"];
            this.merchantName = _data["merchantName"];
            this.channelTypeId = _data["channelTypeId"];
            this.channelTypeName = _data["channelTypeName"];
            this.channelTypeCode = _data["channelTypeCode"];
        }
    }

    static fromJS(data: any): MerchantChannelTypeDayClearPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantChannelTypeDayClearPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["merchantId"] = this.merchantId;
        data["mid"] = this.mid;
        data["merchantName"] = this.merchantName;
        data["channelTypeId"] = this.channelTypeId;
        data["channelTypeName"] = this.channelTypeName;
        data["channelTypeCode"] = this.channelTypeCode;
        return data;
    }

    clone(): MerchantChannelTypeDayClearPageInputDto {
        const json = this.toJSON();
        let result = new MerchantChannelTypeDayClearPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantChannelTypeDayClearPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    createTime: Date | undefined;
    endTime: Date | undefined;
    merchantId: number | undefined;
    mid: string | undefined;
    merchantName: string | undefined;
    channelTypeId: number | undefined;
    channelTypeName: string | undefined;
    channelTypeCode: string | undefined;
}

export class MerchantChannelTypeDto implements IMerchantChannelTypeDto {
    id!: number;
    merchantId!: number | undefined;
    channelTypeId!: number | undefined;
    rate!: number;
    channelTypeName!: string | undefined;
    code!: string | undefined;

    constructor(data?: IMerchantChannelTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.merchantId = _data["merchantId"];
            this.channelTypeId = _data["channelTypeId"];
            this.rate = _data["rate"];
            this.channelTypeName = _data["channelTypeName"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): MerchantChannelTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantChannelTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["merchantId"] = this.merchantId;
        data["channelTypeId"] = this.channelTypeId;
        data["rate"] = this.rate;
        data["channelTypeName"] = this.channelTypeName;
        data["code"] = this.code;
        return data;
    }

    clone(): MerchantChannelTypeDto {
        const json = this.toJSON();
        let result = new MerchantChannelTypeDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantChannelTypeDto {
    id: number;
    merchantId: number | undefined;
    channelTypeId: number | undefined;
    rate: number;
    channelTypeName: string | undefined;
    code: string | undefined;
}

export class MerchantChannelTypeOutResult implements IMerchantChannelTypeOutResult {
    merchantChannelTypes!: MerchantChannelTypeDto[] | undefined;
    merchantChannels!: MerchantChannelDto[] | undefined;

    constructor(data?: IMerchantChannelTypeOutResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["merchantChannelTypes"])) {
                this.merchantChannelTypes = [] as any;
                for (let item of _data["merchantChannelTypes"])
                    this.merchantChannelTypes!.push(MerchantChannelTypeDto.fromJS(item));
            }
            if (Array.isArray(_data["merchantChannels"])) {
                this.merchantChannels = [] as any;
                for (let item of _data["merchantChannels"])
                    this.merchantChannels!.push(MerchantChannelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MerchantChannelTypeOutResult {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantChannelTypeOutResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.merchantChannelTypes)) {
            data["merchantChannelTypes"] = [];
            for (let item of this.merchantChannelTypes)
                data["merchantChannelTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.merchantChannels)) {
            data["merchantChannels"] = [];
            for (let item of this.merchantChannels)
                data["merchantChannels"].push(item.toJSON());
        }
        return data;
    }

    clone(): MerchantChannelTypeOutResult {
        const json = this.toJSON();
        let result = new MerchantChannelTypeOutResult();
        result.init(json);
        return result;
    }
}

export interface IMerchantChannelTypeOutResult {
    merchantChannelTypes: MerchantChannelTypeDto[] | undefined;
    merchantChannels: MerchantChannelDto[] | undefined;
}

export class MerchantChannelTypeStatisticsDto implements IMerchantChannelTypeStatisticsDto {
    channelTypeId!: number | undefined;
    channelTypeName!: string | undefined;
    channelTypeCode!: string | undefined;
    channelTypeRate!: number;
    agentRate!: number;

    constructor(data?: IMerchantChannelTypeStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelTypeId = _data["channelTypeId"];
            this.channelTypeName = _data["channelTypeName"];
            this.channelTypeCode = _data["channelTypeCode"];
            this.channelTypeRate = _data["channelTypeRate"];
            this.agentRate = _data["agentRate"];
        }
    }

    static fromJS(data: any): MerchantChannelTypeStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantChannelTypeStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelTypeId"] = this.channelTypeId;
        data["channelTypeName"] = this.channelTypeName;
        data["channelTypeCode"] = this.channelTypeCode;
        data["channelTypeRate"] = this.channelTypeRate;
        data["agentRate"] = this.agentRate;
        return data;
    }

    clone(): MerchantChannelTypeStatisticsDto {
        const json = this.toJSON();
        let result = new MerchantChannelTypeStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantChannelTypeStatisticsDto {
    channelTypeId: number | undefined;
    channelTypeName: string | undefined;
    channelTypeCode: string | undefined;
    channelTypeRate: number;
    agentRate: number;
}

export class MerchantConCurrentOutDto implements IMerchantConCurrentOutDto {
    mid!: string | undefined;
    merchantId!: number | undefined;
    merchantName!: string | undefined;
    conCurrentNum!: number;

    constructor(data?: IMerchantConCurrentOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mid = _data["mid"];
            this.merchantId = _data["merchantId"];
            this.merchantName = _data["merchantName"];
            this.conCurrentNum = _data["conCurrentNum"];
        }
    }

    static fromJS(data: any): MerchantConCurrentOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantConCurrentOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mid"] = this.mid;
        data["merchantId"] = this.merchantId;
        data["merchantName"] = this.merchantName;
        data["conCurrentNum"] = this.conCurrentNum;
        return data;
    }

    clone(): MerchantConCurrentOutDto {
        const json = this.toJSON();
        let result = new MerchantConCurrentOutDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantConCurrentOutDto {
    mid: string | undefined;
    merchantId: number | undefined;
    merchantName: string | undefined;
    conCurrentNum: number;
}

export class MerchantConCurrentPageInputDto implements IMerchantConCurrentPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    minute!: number;
    tongJiEnumName!: TongJiEnumTypes;

    constructor(data?: IMerchantConCurrentPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.minute = _data["minute"];
            this.tongJiEnumName = _data["tongJiEnumName"];
        }
    }

    static fromJS(data: any): MerchantConCurrentPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantConCurrentPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["minute"] = this.minute;
        data["tongJiEnumName"] = this.tongJiEnumName;
        return data;
    }

    clone(): MerchantConCurrentPageInputDto {
        const json = this.toJSON();
        let result = new MerchantConCurrentPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantConCurrentPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    minute: number;
    tongJiEnumName: TongJiEnumTypes;
}

export class MerchantDayBillDto implements IMerchantDayBillDto {
    id!: number;
    merId!: number | undefined;
    name!: string | undefined;
    mid!: string | undefined;
    money!: number;
    orderNum!: number;
    payMoney!: number;
    commission!: number;
    settlementTimeStr!: string | undefined;
    settlementTime!: Date;
    creationTime!: Date;

    constructor(data?: IMerchantDayBillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.merId = _data["merId"];
            this.name = _data["name"];
            this.mid = _data["mid"];
            this.money = _data["money"];
            this.orderNum = _data["orderNum"];
            this.payMoney = _data["payMoney"];
            this.commission = _data["commission"];
            this.settlementTimeStr = _data["settlementTimeStr"];
            this.settlementTime = _data["settlementTime"] ? new Date(_data["settlementTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MerchantDayBillDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantDayBillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["merId"] = this.merId;
        data["name"] = this.name;
        data["mid"] = this.mid;
        data["money"] = this.money;
        data["orderNum"] = this.orderNum;
        data["payMoney"] = this.payMoney;
        data["commission"] = this.commission;
        data["settlementTimeStr"] = this.settlementTimeStr;
        data["settlementTime"] = this.settlementTime ? this.settlementTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): MerchantDayBillDto {
        const json = this.toJSON();
        let result = new MerchantDayBillDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantDayBillDto {
    id: number;
    merId: number | undefined;
    name: string | undefined;
    mid: string | undefined;
    money: number;
    orderNum: number;
    payMoney: number;
    commission: number;
    settlementTimeStr: string | undefined;
    settlementTime: Date;
    creationTime: Date;
}

export class MerchantDayBillDtoPagedResultDto implements IMerchantDayBillDtoPagedResultDto {
    items!: MerchantDayBillDto[] | undefined;
    totalCount!: number;

    constructor(data?: IMerchantDayBillDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MerchantDayBillDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MerchantDayBillDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantDayBillDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MerchantDayBillDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MerchantDayBillDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantDayBillDtoPagedResultDto {
    items: MerchantDayBillDto[] | undefined;
    totalCount: number;
}

export class MerchantDayBillPageInputDto implements IMerchantDayBillPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    merchantId!: number | undefined;
    createStartTime!: Date | undefined;
    createEndTime!: Date | undefined;

    constructor(data?: IMerchantDayBillPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.merchantId = _data["merchantId"];
            this.createStartTime = _data["createStartTime"] ? new Date(_data["createStartTime"].toString()) : <any>undefined;
            this.createEndTime = _data["createEndTime"] ? new Date(_data["createEndTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MerchantDayBillPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantDayBillPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["merchantId"] = this.merchantId;
        data["createStartTime"] = this.createStartTime ? this.createStartTime.toISOString() : <any>undefined;
        data["createEndTime"] = this.createEndTime ? this.createEndTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): MerchantDayBillPageInputDto {
        const json = this.toJSON();
        let result = new MerchantDayBillPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantDayBillPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    merchantId: number | undefined;
    createStartTime: Date | undefined;
    createEndTime: Date | undefined;
}

export class MerchantDayClearDto implements IMerchantDayClearDto {
    id!: number;
    merchantId!: number | undefined;
    mid!: string | undefined;
    merchantName!: string | undefined;
    totalOrderNum!: number;
    successOrderNum!: number;
    totalAmount!: number;
    successAmount!: number;
    liRun!: number;
    successRate!: number;
    settlementStatus!: number;
    settlementTime!: Date | undefined;
    startTime!: Date;
    endTime!: Date;
    settlementAdvanceMoney!: number;
    settlementBalance!: number;
    settlementYingDe!: number;
    afterSettlementAdvanceMoney!: number;
    afterSettlementBalance!: number;
    afterSettlementYingDe!: number;
    commission!: number;
    channelRateCommission!: number;
    creationTime!: Date;

    constructor(data?: IMerchantDayClearDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.merchantId = _data["merchantId"];
            this.mid = _data["mid"];
            this.merchantName = _data["merchantName"];
            this.totalOrderNum = _data["totalOrderNum"];
            this.successOrderNum = _data["successOrderNum"];
            this.totalAmount = _data["totalAmount"];
            this.successAmount = _data["successAmount"];
            this.liRun = _data["liRun"];
            this.successRate = _data["successRate"];
            this.settlementStatus = _data["settlementStatus"];
            this.settlementTime = _data["settlementTime"] ? new Date(_data["settlementTime"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.settlementAdvanceMoney = _data["settlementAdvanceMoney"];
            this.settlementBalance = _data["settlementBalance"];
            this.settlementYingDe = _data["settlementYingDe"];
            this.afterSettlementAdvanceMoney = _data["afterSettlementAdvanceMoney"];
            this.afterSettlementBalance = _data["afterSettlementBalance"];
            this.afterSettlementYingDe = _data["afterSettlementYingDe"];
            this.commission = _data["commission"];
            this.channelRateCommission = _data["channelRateCommission"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MerchantDayClearDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantDayClearDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["merchantId"] = this.merchantId;
        data["mid"] = this.mid;
        data["merchantName"] = this.merchantName;
        data["totalOrderNum"] = this.totalOrderNum;
        data["successOrderNum"] = this.successOrderNum;
        data["totalAmount"] = this.totalAmount;
        data["successAmount"] = this.successAmount;
        data["liRun"] = this.liRun;
        data["successRate"] = this.successRate;
        data["settlementStatus"] = this.settlementStatus;
        data["settlementTime"] = this.settlementTime ? this.settlementTime.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["settlementAdvanceMoney"] = this.settlementAdvanceMoney;
        data["settlementBalance"] = this.settlementBalance;
        data["settlementYingDe"] = this.settlementYingDe;
        data["afterSettlementAdvanceMoney"] = this.afterSettlementAdvanceMoney;
        data["afterSettlementBalance"] = this.afterSettlementBalance;
        data["afterSettlementYingDe"] = this.afterSettlementYingDe;
        data["commission"] = this.commission;
        data["channelRateCommission"] = this.channelRateCommission;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): MerchantDayClearDto {
        const json = this.toJSON();
        let result = new MerchantDayClearDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantDayClearDto {
    id: number;
    merchantId: number | undefined;
    mid: string | undefined;
    merchantName: string | undefined;
    totalOrderNum: number;
    successOrderNum: number;
    totalAmount: number;
    successAmount: number;
    liRun: number;
    successRate: number;
    settlementStatus: number;
    settlementTime: Date | undefined;
    startTime: Date;
    endTime: Date;
    settlementAdvanceMoney: number;
    settlementBalance: number;
    settlementYingDe: number;
    afterSettlementAdvanceMoney: number;
    afterSettlementBalance: number;
    afterSettlementYingDe: number;
    commission: number;
    channelRateCommission: number;
    creationTime: Date;
}

export class MerchantDayClearDtoPagedResultDto implements IMerchantDayClearDtoPagedResultDto {
    items!: MerchantDayClearDto[] | undefined;
    totalCount!: number;

    constructor(data?: IMerchantDayClearDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MerchantDayClearDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MerchantDayClearDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantDayClearDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MerchantDayClearDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MerchantDayClearDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantDayClearDtoPagedResultDto {
    items: MerchantDayClearDto[] | undefined;
    totalCount: number;
}

export class MerchantDayClearPageInputDto implements IMerchantDayClearPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    createTime!: Date | undefined;
    endTime!: Date | undefined;
    merchantId!: number | undefined;
    mid!: string | undefined;
    merchantName!: string | undefined;

    constructor(data?: IMerchantDayClearPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.createTime = _data["createTime"] ? new Date(_data["createTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.merchantId = _data["merchantId"];
            this.mid = _data["mid"];
            this.merchantName = _data["merchantName"];
        }
    }

    static fromJS(data: any): MerchantDayClearPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantDayClearPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["merchantId"] = this.merchantId;
        data["mid"] = this.mid;
        data["merchantName"] = this.merchantName;
        return data;
    }

    clone(): MerchantDayClearPageInputDto {
        const json = this.toJSON();
        let result = new MerchantDayClearPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantDayClearPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    createTime: Date | undefined;
    endTime: Date | undefined;
    merchantId: number | undefined;
    mid: string | undefined;
    merchantName: string | undefined;
}

export class MerchantDto implements IMerchantDto {
    id!: number;
    mid!: string | undefined;
    userName!: string | undefined;
    userId!: number | undefined;
    merchantName!: string | undefined;
    balance!: number;
    lastLoginTime!: Date | undefined;
    lastLoginIp!: string | undefined;
    status!: StatusEnum;
    withdrawMethod!: number;
    withdrawRate!: number;
    advanceMoney!: number;
    botId!: string | undefined;
    agentId!: number | undefined;
    isEnableGroupMsg!: boolean;
    arrears!: number;
    arrearsTime!: Date | undefined;
    isArrears!: boolean;
    agentName!: string | undefined;
    merchantChannelTypes!: MerchantChannelTypeDto[] | undefined;
    merchantAgentRates!: MerchantAgentRateDto[] | undefined;
    merchantChannels!: MerchantChannelDto[] | undefined;
    creationTime!: Date;
    isEnableApi!: boolean;
    readonly realBalance!: number;
    apiIps!: string | undefined;
    comment!: string | undefined;
    settlementTime!: string | undefined;
    sendBill!: boolean;
    balanceSettlement!: boolean;
    groupFlag!: string | undefined;
    isLoginWhiteLimit!: boolean;
    loginWhiteList!: string | undefined;
    minCreateOrderMoney!: number;
    merchantAndMerBinDingId!: number | undefined;
    usdtFloatGear!: number;

    constructor(data?: IMerchantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mid = _data["mid"];
            this.userName = _data["userName"];
            this.userId = _data["userId"];
            this.merchantName = _data["merchantName"];
            this.balance = _data["balance"];
            this.lastLoginTime = _data["lastLoginTime"] ? new Date(_data["lastLoginTime"].toString()) : <any>undefined;
            this.lastLoginIp = _data["lastLoginIp"];
            this.status = _data["status"];
            this.withdrawMethod = _data["withdrawMethod"];
            this.withdrawRate = _data["withdrawRate"];
            this.advanceMoney = _data["advanceMoney"];
            this.botId = _data["botId"];
            this.agentId = _data["agentId"];
            this.isEnableGroupMsg = _data["isEnableGroupMsg"];
            this.arrears = _data["arrears"];
            this.arrearsTime = _data["arrearsTime"] ? new Date(_data["arrearsTime"].toString()) : <any>undefined;
            this.isArrears = _data["isArrears"];
            this.agentName = _data["agentName"];
            if (Array.isArray(_data["merchantChannelTypes"])) {
                this.merchantChannelTypes = [] as any;
                for (let item of _data["merchantChannelTypes"])
                    this.merchantChannelTypes!.push(MerchantChannelTypeDto.fromJS(item));
            }
            if (Array.isArray(_data["merchantAgentRates"])) {
                this.merchantAgentRates = [] as any;
                for (let item of _data["merchantAgentRates"])
                    this.merchantAgentRates!.push(MerchantAgentRateDto.fromJS(item));
            }
            if (Array.isArray(_data["merchantChannels"])) {
                this.merchantChannels = [] as any;
                for (let item of _data["merchantChannels"])
                    this.merchantChannels!.push(MerchantChannelDto.fromJS(item));
            }
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.isEnableApi = _data["isEnableApi"];
            (<any>this).realBalance = _data["realBalance"];
            this.apiIps = _data["apiIps"];
            this.comment = _data["comment"];
            this.settlementTime = _data["settlementTime"];
            this.sendBill = _data["sendBill"];
            this.balanceSettlement = _data["balanceSettlement"];
            this.groupFlag = _data["groupFlag"];
            this.isLoginWhiteLimit = _data["isLoginWhiteLimit"];
            this.loginWhiteList = _data["loginWhiteList"];
            this.minCreateOrderMoney = _data["minCreateOrderMoney"];
            this.merchantAndMerBinDingId = _data["merchantAndMerBinDingId"];
            this.usdtFloatGear = _data["usdtFloatGear"];
        }
    }

    static fromJS(data: any): MerchantDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mid"] = this.mid;
        data["userName"] = this.userName;
        data["userId"] = this.userId;
        data["merchantName"] = this.merchantName;
        data["balance"] = this.balance;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["lastLoginIp"] = this.lastLoginIp;
        data["status"] = this.status;
        data["withdrawMethod"] = this.withdrawMethod;
        data["withdrawRate"] = this.withdrawRate;
        data["advanceMoney"] = this.advanceMoney;
        data["botId"] = this.botId;
        data["agentId"] = this.agentId;
        data["isEnableGroupMsg"] = this.isEnableGroupMsg;
        data["arrears"] = this.arrears;
        data["arrearsTime"] = this.arrearsTime ? this.arrearsTime.toISOString() : <any>undefined;
        data["isArrears"] = this.isArrears;
        data["agentName"] = this.agentName;
        if (Array.isArray(this.merchantChannelTypes)) {
            data["merchantChannelTypes"] = [];
            for (let item of this.merchantChannelTypes)
                data["merchantChannelTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.merchantAgentRates)) {
            data["merchantAgentRates"] = [];
            for (let item of this.merchantAgentRates)
                data["merchantAgentRates"].push(item.toJSON());
        }
        if (Array.isArray(this.merchantChannels)) {
            data["merchantChannels"] = [];
            for (let item of this.merchantChannels)
                data["merchantChannels"].push(item.toJSON());
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["isEnableApi"] = this.isEnableApi;
        data["realBalance"] = this.realBalance;
        data["apiIps"] = this.apiIps;
        data["comment"] = this.comment;
        data["settlementTime"] = this.settlementTime;
        data["sendBill"] = this.sendBill;
        data["balanceSettlement"] = this.balanceSettlement;
        data["groupFlag"] = this.groupFlag;
        data["isLoginWhiteLimit"] = this.isLoginWhiteLimit;
        data["loginWhiteList"] = this.loginWhiteList;
        data["minCreateOrderMoney"] = this.minCreateOrderMoney;
        data["merchantAndMerBinDingId"] = this.merchantAndMerBinDingId;
        data["usdtFloatGear"] = this.usdtFloatGear;
        return data;
    }

    clone(): MerchantDto {
        const json = this.toJSON();
        let result = new MerchantDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantDto {
    id: number;
    mid: string | undefined;
    userName: string | undefined;
    userId: number | undefined;
    merchantName: string | undefined;
    balance: number;
    lastLoginTime: Date | undefined;
    lastLoginIp: string | undefined;
    status: StatusEnum;
    withdrawMethod: number;
    withdrawRate: number;
    advanceMoney: number;
    botId: string | undefined;
    agentId: number | undefined;
    isEnableGroupMsg: boolean;
    arrears: number;
    arrearsTime: Date | undefined;
    isArrears: boolean;
    agentName: string | undefined;
    merchantChannelTypes: MerchantChannelTypeDto[] | undefined;
    merchantAgentRates: MerchantAgentRateDto[] | undefined;
    merchantChannels: MerchantChannelDto[] | undefined;
    creationTime: Date;
    isEnableApi: boolean;
    realBalance: number;
    apiIps: string | undefined;
    comment: string | undefined;
    settlementTime: string | undefined;
    sendBill: boolean;
    balanceSettlement: boolean;
    groupFlag: string | undefined;
    isLoginWhiteLimit: boolean;
    loginWhiteList: string | undefined;
    minCreateOrderMoney: number;
    merchantAndMerBinDingId: number | undefined;
    usdtFloatGear: number;
}

export class MerchantDtoPagedResultDto implements IMerchantDtoPagedResultDto {
    items!: MerchantDto[] | undefined;
    totalCount!: number;

    constructor(data?: IMerchantDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MerchantDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MerchantDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MerchantDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MerchantDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantDtoPagedResultDto {
    items: MerchantDto[] | undefined;
    totalCount: number;
}

export class MerchantInfoDto implements IMerchantInfoDto {
    id!: number;
    mid!: string | undefined;
    userName!: string | undefined;
    merchantName!: string | undefined;
    balance!: number;
    status!: StatusEnum;
    isEnableApi!: boolean;
    isUpdateLoginPwd!: boolean;
    advanceMoney!: number;
    readonly realMoney!: number;

    constructor(data?: IMerchantInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mid = _data["mid"];
            this.userName = _data["userName"];
            this.merchantName = _data["merchantName"];
            this.balance = _data["balance"];
            this.status = _data["status"];
            this.isEnableApi = _data["isEnableApi"];
            this.isUpdateLoginPwd = _data["isUpdateLoginPwd"];
            this.advanceMoney = _data["advanceMoney"];
            (<any>this).realMoney = _data["realMoney"];
        }
    }

    static fromJS(data: any): MerchantInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mid"] = this.mid;
        data["userName"] = this.userName;
        data["merchantName"] = this.merchantName;
        data["balance"] = this.balance;
        data["status"] = this.status;
        data["isEnableApi"] = this.isEnableApi;
        data["isUpdateLoginPwd"] = this.isUpdateLoginPwd;
        data["advanceMoney"] = this.advanceMoney;
        data["realMoney"] = this.realMoney;
        return data;
    }

    clone(): MerchantInfoDto {
        const json = this.toJSON();
        let result = new MerchantInfoDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantInfoDto {
    id: number;
    mid: string | undefined;
    userName: string | undefined;
    merchantName: string | undefined;
    balance: number;
    status: StatusEnum;
    isEnableApi: boolean;
    isUpdateLoginPwd: boolean;
    advanceMoney: number;
    realMoney: number;
}

export class MerchantLoginWhiteLimitDto implements IMerchantLoginWhiteLimitDto {
    id!: number;
    loginWhiteList!: string | undefined;

    constructor(data?: IMerchantLoginWhiteLimitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.loginWhiteList = _data["loginWhiteList"];
        }
    }

    static fromJS(data: any): MerchantLoginWhiteLimitDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantLoginWhiteLimitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["loginWhiteList"] = this.loginWhiteList;
        return data;
    }

    clone(): MerchantLoginWhiteLimitDto {
        const json = this.toJSON();
        let result = new MerchantLoginWhiteLimitDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantLoginWhiteLimitDto {
    id: number;
    loginWhiteList: string | undefined;
}

export class MerchantLoginWhiteListDto implements IMerchantLoginWhiteListDto {
    id!: number;
    isLoginWhiteLimit!: boolean;
    loginWhiteList!: string | undefined;

    constructor(data?: IMerchantLoginWhiteListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isLoginWhiteLimit = _data["isLoginWhiteLimit"];
            this.loginWhiteList = _data["loginWhiteList"];
        }
    }

    static fromJS(data: any): MerchantLoginWhiteListDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantLoginWhiteListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isLoginWhiteLimit"] = this.isLoginWhiteLimit;
        data["loginWhiteList"] = this.loginWhiteList;
        return data;
    }

    clone(): MerchantLoginWhiteListDto {
        const json = this.toJSON();
        let result = new MerchantLoginWhiteListDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantLoginWhiteListDto {
    id: number;
    isLoginWhiteLimit: boolean;
    loginWhiteList: string | undefined;
}

export class MerchantOrderDto implements IMerchantOrderDto {
    id!: number;
    tid!: string | undefined;
    outTid!: string | undefined;
    merOrderTid!: string | undefined;
    merchantId!: number | undefined;
    mid!: string | undefined;
    merchantName!: string | undefined;
    money!: number;
    successTime!: Date | undefined;
    failTime!: Date | undefined;
    payOrderStatus!: PayOrderStatusEnum;
    merchantAgentRate!: number;
    merchantAgentRateCommission!: number;
    readonly payOrderStatusName!: string | undefined;
    creationTime!: Date;
    payTimeConsuming!: number;
    errorMsg!: string | undefined;
    isCz!: boolean;
    channelRate!: number;
    endTime!: Date | undefined;
    clientUserPayRemark!: string | undefined;
    clientUserId!: string | undefined;
    clientUserName!: string | undefined;

    constructor(data?: IMerchantOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tid = _data["tid"];
            this.outTid = _data["outTid"];
            this.merOrderTid = _data["merOrderTid"];
            this.merchantId = _data["merchantId"];
            this.mid = _data["mid"];
            this.merchantName = _data["merchantName"];
            this.money = _data["money"];
            this.successTime = _data["successTime"] ? new Date(_data["successTime"].toString()) : <any>undefined;
            this.failTime = _data["failTime"] ? new Date(_data["failTime"].toString()) : <any>undefined;
            this.payOrderStatus = _data["payOrderStatus"];
            this.merchantAgentRate = _data["merchantAgentRate"];
            this.merchantAgentRateCommission = _data["merchantAgentRateCommission"];
            (<any>this).payOrderStatusName = _data["payOrderStatusName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.payTimeConsuming = _data["payTimeConsuming"];
            this.errorMsg = _data["errorMsg"];
            this.isCz = _data["isCz"];
            this.channelRate = _data["channelRate"];
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.clientUserPayRemark = _data["clientUserPayRemark"];
            this.clientUserId = _data["clientUserId"];
            this.clientUserName = _data["clientUserName"];
        }
    }

    static fromJS(data: any): MerchantOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tid"] = this.tid;
        data["outTid"] = this.outTid;
        data["merOrderTid"] = this.merOrderTid;
        data["merchantId"] = this.merchantId;
        data["mid"] = this.mid;
        data["merchantName"] = this.merchantName;
        data["money"] = this.money;
        data["successTime"] = this.successTime ? this.successTime.toISOString() : <any>undefined;
        data["failTime"] = this.failTime ? this.failTime.toISOString() : <any>undefined;
        data["payOrderStatus"] = this.payOrderStatus;
        data["merchantAgentRate"] = this.merchantAgentRate;
        data["merchantAgentRateCommission"] = this.merchantAgentRateCommission;
        data["payOrderStatusName"] = this.payOrderStatusName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["payTimeConsuming"] = this.payTimeConsuming;
        data["errorMsg"] = this.errorMsg;
        data["isCz"] = this.isCz;
        data["channelRate"] = this.channelRate;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["clientUserPayRemark"] = this.clientUserPayRemark;
        data["clientUserId"] = this.clientUserId;
        data["clientUserName"] = this.clientUserName;
        return data;
    }

    clone(): MerchantOrderDto {
        const json = this.toJSON();
        let result = new MerchantOrderDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantOrderDto {
    id: number;
    tid: string | undefined;
    outTid: string | undefined;
    merOrderTid: string | undefined;
    merchantId: number | undefined;
    mid: string | undefined;
    merchantName: string | undefined;
    money: number;
    successTime: Date | undefined;
    failTime: Date | undefined;
    payOrderStatus: PayOrderStatusEnum;
    merchantAgentRate: number;
    merchantAgentRateCommission: number;
    payOrderStatusName: string | undefined;
    creationTime: Date;
    payTimeConsuming: number;
    errorMsg: string | undefined;
    isCz: boolean;
    channelRate: number;
    endTime: Date | undefined;
    clientUserPayRemark: string | undefined;
    clientUserId: string | undefined;
    clientUserName: string | undefined;
}

export class MerchantOrderDtoPagedResultDto implements IMerchantOrderDtoPagedResultDto {
    items!: MerchantOrderDto[] | undefined;
    totalCount!: number;

    constructor(data?: IMerchantOrderDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MerchantOrderDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MerchantOrderDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantOrderDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MerchantOrderDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MerchantOrderDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantOrderDtoPagedResultDto {
    items: MerchantOrderDto[] | undefined;
    totalCount: number;
}

export class MerchantPageInputDto implements IMerchantPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    mid!: string | undefined;
    userName!: string | undefined;
    merchantName!: string | undefined;
    agentId!: number | undefined;
    status!: StatusEnum;

    constructor(data?: IMerchantPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.mid = _data["mid"];
            this.userName = _data["userName"];
            this.merchantName = _data["merchantName"];
            this.agentId = _data["agentId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): MerchantPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["mid"] = this.mid;
        data["userName"] = this.userName;
        data["merchantName"] = this.merchantName;
        data["agentId"] = this.agentId;
        data["status"] = this.status;
        return data;
    }

    clone(): MerchantPageInputDto {
        const json = this.toJSON();
        let result = new MerchantPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    mid: string | undefined;
    userName: string | undefined;
    merchantName: string | undefined;
    agentId: number | undefined;
    status: StatusEnum;
}

export class MerchantPayOrderDto implements IMerchantPayOrderDto {
    id!: number;
    tid!: string | undefined;
    merOrderTid!: string | undefined;
    merchantId!: number | undefined;
    mid!: string | undefined;
    merchantName!: string | undefined;
    channelTypeName!: string | undefined;
    channelTypeCode!: string | undefined;
    money!: number;
    commission!: number;
    payMoney!: number;
    failTime!: Date | undefined;
    payOrderStatus!: PayOrderStatusEnum;
    readonly payOrderStatusName!: string | undefined;
    notifyUrl!: string | undefined;
    noticeStatus!: number;
    noticeCount!: number;
    channelTypeId!: number | undefined;
    creationTime!: Date;
    successTime!: Date | undefined;
    payTimeConsuming!: number;
    isCz!: boolean;

    constructor(data?: IMerchantPayOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tid = _data["tid"];
            this.merOrderTid = _data["merOrderTid"];
            this.merchantId = _data["merchantId"];
            this.mid = _data["mid"];
            this.merchantName = _data["merchantName"];
            this.channelTypeName = _data["channelTypeName"];
            this.channelTypeCode = _data["channelTypeCode"];
            this.money = _data["money"];
            this.commission = _data["commission"];
            this.payMoney = _data["payMoney"];
            this.failTime = _data["failTime"] ? new Date(_data["failTime"].toString()) : <any>undefined;
            this.payOrderStatus = _data["payOrderStatus"];
            (<any>this).payOrderStatusName = _data["payOrderStatusName"];
            this.notifyUrl = _data["notifyUrl"];
            this.noticeStatus = _data["noticeStatus"];
            this.noticeCount = _data["noticeCount"];
            this.channelTypeId = _data["channelTypeId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.successTime = _data["successTime"] ? new Date(_data["successTime"].toString()) : <any>undefined;
            this.payTimeConsuming = _data["payTimeConsuming"];
            this.isCz = _data["isCz"];
        }
    }

    static fromJS(data: any): MerchantPayOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantPayOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tid"] = this.tid;
        data["merOrderTid"] = this.merOrderTid;
        data["merchantId"] = this.merchantId;
        data["mid"] = this.mid;
        data["merchantName"] = this.merchantName;
        data["channelTypeName"] = this.channelTypeName;
        data["channelTypeCode"] = this.channelTypeCode;
        data["money"] = this.money;
        data["commission"] = this.commission;
        data["payMoney"] = this.payMoney;
        data["failTime"] = this.failTime ? this.failTime.toISOString() : <any>undefined;
        data["payOrderStatus"] = this.payOrderStatus;
        data["payOrderStatusName"] = this.payOrderStatusName;
        data["notifyUrl"] = this.notifyUrl;
        data["noticeStatus"] = this.noticeStatus;
        data["noticeCount"] = this.noticeCount;
        data["channelTypeId"] = this.channelTypeId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["successTime"] = this.successTime ? this.successTime.toISOString() : <any>undefined;
        data["payTimeConsuming"] = this.payTimeConsuming;
        data["isCz"] = this.isCz;
        return data;
    }

    clone(): MerchantPayOrderDto {
        const json = this.toJSON();
        let result = new MerchantPayOrderDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantPayOrderDto {
    id: number;
    tid: string | undefined;
    merOrderTid: string | undefined;
    merchantId: number | undefined;
    mid: string | undefined;
    merchantName: string | undefined;
    channelTypeName: string | undefined;
    channelTypeCode: string | undefined;
    money: number;
    commission: number;
    payMoney: number;
    failTime: Date | undefined;
    payOrderStatus: PayOrderStatusEnum;
    payOrderStatusName: string | undefined;
    notifyUrl: string | undefined;
    noticeStatus: number;
    noticeCount: number;
    channelTypeId: number | undefined;
    creationTime: Date;
    successTime: Date | undefined;
    payTimeConsuming: number;
    isCz: boolean;
}

export class MerchantPayOrderDtoPagedResultDto implements IMerchantPayOrderDtoPagedResultDto {
    items!: MerchantPayOrderDto[] | undefined;
    totalCount!: number;

    constructor(data?: IMerchantPayOrderDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MerchantPayOrderDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MerchantPayOrderDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantPayOrderDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MerchantPayOrderDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MerchantPayOrderDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantPayOrderDtoPagedResultDto {
    items: MerchantPayOrderDto[] | undefined;
    totalCount: number;
}

export class MerchantRevAccountDto implements IMerchantRevAccountDto {
    id!: number;
    merchantId!: number | undefined;
    bank!: string | undefined;
    bankNo!: string | undefined;
    bankName!: string | undefined;
    bankZhiHang!: string | undefined;
    bankProvince!: string | undefined;

    constructor(data?: IMerchantRevAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.merchantId = _data["merchantId"];
            this.bank = _data["bank"];
            this.bankNo = _data["bankNo"];
            this.bankName = _data["bankName"];
            this.bankZhiHang = _data["bankZhiHang"];
            this.bankProvince = _data["bankProvince"];
        }
    }

    static fromJS(data: any): MerchantRevAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantRevAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["merchantId"] = this.merchantId;
        data["bank"] = this.bank;
        data["bankNo"] = this.bankNo;
        data["bankName"] = this.bankName;
        data["bankZhiHang"] = this.bankZhiHang;
        data["bankProvince"] = this.bankProvince;
        return data;
    }

    clone(): MerchantRevAccountDto {
        const json = this.toJSON();
        let result = new MerchantRevAccountDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantRevAccountDto {
    id: number;
    merchantId: number | undefined;
    bank: string | undefined;
    bankNo: string | undefined;
    bankName: string | undefined;
    bankZhiHang: string | undefined;
    bankProvince: string | undefined;
}

export class MerchantRevAccountDtoPagedResultDto implements IMerchantRevAccountDtoPagedResultDto {
    items!: MerchantRevAccountDto[] | undefined;
    totalCount!: number;

    constructor(data?: IMerchantRevAccountDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MerchantRevAccountDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MerchantRevAccountDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantRevAccountDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MerchantRevAccountDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MerchantRevAccountDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantRevAccountDtoPagedResultDto {
    items: MerchantRevAccountDto[] | undefined;
    totalCount: number;
}

export class MerchantRevAccountPageInputDto implements IMerchantRevAccountPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    merchantId!: number | undefined;

    constructor(data?: IMerchantRevAccountPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.merchantId = _data["merchantId"];
        }
    }

    static fromJS(data: any): MerchantRevAccountPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantRevAccountPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["merchantId"] = this.merchantId;
        return data;
    }

    clone(): MerchantRevAccountPageInputDto {
        const json = this.toJSON();
        let result = new MerchantRevAccountPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantRevAccountPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    merchantId: number | undefined;
}

export class MerchantsDayBillDto implements IMerchantsDayBillDto {
    merId!: number | undefined;
    name!: string | undefined;
    mid!: string | undefined;
    money!: number;
    payMoney!: number;
    budanNum!: number;
    budanMoney!: number;
    commission!: number;
    settlementTimeStr!: string | undefined;
    settlementTime!: Date;
    orderNum!: number;
    creationTime!: Date;

    constructor(data?: IMerchantsDayBillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.merId = _data["merId"];
            this.name = _data["name"];
            this.mid = _data["mid"];
            this.money = _data["money"];
            this.payMoney = _data["payMoney"];
            this.budanNum = _data["budanNum"];
            this.budanMoney = _data["budanMoney"];
            this.commission = _data["commission"];
            this.settlementTimeStr = _data["settlementTimeStr"];
            this.settlementTime = _data["settlementTime"] ? new Date(_data["settlementTime"].toString()) : <any>undefined;
            this.orderNum = _data["orderNum"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MerchantsDayBillDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantsDayBillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["merId"] = this.merId;
        data["name"] = this.name;
        data["mid"] = this.mid;
        data["money"] = this.money;
        data["payMoney"] = this.payMoney;
        data["budanNum"] = this.budanNum;
        data["budanMoney"] = this.budanMoney;
        data["commission"] = this.commission;
        data["settlementTimeStr"] = this.settlementTimeStr;
        data["settlementTime"] = this.settlementTime ? this.settlementTime.toISOString() : <any>undefined;
        data["orderNum"] = this.orderNum;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): MerchantsDayBillDto {
        const json = this.toJSON();
        let result = new MerchantsDayBillDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantsDayBillDto {
    merId: number | undefined;
    name: string | undefined;
    mid: string | undefined;
    money: number;
    payMoney: number;
    budanNum: number;
    budanMoney: number;
    commission: number;
    settlementTimeStr: string | undefined;
    settlementTime: Date;
    orderNum: number;
    creationTime: Date;
}

export class MerchantsDayBillDtoPagedResultDto implements IMerchantsDayBillDtoPagedResultDto {
    items!: MerchantsDayBillDto[] | undefined;
    totalCount!: number;

    constructor(data?: IMerchantsDayBillDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MerchantsDayBillDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MerchantsDayBillDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantsDayBillDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MerchantsDayBillDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MerchantsDayBillDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantsDayBillDtoPagedResultDto {
    items: MerchantsDayBillDto[] | undefined;
    totalCount: number;
}

export class MerchantsDayBillPageInputDto implements IMerchantsDayBillPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    createStartTime!: Date | undefined;
    createEndTime!: Date | undefined;
    merchantId!: number | undefined;

    constructor(data?: IMerchantsDayBillPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.createStartTime = _data["createStartTime"] ? new Date(_data["createStartTime"].toString()) : <any>undefined;
            this.createEndTime = _data["createEndTime"] ? new Date(_data["createEndTime"].toString()) : <any>undefined;
            this.merchantId = _data["merchantId"];
        }
    }

    static fromJS(data: any): MerchantsDayBillPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantsDayBillPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["createStartTime"] = this.createStartTime ? this.createStartTime.toISOString() : <any>undefined;
        data["createEndTime"] = this.createEndTime ? this.createEndTime.toISOString() : <any>undefined;
        data["merchantId"] = this.merchantId;
        return data;
    }

    clone(): MerchantsDayBillPageInputDto {
        const json = this.toJSON();
        let result = new MerchantsDayBillPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantsDayBillPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    createStartTime: Date | undefined;
    createEndTime: Date | undefined;
    merchantId: number | undefined;
}

export class MerchantSimpleDto implements IMerchantSimpleDto {
    id!: number;
    mid!: string | undefined;
    merchantName!: string | undefined;
    groupFlag!: string | undefined;
    status!: StatusEnum;

    constructor(data?: IMerchantSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mid = _data["mid"];
            this.merchantName = _data["merchantName"];
            this.groupFlag = _data["groupFlag"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): MerchantSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mid"] = this.mid;
        data["merchantName"] = this.merchantName;
        data["groupFlag"] = this.groupFlag;
        data["status"] = this.status;
        return data;
    }

    clone(): MerchantSimpleDto {
        const json = this.toJSON();
        let result = new MerchantSimpleDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantSimpleDto {
    id: number;
    mid: string | undefined;
    merchantName: string | undefined;
    groupFlag: string | undefined;
    status: StatusEnum;
}

export class MerchantSimpleInputDto implements IMerchantSimpleInputDto {
    mid!: string | undefined;
    userName!: string | undefined;
    merchantName!: string | undefined;
    status!: StatusEnum;

    constructor(data?: IMerchantSimpleInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mid = _data["mid"];
            this.userName = _data["userName"];
            this.merchantName = _data["merchantName"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): MerchantSimpleInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantSimpleInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mid"] = this.mid;
        data["userName"] = this.userName;
        data["merchantName"] = this.merchantName;
        data["status"] = this.status;
        return data;
    }

    clone(): MerchantSimpleInputDto {
        const json = this.toJSON();
        let result = new MerchantSimpleInputDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantSimpleInputDto {
    mid: string | undefined;
    userName: string | undefined;
    merchantName: string | undefined;
    status: StatusEnum;
}

export class MerchantStatisticsDto implements IMerchantStatisticsDto {
    merchantId!: number | undefined;
    merchantName!: string | undefined;
    mid!: string | undefined;
    totalOrderNum!: number;
    successOrderNum!: number;
    totalAmount!: number;
    successAmount!: number;
    liRun!: number;
    successRate!: number;
    commission!: number;
    merchantActualAmount!: number;
    buDanAmount!: number;
    buDanNum!: number;

    constructor(data?: IMerchantStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.merchantId = _data["merchantId"];
            this.merchantName = _data["merchantName"];
            this.mid = _data["mid"];
            this.totalOrderNum = _data["totalOrderNum"];
            this.successOrderNum = _data["successOrderNum"];
            this.totalAmount = _data["totalAmount"];
            this.successAmount = _data["successAmount"];
            this.liRun = _data["liRun"];
            this.successRate = _data["successRate"];
            this.commission = _data["commission"];
            this.merchantActualAmount = _data["merchantActualAmount"];
            this.buDanAmount = _data["buDanAmount"];
            this.buDanNum = _data["buDanNum"];
        }
    }

    static fromJS(data: any): MerchantStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["merchantId"] = this.merchantId;
        data["merchantName"] = this.merchantName;
        data["mid"] = this.mid;
        data["totalOrderNum"] = this.totalOrderNum;
        data["successOrderNum"] = this.successOrderNum;
        data["totalAmount"] = this.totalAmount;
        data["successAmount"] = this.successAmount;
        data["liRun"] = this.liRun;
        data["successRate"] = this.successRate;
        data["commission"] = this.commission;
        data["merchantActualAmount"] = this.merchantActualAmount;
        data["buDanAmount"] = this.buDanAmount;
        data["buDanNum"] = this.buDanNum;
        return data;
    }

    clone(): MerchantStatisticsDto {
        const json = this.toJSON();
        let result = new MerchantStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantStatisticsDto {
    merchantId: number | undefined;
    merchantName: string | undefined;
    mid: string | undefined;
    totalOrderNum: number;
    successOrderNum: number;
    totalAmount: number;
    successAmount: number;
    liRun: number;
    successRate: number;
    commission: number;
    merchantActualAmount: number;
    buDanAmount: number;
    buDanNum: number;
}

export class MerchantStatisticsPageInputDto implements IMerchantStatisticsPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    createTime!: Date | undefined;
    endTime!: Date | undefined;
    merchantId!: number | undefined;

    constructor(data?: IMerchantStatisticsPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.createTime = _data["createTime"] ? new Date(_data["createTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.merchantId = _data["merchantId"];
        }
    }

    static fromJS(data: any): MerchantStatisticsPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantStatisticsPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["merchantId"] = this.merchantId;
        return data;
    }

    clone(): MerchantStatisticsPageInputDto {
        const json = this.toJSON();
        let result = new MerchantStatisticsPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantStatisticsPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    createTime: Date | undefined;
    endTime: Date | undefined;
    merchantId: number | undefined;
}

export class MerchantSummaryDto implements IMerchantSummaryDto {
    mid!: string | undefined;
    merchantName!: string | undefined;
    balance!: number;
    totalMoney!: number;
    bargainMoney!: number;
    bargainRate!: number;
    agentMoney!: number;
    merchantProfit!: number;

    constructor(data?: IMerchantSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mid = _data["mid"];
            this.merchantName = _data["merchantName"];
            this.balance = _data["balance"];
            this.totalMoney = _data["totalMoney"];
            this.bargainMoney = _data["bargainMoney"];
            this.bargainRate = _data["bargainRate"];
            this.agentMoney = _data["agentMoney"];
            this.merchantProfit = _data["merchantProfit"];
        }
    }

    static fromJS(data: any): MerchantSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mid"] = this.mid;
        data["merchantName"] = this.merchantName;
        data["balance"] = this.balance;
        data["totalMoney"] = this.totalMoney;
        data["bargainMoney"] = this.bargainMoney;
        data["bargainRate"] = this.bargainRate;
        data["agentMoney"] = this.agentMoney;
        data["merchantProfit"] = this.merchantProfit;
        return data;
    }

    clone(): MerchantSummaryDto {
        const json = this.toJSON();
        let result = new MerchantSummaryDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantSummaryDto {
    mid: string | undefined;
    merchantName: string | undefined;
    balance: number;
    totalMoney: number;
    bargainMoney: number;
    bargainRate: number;
    agentMoney: number;
    merchantProfit: number;
}

export class MerchantTotalOutDto implements IMerchantTotalOutDto {
    balance!: number;
    advanceMoney!: number;

    constructor(data?: IMerchantTotalOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.balance = _data["balance"];
            this.advanceMoney = _data["advanceMoney"];
        }
    }

    static fromJS(data: any): MerchantTotalOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantTotalOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["balance"] = this.balance;
        data["advanceMoney"] = this.advanceMoney;
        return data;
    }

    clone(): MerchantTotalOutDto {
        const json = this.toJSON();
        let result = new MerchantTotalOutDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantTotalOutDto {
    balance: number;
    advanceMoney: number;
}

export class MerchantTotalUpfrontStatisticsDto implements IMerchantTotalUpfrontStatisticsDto {
    id!: number;
    type!: string | undefined;
    allBalance!: number;
    allAdvance!: number;
    realBalance!: number;
    createTime!: Date;

    constructor(data?: IMerchantTotalUpfrontStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.allBalance = _data["allBalance"];
            this.allAdvance = _data["allAdvance"];
            this.realBalance = _data["realBalance"];
            this.createTime = _data["createTime"] ? new Date(_data["createTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MerchantTotalUpfrontStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantTotalUpfrontStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["allBalance"] = this.allBalance;
        data["allAdvance"] = this.allAdvance;
        data["realBalance"] = this.realBalance;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): MerchantTotalUpfrontStatisticsDto {
        const json = this.toJSON();
        let result = new MerchantTotalUpfrontStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantTotalUpfrontStatisticsDto {
    id: number;
    type: string | undefined;
    allBalance: number;
    allAdvance: number;
    realBalance: number;
    createTime: Date;
}

export class MerchantTotalUpfrontStatisticsDtoPagedResultDto implements IMerchantTotalUpfrontStatisticsDtoPagedResultDto {
    items!: MerchantTotalUpfrontStatisticsDto[] | undefined;
    totalCount!: number;

    constructor(data?: IMerchantTotalUpfrontStatisticsDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MerchantTotalUpfrontStatisticsDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MerchantTotalUpfrontStatisticsDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantTotalUpfrontStatisticsDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MerchantTotalUpfrontStatisticsDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MerchantTotalUpfrontStatisticsDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantTotalUpfrontStatisticsDtoPagedResultDto {
    items: MerchantTotalUpfrontStatisticsDto[] | undefined;
    totalCount: number;
}

export class MerchantTotalUpfrontStatisticsPageInputDto implements IMerchantTotalUpfrontStatisticsPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    type!: string | undefined;
    startTime!: Date | undefined;
    endTime!: Date | undefined;

    constructor(data?: IMerchantTotalUpfrontStatisticsPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.type = _data["type"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MerchantTotalUpfrontStatisticsPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantTotalUpfrontStatisticsPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["type"] = this.type;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): MerchantTotalUpfrontStatisticsPageInputDto {
        const json = this.toJSON();
        let result = new MerchantTotalUpfrontStatisticsPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantTotalUpfrontStatisticsPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    type: string | undefined;
    startTime: Date | undefined;
    endTime: Date | undefined;
}

export class MerchantUpdateGroupMarkDto implements IMerchantUpdateGroupMarkDto {
    idList!: number[] | undefined;
    groupMark!: string | undefined;

    constructor(data?: IMerchantUpdateGroupMarkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["idList"])) {
                this.idList = [] as any;
                for (let item of _data["idList"])
                    this.idList!.push(item);
            }
            this.groupMark = _data["groupMark"];
        }
    }

    static fromJS(data: any): MerchantUpdateGroupMarkDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantUpdateGroupMarkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.idList)) {
            data["idList"] = [];
            for (let item of this.idList)
                data["idList"].push(item);
        }
        data["groupMark"] = this.groupMark;
        return data;
    }

    clone(): MerchantUpdateGroupMarkDto {
        const json = this.toJSON();
        let result = new MerchantUpdateGroupMarkDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantUpdateGroupMarkDto {
    idList: number[] | undefined;
    groupMark: string | undefined;
}

export class MerchantWithdrawOrderDto implements IMerchantWithdrawOrderDto {
    id!: number;
    orderNo!: string | undefined;
    merchantId!: number | undefined;
    mid!: string | undefined;
    merchantName!: string | undefined;
    money!: number;
    auditStatus!: AuditStatusEnum;
    auditTime!: Date | undefined;
    auditUserId!: number | undefined;
    auditUserName!: string | undefined;
    creationTime!: Date;
    bank!: string | undefined;
    bankNo!: string | undefined;
    bankName!: string | undefined;
    bankZhiHang!: string | undefined;
    bankProvince!: string | undefined;
    comment!: string | undefined;

    constructor(data?: IMerchantWithdrawOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNo = _data["orderNo"];
            this.merchantId = _data["merchantId"];
            this.mid = _data["mid"];
            this.merchantName = _data["merchantName"];
            this.money = _data["money"];
            this.auditStatus = _data["auditStatus"];
            this.auditTime = _data["auditTime"] ? new Date(_data["auditTime"].toString()) : <any>undefined;
            this.auditUserId = _data["auditUserId"];
            this.auditUserName = _data["auditUserName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.bank = _data["bank"];
            this.bankNo = _data["bankNo"];
            this.bankName = _data["bankName"];
            this.bankZhiHang = _data["bankZhiHang"];
            this.bankProvince = _data["bankProvince"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): MerchantWithdrawOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantWithdrawOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNo"] = this.orderNo;
        data["merchantId"] = this.merchantId;
        data["mid"] = this.mid;
        data["merchantName"] = this.merchantName;
        data["money"] = this.money;
        data["auditStatus"] = this.auditStatus;
        data["auditTime"] = this.auditTime ? this.auditTime.toISOString() : <any>undefined;
        data["auditUserId"] = this.auditUserId;
        data["auditUserName"] = this.auditUserName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["bank"] = this.bank;
        data["bankNo"] = this.bankNo;
        data["bankName"] = this.bankName;
        data["bankZhiHang"] = this.bankZhiHang;
        data["bankProvince"] = this.bankProvince;
        data["comment"] = this.comment;
        return data;
    }

    clone(): MerchantWithdrawOrderDto {
        const json = this.toJSON();
        let result = new MerchantWithdrawOrderDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantWithdrawOrderDto {
    id: number;
    orderNo: string | undefined;
    merchantId: number | undefined;
    mid: string | undefined;
    merchantName: string | undefined;
    money: number;
    auditStatus: AuditStatusEnum;
    auditTime: Date | undefined;
    auditUserId: number | undefined;
    auditUserName: string | undefined;
    creationTime: Date;
    bank: string | undefined;
    bankNo: string | undefined;
    bankName: string | undefined;
    bankZhiHang: string | undefined;
    bankProvince: string | undefined;
    comment: string | undefined;
}

export class MerchantWithdrawOrderDtoPagedResultDto implements IMerchantWithdrawOrderDtoPagedResultDto {
    items!: MerchantWithdrawOrderDto[] | undefined;
    totalCount!: number;

    constructor(data?: IMerchantWithdrawOrderDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MerchantWithdrawOrderDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MerchantWithdrawOrderDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantWithdrawOrderDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MerchantWithdrawOrderDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MerchantWithdrawOrderDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantWithdrawOrderDtoPagedResultDto {
    items: MerchantWithdrawOrderDto[] | undefined;
    totalCount: number;
}

export class MerchantWithdrawOrderPageInputDto implements IMerchantWithdrawOrderPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    orderNo!: string | undefined;
    merchantId!: number | undefined;
    mid!: string | undefined;
    merchantName!: string | undefined;
    auditStatus!: AuditStatusEnum;

    constructor(data?: IMerchantWithdrawOrderPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.orderNo = _data["orderNo"];
            this.merchantId = _data["merchantId"];
            this.mid = _data["mid"];
            this.merchantName = _data["merchantName"];
            this.auditStatus = _data["auditStatus"];
        }
    }

    static fromJS(data: any): MerchantWithdrawOrderPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantWithdrawOrderPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["orderNo"] = this.orderNo;
        data["merchantId"] = this.merchantId;
        data["mid"] = this.mid;
        data["merchantName"] = this.merchantName;
        data["auditStatus"] = this.auditStatus;
        return data;
    }

    clone(): MerchantWithdrawOrderPageInputDto {
        const json = this.toJSON();
        let result = new MerchantWithdrawOrderPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IMerchantWithdrawOrderPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    orderNo: string | undefined;
    merchantId: number | undefined;
    mid: string | undefined;
    merchantName: string | undefined;
    auditStatus: AuditStatusEnum;
}

export class Mytree implements IMytree {
    name!: string | undefined;
    value!: string | undefined;
    level!: number;

    constructor(data?: IMytree) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
            this.level = _data["level"];
        }
    }

    static fromJS(data: any): Mytree {
        data = typeof data === 'object' ? data : {};
        let result = new Mytree();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        data["level"] = this.level;
        return data;
    }

    clone(): Mytree {
        const json = this.toJSON();
        let result = new Mytree();
        result.init(json);
        return result;
    }
}

export interface IMytree {
    name: string | undefined;
    value: string | undefined;
    level: number;
}

export class Mytree1 implements IMytree1 {
    name!: string | undefined;
    value!: string | undefined;
    level!: number;
    parent!: string | undefined;

    constructor(data?: IMytree1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
            this.level = _data["level"];
            this.parent = _data["parent"];
        }
    }

    static fromJS(data: any): Mytree1 {
        data = typeof data === 'object' ? data : {};
        let result = new Mytree1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        data["level"] = this.level;
        data["parent"] = this.parent;
        return data;
    }

    clone(): Mytree1 {
        const json = this.toJSON();
        let result = new Mytree1();
        result.init(json);
        return result;
    }
}

export interface IMytree1 {
    name: string | undefined;
    value: string | undefined;
    level: number;
    parent: string | undefined;
}

export class OperatorLogOutDto implements IOperatorLogOutDto {
    id!: number;
    operatorUserId!: number | undefined;
    operatorUserName!: string | undefined;
    createTime!: Date;
    operatorContent!: string | undefined;
    operatorId!: number;
    operatorTableName!: OperatorTableNameEnum;
    operatorLogType!: OperatorLogTypeEnum;
    readonly operatorLogTypeName!: string | undefined;

    constructor(data?: IOperatorLogOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.operatorUserId = _data["operatorUserId"];
            this.operatorUserName = _data["operatorUserName"];
            this.createTime = _data["createTime"] ? new Date(_data["createTime"].toString()) : <any>undefined;
            this.operatorContent = _data["operatorContent"];
            this.operatorId = _data["operatorId"];
            this.operatorTableName = _data["operatorTableName"];
            this.operatorLogType = _data["operatorLogType"];
            (<any>this).operatorLogTypeName = _data["operatorLogTypeName"];
        }
    }

    static fromJS(data: any): OperatorLogOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperatorLogOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["operatorUserId"] = this.operatorUserId;
        data["operatorUserName"] = this.operatorUserName;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["operatorContent"] = this.operatorContent;
        data["operatorId"] = this.operatorId;
        data["operatorTableName"] = this.operatorTableName;
        data["operatorLogType"] = this.operatorLogType;
        data["operatorLogTypeName"] = this.operatorLogTypeName;
        return data;
    }

    clone(): OperatorLogOutDto {
        const json = this.toJSON();
        let result = new OperatorLogOutDto();
        result.init(json);
        return result;
    }
}

export interface IOperatorLogOutDto {
    id: number;
    operatorUserId: number | undefined;
    operatorUserName: string | undefined;
    createTime: Date;
    operatorContent: string | undefined;
    operatorId: number;
    operatorTableName: OperatorTableNameEnum;
    operatorLogType: OperatorLogTypeEnum;
    operatorLogTypeName: string | undefined;
}

export class OperatorLogOutDtoPagedResultDto implements IOperatorLogOutDtoPagedResultDto {
    items!: OperatorLogOutDto[] | undefined;
    totalCount!: number;

    constructor(data?: IOperatorLogOutDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OperatorLogOutDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): OperatorLogOutDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperatorLogOutDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): OperatorLogOutDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OperatorLogOutDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOperatorLogOutDtoPagedResultDto {
    items: OperatorLogOutDto[] | undefined;
    totalCount: number;
}

export class OperatorLogPageInputDto implements IOperatorLogPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    operatorId!: number | undefined;
    operatorTableName!: OperatorTableNameEnum;
    operatorContent!: string | undefined;
    startDate!: Date | undefined;
    endDate!: Date | undefined;

    constructor(data?: IOperatorLogPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.operatorId = _data["operatorId"];
            this.operatorTableName = _data["operatorTableName"];
            this.operatorContent = _data["operatorContent"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OperatorLogPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperatorLogPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["operatorId"] = this.operatorId;
        data["operatorTableName"] = this.operatorTableName;
        data["operatorContent"] = this.operatorContent;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): OperatorLogPageInputDto {
        const json = this.toJSON();
        let result = new OperatorLogPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IOperatorLogPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    operatorId: number | undefined;
    operatorTableName: OperatorTableNameEnum;
    operatorContent: string | undefined;
    startDate: Date | undefined;
    endDate: Date | undefined;
}

export class OperatorLogQueryInput implements IOperatorLogQueryInput {
    operatorId!: number;
    operatorTableName!: OperatorTableNameEnum;

    constructor(data?: IOperatorLogQueryInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operatorId = _data["operatorId"];
            this.operatorTableName = _data["operatorTableName"];
        }
    }

    static fromJS(data: any): OperatorLogQueryInput {
        data = typeof data === 'object' ? data : {};
        let result = new OperatorLogQueryInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operatorId"] = this.operatorId;
        data["operatorTableName"] = this.operatorTableName;
        return data;
    }

    clone(): OperatorLogQueryInput {
        const json = this.toJSON();
        let result = new OperatorLogQueryInput();
        result.init(json);
        return result;
    }
}

export interface IOperatorLogQueryInput {
    operatorId: number;
    operatorTableName: OperatorTableNameEnum;
}

export enum OperatorLogTypeEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum OperatorTableNameEnum {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12,
    _13 = 13,
    _14 = 14,
    _15 = 15,
    _16 = 16,
    _17 = 17,
    _18 = 18,
    _19 = 19,
    _20 = 20,
    _21 = 21,
    _22 = 22,
    _23 = 23,
    _24 = 24,
    _25 = 25,
    _26 = 26,
    _27 = 27,
    _28 = 28,
    _29 = 29,
    _30 = 30,
    _31 = 31,
    _32 = 32,
    _33 = 33,
    _40 = 40,
    _41 = 41,
    _42 = 42,
    _43 = 43,
    _44 = 44,
    _45 = 45,
    _46 = 46,
    _47 = 47,
    _48 = 48,
    _49 = 49,
    _50 = 50,
    _51 = 51,
    _52 = 52,
}

export class OrderSubmitPlatOutDto implements IOrderSubmitPlatOutDto {
    payUrl!: string | undefined;
    reqUrl!: string | undefined;
    reqData!: string | undefined;
    res!: string | undefined;
    isOk!: boolean;
    errMsg!: string | undefined;
    outTid!: string | undefined;
    bankCode!: string | undefined;
    bankName!: string | undefined;
    bankAddress!: string | undefined;
    payeeName!: string | undefined;

    constructor(data?: IOrderSubmitPlatOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payUrl = _data["payUrl"];
            this.reqUrl = _data["reqUrl"];
            this.reqData = _data["reqData"];
            this.res = _data["res"];
            this.isOk = _data["isOk"];
            this.errMsg = _data["errMsg"];
            this.outTid = _data["outTid"];
            this.bankCode = _data["bankCode"];
            this.bankName = _data["bankName"];
            this.bankAddress = _data["bankAddress"];
            this.payeeName = _data["payeeName"];
        }
    }

    static fromJS(data: any): OrderSubmitPlatOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderSubmitPlatOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payUrl"] = this.payUrl;
        data["reqUrl"] = this.reqUrl;
        data["reqData"] = this.reqData;
        data["res"] = this.res;
        data["isOk"] = this.isOk;
        data["errMsg"] = this.errMsg;
        data["outTid"] = this.outTid;
        data["bankCode"] = this.bankCode;
        data["bankName"] = this.bankName;
        data["bankAddress"] = this.bankAddress;
        data["payeeName"] = this.payeeName;
        return data;
    }

    clone(): OrderSubmitPlatOutDto {
        const json = this.toJSON();
        let result = new OrderSubmitPlatOutDto();
        result.init(json);
        return result;
    }
}

export interface IOrderSubmitPlatOutDto {
    payUrl: string | undefined;
    reqUrl: string | undefined;
    reqData: string | undefined;
    res: string | undefined;
    isOk: boolean;
    errMsg: string | undefined;
    outTid: string | undefined;
    bankCode: string | undefined;
    bankName: string | undefined;
    bankAddress: string | undefined;
    payeeName: string | undefined;
}

export class PayOrderDto implements IPayOrderDto {
    id!: number;
    tid!: string | undefined;
    outTid!: string | undefined;
    merOrderTid!: string | undefined;
    merchantId!: number | undefined;
    mid!: string | undefined;
    payUrl!: string | undefined;
    orderApiIps!: string | undefined;
    merchantName!: string | undefined;
    channelName!: string | undefined;
    channelTypeId!: number | undefined;
    channelTypeName!: string | undefined;
    money!: number;
    commission!: number;
    payMoney!: number;
    successTime!: Date | undefined;
    agentRateCommission!: number;
    agentRate!: number;
    merchantAgentRate!: number;
    merchantAgentRateCommission!: number;
    merchantAgentId!: number | undefined;
    channelAgentId!: number | undefined;
    failTime!: Date | undefined;
    payOrderStatus!: PayOrderStatusEnum;
    readonly payOrderStatusName!: string | undefined;
    notifyUrl!: string | undefined;
    noticeStatus!: number;
    noticeCount!: number;
    isBuDan!: boolean;
    channelId!: number | undefined;
    channelTypeCode!: string | undefined;
    orderCommont!: string | undefined;
    creationTime!: Date;
    payTimeConsuming!: number;
    channelRateCommission!: number;
    errorMsg!: string | undefined;
    isCz!: boolean;
    readonly isCzStr!: string | undefined;
    isUpdateMoney!: boolean;
    readonly isUmStr!: string | undefined;
    channelRate!: number;
    endTime!: Date | undefined;
    clientUserPayRemark!: string | undefined;
    clientUserId!: string | undefined;
    clientUserName!: string | undefined;

    constructor(data?: IPayOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tid = _data["tid"];
            this.outTid = _data["outTid"];
            this.merOrderTid = _data["merOrderTid"];
            this.merchantId = _data["merchantId"];
            this.mid = _data["mid"];
            this.payUrl = _data["payUrl"];
            this.orderApiIps = _data["orderApiIps"];
            this.merchantName = _data["merchantName"];
            this.channelName = _data["channelName"];
            this.channelTypeId = _data["channelTypeId"];
            this.channelTypeName = _data["channelTypeName"];
            this.money = _data["money"];
            this.commission = _data["commission"];
            this.payMoney = _data["payMoney"];
            this.successTime = _data["successTime"] ? new Date(_data["successTime"].toString()) : <any>undefined;
            this.agentRateCommission = _data["agentRateCommission"];
            this.agentRate = _data["agentRate"];
            this.merchantAgentRate = _data["merchantAgentRate"];
            this.merchantAgentRateCommission = _data["merchantAgentRateCommission"];
            this.merchantAgentId = _data["merchantAgentId"];
            this.channelAgentId = _data["channelAgentId"];
            this.failTime = _data["failTime"] ? new Date(_data["failTime"].toString()) : <any>undefined;
            this.payOrderStatus = _data["payOrderStatus"];
            (<any>this).payOrderStatusName = _data["payOrderStatusName"];
            this.notifyUrl = _data["notifyUrl"];
            this.noticeStatus = _data["noticeStatus"];
            this.noticeCount = _data["noticeCount"];
            this.isBuDan = _data["isBuDan"];
            this.channelId = _data["channelId"];
            this.channelTypeCode = _data["channelTypeCode"];
            this.orderCommont = _data["orderCommont"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.payTimeConsuming = _data["payTimeConsuming"];
            this.channelRateCommission = _data["channelRateCommission"];
            this.errorMsg = _data["errorMsg"];
            this.isCz = _data["isCz"];
            (<any>this).isCzStr = _data["isCzStr"];
            this.isUpdateMoney = _data["isUpdateMoney"];
            (<any>this).isUmStr = _data["isUmStr"];
            this.channelRate = _data["channelRate"];
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.clientUserPayRemark = _data["clientUserPayRemark"];
            this.clientUserId = _data["clientUserId"];
            this.clientUserName = _data["clientUserName"];
        }
    }

    static fromJS(data: any): PayOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new PayOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tid"] = this.tid;
        data["outTid"] = this.outTid;
        data["merOrderTid"] = this.merOrderTid;
        data["merchantId"] = this.merchantId;
        data["mid"] = this.mid;
        data["payUrl"] = this.payUrl;
        data["orderApiIps"] = this.orderApiIps;
        data["merchantName"] = this.merchantName;
        data["channelName"] = this.channelName;
        data["channelTypeId"] = this.channelTypeId;
        data["channelTypeName"] = this.channelTypeName;
        data["money"] = this.money;
        data["commission"] = this.commission;
        data["payMoney"] = this.payMoney;
        data["successTime"] = this.successTime ? this.successTime.toISOString() : <any>undefined;
        data["agentRateCommission"] = this.agentRateCommission;
        data["agentRate"] = this.agentRate;
        data["merchantAgentRate"] = this.merchantAgentRate;
        data["merchantAgentRateCommission"] = this.merchantAgentRateCommission;
        data["merchantAgentId"] = this.merchantAgentId;
        data["channelAgentId"] = this.channelAgentId;
        data["failTime"] = this.failTime ? this.failTime.toISOString() : <any>undefined;
        data["payOrderStatus"] = this.payOrderStatus;
        data["payOrderStatusName"] = this.payOrderStatusName;
        data["notifyUrl"] = this.notifyUrl;
        data["noticeStatus"] = this.noticeStatus;
        data["noticeCount"] = this.noticeCount;
        data["isBuDan"] = this.isBuDan;
        data["channelId"] = this.channelId;
        data["channelTypeCode"] = this.channelTypeCode;
        data["orderCommont"] = this.orderCommont;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["payTimeConsuming"] = this.payTimeConsuming;
        data["channelRateCommission"] = this.channelRateCommission;
        data["errorMsg"] = this.errorMsg;
        data["isCz"] = this.isCz;
        data["isCzStr"] = this.isCzStr;
        data["isUpdateMoney"] = this.isUpdateMoney;
        data["isUmStr"] = this.isUmStr;
        data["channelRate"] = this.channelRate;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["clientUserPayRemark"] = this.clientUserPayRemark;
        data["clientUserId"] = this.clientUserId;
        data["clientUserName"] = this.clientUserName;
        return data;
    }

    clone(): PayOrderDto {
        const json = this.toJSON();
        let result = new PayOrderDto();
        result.init(json);
        return result;
    }
}

export interface IPayOrderDto {
    id: number;
    tid: string | undefined;
    outTid: string | undefined;
    merOrderTid: string | undefined;
    merchantId: number | undefined;
    mid: string | undefined;
    payUrl: string | undefined;
    orderApiIps: string | undefined;
    merchantName: string | undefined;
    channelName: string | undefined;
    channelTypeId: number | undefined;
    channelTypeName: string | undefined;
    money: number;
    commission: number;
    payMoney: number;
    successTime: Date | undefined;
    agentRateCommission: number;
    agentRate: number;
    merchantAgentRate: number;
    merchantAgentRateCommission: number;
    merchantAgentId: number | undefined;
    channelAgentId: number | undefined;
    failTime: Date | undefined;
    payOrderStatus: PayOrderStatusEnum;
    payOrderStatusName: string | undefined;
    notifyUrl: string | undefined;
    noticeStatus: number;
    noticeCount: number;
    isBuDan: boolean;
    channelId: number | undefined;
    channelTypeCode: string | undefined;
    orderCommont: string | undefined;
    creationTime: Date;
    payTimeConsuming: number;
    channelRateCommission: number;
    errorMsg: string | undefined;
    isCz: boolean;
    isCzStr: string | undefined;
    isUpdateMoney: boolean;
    isUmStr: string | undefined;
    channelRate: number;
    endTime: Date | undefined;
    clientUserPayRemark: string | undefined;
    clientUserId: string | undefined;
    clientUserName: string | undefined;
}

export class PayOrderDtoPagedResultDto implements IPayOrderDtoPagedResultDto {
    items!: PayOrderDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPayOrderDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PayOrderDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PayOrderDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PayOrderDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PayOrderDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PayOrderDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPayOrderDtoPagedResultDto {
    items: PayOrderDto[] | undefined;
    totalCount: number;
}

export class PayOrderPageInputDto implements IPayOrderPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    tid!: string | undefined;
    outTid!: string | undefined;
    isYcOrder!: boolean;
    merOrderTid!: string | undefined;
    merchantId!: number | undefined;
    merchantIds!: number[] | undefined;
    mid!: string | undefined;
    merchantName!: string | undefined;
    payOrderStatus!: PayOrderStatusEnum;
    noticeStatus!: number | undefined;
    isBuDan!: boolean | undefined;
    channelId!: number | undefined;
    channelName!: string | undefined;
    channelTypeId!: number | undefined;
    channelTypeName!: string | undefined;
    channelTypeCode!: string | undefined;
    orderCommont!: string | undefined;
    createStartTime!: Date | undefined;
    createEndTime!: Date | undefined;
    successStartTime!: Date | undefined;
    successEndTime!: Date | undefined;
    cancelTimeStart!: Date | undefined;
    cancelTimeEnd!: Date | undefined;
    startMoney!: number | undefined;
    endMoney!: number | undefined;
    isCz!: boolean | undefined;
    channelSupplierId!: number | undefined;
    channelAgentId!: number | undefined;
    merchantAgentId!: number | undefined;

    constructor(data?: IPayOrderPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.tid = _data["tid"];
            this.outTid = _data["outTid"];
            this.isYcOrder = _data["isYcOrder"];
            this.merOrderTid = _data["merOrderTid"];
            this.merchantId = _data["merchantId"];
            if (Array.isArray(_data["merchantIds"])) {
                this.merchantIds = [] as any;
                for (let item of _data["merchantIds"])
                    this.merchantIds!.push(item);
            }
            this.mid = _data["mid"];
            this.merchantName = _data["merchantName"];
            this.payOrderStatus = _data["payOrderStatus"];
            this.noticeStatus = _data["noticeStatus"];
            this.isBuDan = _data["isBuDan"];
            this.channelId = _data["channelId"];
            this.channelName = _data["channelName"];
            this.channelTypeId = _data["channelTypeId"];
            this.channelTypeName = _data["channelTypeName"];
            this.channelTypeCode = _data["channelTypeCode"];
            this.orderCommont = _data["orderCommont"];
            this.createStartTime = _data["createStartTime"] ? new Date(_data["createStartTime"].toString()) : <any>undefined;
            this.createEndTime = _data["createEndTime"] ? new Date(_data["createEndTime"].toString()) : <any>undefined;
            this.successStartTime = _data["successStartTime"] ? new Date(_data["successStartTime"].toString()) : <any>undefined;
            this.successEndTime = _data["successEndTime"] ? new Date(_data["successEndTime"].toString()) : <any>undefined;
            this.cancelTimeStart = _data["cancelTimeStart"] ? new Date(_data["cancelTimeStart"].toString()) : <any>undefined;
            this.cancelTimeEnd = _data["cancelTimeEnd"] ? new Date(_data["cancelTimeEnd"].toString()) : <any>undefined;
            this.startMoney = _data["startMoney"];
            this.endMoney = _data["endMoney"];
            this.isCz = _data["isCz"];
            this.channelSupplierId = _data["channelSupplierId"];
            this.channelAgentId = _data["channelAgentId"];
            this.merchantAgentId = _data["merchantAgentId"];
        }
    }

    static fromJS(data: any): PayOrderPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PayOrderPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["tid"] = this.tid;
        data["outTid"] = this.outTid;
        data["isYcOrder"] = this.isYcOrder;
        data["merOrderTid"] = this.merOrderTid;
        data["merchantId"] = this.merchantId;
        if (Array.isArray(this.merchantIds)) {
            data["merchantIds"] = [];
            for (let item of this.merchantIds)
                data["merchantIds"].push(item);
        }
        data["mid"] = this.mid;
        data["merchantName"] = this.merchantName;
        data["payOrderStatus"] = this.payOrderStatus;
        data["noticeStatus"] = this.noticeStatus;
        data["isBuDan"] = this.isBuDan;
        data["channelId"] = this.channelId;
        data["channelName"] = this.channelName;
        data["channelTypeId"] = this.channelTypeId;
        data["channelTypeName"] = this.channelTypeName;
        data["channelTypeCode"] = this.channelTypeCode;
        data["orderCommont"] = this.orderCommont;
        data["createStartTime"] = this.createStartTime ? this.createStartTime.toISOString() : <any>undefined;
        data["createEndTime"] = this.createEndTime ? this.createEndTime.toISOString() : <any>undefined;
        data["successStartTime"] = this.successStartTime ? this.successStartTime.toISOString() : <any>undefined;
        data["successEndTime"] = this.successEndTime ? this.successEndTime.toISOString() : <any>undefined;
        data["cancelTimeStart"] = this.cancelTimeStart ? this.cancelTimeStart.toISOString() : <any>undefined;
        data["cancelTimeEnd"] = this.cancelTimeEnd ? this.cancelTimeEnd.toISOString() : <any>undefined;
        data["startMoney"] = this.startMoney;
        data["endMoney"] = this.endMoney;
        data["isCz"] = this.isCz;
        data["channelSupplierId"] = this.channelSupplierId;
        data["channelAgentId"] = this.channelAgentId;
        data["merchantAgentId"] = this.merchantAgentId;
        return data;
    }

    clone(): PayOrderPageInputDto {
        const json = this.toJSON();
        let result = new PayOrderPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IPayOrderPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    tid: string | undefined;
    outTid: string | undefined;
    isYcOrder: boolean;
    merOrderTid: string | undefined;
    merchantId: number | undefined;
    merchantIds: number[] | undefined;
    mid: string | undefined;
    merchantName: string | undefined;
    payOrderStatus: PayOrderStatusEnum;
    noticeStatus: number | undefined;
    isBuDan: boolean | undefined;
    channelId: number | undefined;
    channelName: string | undefined;
    channelTypeId: number | undefined;
    channelTypeName: string | undefined;
    channelTypeCode: string | undefined;
    orderCommont: string | undefined;
    createStartTime: Date | undefined;
    createEndTime: Date | undefined;
    successStartTime: Date | undefined;
    successEndTime: Date | undefined;
    cancelTimeStart: Date | undefined;
    cancelTimeEnd: Date | undefined;
    startMoney: number | undefined;
    endMoney: number | undefined;
    isCz: boolean | undefined;
    channelSupplierId: number | undefined;
    channelAgentId: number | undefined;
    merchantAgentId: number | undefined;
}

export class PayOrderPageOutDto implements IPayOrderPageOutDto {
    id!: number;
    tid!: string | undefined;
    merOrderTid!: string | undefined;
    merchantId!: number | undefined;
    mid!: string | undefined;
    merchantName!: string | undefined;
    channelName!: string | undefined;
    channelTypeId!: number | undefined;
    channelTypeName!: string | undefined;
    money!: number;
    commission!: number;
    successTime!: Date | undefined;
    agentRateCommission!: number;
    agentRate!: number;
    merchantAgentRate!: number;
    merchantAgentRateCommission!: number;
    merchantAgentId!: number | undefined;
    channelAgentId!: number | undefined;
    payOrderStatus!: PayOrderStatusEnum;
    readonly payOrderStatusName!: string | undefined;
    noticeStatus!: number;
    isBuDan!: boolean;
    channelId!: number | undefined;
    channelTypeCode!: string | undefined;
    orderCommont!: string | undefined;
    creationTime!: Date;
    payTimeConsuming!: number;
    channelRateCommission!: number;
    errorMsg!: string | undefined;
    isCz!: boolean;
    readonly isCzStr!: string | undefined;
    isUpdateMoney!: boolean;
    readonly isUmStr!: string | undefined;
    channelRate!: number;
    merchantRate!: number;
    clientUserPayRemark!: string | undefined;
    clientUserId!: string | undefined;
    clientUserName!: string | undefined;

    constructor(data?: IPayOrderPageOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tid = _data["tid"];
            this.merOrderTid = _data["merOrderTid"];
            this.merchantId = _data["merchantId"];
            this.mid = _data["mid"];
            this.merchantName = _data["merchantName"];
            this.channelName = _data["channelName"];
            this.channelTypeId = _data["channelTypeId"];
            this.channelTypeName = _data["channelTypeName"];
            this.money = _data["money"];
            this.commission = _data["commission"];
            this.successTime = _data["successTime"] ? new Date(_data["successTime"].toString()) : <any>undefined;
            this.agentRateCommission = _data["agentRateCommission"];
            this.agentRate = _data["agentRate"];
            this.merchantAgentRate = _data["merchantAgentRate"];
            this.merchantAgentRateCommission = _data["merchantAgentRateCommission"];
            this.merchantAgentId = _data["merchantAgentId"];
            this.channelAgentId = _data["channelAgentId"];
            this.payOrderStatus = _data["payOrderStatus"];
            (<any>this).payOrderStatusName = _data["payOrderStatusName"];
            this.noticeStatus = _data["noticeStatus"];
            this.isBuDan = _data["isBuDan"];
            this.channelId = _data["channelId"];
            this.channelTypeCode = _data["channelTypeCode"];
            this.orderCommont = _data["orderCommont"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.payTimeConsuming = _data["payTimeConsuming"];
            this.channelRateCommission = _data["channelRateCommission"];
            this.errorMsg = _data["errorMsg"];
            this.isCz = _data["isCz"];
            (<any>this).isCzStr = _data["isCzStr"];
            this.isUpdateMoney = _data["isUpdateMoney"];
            (<any>this).isUmStr = _data["isUmStr"];
            this.channelRate = _data["channelRate"];
            this.merchantRate = _data["merchantRate"];
            this.clientUserPayRemark = _data["clientUserPayRemark"];
            this.clientUserId = _data["clientUserId"];
            this.clientUserName = _data["clientUserName"];
        }
    }

    static fromJS(data: any): PayOrderPageOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new PayOrderPageOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tid"] = this.tid;
        data["merOrderTid"] = this.merOrderTid;
        data["merchantId"] = this.merchantId;
        data["mid"] = this.mid;
        data["merchantName"] = this.merchantName;
        data["channelName"] = this.channelName;
        data["channelTypeId"] = this.channelTypeId;
        data["channelTypeName"] = this.channelTypeName;
        data["money"] = this.money;
        data["commission"] = this.commission;
        data["successTime"] = this.successTime ? this.successTime.toISOString() : <any>undefined;
        data["agentRateCommission"] = this.agentRateCommission;
        data["agentRate"] = this.agentRate;
        data["merchantAgentRate"] = this.merchantAgentRate;
        data["merchantAgentRateCommission"] = this.merchantAgentRateCommission;
        data["merchantAgentId"] = this.merchantAgentId;
        data["channelAgentId"] = this.channelAgentId;
        data["payOrderStatus"] = this.payOrderStatus;
        data["payOrderStatusName"] = this.payOrderStatusName;
        data["noticeStatus"] = this.noticeStatus;
        data["isBuDan"] = this.isBuDan;
        data["channelId"] = this.channelId;
        data["channelTypeCode"] = this.channelTypeCode;
        data["orderCommont"] = this.orderCommont;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["payTimeConsuming"] = this.payTimeConsuming;
        data["channelRateCommission"] = this.channelRateCommission;
        data["errorMsg"] = this.errorMsg;
        data["isCz"] = this.isCz;
        data["isCzStr"] = this.isCzStr;
        data["isUpdateMoney"] = this.isUpdateMoney;
        data["isUmStr"] = this.isUmStr;
        data["channelRate"] = this.channelRate;
        data["merchantRate"] = this.merchantRate;
        data["clientUserPayRemark"] = this.clientUserPayRemark;
        data["clientUserId"] = this.clientUserId;
        data["clientUserName"] = this.clientUserName;
        return data;
    }

    clone(): PayOrderPageOutDto {
        const json = this.toJSON();
        let result = new PayOrderPageOutDto();
        result.init(json);
        return result;
    }
}

export interface IPayOrderPageOutDto {
    id: number;
    tid: string | undefined;
    merOrderTid: string | undefined;
    merchantId: number | undefined;
    mid: string | undefined;
    merchantName: string | undefined;
    channelName: string | undefined;
    channelTypeId: number | undefined;
    channelTypeName: string | undefined;
    money: number;
    commission: number;
    successTime: Date | undefined;
    agentRateCommission: number;
    agentRate: number;
    merchantAgentRate: number;
    merchantAgentRateCommission: number;
    merchantAgentId: number | undefined;
    channelAgentId: number | undefined;
    payOrderStatus: PayOrderStatusEnum;
    payOrderStatusName: string | undefined;
    noticeStatus: number;
    isBuDan: boolean;
    channelId: number | undefined;
    channelTypeCode: string | undefined;
    orderCommont: string | undefined;
    creationTime: Date;
    payTimeConsuming: number;
    channelRateCommission: number;
    errorMsg: string | undefined;
    isCz: boolean;
    isCzStr: string | undefined;
    isUpdateMoney: boolean;
    isUmStr: string | undefined;
    channelRate: number;
    merchantRate: number;
    clientUserPayRemark: string | undefined;
    clientUserId: string | undefined;
    clientUserName: string | undefined;
}

export class PayOrderPageOutDtoPagedResultDto implements IPayOrderPageOutDtoPagedResultDto {
    items!: PayOrderPageOutDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPayOrderPageOutDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PayOrderPageOutDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PayOrderPageOutDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PayOrderPageOutDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PayOrderPageOutDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PayOrderPageOutDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPayOrderPageOutDtoPagedResultDto {
    items: PayOrderPageOutDto[] | undefined;
    totalCount: number;
}

export enum PayOrderStatusEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class PayUnusalOrderDto implements IPayUnusalOrderDto {
    id!: number;
    tid!: string | undefined;
    outTid!: string | undefined;
    merOrderTid!: string | undefined;
    merchantId!: number | undefined;
    mid!: string | undefined;
    merchantName!: string | undefined;
    money!: number;
    commission!: number;
    payMoney!: number;
    channelId!: number | undefined;
    channelName!: string | undefined;
    channelTypeId!: number | undefined;
    channelTypeName!: string | undefined;
    channelTypeCode!: string | undefined;
    channelRateCommission!: number;
    channelRate!: number;
    agentRateCommission!: number;
    agentRate!: number;
    merchantAgentRate!: number;
    merchantAgentRateCommission!: number;
    merchantAgentId!: number | undefined;
    channelAgentId!: number | undefined;
    errorMsg!: string | undefined;
    channelSupplierId!: number | undefined;
    channelSupplierName!: string | undefined;
    merchantRate!: number;
    creationTime!: Date;

    constructor(data?: IPayUnusalOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tid = _data["tid"];
            this.outTid = _data["outTid"];
            this.merOrderTid = _data["merOrderTid"];
            this.merchantId = _data["merchantId"];
            this.mid = _data["mid"];
            this.merchantName = _data["merchantName"];
            this.money = _data["money"];
            this.commission = _data["commission"];
            this.payMoney = _data["payMoney"];
            this.channelId = _data["channelId"];
            this.channelName = _data["channelName"];
            this.channelTypeId = _data["channelTypeId"];
            this.channelTypeName = _data["channelTypeName"];
            this.channelTypeCode = _data["channelTypeCode"];
            this.channelRateCommission = _data["channelRateCommission"];
            this.channelRate = _data["channelRate"];
            this.agentRateCommission = _data["agentRateCommission"];
            this.agentRate = _data["agentRate"];
            this.merchantAgentRate = _data["merchantAgentRate"];
            this.merchantAgentRateCommission = _data["merchantAgentRateCommission"];
            this.merchantAgentId = _data["merchantAgentId"];
            this.channelAgentId = _data["channelAgentId"];
            this.errorMsg = _data["errorMsg"];
            this.channelSupplierId = _data["channelSupplierId"];
            this.channelSupplierName = _data["channelSupplierName"];
            this.merchantRate = _data["merchantRate"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PayUnusalOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new PayUnusalOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tid"] = this.tid;
        data["outTid"] = this.outTid;
        data["merOrderTid"] = this.merOrderTid;
        data["merchantId"] = this.merchantId;
        data["mid"] = this.mid;
        data["merchantName"] = this.merchantName;
        data["money"] = this.money;
        data["commission"] = this.commission;
        data["payMoney"] = this.payMoney;
        data["channelId"] = this.channelId;
        data["channelName"] = this.channelName;
        data["channelTypeId"] = this.channelTypeId;
        data["channelTypeName"] = this.channelTypeName;
        data["channelTypeCode"] = this.channelTypeCode;
        data["channelRateCommission"] = this.channelRateCommission;
        data["channelRate"] = this.channelRate;
        data["agentRateCommission"] = this.agentRateCommission;
        data["agentRate"] = this.agentRate;
        data["merchantAgentRate"] = this.merchantAgentRate;
        data["merchantAgentRateCommission"] = this.merchantAgentRateCommission;
        data["merchantAgentId"] = this.merchantAgentId;
        data["channelAgentId"] = this.channelAgentId;
        data["errorMsg"] = this.errorMsg;
        data["channelSupplierId"] = this.channelSupplierId;
        data["channelSupplierName"] = this.channelSupplierName;
        data["merchantRate"] = this.merchantRate;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): PayUnusalOrderDto {
        const json = this.toJSON();
        let result = new PayUnusalOrderDto();
        result.init(json);
        return result;
    }
}

export interface IPayUnusalOrderDto {
    id: number;
    tid: string | undefined;
    outTid: string | undefined;
    merOrderTid: string | undefined;
    merchantId: number | undefined;
    mid: string | undefined;
    merchantName: string | undefined;
    money: number;
    commission: number;
    payMoney: number;
    channelId: number | undefined;
    channelName: string | undefined;
    channelTypeId: number | undefined;
    channelTypeName: string | undefined;
    channelTypeCode: string | undefined;
    channelRateCommission: number;
    channelRate: number;
    agentRateCommission: number;
    agentRate: number;
    merchantAgentRate: number;
    merchantAgentRateCommission: number;
    merchantAgentId: number | undefined;
    channelAgentId: number | undefined;
    errorMsg: string | undefined;
    channelSupplierId: number | undefined;
    channelSupplierName: string | undefined;
    merchantRate: number;
    creationTime: Date;
}

export class PayUnusalOrderDtoPagedResultDto implements IPayUnusalOrderDtoPagedResultDto {
    items!: PayUnusalOrderDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPayUnusalOrderDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PayUnusalOrderDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PayUnusalOrderDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PayUnusalOrderDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PayUnusalOrderDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PayUnusalOrderDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPayUnusalOrderDtoPagedResultDto {
    items: PayUnusalOrderDto[] | undefined;
    totalCount: number;
}

export class PayUnusalOrderPageInputDto implements IPayUnusalOrderPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    tid!: string | undefined;
    outTid!: string | undefined;
    merOrderTid!: string | undefined;
    merchantId!: number | undefined;
    channelId!: number | undefined;
    channelName!: string | undefined;
    channelTypeId!: number | undefined;
    channelTypeName!: string | undefined;
    channelTypeCode!: string | undefined;
    createStartTime!: Date | undefined;
    createEndTime!: Date | undefined;
    channelSupplierId!: number | undefined;
    startMoney!: number | undefined;
    endMoney!: number | undefined;

    constructor(data?: IPayUnusalOrderPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.tid = _data["tid"];
            this.outTid = _data["outTid"];
            this.merOrderTid = _data["merOrderTid"];
            this.merchantId = _data["merchantId"];
            this.channelId = _data["channelId"];
            this.channelName = _data["channelName"];
            this.channelTypeId = _data["channelTypeId"];
            this.channelTypeName = _data["channelTypeName"];
            this.channelTypeCode = _data["channelTypeCode"];
            this.createStartTime = _data["createStartTime"] ? new Date(_data["createStartTime"].toString()) : <any>undefined;
            this.createEndTime = _data["createEndTime"] ? new Date(_data["createEndTime"].toString()) : <any>undefined;
            this.channelSupplierId = _data["channelSupplierId"];
            this.startMoney = _data["startMoney"];
            this.endMoney = _data["endMoney"];
        }
    }

    static fromJS(data: any): PayUnusalOrderPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PayUnusalOrderPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["tid"] = this.tid;
        data["outTid"] = this.outTid;
        data["merOrderTid"] = this.merOrderTid;
        data["merchantId"] = this.merchantId;
        data["channelId"] = this.channelId;
        data["channelName"] = this.channelName;
        data["channelTypeId"] = this.channelTypeId;
        data["channelTypeName"] = this.channelTypeName;
        data["channelTypeCode"] = this.channelTypeCode;
        data["createStartTime"] = this.createStartTime ? this.createStartTime.toISOString() : <any>undefined;
        data["createEndTime"] = this.createEndTime ? this.createEndTime.toISOString() : <any>undefined;
        data["channelSupplierId"] = this.channelSupplierId;
        data["startMoney"] = this.startMoney;
        data["endMoney"] = this.endMoney;
        return data;
    }

    clone(): PayUnusalOrderPageInputDto {
        const json = this.toJSON();
        let result = new PayUnusalOrderPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IPayUnusalOrderPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    tid: string | undefined;
    outTid: string | undefined;
    merOrderTid: string | undefined;
    merchantId: number | undefined;
    channelId: number | undefined;
    channelName: string | undefined;
    channelTypeId: number | undefined;
    channelTypeName: string | undefined;
    channelTypeCode: string | undefined;
    createStartTime: Date | undefined;
    createEndTime: Date | undefined;
    channelSupplierId: number | undefined;
    startMoney: number | undefined;
    endMoney: number | undefined;
}

export class PermissionDto implements IPermissionDto {
    id!: number;
    name!: string | undefined;
    displayName!: string | undefined;
    readonly title!: string | undefined;
    readonly key!: string | undefined;
    readonly expand!: boolean;
    checked!: boolean;
    children!: PermissionDto[] | undefined;

    constructor(data?: IPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            (<any>this).title = _data["title"];
            (<any>this).key = _data["key"];
            (<any>this).expand = _data["expand"];
            this.checked = _data["checked"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(PermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["title"] = this.title;
        data["key"] = this.key;
        data["expand"] = this.expand;
        data["checked"] = this.checked;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }

    clone(): PermissionDto {
        const json = this.toJSON();
        let result = new PermissionDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    title: string | undefined;
    key: string | undefined;
    expand: boolean;
    checked: boolean;
    children: PermissionDto[] | undefined;
}

export class PermissionDtoListResultDto implements IPermissionDtoListResultDto {
    items!: PermissionDto[] | undefined;

    constructor(data?: IPermissionDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PermissionDtoListResultDto {
        const json = this.toJSON();
        let result = new PermissionDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;
}

export class QueryChannelSupplierStatisticsOutDto implements IQueryChannelSupplierStatisticsOutDto {
    channelSupplierName!: string | undefined;
    channelSupplierId!: number | undefined;
    totalOrderNum!: number;
    successOrderNum!: number;
    totalAmount!: number;
    successAmount!: number;
    liRun!: number;
    successRate!: number;
    channelRateCommission!: number;
    channelSupplierActualAmount!: number;
    buDanAmount!: number;
    buDanNum!: number;

    constructor(data?: IQueryChannelSupplierStatisticsOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelSupplierName = _data["channelSupplierName"];
            this.channelSupplierId = _data["channelSupplierId"];
            this.totalOrderNum = _data["totalOrderNum"];
            this.successOrderNum = _data["successOrderNum"];
            this.totalAmount = _data["totalAmount"];
            this.successAmount = _data["successAmount"];
            this.liRun = _data["liRun"];
            this.successRate = _data["successRate"];
            this.channelRateCommission = _data["channelRateCommission"];
            this.channelSupplierActualAmount = _data["channelSupplierActualAmount"];
            this.buDanAmount = _data["buDanAmount"];
            this.buDanNum = _data["buDanNum"];
        }
    }

    static fromJS(data: any): QueryChannelSupplierStatisticsOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryChannelSupplierStatisticsOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelSupplierName"] = this.channelSupplierName;
        data["channelSupplierId"] = this.channelSupplierId;
        data["totalOrderNum"] = this.totalOrderNum;
        data["successOrderNum"] = this.successOrderNum;
        data["totalAmount"] = this.totalAmount;
        data["successAmount"] = this.successAmount;
        data["liRun"] = this.liRun;
        data["successRate"] = this.successRate;
        data["channelRateCommission"] = this.channelRateCommission;
        data["channelSupplierActualAmount"] = this.channelSupplierActualAmount;
        data["buDanAmount"] = this.buDanAmount;
        data["buDanNum"] = this.buDanNum;
        return data;
    }

    clone(): QueryChannelSupplierStatisticsOutDto {
        const json = this.toJSON();
        let result = new QueryChannelSupplierStatisticsOutDto();
        result.init(json);
        return result;
    }
}

export interface IQueryChannelSupplierStatisticsOutDto {
    channelSupplierName: string | undefined;
    channelSupplierId: number | undefined;
    totalOrderNum: number;
    successOrderNum: number;
    totalAmount: number;
    successAmount: number;
    liRun: number;
    successRate: number;
    channelRateCommission: number;
    channelSupplierActualAmount: number;
    buDanAmount: number;
    buDanNum: number;
}

export class QueryChannelSupplierStatisticsPageInputDto implements IQueryChannelSupplierStatisticsPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    createTime!: Date | undefined;
    endTime!: Date | undefined;
    channelSupplierId!: number | undefined;

    constructor(data?: IQueryChannelSupplierStatisticsPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.createTime = _data["createTime"] ? new Date(_data["createTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.channelSupplierId = _data["channelSupplierId"];
        }
    }

    static fromJS(data: any): QueryChannelSupplierStatisticsPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryChannelSupplierStatisticsPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["channelSupplierId"] = this.channelSupplierId;
        return data;
    }

    clone(): QueryChannelSupplierStatisticsPageInputDto {
        const json = this.toJSON();
        let result = new QueryChannelSupplierStatisticsPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IQueryChannelSupplierStatisticsPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    createTime: Date | undefined;
    endTime: Date | undefined;
    channelSupplierId: number | undefined;
}

export class QueryChannelTotalPageInputDto implements IQueryChannelTotalPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    createTime!: Date | undefined;
    endTime!: Date | undefined;
    channelId!: number | undefined;
    channelSuplierId!: number | undefined;

    constructor(data?: IQueryChannelTotalPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.createTime = _data["createTime"] ? new Date(_data["createTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.channelId = _data["channelId"];
            this.channelSuplierId = _data["channelSuplierId"];
        }
    }

    static fromJS(data: any): QueryChannelTotalPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryChannelTotalPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["channelId"] = this.channelId;
        data["channelSuplierId"] = this.channelSuplierId;
        return data;
    }

    clone(): QueryChannelTotalPageInputDto {
        const json = this.toJSON();
        let result = new QueryChannelTotalPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IQueryChannelTotalPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    createTime: Date | undefined;
    endTime: Date | undefined;
    channelId: number | undefined;
    channelSuplierId: number | undefined;
}

export class QueryChannelTypeStatisticsPageInputDto implements IQueryChannelTypeStatisticsPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    createTime!: Date | undefined;
    endTime!: Date | undefined;
    channelTypeId!: number | undefined;

    constructor(data?: IQueryChannelTypeStatisticsPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.createTime = _data["createTime"] ? new Date(_data["createTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.channelTypeId = _data["channelTypeId"];
        }
    }

    static fromJS(data: any): QueryChannelTypeStatisticsPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryChannelTypeStatisticsPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["channelTypeId"] = this.channelTypeId;
        return data;
    }

    clone(): QueryChannelTypeStatisticsPageInputDto {
        const json = this.toJSON();
        let result = new QueryChannelTypeStatisticsPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IQueryChannelTypeStatisticsPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    createTime: Date | undefined;
    endTime: Date | undefined;
    channelTypeId: number | undefined;
}

export class QueryHomeTotalOutDto implements IQueryHomeTotalOutDto {
    totalOrderNum!: number;
    totalOrderAmount!: number;
    successOrderNum!: number;
    successOrderAmount!: number;
    successRate!: number;
    liRun!: number;
    dlLiRun!: number;
    yestodayTotalOrderNum!: number;
    yestodayTotalOrderAmount!: number;
    yestodaySuccessOrderNum!: number;
    yestodaySuccessOrderAmount!: number;
    yestodaySuccessRate!: number;
    yestodayLiRun!: number;
    yestodayDlLiRun!: number;

    constructor(data?: IQueryHomeTotalOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalOrderNum = _data["totalOrderNum"];
            this.totalOrderAmount = _data["totalOrderAmount"];
            this.successOrderNum = _data["successOrderNum"];
            this.successOrderAmount = _data["successOrderAmount"];
            this.successRate = _data["successRate"];
            this.liRun = _data["liRun"];
            this.dlLiRun = _data["dlLiRun"];
            this.yestodayTotalOrderNum = _data["yestodayTotalOrderNum"];
            this.yestodayTotalOrderAmount = _data["yestodayTotalOrderAmount"];
            this.yestodaySuccessOrderNum = _data["yestodaySuccessOrderNum"];
            this.yestodaySuccessOrderAmount = _data["yestodaySuccessOrderAmount"];
            this.yestodaySuccessRate = _data["yestodaySuccessRate"];
            this.yestodayLiRun = _data["yestodayLiRun"];
            this.yestodayDlLiRun = _data["yestodayDlLiRun"];
        }
    }

    static fromJS(data: any): QueryHomeTotalOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryHomeTotalOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalOrderNum"] = this.totalOrderNum;
        data["totalOrderAmount"] = this.totalOrderAmount;
        data["successOrderNum"] = this.successOrderNum;
        data["successOrderAmount"] = this.successOrderAmount;
        data["successRate"] = this.successRate;
        data["liRun"] = this.liRun;
        data["dlLiRun"] = this.dlLiRun;
        data["yestodayTotalOrderNum"] = this.yestodayTotalOrderNum;
        data["yestodayTotalOrderAmount"] = this.yestodayTotalOrderAmount;
        data["yestodaySuccessOrderNum"] = this.yestodaySuccessOrderNum;
        data["yestodaySuccessOrderAmount"] = this.yestodaySuccessOrderAmount;
        data["yestodaySuccessRate"] = this.yestodaySuccessRate;
        data["yestodayLiRun"] = this.yestodayLiRun;
        data["yestodayDlLiRun"] = this.yestodayDlLiRun;
        return data;
    }

    clone(): QueryHomeTotalOutDto {
        const json = this.toJSON();
        let result = new QueryHomeTotalOutDto();
        result.init(json);
        return result;
    }
}

export interface IQueryHomeTotalOutDto {
    totalOrderNum: number;
    totalOrderAmount: number;
    successOrderNum: number;
    successOrderAmount: number;
    successRate: number;
    liRun: number;
    dlLiRun: number;
    yestodayTotalOrderNum: number;
    yestodayTotalOrderAmount: number;
    yestodaySuccessOrderNum: number;
    yestodaySuccessOrderAmount: number;
    yestodaySuccessRate: number;
    yestodayLiRun: number;
    yestodayDlLiRun: number;
}

export class QueryMerchantChannelsInputDto implements IQueryMerchantChannelsInputDto {
    merchantId!: number | undefined;
    channelId!: number | undefined;

    constructor(data?: IQueryMerchantChannelsInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.merchantId = _data["merchantId"];
            this.channelId = _data["channelId"];
        }
    }

    static fromJS(data: any): QueryMerchantChannelsInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryMerchantChannelsInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["merchantId"] = this.merchantId;
        data["channelId"] = this.channelId;
        return data;
    }

    clone(): QueryMerchantChannelsInputDto {
        const json = this.toJSON();
        let result = new QueryMerchantChannelsInputDto();
        result.init(json);
        return result;
    }
}

export interface IQueryMerchantChannelsInputDto {
    merchantId: number | undefined;
    channelId: number | undefined;
}

export class QueryMerchantChannelStatisticsOutDto implements IQueryMerchantChannelStatisticsOutDto {
    channelName!: string | undefined;
    channelId!: number | undefined;
    merchantId!: number | undefined;
    merchantName!: string | undefined;
    mid!: string | undefined;
    totalOrderNum!: number;
    successOrderNum!: number;
    totalAmount!: number;
    successAmount!: number;
    liRun!: number;
    successRate!: number;
    commission!: number;
    channelRateCommission!: number;
    merchantActualAmount!: number;
    channelActualAmount!: number;
    buDanAmount!: number;
    buDanNum!: number;

    constructor(data?: IQueryMerchantChannelStatisticsOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelName = _data["channelName"];
            this.channelId = _data["channelId"];
            this.merchantId = _data["merchantId"];
            this.merchantName = _data["merchantName"];
            this.mid = _data["mid"];
            this.totalOrderNum = _data["totalOrderNum"];
            this.successOrderNum = _data["successOrderNum"];
            this.totalAmount = _data["totalAmount"];
            this.successAmount = _data["successAmount"];
            this.liRun = _data["liRun"];
            this.successRate = _data["successRate"];
            this.commission = _data["commission"];
            this.channelRateCommission = _data["channelRateCommission"];
            this.merchantActualAmount = _data["merchantActualAmount"];
            this.channelActualAmount = _data["channelActualAmount"];
            this.buDanAmount = _data["buDanAmount"];
            this.buDanNum = _data["buDanNum"];
        }
    }

    static fromJS(data: any): QueryMerchantChannelStatisticsOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryMerchantChannelStatisticsOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelName"] = this.channelName;
        data["channelId"] = this.channelId;
        data["merchantId"] = this.merchantId;
        data["merchantName"] = this.merchantName;
        data["mid"] = this.mid;
        data["totalOrderNum"] = this.totalOrderNum;
        data["successOrderNum"] = this.successOrderNum;
        data["totalAmount"] = this.totalAmount;
        data["successAmount"] = this.successAmount;
        data["liRun"] = this.liRun;
        data["successRate"] = this.successRate;
        data["commission"] = this.commission;
        data["channelRateCommission"] = this.channelRateCommission;
        data["merchantActualAmount"] = this.merchantActualAmount;
        data["channelActualAmount"] = this.channelActualAmount;
        data["buDanAmount"] = this.buDanAmount;
        data["buDanNum"] = this.buDanNum;
        return data;
    }

    clone(): QueryMerchantChannelStatisticsOutDto {
        const json = this.toJSON();
        let result = new QueryMerchantChannelStatisticsOutDto();
        result.init(json);
        return result;
    }
}

export interface IQueryMerchantChannelStatisticsOutDto {
    channelName: string | undefined;
    channelId: number | undefined;
    merchantId: number | undefined;
    merchantName: string | undefined;
    mid: string | undefined;
    totalOrderNum: number;
    successOrderNum: number;
    totalAmount: number;
    successAmount: number;
    liRun: number;
    successRate: number;
    commission: number;
    channelRateCommission: number;
    merchantActualAmount: number;
    channelActualAmount: number;
    buDanAmount: number;
    buDanNum: number;
}

export class QueryMerchantChannelStatisticsPageInputDto implements IQueryMerchantChannelStatisticsPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    createTime!: Date | undefined;
    endTime!: Date | undefined;
    channelId!: number | undefined;
    merchantId!: number | undefined;

    constructor(data?: IQueryMerchantChannelStatisticsPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.createTime = _data["createTime"] ? new Date(_data["createTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.channelId = _data["channelId"];
            this.merchantId = _data["merchantId"];
        }
    }

    static fromJS(data: any): QueryMerchantChannelStatisticsPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryMerchantChannelStatisticsPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["channelId"] = this.channelId;
        data["merchantId"] = this.merchantId;
        return data;
    }

    clone(): QueryMerchantChannelStatisticsPageInputDto {
        const json = this.toJSON();
        let result = new QueryMerchantChannelStatisticsPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IQueryMerchantChannelStatisticsPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    createTime: Date | undefined;
    endTime: Date | undefined;
    channelId: number | undefined;
    merchantId: number | undefined;
}

export class QueryMerchantChannelTypesByTypeIdsInputDto implements IQueryMerchantChannelTypesByTypeIdsInputDto {
    typeIds!: number[] | undefined;
    channelId!: number;

    constructor(data?: IQueryMerchantChannelTypesByTypeIdsInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["typeIds"])) {
                this.typeIds = [] as any;
                for (let item of _data["typeIds"])
                    this.typeIds!.push(item);
            }
            this.channelId = _data["channelId"];
        }
    }

    static fromJS(data: any): QueryMerchantChannelTypesByTypeIdsInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryMerchantChannelTypesByTypeIdsInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.typeIds)) {
            data["typeIds"] = [];
            for (let item of this.typeIds)
                data["typeIds"].push(item);
        }
        data["channelId"] = this.channelId;
        return data;
    }

    clone(): QueryMerchantChannelTypesByTypeIdsInputDto {
        const json = this.toJSON();
        let result = new QueryMerchantChannelTypesByTypeIdsInputDto();
        result.init(json);
        return result;
    }
}

export interface IQueryMerchantChannelTypesByTypeIdsInputDto {
    typeIds: number[] | undefined;
    channelId: number;
}

export class QueryMerchantChannelTypeStatisticsOutDto implements IQueryMerchantChannelTypeStatisticsOutDto {
    channelTypeCode!: string | undefined;
    channelTypeName!: string | undefined;
    channelTypeId!: number | undefined;
    merchantId!: number | undefined;
    merchantName!: string | undefined;
    mid!: string | undefined;
    totalOrderNum!: number;
    successOrderNum!: number;
    totalAmount!: number;
    successAmount!: number;
    liRun!: number;
    successRate!: number;
    commission!: number;
    channelRateCommission!: number;
    channelActualAmount!: number;
    merchantActualAmount!: number;
    buDanAmount!: number;
    buDanNum!: number;
    diaoDanNum!: string | undefined;

    constructor(data?: IQueryMerchantChannelTypeStatisticsOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelTypeCode = _data["channelTypeCode"];
            this.channelTypeName = _data["channelTypeName"];
            this.channelTypeId = _data["channelTypeId"];
            this.merchantId = _data["merchantId"];
            this.merchantName = _data["merchantName"];
            this.mid = _data["mid"];
            this.totalOrderNum = _data["totalOrderNum"];
            this.successOrderNum = _data["successOrderNum"];
            this.totalAmount = _data["totalAmount"];
            this.successAmount = _data["successAmount"];
            this.liRun = _data["liRun"];
            this.successRate = _data["successRate"];
            this.commission = _data["commission"];
            this.channelRateCommission = _data["channelRateCommission"];
            this.channelActualAmount = _data["channelActualAmount"];
            this.merchantActualAmount = _data["merchantActualAmount"];
            this.buDanAmount = _data["buDanAmount"];
            this.buDanNum = _data["buDanNum"];
            this.diaoDanNum = _data["diaoDanNum"];
        }
    }

    static fromJS(data: any): QueryMerchantChannelTypeStatisticsOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryMerchantChannelTypeStatisticsOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelTypeCode"] = this.channelTypeCode;
        data["channelTypeName"] = this.channelTypeName;
        data["channelTypeId"] = this.channelTypeId;
        data["merchantId"] = this.merchantId;
        data["merchantName"] = this.merchantName;
        data["mid"] = this.mid;
        data["totalOrderNum"] = this.totalOrderNum;
        data["successOrderNum"] = this.successOrderNum;
        data["totalAmount"] = this.totalAmount;
        data["successAmount"] = this.successAmount;
        data["liRun"] = this.liRun;
        data["successRate"] = this.successRate;
        data["commission"] = this.commission;
        data["channelRateCommission"] = this.channelRateCommission;
        data["channelActualAmount"] = this.channelActualAmount;
        data["merchantActualAmount"] = this.merchantActualAmount;
        data["buDanAmount"] = this.buDanAmount;
        data["buDanNum"] = this.buDanNum;
        data["diaoDanNum"] = this.diaoDanNum;
        return data;
    }

    clone(): QueryMerchantChannelTypeStatisticsOutDto {
        const json = this.toJSON();
        let result = new QueryMerchantChannelTypeStatisticsOutDto();
        result.init(json);
        return result;
    }
}

export interface IQueryMerchantChannelTypeStatisticsOutDto {
    channelTypeCode: string | undefined;
    channelTypeName: string | undefined;
    channelTypeId: number | undefined;
    merchantId: number | undefined;
    merchantName: string | undefined;
    mid: string | undefined;
    totalOrderNum: number;
    successOrderNum: number;
    totalAmount: number;
    successAmount: number;
    liRun: number;
    successRate: number;
    commission: number;
    channelRateCommission: number;
    channelActualAmount: number;
    merchantActualAmount: number;
    buDanAmount: number;
    buDanNum: number;
    diaoDanNum: string | undefined;
}

export class QueryMerchantChannelTypeStatisticsPageInputDto implements IQueryMerchantChannelTypeStatisticsPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    createTime!: Date | undefined;
    endTime!: Date | undefined;
    merchantId!: number | undefined;
    channelTypeId!: number | undefined;

    constructor(data?: IQueryMerchantChannelTypeStatisticsPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.createTime = _data["createTime"] ? new Date(_data["createTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.merchantId = _data["merchantId"];
            this.channelTypeId = _data["channelTypeId"];
        }
    }

    static fromJS(data: any): QueryMerchantChannelTypeStatisticsPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryMerchantChannelTypeStatisticsPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["merchantId"] = this.merchantId;
        data["channelTypeId"] = this.channelTypeId;
        return data;
    }

    clone(): QueryMerchantChannelTypeStatisticsPageInputDto {
        const json = this.toJSON();
        let result = new QueryMerchantChannelTypeStatisticsPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IQueryMerchantChannelTypeStatisticsPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    createTime: Date | undefined;
    endTime: Date | undefined;
    merchantId: number | undefined;
    channelTypeId: number | undefined;
}

export class QueryMerchantOrderTotalOutDto implements IQueryMerchantOrderTotalOutDto {
    orderNum!: number;
    orderSumMoney!: number;
    successOrderNum!: number;
    successOrderMoney!: number;
    successOrderRateMoney!: number;

    constructor(data?: IQueryMerchantOrderTotalOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderNum = _data["orderNum"];
            this.orderSumMoney = _data["orderSumMoney"];
            this.successOrderNum = _data["successOrderNum"];
            this.successOrderMoney = _data["successOrderMoney"];
            this.successOrderRateMoney = _data["successOrderRateMoney"];
        }
    }

    static fromJS(data: any): QueryMerchantOrderTotalOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryMerchantOrderTotalOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderNum"] = this.orderNum;
        data["orderSumMoney"] = this.orderSumMoney;
        data["successOrderNum"] = this.successOrderNum;
        data["successOrderMoney"] = this.successOrderMoney;
        data["successOrderRateMoney"] = this.successOrderRateMoney;
        return data;
    }

    clone(): QueryMerchantOrderTotalOutDto {
        const json = this.toJSON();
        let result = new QueryMerchantOrderTotalOutDto();
        result.init(json);
        return result;
    }
}

export interface IQueryMerchantOrderTotalOutDto {
    orderNum: number;
    orderSumMoney: number;
    successOrderNum: number;
    successOrderMoney: number;
    successOrderRateMoney: number;
}

export class QueryPlatStatisticsOutDto implements IQueryPlatStatisticsOutDto {
    totalOrderNum!: number;
    successOrderNum!: number;
    totalAmount!: number;
    successAmount!: number;
    liRun!: number;
    successRate!: number;
    channelRateCommission!: number;
    commission!: number;
    channelActualAmount!: number;
    merchantActualAmount!: number;
    buDanAmount!: number;
    buDanNum!: number;

    constructor(data?: IQueryPlatStatisticsOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalOrderNum = _data["totalOrderNum"];
            this.successOrderNum = _data["successOrderNum"];
            this.totalAmount = _data["totalAmount"];
            this.successAmount = _data["successAmount"];
            this.liRun = _data["liRun"];
            this.successRate = _data["successRate"];
            this.channelRateCommission = _data["channelRateCommission"];
            this.commission = _data["commission"];
            this.channelActualAmount = _data["channelActualAmount"];
            this.merchantActualAmount = _data["merchantActualAmount"];
            this.buDanAmount = _data["buDanAmount"];
            this.buDanNum = _data["buDanNum"];
        }
    }

    static fromJS(data: any): QueryPlatStatisticsOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryPlatStatisticsOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalOrderNum"] = this.totalOrderNum;
        data["successOrderNum"] = this.successOrderNum;
        data["totalAmount"] = this.totalAmount;
        data["successAmount"] = this.successAmount;
        data["liRun"] = this.liRun;
        data["successRate"] = this.successRate;
        data["channelRateCommission"] = this.channelRateCommission;
        data["commission"] = this.commission;
        data["channelActualAmount"] = this.channelActualAmount;
        data["merchantActualAmount"] = this.merchantActualAmount;
        data["buDanAmount"] = this.buDanAmount;
        data["buDanNum"] = this.buDanNum;
        return data;
    }

    clone(): QueryPlatStatisticsOutDto {
        const json = this.toJSON();
        let result = new QueryPlatStatisticsOutDto();
        result.init(json);
        return result;
    }
}

export interface IQueryPlatStatisticsOutDto {
    totalOrderNum: number;
    successOrderNum: number;
    totalAmount: number;
    successAmount: number;
    liRun: number;
    successRate: number;
    channelRateCommission: number;
    commission: number;
    channelActualAmount: number;
    merchantActualAmount: number;
    buDanAmount: number;
    buDanNum: number;
}

export class QueryPlatStatisticsPageInputDto implements IQueryPlatStatisticsPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    createTime!: Date | undefined;
    endTime!: Date | undefined;

    constructor(data?: IQueryPlatStatisticsPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.createTime = _data["createTime"] ? new Date(_data["createTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): QueryPlatStatisticsPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryPlatStatisticsPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): QueryPlatStatisticsPageInputDto {
        const json = this.toJSON();
        let result = new QueryPlatStatisticsPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IQueryPlatStatisticsPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    createTime: Date | undefined;
    endTime: Date | undefined;
}

export class QuerySuccessTotalOutDto implements IQuerySuccessTotalOutDto {
    successRate_30!: number;
    successRate_60!: number;
    successRate_180!: number;
    successRate_360!: number;
    successRate_today!: number;
    successRate_yestoday!: number;

    constructor(data?: IQuerySuccessTotalOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.successRate_30 = _data["successRate_30"];
            this.successRate_60 = _data["successRate_60"];
            this.successRate_180 = _data["successRate_180"];
            this.successRate_360 = _data["successRate_360"];
            this.successRate_today = _data["successRate_today"];
            this.successRate_yestoday = _data["successRate_yestoday"];
        }
    }

    static fromJS(data: any): QuerySuccessTotalOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuerySuccessTotalOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["successRate_30"] = this.successRate_30;
        data["successRate_60"] = this.successRate_60;
        data["successRate_180"] = this.successRate_180;
        data["successRate_360"] = this.successRate_360;
        data["successRate_today"] = this.successRate_today;
        data["successRate_yestoday"] = this.successRate_yestoday;
        return data;
    }

    clone(): QuerySuccessTotalOutDto {
        const json = this.toJSON();
        let result = new QuerySuccessTotalOutDto();
        result.init(json);
        return result;
    }
}

export interface IQuerySuccessTotalOutDto {
    successRate_30: number;
    successRate_60: number;
    successRate_180: number;
    successRate_360: number;
    successRate_today: number;
    successRate_yestoday: number;
}

export class RealBalanceLogDto implements IRealBalanceLogDto {
    id!: number;
    merchantId!: number | undefined;
    mid!: string | undefined;
    merchantName!: string | undefined;
    money!: number;
    balance!: number;
    afterBalance!: number;
    tid!: string | undefined;
    merchantTid!: string | undefined;
    creationTime!: Date;
    comment!: string | undefined;

    constructor(data?: IRealBalanceLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.merchantId = _data["merchantId"];
            this.mid = _data["mid"];
            this.merchantName = _data["merchantName"];
            this.money = _data["money"];
            this.balance = _data["balance"];
            this.afterBalance = _data["afterBalance"];
            this.tid = _data["tid"];
            this.merchantTid = _data["merchantTid"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): RealBalanceLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new RealBalanceLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["merchantId"] = this.merchantId;
        data["mid"] = this.mid;
        data["merchantName"] = this.merchantName;
        data["money"] = this.money;
        data["balance"] = this.balance;
        data["afterBalance"] = this.afterBalance;
        data["tid"] = this.tid;
        data["merchantTid"] = this.merchantTid;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        return data;
    }

    clone(): RealBalanceLogDto {
        const json = this.toJSON();
        let result = new RealBalanceLogDto();
        result.init(json);
        return result;
    }
}

export interface IRealBalanceLogDto {
    id: number;
    merchantId: number | undefined;
    mid: string | undefined;
    merchantName: string | undefined;
    money: number;
    balance: number;
    afterBalance: number;
    tid: string | undefined;
    merchantTid: string | undefined;
    creationTime: Date;
    comment: string | undefined;
}

export class RealBalanceLogDtoPagedResultDto implements IRealBalanceLogDtoPagedResultDto {
    items!: RealBalanceLogDto[] | undefined;
    totalCount!: number;

    constructor(data?: IRealBalanceLogDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RealBalanceLogDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): RealBalanceLogDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RealBalanceLogDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): RealBalanceLogDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RealBalanceLogDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRealBalanceLogDtoPagedResultDto {
    items: RealBalanceLogDto[] | undefined;
    totalCount: number;
}

export class RealBalanceLogPageInputDto implements IRealBalanceLogPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    merchantId!: number | undefined;
    createStartTime!: Date | undefined;
    createEndTime!: Date | undefined;
    merchantTid!: string | undefined;

    constructor(data?: IRealBalanceLogPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.merchantId = _data["merchantId"];
            this.createStartTime = _data["createStartTime"] ? new Date(_data["createStartTime"].toString()) : <any>undefined;
            this.createEndTime = _data["createEndTime"] ? new Date(_data["createEndTime"].toString()) : <any>undefined;
            this.merchantTid = _data["merchantTid"];
        }
    }

    static fromJS(data: any): RealBalanceLogPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new RealBalanceLogPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["merchantId"] = this.merchantId;
        data["createStartTime"] = this.createStartTime ? this.createStartTime.toISOString() : <any>undefined;
        data["createEndTime"] = this.createEndTime ? this.createEndTime.toISOString() : <any>undefined;
        data["merchantTid"] = this.merchantTid;
        return data;
    }

    clone(): RealBalanceLogPageInputDto {
        const json = this.toJSON();
        let result = new RealBalanceLogPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IRealBalanceLogPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    merchantId: number | undefined;
    createStartTime: Date | undefined;
    createEndTime: Date | undefined;
    merchantTid: string | undefined;
}

export class ResetPasswordDto implements IResetPasswordDto {
    adminPassword!: string;
    userId!: number;
    newPassword!: string;

    constructor(data?: IResetPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adminPassword = _data["adminPassword"];
            this.userId = _data["userId"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminPassword"] = this.adminPassword;
        data["userId"] = this.userId;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ResetPasswordDto {
        const json = this.toJSON();
        let result = new ResetPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;
}

export class RoleDto implements IRoleDto {
    id!: number;
    name!: string;
    displayName!: string;
    normalizedName!: string | undefined;
    description!: string | undefined;
    grantedPermissions!: string[] | undefined;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions!.push(item);
            }
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data;
    }

    clone(): RoleDto {
        const json = this.toJSON();
        let result = new RoleDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDto {
    id: number;
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class RoleDtoListResultDto implements IRoleDtoListResultDto {
    items!: RoleDto[] | undefined;

    constructor(data?: IRoleDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoListResultDto {
    items: RoleDto[] | undefined;
}

export class RoleDtoPagedResultDto implements IRoleDtoPagedResultDto {
    items!: RoleDto[] | undefined;
    totalCount!: number;

    constructor(data?: IRoleDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoleDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): RoleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): RoleDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RoleDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoPagedResultDto {
    items: RoleDto[] | undefined;
    totalCount: number;
}

export class RoleEditDto implements IRoleEditDto {
    id!: number;
    name!: string;
    displayName!: string;
    description!: string | undefined;
    isStatic!: boolean;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isStatic = _data["isStatic"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isStatic"] = this.isStatic;
        return data;
    }

    clone(): RoleEditDto {
        const json = this.toJSON();
        let result = new RoleEditDto();
        result.init(json);
        return result;
    }
}

export interface IRoleEditDto {
    id: number;
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;
}

export class RoleListDto implements IRoleListDto {
    id!: number;
    name!: string | undefined;
    displayName!: string | undefined;
    isStatic!: boolean;
    isDefault!: boolean;
    creationTime!: Date;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isStatic = _data["isStatic"];
            this.isDefault = _data["isDefault"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): RoleListDto {
        const json = this.toJSON();
        let result = new RoleListDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: Date;
}

export class RoleListDtoListResultDto implements IRoleListDtoListResultDto {
    items!: RoleListDto[] | undefined;

    constructor(data?: IRoleListDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleListDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleListDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleListDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;
}

export class RuJinAndChuJinUsdtDto implements IRuJinAndChuJinUsdtDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    merchantId!: number | undefined;

    constructor(data?: IRuJinAndChuJinUsdtDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.merchantId = _data["merchantId"];
        }
    }

    static fromJS(data: any): RuJinAndChuJinUsdtDto {
        data = typeof data === 'object' ? data : {};
        let result = new RuJinAndChuJinUsdtDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["merchantId"] = this.merchantId;
        return data;
    }

    clone(): RuJinAndChuJinUsdtDto {
        const json = this.toJSON();
        let result = new RuJinAndChuJinUsdtDto();
        result.init(json);
        return result;
    }
}

export interface IRuJinAndChuJinUsdtDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    merchantId: number | undefined;
}

export class SelectItemDto implements ISelectItemDto {
    id!: number;
    readonly value!: string | undefined;
    label!: string | undefined;
    isSelected!: boolean;

    constructor(data?: ISelectItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            (<any>this).value = _data["value"];
            this.label = _data["label"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): SelectItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["label"] = this.label;
        data["isSelected"] = this.isSelected;
        return data;
    }

    clone(): SelectItemDto {
        const json = this.toJSON();
        let result = new SelectItemDto();
        result.init(json);
        return result;
    }
}

export interface ISelectItemDto {
    id: number;
    value: string | undefined;
    label: string | undefined;
    isSelected: boolean;
}

export class SettlementPreDataOutDto implements ISettlementPreDataOutDto {
    merId!: number | undefined;
    name!: string | undefined;
    money!: number;
    payMoney!: number;
    commission!: number;
    jiZhang!: number;
    jiZhangNum!: number;
    xiafa!: number;
    xiafaNum!: number;
    settlementAdvanceMoney!: number;
    settlementBalance!: number;
    settlementYingDe!: number;
    afterSettlementAdvanceMoney!: number;
    afterSettlementBalance!: number;
    afterSettlementYingDe!: number;

    constructor(data?: ISettlementPreDataOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.merId = _data["merId"];
            this.name = _data["name"];
            this.money = _data["money"];
            this.payMoney = _data["payMoney"];
            this.commission = _data["commission"];
            this.jiZhang = _data["jiZhang"];
            this.jiZhangNum = _data["jiZhangNum"];
            this.xiafa = _data["xiafa"];
            this.xiafaNum = _data["xiafaNum"];
            this.settlementAdvanceMoney = _data["settlementAdvanceMoney"];
            this.settlementBalance = _data["settlementBalance"];
            this.settlementYingDe = _data["settlementYingDe"];
            this.afterSettlementAdvanceMoney = _data["afterSettlementAdvanceMoney"];
            this.afterSettlementBalance = _data["afterSettlementBalance"];
            this.afterSettlementYingDe = _data["afterSettlementYingDe"];
        }
    }

    static fromJS(data: any): SettlementPreDataOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new SettlementPreDataOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["merId"] = this.merId;
        data["name"] = this.name;
        data["money"] = this.money;
        data["payMoney"] = this.payMoney;
        data["commission"] = this.commission;
        data["jiZhang"] = this.jiZhang;
        data["jiZhangNum"] = this.jiZhangNum;
        data["xiafa"] = this.xiafa;
        data["xiafaNum"] = this.xiafaNum;
        data["settlementAdvanceMoney"] = this.settlementAdvanceMoney;
        data["settlementBalance"] = this.settlementBalance;
        data["settlementYingDe"] = this.settlementYingDe;
        data["afterSettlementAdvanceMoney"] = this.afterSettlementAdvanceMoney;
        data["afterSettlementBalance"] = this.afterSettlementBalance;
        data["afterSettlementYingDe"] = this.afterSettlementYingDe;
        return data;
    }

    clone(): SettlementPreDataOutDto {
        const json = this.toJSON();
        let result = new SettlementPreDataOutDto();
        result.init(json);
        return result;
    }
}

export interface ISettlementPreDataOutDto {
    merId: number | undefined;
    name: string | undefined;
    money: number;
    payMoney: number;
    commission: number;
    jiZhang: number;
    jiZhangNum: number;
    xiafa: number;
    xiafaNum: number;
    settlementAdvanceMoney: number;
    settlementBalance: number;
    settlementYingDe: number;
    afterSettlementAdvanceMoney: number;
    afterSettlementBalance: number;
    afterSettlementYingDe: number;
}

export class SettlementPreMerInputDto implements ISettlementPreMerInputDto {
    merIds!: number[] | undefined;
    time!: Date;

    constructor(data?: ISettlementPreMerInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["merIds"])) {
                this.merIds = [] as any;
                for (let item of _data["merIds"])
                    this.merIds!.push(item);
            }
            this.time = _data["time"] ? new Date(_data["time"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SettlementPreMerInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SettlementPreMerInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.merIds)) {
            data["merIds"] = [];
            for (let item of this.merIds)
                data["merIds"].push(item);
        }
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        return data;
    }

    clone(): SettlementPreMerInputDto {
        const json = this.toJSON();
        let result = new SettlementPreMerInputDto();
        result.init(json);
        return result;
    }
}

export interface ISettlementPreMerInputDto {
    merIds: number[] | undefined;
    time: Date;
}

export class SettlementPreOutDto implements ISettlementPreOutDto {
    datas!: SettlementPreDataOutDto[] | undefined;

    constructor(data?: ISettlementPreOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["datas"])) {
                this.datas = [] as any;
                for (let item of _data["datas"])
                    this.datas!.push(SettlementPreDataOutDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SettlementPreOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new SettlementPreOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datas)) {
            data["datas"] = [];
            for (let item of this.datas)
                data["datas"].push(item.toJSON());
        }
        return data;
    }

    clone(): SettlementPreOutDto {
        const json = this.toJSON();
        let result = new SettlementPreOutDto();
        result.init(json);
        return result;
    }
}

export interface ISettlementPreOutDto {
    datas: SettlementPreDataOutDto[] | undefined;
}

export class ShowAppkeyInputDto implements IShowAppkeyInputDto {
    merchantId!: number | undefined;
    googleCode!: string | undefined;
    memberId!: number | undefined;

    constructor(data?: IShowAppkeyInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.merchantId = _data["merchantId"];
            this.googleCode = _data["googleCode"];
            this.memberId = _data["memberId"];
        }
    }

    static fromJS(data: any): ShowAppkeyInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShowAppkeyInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["merchantId"] = this.merchantId;
        data["googleCode"] = this.googleCode;
        data["memberId"] = this.memberId;
        return data;
    }

    clone(): ShowAppkeyInputDto {
        const json = this.toJSON();
        let result = new ShowAppkeyInputDto();
        result.init(json);
        return result;
    }
}

export interface IShowAppkeyInputDto {
    merchantId: number | undefined;
    googleCode: string | undefined;
    memberId: number | undefined;
}

export enum StatusEnum {
    _0 = 0,
    _1 = 1,
}

export class StorageProductChannelDto implements IStorageProductChannelDto {
    id!: number;
    storageQueryProductChannelId!: number | undefined;
    channelTypeId!: number | undefined;
    channelId!: number | undefined;
    weight!: number;

    constructor(data?: IStorageProductChannelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.storageQueryProductChannelId = _data["storageQueryProductChannelId"];
            this.channelTypeId = _data["channelTypeId"];
            this.channelId = _data["channelId"];
            this.weight = _data["weight"];
        }
    }

    static fromJS(data: any): StorageProductChannelDto {
        data = typeof data === 'object' ? data : {};
        let result = new StorageProductChannelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storageQueryProductChannelId"] = this.storageQueryProductChannelId;
        data["channelTypeId"] = this.channelTypeId;
        data["channelId"] = this.channelId;
        data["weight"] = this.weight;
        return data;
    }

    clone(): StorageProductChannelDto {
        const json = this.toJSON();
        let result = new StorageProductChannelDto();
        result.init(json);
        return result;
    }
}

export interface IStorageProductChannelDto {
    id: number;
    storageQueryProductChannelId: number | undefined;
    channelTypeId: number | undefined;
    channelId: number | undefined;
    weight: number;
}

export class StorageProductDto implements IStorageProductDto {
    id!: number;
    storageQueryProductChannelId!: number | undefined;
    channelTypeId!: number | undefined;
    rate!: number;

    constructor(data?: IStorageProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.storageQueryProductChannelId = _data["storageQueryProductChannelId"];
            this.channelTypeId = _data["channelTypeId"];
            this.rate = _data["rate"];
        }
    }

    static fromJS(data: any): StorageProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new StorageProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storageQueryProductChannelId"] = this.storageQueryProductChannelId;
        data["channelTypeId"] = this.channelTypeId;
        data["rate"] = this.rate;
        return data;
    }

    clone(): StorageProductDto {
        const json = this.toJSON();
        let result = new StorageProductDto();
        result.init(json);
        return result;
    }
}

export interface IStorageProductDto {
    id: number;
    storageQueryProductChannelId: number | undefined;
    channelTypeId: number | undefined;
    rate: number;
}

export class StorageQueryProductChannelDto implements IStorageQueryProductChannelDto {
    id!: number;
    name!: string | undefined;
    storageProductChannels!: StorageProductChannelDto[] | undefined;
    storageProducts!: StorageProductDto[] | undefined;
    creationTime!: Date;

    constructor(data?: IStorageQueryProductChannelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["storageProductChannels"])) {
                this.storageProductChannels = [] as any;
                for (let item of _data["storageProductChannels"])
                    this.storageProductChannels!.push(StorageProductChannelDto.fromJS(item));
            }
            if (Array.isArray(_data["storageProducts"])) {
                this.storageProducts = [] as any;
                for (let item of _data["storageProducts"])
                    this.storageProducts!.push(StorageProductDto.fromJS(item));
            }
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): StorageQueryProductChannelDto {
        data = typeof data === 'object' ? data : {};
        let result = new StorageQueryProductChannelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.storageProductChannels)) {
            data["storageProductChannels"] = [];
            for (let item of this.storageProductChannels)
                data["storageProductChannels"].push(item.toJSON());
        }
        if (Array.isArray(this.storageProducts)) {
            data["storageProducts"] = [];
            for (let item of this.storageProducts)
                data["storageProducts"].push(item.toJSON());
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): StorageQueryProductChannelDto {
        const json = this.toJSON();
        let result = new StorageQueryProductChannelDto();
        result.init(json);
        return result;
    }
}

export interface IStorageQueryProductChannelDto {
    id: number;
    name: string | undefined;
    storageProductChannels: StorageProductChannelDto[] | undefined;
    storageProducts: StorageProductDto[] | undefined;
    creationTime: Date;
}

export class StorageQueryProductChannelDtoPagedResultDto implements IStorageQueryProductChannelDtoPagedResultDto {
    items!: StorageQueryProductChannelDto[] | undefined;
    totalCount!: number;

    constructor(data?: IStorageQueryProductChannelDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StorageQueryProductChannelDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): StorageQueryProductChannelDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StorageQueryProductChannelDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): StorageQueryProductChannelDtoPagedResultDto {
        const json = this.toJSON();
        let result = new StorageQueryProductChannelDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IStorageQueryProductChannelDtoPagedResultDto {
    items: StorageQueryProductChannelDto[] | undefined;
    totalCount: number;
}

export class StorageQueryProductChannelPageInputDto implements IStorageQueryProductChannelPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    name!: string | undefined;

    constructor(data?: IStorageQueryProductChannelPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): StorageQueryProductChannelPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new StorageQueryProductChannelPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["name"] = this.name;
        return data;
    }

    clone(): StorageQueryProductChannelPageInputDto {
        const json = this.toJSON();
        let result = new StorageQueryProductChannelPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IStorageQueryProductChannelPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    name: string | undefined;
}

export class SystemBalanceLogDto implements ISystemBalanceLogDto {
    id!: number;
    money!: number;
    balance!: number;
    afterBalance!: number;
    settlementTime!: number;
    systemBalanceLogType!: SystemBalanceLogTypeEnum;
    readonly systemBalanceLogTypeName!: string | undefined;
    comment!: string | undefined;
    creationTime!: Date;

    constructor(data?: ISystemBalanceLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.money = _data["money"];
            this.balance = _data["balance"];
            this.afterBalance = _data["afterBalance"];
            this.settlementTime = _data["settlementTime"];
            this.systemBalanceLogType = _data["systemBalanceLogType"];
            (<any>this).systemBalanceLogTypeName = _data["systemBalanceLogTypeName"];
            this.comment = _data["comment"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SystemBalanceLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemBalanceLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["money"] = this.money;
        data["balance"] = this.balance;
        data["afterBalance"] = this.afterBalance;
        data["settlementTime"] = this.settlementTime;
        data["systemBalanceLogType"] = this.systemBalanceLogType;
        data["systemBalanceLogTypeName"] = this.systemBalanceLogTypeName;
        data["comment"] = this.comment;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): SystemBalanceLogDto {
        const json = this.toJSON();
        let result = new SystemBalanceLogDto();
        result.init(json);
        return result;
    }
}

export interface ISystemBalanceLogDto {
    id: number;
    money: number;
    balance: number;
    afterBalance: number;
    settlementTime: number;
    systemBalanceLogType: SystemBalanceLogTypeEnum;
    systemBalanceLogTypeName: string | undefined;
    comment: string | undefined;
    creationTime: Date;
}

export class SystemBalanceLogDtoPagedResultDto implements ISystemBalanceLogDtoPagedResultDto {
    items!: SystemBalanceLogDto[] | undefined;
    totalCount!: number;

    constructor(data?: ISystemBalanceLogDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SystemBalanceLogDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SystemBalanceLogDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemBalanceLogDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SystemBalanceLogDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SystemBalanceLogDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISystemBalanceLogDtoPagedResultDto {
    items: SystemBalanceLogDto[] | undefined;
    totalCount: number;
}

export class SystemBalanceLogPageInputDto implements ISystemBalanceLogPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;

    constructor(data?: ISystemBalanceLogPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
        }
    }

    static fromJS(data: any): SystemBalanceLogPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemBalanceLogPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        return data;
    }

    clone(): SystemBalanceLogPageInputDto {
        const json = this.toJSON();
        let result = new SystemBalanceLogPageInputDto();
        result.init(json);
        return result;
    }
}

export interface ISystemBalanceLogPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
}

export enum SystemBalanceLogTypeEnum {
    _0 = 0,
    _1 = 1,
}

export class SystemSettingDto implements ISystemSettingDto {
    id!: number;
    isEnableGoogleCheckLogin!: boolean;
    title!: string | undefined;
    payOrderFix!: string | undefined;
    isCloseOrder!: boolean;
    apiIps!: string | undefined;
    orderApiIps!: string | undefined;
    autoCloseTime!: number;
    channelYufuYuZhi!: number;
    disableOrderNotify!: boolean;
    isEnableAuto!: boolean;
    inStartTime!: string | undefined;
    inEndTime!: string | undefined;
    isQuFenYiChang!: boolean;
    isChannelFuLiRunOpen!: boolean;

    constructor(data?: ISystemSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isEnableGoogleCheckLogin = _data["isEnableGoogleCheckLogin"];
            this.title = _data["title"];
            this.payOrderFix = _data["payOrderFix"];
            this.isCloseOrder = _data["isCloseOrder"];
            this.apiIps = _data["apiIps"];
            this.orderApiIps = _data["orderApiIps"];
            this.autoCloseTime = _data["autoCloseTime"];
            this.channelYufuYuZhi = _data["channelYufuYuZhi"];
            this.disableOrderNotify = _data["disableOrderNotify"];
            this.isEnableAuto = _data["isEnableAuto"];
            this.inStartTime = _data["inStartTime"];
            this.inEndTime = _data["inEndTime"];
            this.isQuFenYiChang = _data["isQuFenYiChang"];
            this.isChannelFuLiRunOpen = _data["isChannelFuLiRunOpen"];
        }
    }

    static fromJS(data: any): SystemSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isEnableGoogleCheckLogin"] = this.isEnableGoogleCheckLogin;
        data["title"] = this.title;
        data["payOrderFix"] = this.payOrderFix;
        data["isCloseOrder"] = this.isCloseOrder;
        data["apiIps"] = this.apiIps;
        data["orderApiIps"] = this.orderApiIps;
        data["autoCloseTime"] = this.autoCloseTime;
        data["channelYufuYuZhi"] = this.channelYufuYuZhi;
        data["disableOrderNotify"] = this.disableOrderNotify;
        data["isEnableAuto"] = this.isEnableAuto;
        data["inStartTime"] = this.inStartTime;
        data["inEndTime"] = this.inEndTime;
        data["isQuFenYiChang"] = this.isQuFenYiChang;
        data["isChannelFuLiRunOpen"] = this.isChannelFuLiRunOpen;
        return data;
    }

    clone(): SystemSettingDto {
        const json = this.toJSON();
        let result = new SystemSettingDto();
        result.init(json);
        return result;
    }
}

export interface ISystemSettingDto {
    id: number;
    isEnableGoogleCheckLogin: boolean;
    title: string | undefined;
    payOrderFix: string | undefined;
    isCloseOrder: boolean;
    apiIps: string | undefined;
    orderApiIps: string | undefined;
    autoCloseTime: number;
    channelYufuYuZhi: number;
    disableOrderNotify: boolean;
    isEnableAuto: boolean;
    inStartTime: string | undefined;
    inEndTime: string | undefined;
    isQuFenYiChang: boolean;
    isChannelFuLiRunOpen: boolean;
}

export class TelegramGroupDto implements ITelegramGroupDto {
    id!: number;
    chatId!: number;
    name!: string | undefined;
    userId!: number | undefined;
    userName!: string | undefined;
    isEnableBot!: boolean;
    merchantId!: number | undefined;
    mid!: string | undefined;
    merName!: string | undefined;
    isEnableNumValue!: boolean;
    numValue!: number;
    telegramGroupType!: TelegramGroupTypeEnum;
    usdtSendAddress!: string | undefined;
    channelName!: string | undefined;
    channelId!: number | undefined;
    readonly telegramGroupTypeName!: string | undefined;
    channelFlag!: string | undefined;
    channelSupplierId!: number | undefined;
    isOffUsdtMonitor!: boolean;
    atUser!: string | undefined;

    constructor(data?: ITelegramGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.chatId = _data["chatId"];
            this.name = _data["name"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.isEnableBot = _data["isEnableBot"];
            this.merchantId = _data["merchantId"];
            this.mid = _data["mid"];
            this.merName = _data["merName"];
            this.isEnableNumValue = _data["isEnableNumValue"];
            this.numValue = _data["numValue"];
            this.telegramGroupType = _data["telegramGroupType"];
            this.usdtSendAddress = _data["usdtSendAddress"];
            this.channelName = _data["channelName"];
            this.channelId = _data["channelId"];
            (<any>this).telegramGroupTypeName = _data["telegramGroupTypeName"];
            this.channelFlag = _data["channelFlag"];
            this.channelSupplierId = _data["channelSupplierId"];
            this.isOffUsdtMonitor = _data["isOffUsdtMonitor"];
            this.atUser = _data["atUser"];
        }
    }

    static fromJS(data: any): TelegramGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new TelegramGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["chatId"] = this.chatId;
        data["name"] = this.name;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["isEnableBot"] = this.isEnableBot;
        data["merchantId"] = this.merchantId;
        data["mid"] = this.mid;
        data["merName"] = this.merName;
        data["isEnableNumValue"] = this.isEnableNumValue;
        data["numValue"] = this.numValue;
        data["telegramGroupType"] = this.telegramGroupType;
        data["usdtSendAddress"] = this.usdtSendAddress;
        data["channelName"] = this.channelName;
        data["channelId"] = this.channelId;
        data["telegramGroupTypeName"] = this.telegramGroupTypeName;
        data["channelFlag"] = this.channelFlag;
        data["channelSupplierId"] = this.channelSupplierId;
        data["isOffUsdtMonitor"] = this.isOffUsdtMonitor;
        data["atUser"] = this.atUser;
        return data;
    }

    clone(): TelegramGroupDto {
        const json = this.toJSON();
        let result = new TelegramGroupDto();
        result.init(json);
        return result;
    }
}

export interface ITelegramGroupDto {
    id: number;
    chatId: number;
    name: string | undefined;
    userId: number | undefined;
    userName: string | undefined;
    isEnableBot: boolean;
    merchantId: number | undefined;
    mid: string | undefined;
    merName: string | undefined;
    isEnableNumValue: boolean;
    numValue: number;
    telegramGroupType: TelegramGroupTypeEnum;
    usdtSendAddress: string | undefined;
    channelName: string | undefined;
    channelId: number | undefined;
    telegramGroupTypeName: string | undefined;
    channelFlag: string | undefined;
    channelSupplierId: number | undefined;
    isOffUsdtMonitor: boolean;
    atUser: string | undefined;
}

export class TelegramGroupDtoPagedResultDto implements ITelegramGroupDtoPagedResultDto {
    items!: TelegramGroupDto[] | undefined;
    totalCount!: number;

    constructor(data?: ITelegramGroupDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TelegramGroupDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TelegramGroupDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TelegramGroupDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TelegramGroupDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TelegramGroupDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITelegramGroupDtoPagedResultDto {
    items: TelegramGroupDto[] | undefined;
    totalCount: number;
}

export class TelegramGroupPageInputDto implements ITelegramGroupPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    chatId!: number | undefined;
    name!: string | undefined;
    isEnableBot!: boolean | undefined;
    telegramGroupTypeId!: TelegramGroupTypeEnum;

    constructor(data?: ITelegramGroupPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.chatId = _data["chatId"];
            this.name = _data["name"];
            this.isEnableBot = _data["isEnableBot"];
            this.telegramGroupTypeId = _data["telegramGroupTypeId"];
        }
    }

    static fromJS(data: any): TelegramGroupPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new TelegramGroupPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["chatId"] = this.chatId;
        data["name"] = this.name;
        data["isEnableBot"] = this.isEnableBot;
        data["telegramGroupTypeId"] = this.telegramGroupTypeId;
        return data;
    }

    clone(): TelegramGroupPageInputDto {
        const json = this.toJSON();
        let result = new TelegramGroupPageInputDto();
        result.init(json);
        return result;
    }
}

export interface ITelegramGroupPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    chatId: number | undefined;
    name: string | undefined;
    isEnableBot: boolean | undefined;
    telegramGroupTypeId: TelegramGroupTypeEnum;
}

export enum TelegramGroupTypeEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _99 = 99,
}

export class TelegramSearchOrderDto implements ITelegramSearchOrderDto {
    id!: number;
    payOrderId!: number | undefined;
    payOrder!: PayOrderDto;
    consuming!: number;
    status!: number;
    handleTime!: Date | undefined;
    creationTime!: Date;

    constructor(data?: ITelegramSearchOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.payOrderId = _data["payOrderId"];
            this.payOrder = _data["payOrder"] ? PayOrderDto.fromJS(_data["payOrder"]) : <any>undefined;
            this.consuming = _data["consuming"];
            this.status = _data["status"];
            this.handleTime = _data["handleTime"] ? new Date(_data["handleTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TelegramSearchOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new TelegramSearchOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payOrderId"] = this.payOrderId;
        data["payOrder"] = this.payOrder ? this.payOrder.toJSON() : <any>undefined;
        data["consuming"] = this.consuming;
        data["status"] = this.status;
        data["handleTime"] = this.handleTime ? this.handleTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): TelegramSearchOrderDto {
        const json = this.toJSON();
        let result = new TelegramSearchOrderDto();
        result.init(json);
        return result;
    }
}

export interface ITelegramSearchOrderDto {
    id: number;
    payOrderId: number | undefined;
    payOrder: PayOrderDto;
    consuming: number;
    status: number;
    handleTime: Date | undefined;
    creationTime: Date;
}

export class TelegramSearchOrderDtoPagedResultDto implements ITelegramSearchOrderDtoPagedResultDto {
    items!: TelegramSearchOrderDto[] | undefined;
    totalCount!: number;

    constructor(data?: ITelegramSearchOrderDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TelegramSearchOrderDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TelegramSearchOrderDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TelegramSearchOrderDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TelegramSearchOrderDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TelegramSearchOrderDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITelegramSearchOrderDtoPagedResultDto {
    items: TelegramSearchOrderDto[] | undefined;
    totalCount: number;
}

export class TelegramSearchOrderPageInputDto implements ITelegramSearchOrderPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    status!: number | undefined;
    tid!: string | undefined;
    merOrderTid!: string | undefined;

    constructor(data?: ITelegramSearchOrderPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.status = _data["status"];
            this.tid = _data["tid"];
            this.merOrderTid = _data["merOrderTid"];
        }
    }

    static fromJS(data: any): TelegramSearchOrderPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new TelegramSearchOrderPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["status"] = this.status;
        data["tid"] = this.tid;
        data["merOrderTid"] = this.merOrderTid;
        return data;
    }

    clone(): TelegramSearchOrderPageInputDto {
        const json = this.toJSON();
        let result = new TelegramSearchOrderPageInputDto();
        result.init(json);
        return result;
    }
}

export interface ITelegramSearchOrderPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    status: number | undefined;
    tid: string | undefined;
    merOrderTid: string | undefined;
}

export class TelegramSettingDto implements ITelegramSettingDto {
    id!: number;
    token!: string | undefined;
    usdtTokens!: string | undefined;
    isNeibuGroup!: boolean;
    isChannelGroup!: boolean;
    createOrderErrorLastTime!: Date | undefined;
    tixingJiange!: number;
    merchantCreateOrderNumTixing!: number;
    merchantCreateOrderMinuteTixing!: number;
    loginTixing!: boolean;
    budanTixing!: boolean;
    uj!: string | undefined;
    wx!: string | undefined;
    zf!: string | undefined;
    lk!: string | undefined;
    dzUj!: string | undefined;
    dzWx!: string | undefined;
    dzZf!: string | undefined;
    dzLk!: string | undefined;
    autoCuidan!: boolean;
    cuidanJIange!: string | undefined;
    isShowCreateTime!: boolean;
    chaDanButtons!: string | undefined;
    chaDanChannelSendImg!: boolean;
    isDeficitRemind!: boolean;
    deficitRemindMoney!: number;
    merQueryOrderFilterkey!: string | undefined;
    corderTimeOutGroupId!: string | undefined;

    constructor(data?: ITelegramSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.token = _data["token"];
            this.usdtTokens = _data["usdtTokens"];
            this.isNeibuGroup = _data["isNeibuGroup"];
            this.isChannelGroup = _data["isChannelGroup"];
            this.createOrderErrorLastTime = _data["createOrderErrorLastTime"] ? new Date(_data["createOrderErrorLastTime"].toString()) : <any>undefined;
            this.tixingJiange = _data["tixingJiange"];
            this.merchantCreateOrderNumTixing = _data["merchantCreateOrderNumTixing"];
            this.merchantCreateOrderMinuteTixing = _data["merchantCreateOrderMinuteTixing"];
            this.loginTixing = _data["loginTixing"];
            this.budanTixing = _data["budanTixing"];
            this.uj = _data["uj"];
            this.wx = _data["wx"];
            this.zf = _data["zf"];
            this.lk = _data["lk"];
            this.dzUj = _data["dzUj"];
            this.dzWx = _data["dzWx"];
            this.dzZf = _data["dzZf"];
            this.dzLk = _data["dzLk"];
            this.autoCuidan = _data["autoCuidan"];
            this.cuidanJIange = _data["cuidanJIange"];
            this.isShowCreateTime = _data["isShowCreateTime"];
            this.chaDanButtons = _data["chaDanButtons"];
            this.chaDanChannelSendImg = _data["chaDanChannelSendImg"];
            this.isDeficitRemind = _data["isDeficitRemind"];
            this.deficitRemindMoney = _data["deficitRemindMoney"];
            this.merQueryOrderFilterkey = _data["merQueryOrderFilterkey"];
            this.corderTimeOutGroupId = _data["corderTimeOutGroupId"];
        }
    }

    static fromJS(data: any): TelegramSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new TelegramSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["token"] = this.token;
        data["usdtTokens"] = this.usdtTokens;
        data["isNeibuGroup"] = this.isNeibuGroup;
        data["isChannelGroup"] = this.isChannelGroup;
        data["createOrderErrorLastTime"] = this.createOrderErrorLastTime ? this.createOrderErrorLastTime.toISOString() : <any>undefined;
        data["tixingJiange"] = this.tixingJiange;
        data["merchantCreateOrderNumTixing"] = this.merchantCreateOrderNumTixing;
        data["merchantCreateOrderMinuteTixing"] = this.merchantCreateOrderMinuteTixing;
        data["loginTixing"] = this.loginTixing;
        data["budanTixing"] = this.budanTixing;
        data["uj"] = this.uj;
        data["wx"] = this.wx;
        data["zf"] = this.zf;
        data["lk"] = this.lk;
        data["dzUj"] = this.dzUj;
        data["dzWx"] = this.dzWx;
        data["dzZf"] = this.dzZf;
        data["dzLk"] = this.dzLk;
        data["autoCuidan"] = this.autoCuidan;
        data["cuidanJIange"] = this.cuidanJIange;
        data["isShowCreateTime"] = this.isShowCreateTime;
        data["chaDanButtons"] = this.chaDanButtons;
        data["chaDanChannelSendImg"] = this.chaDanChannelSendImg;
        data["isDeficitRemind"] = this.isDeficitRemind;
        data["deficitRemindMoney"] = this.deficitRemindMoney;
        data["merQueryOrderFilterkey"] = this.merQueryOrderFilterkey;
        data["corderTimeOutGroupId"] = this.corderTimeOutGroupId;
        return data;
    }

    clone(): TelegramSettingDto {
        const json = this.toJSON();
        let result = new TelegramSettingDto();
        result.init(json);
        return result;
    }
}

export interface ITelegramSettingDto {
    id: number;
    token: string | undefined;
    usdtTokens: string | undefined;
    isNeibuGroup: boolean;
    isChannelGroup: boolean;
    createOrderErrorLastTime: Date | undefined;
    tixingJiange: number;
    merchantCreateOrderNumTixing: number;
    merchantCreateOrderMinuteTixing: number;
    loginTixing: boolean;
    budanTixing: boolean;
    uj: string | undefined;
    wx: string | undefined;
    zf: string | undefined;
    lk: string | undefined;
    dzUj: string | undefined;
    dzWx: string | undefined;
    dzZf: string | undefined;
    dzLk: string | undefined;
    autoCuidan: boolean;
    cuidanJIange: string | undefined;
    isShowCreateTime: boolean;
    chaDanButtons: string | undefined;
    chaDanChannelSendImg: boolean;
    isDeficitRemind: boolean;
    deficitRemindMoney: number;
    merQueryOrderFilterkey: string | undefined;
    corderTimeOutGroupId: string | undefined;
}

export class TenantDto implements ITenantDto {
    id!: number;
    tenancyName!: string;
    name!: string;
    isActive!: boolean;

    constructor(data?: ITenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): TenantDto {
        const json = this.toJSON();
        let result = new TenantDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDto {
    id: number;
    tenancyName: string;
    name: string;
    isActive: boolean;
}

export class TenantDtoPagedResultDto implements ITenantDtoPagedResultDto {
    items!: TenantDto[] | undefined;
    totalCount!: number;

    constructor(data?: ITenantDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TenantDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TenantDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TenantDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDtoPagedResultDto {
    items: TenantDto[] | undefined;
    totalCount: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    id!: number;
    tenancyName!: string | undefined;
    name!: string | undefined;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        return data;
    }

    clone(): TenantLoginInfoDto {
        const json = this.toJSON();
        let result = new TenantLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface ITenantLoginInfoDto {
    id: number;
    tenancyName: string | undefined;
    name: string | undefined;
}

export enum TongJiEnumTypes {
    _0 = 0,
    _1 = 1,
}

export class UpdateChannelQuanzhongInputDto implements IUpdateChannelQuanzhongInputDto {
    channelId!: number;
    quanZhong!: number;

    constructor(data?: IUpdateChannelQuanzhongInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelId = _data["channelId"];
            this.quanZhong = _data["quanZhong"];
        }
    }

    static fromJS(data: any): UpdateChannelQuanzhongInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateChannelQuanzhongInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelId"] = this.channelId;
        data["quanZhong"] = this.quanZhong;
        return data;
    }

    clone(): UpdateChannelQuanzhongInputDto {
        const json = this.toJSON();
        let result = new UpdateChannelQuanzhongInputDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateChannelQuanzhongInputDto {
    channelId: number;
    quanZhong: number;
}

export class UpdateChannelRateDto implements IUpdateChannelRateDto {
    idList!: number[] | undefined;
    rate!: number;

    constructor(data?: IUpdateChannelRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["idList"])) {
                this.idList = [] as any;
                for (let item of _data["idList"])
                    this.idList!.push(item);
            }
            this.rate = _data["rate"];
        }
    }

    static fromJS(data: any): UpdateChannelRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateChannelRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.idList)) {
            data["idList"] = [];
            for (let item of this.idList)
                data["idList"].push(item);
        }
        data["rate"] = this.rate;
        return data;
    }

    clone(): UpdateChannelRateDto {
        const json = this.toJSON();
        let result = new UpdateChannelRateDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateChannelRateDto {
    idList: number[] | undefined;
    rate: number;
}

export class UsdtTransactionDto implements IUsdtTransactionDto {
    id!: number;
    txid!: string | undefined;
    transactionTime!: Date;
    from!: string | undefined;
    to!: string | undefined;
    value!: number;
    creationTime!: Date;
    method!: number;

    constructor(data?: IUsdtTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.txid = _data["txid"];
            this.transactionTime = _data["transactionTime"] ? new Date(_data["transactionTime"].toString()) : <any>undefined;
            this.from = _data["from"];
            this.to = _data["to"];
            this.value = _data["value"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.method = _data["method"];
        }
    }

    static fromJS(data: any): UsdtTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UsdtTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["txid"] = this.txid;
        data["transactionTime"] = this.transactionTime ? this.transactionTime.toISOString() : <any>undefined;
        data["from"] = this.from;
        data["to"] = this.to;
        data["value"] = this.value;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["method"] = this.method;
        return data;
    }

    clone(): UsdtTransactionDto {
        const json = this.toJSON();
        let result = new UsdtTransactionDto();
        result.init(json);
        return result;
    }
}

export interface IUsdtTransactionDto {
    id: number;
    txid: string | undefined;
    transactionTime: Date;
    from: string | undefined;
    to: string | undefined;
    value: number;
    creationTime: Date;
    method: number;
}

export class UsdtTransactionDtoPagedResultDto implements IUsdtTransactionDtoPagedResultDto {
    items!: UsdtTransactionDto[] | undefined;
    totalCount!: number;

    constructor(data?: IUsdtTransactionDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UsdtTransactionDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UsdtTransactionDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UsdtTransactionDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UsdtTransactionDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UsdtTransactionDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUsdtTransactionDtoPagedResultDto {
    items: UsdtTransactionDto[] | undefined;
    totalCount: number;
}

export class UsdtTransactionPageInputDto implements IUsdtTransactionPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    from!: string | undefined;
    to!: string | undefined;

    constructor(data?: IUsdtTransactionPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.from = _data["from"];
            this.to = _data["to"];
        }
    }

    static fromJS(data: any): UsdtTransactionPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UsdtTransactionPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["from"] = this.from;
        data["to"] = this.to;
        return data;
    }

    clone(): UsdtTransactionPageInputDto {
        const json = this.toJSON();
        let result = new UsdtTransactionPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IUsdtTransactionPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    from: string | undefined;
    to: string | undefined;
}

export class UserDto implements IUserDto {
    id!: number;
    userName!: string;
    name!: string;
    surname!: string;
    emailAddress!: string;
    isActive!: boolean;
    fullName!: string | undefined;
    lastLoginTime!: Date | undefined;
    creationTime!: Date;
    roleNames!: string[] | undefined;
    isShow!: boolean;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            this.fullName = _data["fullName"];
            this.lastLoginTime = _data["lastLoginTime"] ? new Date(_data["lastLoginTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
            this.isShow = _data["isShow"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        data["fullName"] = this.fullName;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["isShow"] = this.isShow;
        return data;
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

export interface IUserDto {
    id: number;
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    fullName: string | undefined;
    lastLoginTime: Date | undefined;
    creationTime: Date;
    roleNames: string[] | undefined;
    isShow: boolean;
}

export class UserDtoPagedResultDto implements IUserDtoPagedResultDto {
    items!: UserDto[] | undefined;
    totalCount!: number;

    constructor(data?: IUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserDtoPagedResultDto {
    items: UserDto[] | undefined;
    totalCount: number;
}

export class UserInfoDto implements IUserInfoDto {
    userName!: string | undefined;
    name!: string | undefined;
    isShow!: boolean;

    constructor(data?: IUserInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.isShow = _data["isShow"];
        }
    }

    static fromJS(data: any): UserInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["isShow"] = this.isShow;
        return data;
    }

    clone(): UserInfoDto {
        const json = this.toJSON();
        let result = new UserInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUserInfoDto {
    userName: string | undefined;
    name: string | undefined;
    isShow: boolean;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    id!: number;
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        return data;
    }

    clone(): UserLoginInfoDto {
        const json = this.toJSON();
        let result = new UserLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUserLoginInfoDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
}

export enum UserTypeEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class WarehousingProductDto implements IWarehousingProductDto {
    id!: number;
    params!: string | undefined;
    warehousingProductName!: string | undefined;

    constructor(data?: IWarehousingProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.params = _data["params"];
            this.warehousingProductName = _data["warehousingProductName"];
        }
    }

    static fromJS(data: any): WarehousingProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new WarehousingProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["params"] = this.params;
        data["warehousingProductName"] = this.warehousingProductName;
        return data;
    }

    clone(): WarehousingProductDto {
        const json = this.toJSON();
        let result = new WarehousingProductDto();
        result.init(json);
        return result;
    }
}

export interface IWarehousingProductDto {
    id: number;
    params: string | undefined;
    warehousingProductName: string | undefined;
}

export class WarehousingProductDtoPagedResultDto implements IWarehousingProductDtoPagedResultDto {
    items!: WarehousingProductDto[] | undefined;
    totalCount!: number;

    constructor(data?: IWarehousingProductDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(WarehousingProductDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): WarehousingProductDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new WarehousingProductDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): WarehousingProductDtoPagedResultDto {
        const json = this.toJSON();
        let result = new WarehousingProductDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IWarehousingProductDtoPagedResultDto {
    items: WarehousingProductDto[] | undefined;
    totalCount: number;
}

export class WarehousingProductPageInputDto implements IWarehousingProductPageInputDto {
    maxResultCount!: number;
    skipCount!: number;
    ids!: number[] | undefined;
    sorting!: string | undefined;
    warehousingProductName!: string | undefined;

    constructor(data?: IWarehousingProductPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.sorting = _data["sorting"];
            this.warehousingProductName = _data["warehousingProductName"];
        }
    }

    static fromJS(data: any): WarehousingProductPageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new WarehousingProductPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["sorting"] = this.sorting;
        data["warehousingProductName"] = this.warehousingProductName;
        return data;
    }

    clone(): WarehousingProductPageInputDto {
        const json = this.toJSON();
        let result = new WarehousingProductPageInputDto();
        result.init(json);
        return result;
    }
}

export interface IWarehousingProductPageInputDto {
    maxResultCount: number;
    skipCount: number;
    ids: number[] | undefined;
    sorting: string | undefined;
    warehousingProductName: string | undefined;
}

export class WxAreaDto implements IWxAreaDto {
    v!: number;
    n!: string | undefined;
    c!: WxAreaDto[] | undefined;

    constructor(data?: IWxAreaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.v = _data["v"];
            this.n = _data["n"];
            if (Array.isArray(_data["c"])) {
                this.c = [] as any;
                for (let item of _data["c"])
                    this.c!.push(WxAreaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WxAreaDto {
        data = typeof data === 'object' ? data : {};
        let result = new WxAreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["v"] = this.v;
        data["n"] = this.n;
        if (Array.isArray(this.c)) {
            data["c"] = [];
            for (let item of this.c)
                data["c"].push(item.toJSON());
        }
        return data;
    }

    clone(): WxAreaDto {
        const json = this.toJSON();
        let result = new WxAreaDto();
        result.init(json);
        return result;
    }
}

export interface IWxAreaDto {
    v: number;
    n: string | undefined;
    c: WxAreaDto[] | undefined;
}

export class ZhuYeChannelStatisticsDto implements IZhuYeChannelStatisticsDto {
    channelName!: string | undefined;
    zongAmount!: number;
    successAmount!: number;
    zongNum!: number;
    successNum!: number;
    successRate!: number;

    constructor(data?: IZhuYeChannelStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelName = _data["channelName"];
            this.zongAmount = _data["zongAmount"];
            this.successAmount = _data["successAmount"];
            this.zongNum = _data["zongNum"];
            this.successNum = _data["successNum"];
            this.successRate = _data["successRate"];
        }
    }

    static fromJS(data: any): ZhuYeChannelStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ZhuYeChannelStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelName"] = this.channelName;
        data["zongAmount"] = this.zongAmount;
        data["successAmount"] = this.successAmount;
        data["zongNum"] = this.zongNum;
        data["successNum"] = this.successNum;
        data["successRate"] = this.successRate;
        return data;
    }

    clone(): ZhuYeChannelStatisticsDto {
        const json = this.toJSON();
        let result = new ZhuYeChannelStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface IZhuYeChannelStatisticsDto {
    channelName: string | undefined;
    zongAmount: number;
    successAmount: number;
    zongNum: number;
    successNum: number;
    successRate: number;
}

export class ZhuYeChannelTypeStatisticsDto implements IZhuYeChannelTypeStatisticsDto {
    channelTypeName!: string | undefined;
    zongAmount!: number;
    successAmount!: number;
    zongNum!: number;
    successNum!: number;
    successRate!: number;
    channelTypeCode!: string | undefined;

    constructor(data?: IZhuYeChannelTypeStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelTypeName = _data["channelTypeName"];
            this.zongAmount = _data["zongAmount"];
            this.successAmount = _data["successAmount"];
            this.zongNum = _data["zongNum"];
            this.successNum = _data["successNum"];
            this.successRate = _data["successRate"];
            this.channelTypeCode = _data["channelTypeCode"];
        }
    }

    static fromJS(data: any): ZhuYeChannelTypeStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ZhuYeChannelTypeStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelTypeName"] = this.channelTypeName;
        data["zongAmount"] = this.zongAmount;
        data["successAmount"] = this.successAmount;
        data["zongNum"] = this.zongNum;
        data["successNum"] = this.successNum;
        data["successRate"] = this.successRate;
        data["channelTypeCode"] = this.channelTypeCode;
        return data;
    }

    clone(): ZhuYeChannelTypeStatisticsDto {
        const json = this.toJSON();
        let result = new ZhuYeChannelTypeStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface IZhuYeChannelTypeStatisticsDto {
    channelTypeName: string | undefined;
    zongAmount: number;
    successAmount: number;
    zongNum: number;
    successNum: number;
    successRate: number;
    channelTypeCode: string | undefined;
}

export class ZhuYeMerchantStatisticsDto implements IZhuYeMerchantStatisticsDto {
    merchantName!: string | undefined;
    zongAmount!: number;
    successAmount!: number;
    zongNum!: number;
    successNum!: number;
    successRate!: number;

    constructor(data?: IZhuYeMerchantStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.merchantName = _data["merchantName"];
            this.zongAmount = _data["zongAmount"];
            this.successAmount = _data["successAmount"];
            this.zongNum = _data["zongNum"];
            this.successNum = _data["successNum"];
            this.successRate = _data["successRate"];
        }
    }

    static fromJS(data: any): ZhuYeMerchantStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ZhuYeMerchantStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["merchantName"] = this.merchantName;
        data["zongAmount"] = this.zongAmount;
        data["successAmount"] = this.successAmount;
        data["zongNum"] = this.zongNum;
        data["successNum"] = this.successNum;
        data["successRate"] = this.successRate;
        return data;
    }

    clone(): ZhuYeMerchantStatisticsDto {
        const json = this.toJSON();
        let result = new ZhuYeMerchantStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface IZhuYeMerchantStatisticsDto {
    merchantName: string | undefined;
    zongAmount: number;
    successAmount: number;
    zongNum: number;
    successNum: number;
    successRate: number;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}